webpackJsonp(["pages.projects.merge_requests.show"],{

/***/ "../../../ee/app/assets/javascripts/pages/projects/merge_requests/show/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./merge_request.js
var merge_request = __webpack_require__("./merge_request.js");

// EXTERNAL MODULE: ./zen_mode.js
var zen_mode = __webpack_require__("./zen_mode.js");

// EXTERNAL MODULE: ./init_notes.js
var init_notes = __webpack_require__("./init_notes.js");

// EXTERNAL MODULE: ./init_issuable_sidebar.js
var init_issuable_sidebar = __webpack_require__("./init_issuable_sidebar.js");

// EXTERNAL MODULE: ./diff_notes/diff_notes_bundle.js
var diff_notes_bundle = __webpack_require__("./diff_notes/diff_notes_bundle.js");

// EXTERNAL MODULE: ./shortcuts_issuable.js
var shortcuts_issuable = __webpack_require__("./shortcuts_issuable.js");

// EXTERNAL MODULE: ./diff.js
var diff = __webpack_require__("./diff.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// EXTERNAL MODULE: ./how_to_merge.js
var how_to_merge = __webpack_require__("./how_to_merge.js");

// EXTERNAL MODULE: ./commit/pipelines/pipelines_bundle.js + 3 modules
var pipelines_bundle = __webpack_require__("./commit/pipelines/pipelines_bundle.js");

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: ./smart_interval.js
var smart_interval = __webpack_require__("./smart_interval.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/clipboard_button.vue + 2 modules
var clipboard_button = __webpack_require__("./vue_shared/components/clipboard_button.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_header.vue






/* harmony default export */ var mr_widget_header = ({
  name: 'MRWidgetHeader',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    icon: icon["a" /* default */],
    clipboardButton: clipboard_button["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true
    }
  },
  computed: {
    shouldShowCommitsBehindText: function shouldShowCommitsBehindText() {
      return this.mr.divergedCommitsCount > 0;
    },
    commitsText: function commitsText() {
      return Object(locale["d" /* n__ */])('%d commit behind', '%d commits behind', this.mr.divergedCommitsCount);
    },
    branchNameClipboardData: function branchNameClipboardData() {
      // This supports code in app/assets/javascripts/copy_to_clipboard.js that
      // works around ClipboardJS limitations to allow the context-specific
      // copy/pasting of plain text or GFM.
      return JSON.stringify({
        text: this.mr.sourceBranch,
        gfm: '`' + this.mr.sourceBranch + '`'
      });
    },
    isSourceBranchLong: function isSourceBranchLong() {
      return this.isBranchTitleLong(this.mr.sourceBranch);
    },
    isTargetBranchLong: function isTargetBranchLong() {
      return this.isBranchTitleLong(this.mr.targetBranch);
    }
  },
  methods: {
    isBranchTitleLong: function isBranchTitleLong(branchTitle) {
      return branchTitle.length > 32;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf80d446","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-source-target"},[_c('div',{staticClass:"normal"},[_c('strong',[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|Request to merge"))+"\n      "),_c('span',{staticClass:"label-branch js-source-branch",class:{ 'label-truncated': _vm.isSourceBranchLong },attrs:{"title":_vm.isSourceBranchLong ? _vm.mr.sourceBranch : '',"data-placement":"bottom","v-tooltip":_vm.isSourceBranchLong},domProps:{"innerHTML":_vm._s(_vm.mr.sourceBranchLink)}}),_vm._v(" "),_c('clipboard-button',{attrs:{"text":_vm.branchNameClipboardData,"title":_vm.__('Copy branch name to clipboard'),"css-class":"btn-default btn-transparent btn-clipboard"}}),_vm._v("\n\n      "+_vm._s(_vm.s__("mrWidget|into"))+"\n\n      "),_c('span',{staticClass:"label-branch",class:{ 'label-truncatedtooltip': _vm.isTargetBranchLong },attrs:{"v-tooltip":_vm.isTargetBranchLong,"title":_vm.isTargetBranchLong ? _vm.mr.targetBranch : '',"data-placement":"bottom"}},[_c('a',{staticClass:"js-target-branch",attrs:{"href":_vm.mr.targetBranchTreePath}},[_vm._v("\n          "+_vm._s(_vm.mr.targetBranch)+"\n        ")])])],1),_vm._v(" "),(_vm.shouldShowCommitsBehindText)?_c('span',{staticClass:"diverged-commits-count"},[_vm._v("\n      ("),_c('a',{attrs:{"href":_vm.mr.targetBranchPath}},[_vm._v(_vm._s(_vm.commitsText))]),_vm._v(")\n    ")]):_vm._e()]),_vm._v(" "),(_vm.mr.isOpen)?_c('div',[_c('button',{staticClass:"btn btn-sm btn-default inline js-check-out-branch",attrs:{"data-target":"#modal_merge_info","data-toggle":"modal","disabled":_vm.mr.sourceBranchRemoved,"type":"button"}},[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|Check out branch"))+"\n    ")]),_vm._v(" "),_c('span',{staticClass:"dropdown prepend-left-10"},[_c('button',{staticClass:"btn btn-sm inline dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown","aria-label":"Download as","aria-haspopup":"true","aria-expanded":"false"}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}})],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-align-right"},[_c('li',[_c('a',{staticClass:"js-download-email-patches",attrs:{"href":_vm.mr.emailPatchesPath,"download":""}},[_vm._v("\n            "+_vm._s(_vm.s__("mrWidget|Email patches"))+"\n          ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"js-download-plain-diff",attrs:{"href":_vm.mr.plainDiffPath,"download":""}},[_vm._v("\n            "+_vm._s(_vm.s__("mrWidget|Plain diff"))+"\n          ")])])])])]):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_header.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  mr_widget_header,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_header = (Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_merge_help.vue



/* harmony default export */ var mr_widget_merge_help = ({
  name: 'MRWidgetMergeHelp',
  props: {
    missingBranch: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    missingBranchInfo: function missingBranchInfo() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('mrWidget|If the %{branch} branch exists in your local repository, you can merge this merge request manually using the'), { branch: this.missingBranch });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12cfd29e","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_merge_help.vue
var mr_widget_merge_help_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mr-widget-help"},[(_vm.missingBranch)?[_vm._v("\n    "+_vm._s(_vm.missingBranchInfo)+"\n  ")]:[_vm._v("\n    "+_vm._s(_vm.s__("mrWidget|You can merge this merge request manually using the"))+"\n  ")],_vm._v(" "),_c('button',{staticClass:"btn-link btn-blank js-open-modal-help",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal_merge_info"}},[_vm._v("\n    "+_vm._s(_vm.s__("mrWidget|command line"))+"\n  ")])],2)}
var mr_widget_merge_help_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_merge_help.vue
/* script */


/* template */

/* template functional */
var mr_widget_merge_help___vue_template_functional__ = false
/* styles */
var mr_widget_merge_help___vue_styles__ = null
/* scopeId */
var mr_widget_merge_help___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_merge_help___vue_module_identifier__ = null

var mr_widget_merge_help_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_merge_help,
  mr_widget_merge_help_render,
  mr_widget_merge_help_staticRenderFns,
  mr_widget_merge_help___vue_template_functional__,
  mr_widget_merge_help___vue_styles__,
  mr_widget_merge_help___vue_scopeId__,
  mr_widget_merge_help___vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_merge_help = (mr_widget_merge_help_Component.exports);

// EXTERNAL MODULE: ./pipelines/components/stage.vue + 1 modules
var stage = __webpack_require__("./pipelines/components/stage.vue");

// EXTERNAL MODULE: ./vue_shared/components/ci_icon.vue + 2 modules
var ci_icon = __webpack_require__("./vue_shared/components/ci_icon.vue");

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/views/shared/icons/_arrow_mini_pipeline_graph.svg
var _arrow_mini_pipeline_graph = __webpack_require__("../../../ee/app/views/shared/icons/_arrow_mini_pipeline_graph.svg");
var _arrow_mini_pipeline_graph_default = /*#__PURE__*/__webpack_require__.n(_arrow_mini_pipeline_graph);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!/var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_shared/components/linked_pipelines_mini_list.vue






/* harmony default export */ var linked_pipelines_mini_list = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    ciStatus: ci_icon["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    triggeredBy: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    triggered: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    pipelinePath: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      arrowSvg: _arrow_mini_pipeline_graph_default.a,
      maxRenderedPipelines: 3
    };
  },

  computed: {
    // Exactly one of these (triggeredBy and triggered) must be truthy. Never both. Never neither.
    isUpstream: function isUpstream() {
      return !!this.triggeredBy.length && !this.triggered.length;
    },
    isDownstream: function isDownstream() {
      return !this.triggeredBy.length && !!this.triggered.length;
    },
    linkedPipelines: function linkedPipelines() {
      return this.isUpstream ? this.triggeredBy : this.triggered;
    },
    totalPipelineCount: function totalPipelineCount() {
      return this.linkedPipelines.length;
    },
    linkedPipelinesTrimmed: function linkedPipelinesTrimmed() {
      return this.totalPipelineCount > this.maxRenderedPipelines ? this.linkedPipelines.slice(0, this.maxRenderedPipelines) : this.linkedPipelines;
    },
    shouldRenderCounter: function shouldRenderCounter() {
      return this.isDownstream && this.linkedPipelines.length > this.maxRenderedPipelines;
    },
    counterLabel: function counterLabel() {
      return '+' + (this.linkedPipelines.length - this.maxRenderedPipelines);
    },
    counterTooltipText: function counterTooltipText() {
      return this.counterLabel + ' more downstream pipelines';
    }
  },
  methods: {
    pipelineTooltipText: function pipelineTooltipText(pipeline) {
      return pipeline.project.name + ' - ' + pipeline.details.status.label;
    },
    getStatusIcon: function getStatusIcon(iconName) {
      return iconName + '_borderless';
    },
    triggerButtonClass: function triggerButtonClass(group) {
      return 'ci-status-icon-' + group;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53d057c4","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!/var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_shared/components/linked_pipelines_mini_list.vue
var linked_pipelines_mini_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkedPipelines)?_c('span',{staticClass:"linked-pipeline-mini-list",class:{
    'is-upstream' : _vm.isUpstream,
    'is-downstream': _vm.isDownstream
  }},[(_vm.isDownstream)?_c('span',{staticClass:"arrow-icon",attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.arrowSvg)}}):_vm._e(),_vm._v(" "),_vm._l((_vm.linkedPipelinesTrimmed),function(pipeline){return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],key:pipeline.id,staticClass:"linked-pipeline-mini-item",class:_vm.triggerButtonClass(pipeline.details.status.group),attrs:{"href":pipeline.path,"title":_vm.pipelineTooltipText(pipeline),"data-placement":"top","data-container":"body"}},[_c('icon',{attrs:{"name":_vm.getStatusIcon(pipeline.details.status.icon)}})],1)}),_vm._v(" "),(_vm.shouldRenderCounter)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"linked-pipelines-counter linked-pipeline-mini-item",attrs:{"title":_vm.counterTooltipText,"href":_vm.pipelinePath,"data-placement":"top","data-container":"body"}},[_vm._v("\n    "+_vm._s(_vm.counterLabel)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.isUpstream)?_c('span',{staticClass:"arrow-icon",attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.arrowSvg)}}):_vm._e()],2):_vm._e()}
var linked_pipelines_mini_list_staticRenderFns = []

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_shared/components/linked_pipelines_mini_list.vue
/* script */


/* template */

/* template functional */
var linked_pipelines_mini_list___vue_template_functional__ = false
/* styles */
var linked_pipelines_mini_list___vue_styles__ = null
/* scopeId */
var linked_pipelines_mini_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var linked_pipelines_mini_list___vue_module_identifier__ = null

var linked_pipelines_mini_list_Component = Object(component_normalizer["a" /* default */])(
  linked_pipelines_mini_list,
  linked_pipelines_mini_list_render,
  linked_pipelines_mini_list_staticRenderFns,
  linked_pipelines_mini_list___vue_template_functional__,
  linked_pipelines_mini_list___vue_styles__,
  linked_pipelines_mini_list___vue_scopeId__,
  linked_pipelines_mini_list___vue_module_identifier__
)

/* harmony default export */ var components_linked_pipelines_mini_list = (linked_pipelines_mini_list_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_pipeline.vue

/* eslint-disable vue/require-default-prop */





/* harmony default export */ var mr_widget_pipeline = ({
  name: 'MRWidgetPipeline',
  components: {
    pipelineStage: stage["a" /* default */],
    ciIcon: ci_icon["a" /* default */],
    icon: icon["a" /* default */],
    linkedPipelinesMiniList: components_linked_pipelines_mini_list
  },
  props: {
    pipeline: {
      type: Object,
      required: true
    },
    // This prop needs to be camelCase, html attributes are case insensive
    // https://vuejs.org/v2/guide/components.html#camelCase-vs-kebab-case
    hasCi: {
      type: Boolean,
      required: false
    },
    ciStatus: {
      type: String,
      required: false
    }
  },
  computed: {
    hasPipeline: function hasPipeline() {
      return this.pipeline && Object.keys(this.pipeline).length > 0;
    },
    hasCIError: function hasCIError() {
      return this.hasCi && !this.ciStatus;
    },
    status: function status() {
      return this.pipeline.details && this.pipeline.details.status ? this.pipeline.details.status : {};
    },
    hasStages: function hasStages() {
      return this.pipeline.details && this.pipeline.details.stages && this.pipeline.details.stages.length;
    },


    /* We typically set defaults ([]) in the store or prop declarations, but because triggered
    * and triggeredBy are appended to `pipeline`, we can't set defaults in the store, and we
    * need to check their length here to prevent initializing linked-pipeline-mini-lists
    * unneccessarily. */
    triggered: function triggered() {
      return this.pipeline.triggered || [];
    },
    triggeredBy: function triggeredBy() {
      var response = this.pipeline.triggered_by;
      return response ? [response] : [];
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-350aaef8","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_pipeline.vue
var mr_widget_pipeline_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPipeline || _vm.hasCIError)?_c('div',{staticClass:"mr-widget-heading"},[_c('div',{staticClass:"ci-widget media"},[(_vm.hasCIError)?[_c('div',{staticClass:"ci-status-icon ci-status-icon-failed ci-error js-ci-error append-right-10"},[_c('icon',{attrs:{"name":"status_failed"}})],1),_vm._v(" "),_c('div',{staticClass:"media-body"},[_vm._v("\n        Could not connect to the CI server. Please check your settings and try again\n      ")])]:(_vm.hasPipeline)?[_c('a',{staticClass:"append-right-10",attrs:{"href":_vm.status.details_path}},[_c('ci-icon',{attrs:{"status":_vm.status}})],1),_vm._v(" "),_c('div',{staticClass:"media-body"},[_vm._v("\n        Pipeline\n        "),_c('a',{staticClass:"pipeline-id",attrs:{"href":_vm.pipeline.path}},[_vm._v("\n          #"+_vm._s(_vm.pipeline.id)+"\n        ")]),_vm._v("\n\n        "+_vm._s(_vm.pipeline.details.status.label)+" for\n\n        "),_c('a',{staticClass:"commit-sha js-commit-link",attrs:{"href":_vm.pipeline.commit.commit_path}},[_vm._v("\n        "+_vm._s(_vm.pipeline.commit.short_id))]),_vm._v(".\n\n        "),_c('span',{staticClass:"mr-widget-pipeline-graph"},[_c('span',{staticClass:"stage-cell"},[(_vm.triggeredBy.length)?_c('linked-pipelines-mini-list',{attrs:{"triggered-by":_vm.triggeredBy}}):_vm._e(),_vm._v(" "),(_vm.hasStages)?_vm._l((_vm.pipeline.details.stages),function(stage,i){return _c('div',{key:i,staticClass:"stage-container dropdown js-mini-pipeline-graph",class:{
                  'has-downstream': i === _vm.pipeline.details.stages.length - 1 && _vm.triggered.length
                }},[_c('pipeline-stage',{attrs:{"stage":stage}})],1)}):_vm._e(),_vm._v(" "),(_vm.triggered.length)?_c('linked-pipelines-mini-list',{attrs:{"triggered":_vm.triggered}}):_vm._e()],2)]),_vm._v(" "),(_vm.pipeline.coverage)?[_vm._v("\n          Coverage "+_vm._s(_vm.pipeline.coverage)+"%\n        ")]:_vm._e()],2)]:_vm._e()],2)]):_vm._e()}
var mr_widget_pipeline_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_pipeline.vue
/* script */


/* template */

/* template functional */
var mr_widget_pipeline___vue_template_functional__ = false
/* styles */
var mr_widget_pipeline___vue_styles__ = null
/* scopeId */
var mr_widget_pipeline___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_pipeline___vue_module_identifier__ = null

var mr_widget_pipeline_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_pipeline,
  mr_widget_pipeline_render,
  mr_widget_pipeline_staticRenderFns,
  mr_widget_pipeline___vue_template_functional__,
  mr_widget_pipeline___vue_styles__,
  mr_widget_pipeline___vue_scopeId__,
  mr_widget_pipeline___vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_pipeline = (mr_widget_pipeline_Component.exports);

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./lib/utils/http_status.js
var http_status = __webpack_require__("./lib/utils/http_status.js");

// EXTERNAL MODULE: ./lib/utils/number_utils.js
var number_utils = __webpack_require__("./lib/utils/number_utils.js");

// CONCATENATED MODULE: ./vue_shared/components/memory_graph.js


/* harmony default export */ var memory_graph = ({
  name: 'MemoryGraph',
  props: {
    metrics: { type: Array, required: true },
    deploymentTime: { type: Number, required: true },
    width: { type: String, required: true },
    height: { type: String, required: true }
  },
  data: function data() {
    return {
      pathD: '',
      pathViewBox: '',
      dotX: '',
      dotY: ''
    };
  },

  computed: {
    getFormattedMedian: function getFormattedMedian() {
      var deployedSince = Object(datetime_utility["f" /* getTimeago */])().format(this.deploymentTime * 1000);
      return 'Deployed ' + deployedSince;
    }
  },
  methods: {
    /**
     * Returns metric value index in metrics array
     * with timestamp closest to matching median
     */
    getMedianMetricIndex: function getMedianMetricIndex(median, metrics) {
      var matchIndex = 0;
      var timestampDiff = 0;
      var smallestDiff = 0;

      var metricTimestamps = metrics.map(function (v) {
        return v[0];
      });

      // Find metric timestamp which is closest to deploymentTime
      timestampDiff = Math.abs(metricTimestamps[0] - median);
      metricTimestamps.forEach(function (timestamp, index) {
        if (index === 0) {
          // Skip first element
          return;
        }

        smallestDiff = Math.abs(timestamp - median);
        if (smallestDiff < timestampDiff) {
          matchIndex = index;
          timestampDiff = smallestDiff;
        }
      });

      return matchIndex;
    },


    /**
     * Get Graph Plotting values to render Line and Dot
     */
    getGraphPlotValues: function getGraphPlotValues(median, metrics) {
      var renderData = metrics.map(function (v) {
        return v[1];
      });
      var medianMetricIndex = this.getMedianMetricIndex(median, metrics);
      var cx = 0;
      var cy = 0;

      // Find Maximum and Minimum values from `renderData` array
      var maxMemory = Math.max.apply(null, renderData);
      var minMemory = Math.min.apply(null, renderData);

      // Find difference between extreme ends
      var diff = maxMemory - minMemory;
      var lineWidth = renderData.length;

      // Iterate over metrics values and perform following
      // 1. Find x & y co-ords for deploymentTime's memory value
      // 2. Return line path against maxMemory
      var linePath = renderData.map(function (y, x) {
        if (medianMetricIndex === x) {
          cx = x;
          cy = maxMemory - y;
        }
        return x + ' ' + (maxMemory - y);
      });

      return {
        pathD: linePath,
        pathViewBox: {
          lineWidth: lineWidth,
          diff: diff
        },
        dotX: cx,
        dotY: cy
      };
    },


    /**
     * Render Graph based on provided median and metrics values
     */
    renderGraph: function renderGraph(median, metrics) {
      var _getGraphPlotValues = this.getGraphPlotValues(median, metrics),
          pathD = _getGraphPlotValues.pathD,
          pathViewBox = _getGraphPlotValues.pathViewBox,
          dotX = _getGraphPlotValues.dotX,
          dotY = _getGraphPlotValues.dotY;

      // Set props and update graph on UI.


      this.pathD = 'M ' + pathD;
      this.pathViewBox = '0 0 ' + pathViewBox.lineWidth + ' ' + pathViewBox.diff;
      this.dotX = dotX;
      this.dotY = dotY;
    }
  },
  mounted: function mounted() {
    this.renderGraph(this.deploymentTime, this.metrics);
  },

  template: '\n    <div class="memory-graph-container">\n      <svg class="has-tooltip" :title="getFormattedMedian" :width="width" :height="height" xmlns="http://www.w3.org/2000/svg">\n        <path :d="pathD" :viewBox="pathViewBox" />\n        <circle r="1.5" :cx="dotX" :cy="dotY" tranform="translate(0 -1)" />\n      </svg>\n    </div>\n  '
});
// EXTERNAL MODULE: ./lib/utils/axios_utils.js
var axios_utils = __webpack_require__("./lib/utils/axios_utils.js");

// CONCATENATED MODULE: ./vue_merge_request_widget/services/mr_widget_service.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var mr_widget_service_MRWidgetService = function () {
  function MRWidgetService(endpoints) {
    _classCallCheck(this, MRWidgetService);

    this.endpoints = endpoints;
  }

  _createClass(MRWidgetService, [{
    key: 'merge',
    value: function merge(data) {
      return axios_utils["a" /* default */].post(this.endpoints.mergePath, data);
    }
  }, {
    key: 'cancelAutomaticMerge',
    value: function cancelAutomaticMerge() {
      return axios_utils["a" /* default */].post(this.endpoints.cancelAutoMergePath);
    }
  }, {
    key: 'removeWIP',
    value: function removeWIP() {
      return axios_utils["a" /* default */].post(this.endpoints.removeWIPPath);
    }
  }, {
    key: 'removeSourceBranch',
    value: function removeSourceBranch() {
      return axios_utils["a" /* default */].delete(this.endpoints.sourceBranchPath);
    }
  }, {
    key: 'fetchDeployments',
    value: function fetchDeployments() {
      return axios_utils["a" /* default */].get(this.endpoints.ciEnvironmentsStatusPath);
    }
  }, {
    key: 'poll',
    value: function poll() {
      return axios_utils["a" /* default */].get(this.endpoints.statusPath + '?serializer=basic');
    }
  }, {
    key: 'checkStatus',
    value: function checkStatus() {
      return axios_utils["a" /* default */].get(this.endpoints.statusPath + '?serializer=widget');
    }
  }, {
    key: 'fetchMergeActionsContent',
    value: function fetchMergeActionsContent() {
      return axios_utils["a" /* default */].get(this.endpoints.mergeActionsContentPath);
    }
  }, {
    key: 'rebase',
    value: function rebase() {
      return axios_utils["a" /* default */].post(this.endpoints.rebasePath);
    }
  }], [{
    key: 'stopEnvironment',
    value: function stopEnvironment(url) {
      return axios_utils["a" /* default */].post(url);
    }
  }, {
    key: 'fetchMetrics',
    value: function fetchMetrics(metricsUrl) {
      return axios_utils["a" /* default */].get(metricsUrl + '.json');
    }
  }]);

  return MRWidgetService;
}();

/* harmony default export */ var mr_widget_service = (mr_widget_service_MRWidgetService);
// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_memory_usage.js






/* harmony default export */ var mr_widget_memory_usage = ({
  name: 'MemoryUsage',
  props: {
    metricsUrl: {
      type: String,
      required: true
    },
    metricsMonitoringUrl: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      memoryFrom: 0,
      memoryTo: 0,
      memoryMetrics: [],
      deploymentTime: 0,
      hasMetrics: false,
      loadFailed: false,
      loadingMetrics: true,
      backOffRequestCounter: 0
    };
  },

  components: {
    'mr-memory-graph': memory_graph
  },
  computed: {
    shouldShowLoading: function shouldShowLoading() {
      return this.loadingMetrics && !this.hasMetrics && !this.loadFailed;
    },
    shouldShowMemoryGraph: function shouldShowMemoryGraph() {
      return !this.loadingMetrics && this.hasMetrics && !this.loadFailed;
    },
    shouldShowLoadFailure: function shouldShowLoadFailure() {
      return !this.loadingMetrics && !this.hasMetrics && this.loadFailed;
    },
    shouldShowMetricsUnavailable: function shouldShowMetricsUnavailable() {
      return !this.loadingMetrics && !this.hasMetrics && !this.loadFailed;
    },
    memoryChangeType: function memoryChangeType() {
      var memoryTo = Number(this.memoryTo);
      var memoryFrom = Number(this.memoryFrom);

      if (memoryTo > memoryFrom) {
        return 'increased';
      } else if (memoryTo < memoryFrom) {
        return 'decreased';
      }

      return 'unchanged';
    }
  },
  methods: {
    getMegabytes: function getMegabytes(bytesString) {
      var valueInBytes = Number(bytesString).toFixed(2);
      return Object(number_utils["a" /* bytesToMiB */])(valueInBytes).toFixed(2);
    },
    computeGraphData: function computeGraphData(metrics, deploymentTime) {
      this.loadingMetrics = false;
      var memory_before = metrics.memory_before,
          memory_after = metrics.memory_after,
          memory_values = metrics.memory_values;

      // Both `memory_before` and `memory_after` objects
      // have peculiar structure where accessing only a specific
      // index yeilds correct value that we can use to show memory delta.

      if (memory_before.length > 0) {
        this.memoryFrom = this.getMegabytes(memory_before[0].value[1]);
      }

      if (memory_after.length > 0) {
        this.memoryTo = this.getMegabytes(memory_after[0].value[1]);
      }

      if (memory_values.length > 0) {
        this.hasMetrics = true;
        this.memoryMetrics = memory_values[0].values;
        this.deploymentTime = deploymentTime;
      }
    },
    loadMetrics: function loadMetrics() {
      var _this = this;

      Object(common_utils["c" /* backOff */])(function (next, stop) {
        mr_widget_service.fetchMetrics(_this.metricsUrl).then(function (res) {
          if (res.status === http_status["a" /* default */].NO_CONTENT) {
            _this.backOffRequestCounter = _this.backOffRequestCounter += 1;
            /* eslint-disable no-unused-expressions */
            _this.backOffRequestCounter < 3 ? next() : stop(res);
          } else {
            stop(res);
          }
        }).catch(stop);
      }).then(function (res) {
        if (res.status === http_status["a" /* default */].NO_CONTENT) {
          return res;
        }

        return res.data;
      }).then(function (data) {
        _this.computeGraphData(data.metrics, data.deployment_time);
        return data;
      }).catch(function () {
        _this.loadFailed = true;
        _this.loadingMetrics = false;
      });
    }
  },
  mounted: function mounted() {
    this.loadingMetrics = true;
    this.loadMetrics();
  },

  template: '\n    <div class="mr-info-list clearfix mr-memory-usage js-mr-memory-usage">\n      <p\n        v-if="shouldShowLoading"\n        class="usage-info js-usage-info usage-info-loading">\n        <i\n          class="fa fa-spinner fa-spin usage-info-load-spinner"\n          aria-hidden="true" />Loading deployment statistics\n      </p>\n      <p\n        v-if="shouldShowMemoryGraph"\n        class="usage-info js-usage-info">\n        <a :href="metricsMonitoringUrl">Memory</a> usage <b>{{memoryChangeType}}</b> from {{memoryFrom}}MB to {{memoryTo}}MB\n      </p>\n      <p\n        v-if="shouldShowLoadFailure"\n        class="usage-info js-usage-info usage-info-failed">\n        Failed to load deployment statistics\n      </p>\n      <p\n        v-if="shouldShowMetricsUnavailable"\n        class="usage-info js-usage-info usage-info-unavailable">\n        Deployment statistics are not available currently\n      </p>\n      <mr-memory-graph\n        v-if="shouldShowMemoryGraph"\n        :metrics="memoryMetrics"\n        :deploymentTime="deploymentTime"\n        height="25"\n        width="100" />\n    </div>\n  '
});
// EXTERNAL MODULE: ./vue_merge_request_widget/components/mr_widget_status_icon.vue + 2 modules
var mr_widget_status_icon = __webpack_require__("./vue_merge_request_widget/components/mr_widget_status_icon.vue");

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_deployment.js







/* harmony default export */ var mr_widget_deployment = ({
  name: 'MRWidgetDeployment',
  props: {
    mr: { type: Object, required: true },
    service: { type: Object, required: true }
  },
  components: {
    'mr-widget-memory-usage': mr_widget_memory_usage,
    'status-icon': mr_widget_status_icon["a" /* default */]
  },
  methods: {
    formatDate: function formatDate(date) {
      return Object(datetime_utility["f" /* getTimeago */])().format(date);
    },
    hasExternalUrls: function hasExternalUrls() {
      var deployment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return deployment.external_url && deployment.external_url_formatted;
    },
    hasDeploymentTime: function hasDeploymentTime() {
      var deployment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return deployment.deployed_at && deployment.deployed_at_formatted;
    },
    hasDeploymentMeta: function hasDeploymentMeta() {
      var deployment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return deployment.url && deployment.name;
    },
    stopEnvironment: function stopEnvironment(deployment) {
      var msg = 'Are you sure you want to stop this environment?';
      var isConfirmed = confirm(msg); // eslint-disable-line

      if (isConfirmed) {
        mr_widget_service.stopEnvironment(deployment.stop_url).then(function (res) {
          return res.data;
        }).then(function (data) {
          if (data.redirect_url) {
            Object(url_utility["g" /* visitUrl */])(data.redirect_url);
          }
        }).catch(function () {
          new flash["a" /* default */]('Something went wrong while stopping this environment. Please try again.'); // eslint-disable-line
        });
      }
    }
  },
  template: '\n    <div class="mr-widget-heading deploy-heading">\n      <div v-for="deployment in mr.deployments">\n        <div class="ci-widget media">\n          <div class="ci-status-icon ci-status-icon-success">\n            <span class="js-icon-link icon-link">\n              <status-icon status="success" />\n            </span>\n          </div>\n          <div class="media-body space-children">\n            <span>\n              <span\n                v-if="hasDeploymentMeta(deployment)">\n                Deployed to\n              </span>\n              <a\n                v-if="hasDeploymentMeta(deployment)"\n                :href="deployment.url"\n                target="_blank"\n                rel="noopener noreferrer nofollow"\n                class="js-deploy-meta inline">\n                {{deployment.name}}\n              </a>\n              <span\n                v-if="hasExternalUrls(deployment)">\n                on\n              </span>\n              <a\n                v-if="hasExternalUrls(deployment)"\n                :href="deployment.external_url"\n                target="_blank"\n                rel="noopener noreferrer nofollow"\n                class="js-deploy-url inline">\n                <i\n                  class="fa fa-external-link"\n                  aria-hidden="true" />\n                {{deployment.external_url_formatted}}\n              </a>\n              <span\n                v-if="hasDeploymentTime(deployment)"\n                :data-title="deployment.deployed_at_formatted"\n                class="js-deploy-time"\n                data-toggle="tooltip"\n                data-placement="top">\n                {{formatDate(deployment.deployed_at)}}\n              </span>\n            </span>\n            <button\n              type="button"\n              v-if="deployment.stop_url"\n              @click="stopEnvironment(deployment)"\n              class="btn btn-default btn-xs">\n              Stop environment\n            </button>\n            <mr-widget-memory-usage\n              v-if="deployment.metrics_url"\n              :metrics-url="deployment.metrics_url"\n              :metrics-monitoring-url="deployment.metrics_monitoring_url"\n            />\n          </div>\n        </div>\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_maintainer_edit.vue

/* harmony default export */ var mr_widget_maintainer_edit = ({
  name: 'MRWidgetMaintainerEdit',
  props: {
    maintainerEditAllowed: {
      type: Boolean,
      default: false,
      required: false
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c99de5","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_maintainer_edit.vue
var mr_widget_maintainer_edit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mr-info-list mr-links"},[(_vm.maintainerEditAllowed)?_c('p',[_vm._v("\n    "+_vm._s(_vm.s__("mrWidget|Allows edits from maintainers"))+"\n  ")]):_vm._e()])}
var mr_widget_maintainer_edit_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_maintainer_edit.vue
/* script */


/* template */

/* template functional */
var mr_widget_maintainer_edit___vue_template_functional__ = false
/* styles */
var mr_widget_maintainer_edit___vue_styles__ = null
/* scopeId */
var mr_widget_maintainer_edit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_maintainer_edit___vue_module_identifier__ = null

var mr_widget_maintainer_edit_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_maintainer_edit,
  mr_widget_maintainer_edit_render,
  mr_widget_maintainer_edit_staticRenderFns,
  mr_widget_maintainer_edit___vue_template_functional__,
  mr_widget_maintainer_edit___vue_styles__,
  mr_widget_maintainer_edit___vue_scopeId__,
  mr_widget_maintainer_edit___vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_maintainer_edit = (mr_widget_maintainer_edit_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_related_links.vue



/* harmony default export */ var mr_widget_related_links = ({
  name: 'MRWidgetRelatedLinks',
  props: {
    relatedLinks: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    state: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    closesText: function closesText() {
      if (this.state === 'merged') {
        return Object(locale["e" /* s__ */])('mrWidget|Closed');
      }
      if (this.state === 'closed') {
        return Object(locale["e" /* s__ */])('mrWidget|Did not close');
      }
      return Object(locale["e" /* s__ */])('mrWidget|Closes');
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf14ab0","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_related_links.vue
var mr_widget_related_links_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mr-info-list mr-links"},[(_vm.relatedLinks.closing)?_c('p',[_vm._v("\n    "+_vm._s(_vm.closesText)+" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.relatedLinks.closing)}})]):_vm._e(),_vm._v(" "),(_vm.relatedLinks.mentioned)?_c('p',[_vm._v("\n    "+_vm._s(_vm.s__("mrWidget|Mentions"))+" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.relatedLinks.mentioned)}})]):_vm._e(),_vm._v(" "),(_vm.relatedLinks.assignToMe)?_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.relatedLinks.assignToMe)}})]):_vm._e()])}
var mr_widget_related_links_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_related_links.vue
/* script */


/* template */

/* template functional */
var mr_widget_related_links___vue_template_functional__ = false
/* styles */
var mr_widget_related_links___vue_styles__ = null
/* scopeId */
var mr_widget_related_links___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_related_links___vue_module_identifier__ = null

var mr_widget_related_links_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_related_links,
  mr_widget_related_links_render,
  mr_widget_related_links_staticRenderFns,
  mr_widget_related_links___vue_template_functional__,
  mr_widget_related_links___vue_styles__,
  mr_widget_related_links___vue_scopeId__,
  mr_widget_related_links___vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_related_links = (mr_widget_related_links_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_author.vue



/* harmony default export */ var mr_widget_author = ({
  name: 'MRWidgetAuthor',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    author: {
      type: Object,
      required: true
    },
    showAuthorName: {
      type: Boolean,
      required: false,
      default: true
    },
    showAuthorTooltip: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    authorUrl: function authorUrl() {
      return this.author.webUrl || this.author.web_url;
    },
    avatarUrl: function avatarUrl() {
      return this.author.avatarUrl || this.author.avatar_url;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fe1caf0","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_author.vue
var mr_widget_author_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"author-link inline",attrs:{"href":_vm.authorUrl,"v-tooltip":_vm.showAuthorTooltip,"title":_vm.author.name}},[_c('img',{staticClass:"avatar avatar-inline s16",attrs:{"src":_vm.avatarUrl}}),_vm._v(" "),(_vm.showAuthorName)?_c('span',{staticClass:"author"},[_vm._v("\n    "+_vm._s(_vm.author.name)+"\n  ")]):_vm._e()])}
var mr_widget_author_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_author.vue
/* script */


/* template */

/* template functional */
var mr_widget_author___vue_template_functional__ = false
/* styles */
var mr_widget_author___vue_styles__ = null
/* scopeId */
var mr_widget_author___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_author___vue_module_identifier__ = null

var mr_widget_author_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_author,
  mr_widget_author_render,
  mr_widget_author_staticRenderFns,
  mr_widget_author___vue_template_functional__,
  mr_widget_author___vue_styles__,
  mr_widget_author___vue_scopeId__,
  mr_widget_author___vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_author = (mr_widget_author_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_author_time.vue



/* harmony default export */ var mr_widget_author_time = ({
  name: 'MRWidgetAuthorTime',
  components: {
    mrWidgetAuthor: components_mr_widget_author
  },
  props: {
    actionText: {
      type: String,
      required: true
    },
    author: {
      type: Object,
      required: true
    },
    dateTitle: {
      type: String,
      required: true
    },
    dateReadable: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-658e77d0","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_author_time.vue
var mr_widget_author_time_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"js-mr-widget-author"},[_vm._v("\n  "+_vm._s(_vm.actionText)+"\n  "),_c('mr-widget-author',{attrs:{"author":_vm.author}}),_vm._v(" "),_c('time',{attrs:{"title":_vm.dateTitle,"data-toggle":"tooltip","data-placement":"top","data-container":"body"}},[_vm._v("\n    "+_vm._s(_vm.dateReadable)+"\n  ")])],1)}
var mr_widget_author_time_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_author_time.vue
/* script */


/* template */

/* template functional */
var mr_widget_author_time___vue_template_functional__ = false
/* styles */
var mr_widget_author_time___vue_styles__ = null
/* scopeId */
var mr_widget_author_time___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_author_time___vue_module_identifier__ = null

var mr_widget_author_time_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_author_time,
  mr_widget_author_time_render,
  mr_widget_author_time_staticRenderFns,
  mr_widget_author_time___vue_template_functional__,
  mr_widget_author_time___vue_styles__,
  mr_widget_author_time___vue_scopeId__,
  mr_widget_author_time___vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_author_time = (mr_widget_author_time_Component.exports);

// EXTERNAL MODULE: ./vue_merge_request_widget/event_hub.js
var event_hub = __webpack_require__("./vue_merge_request_widget/event_hub.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_merged.vue









/* harmony default export */ var mr_widget_merged = ({
  name: 'MRWidgetMerged',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    mrWidgetAuthorTime: components_mr_widget_author_time,
    loadingIcon: loading_icon["a" /* default */],
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    service: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isMakingRequest: false
    };
  },

  computed: {
    shouldShowRemoveSourceBranch: function shouldShowRemoveSourceBranch() {
      var _mr = this.mr,
          sourceBranchRemoved = _mr.sourceBranchRemoved,
          isRemovingSourceBranch = _mr.isRemovingSourceBranch,
          canRemoveSourceBranch = _mr.canRemoveSourceBranch;


      return !sourceBranchRemoved && canRemoveSourceBranch && !this.isMakingRequest && !isRemovingSourceBranch;
    },
    shouldShowSourceBranchRemoving: function shouldShowSourceBranchRemoving() {
      var _mr2 = this.mr,
          sourceBranchRemoved = _mr2.sourceBranchRemoved,
          isRemovingSourceBranch = _mr2.isRemovingSourceBranch;

      return !sourceBranchRemoved && (isRemovingSourceBranch || this.isMakingRequest);
    },
    shouldShowMergedButtons: function shouldShowMergedButtons() {
      var _mr3 = this.mr,
          canRevertInCurrentMR = _mr3.canRevertInCurrentMR,
          canCherryPickInCurrentMR = _mr3.canCherryPickInCurrentMR,
          revertInForkPath = _mr3.revertInForkPath,
          cherryPickInForkPath = _mr3.cherryPickInForkPath;


      return canRevertInCurrentMR || canCherryPickInCurrentMR || revertInForkPath || cherryPickInForkPath;
    },
    revertTitle: function revertTitle() {
      return Object(locale["e" /* s__ */])('mrWidget|Revert this merge request in a new merge request');
    },
    cherryPickTitle: function cherryPickTitle() {
      return Object(locale["e" /* s__ */])('mrWidget|Cherry-pick this merge request in a new merge request');
    },
    revertLabel: function revertLabel() {
      return Object(locale["e" /* s__ */])('mrWidget|Revert');
    },
    cherryPickLabel: function cherryPickLabel() {
      return Object(locale["e" /* s__ */])('mrWidget|Cherry-pick');
    }
  },
  methods: {
    removeSourceBranch: function removeSourceBranch() {
      var _this = this;

      this.isMakingRequest = true;

      this.service.removeSourceBranch().then(function (res) {
        return res.data;
      }).then(function (data) {
        if (data.message === 'Branch was removed') {
          event_hub["a" /* default */].$emit('MRWidgetUpdateRequested', function () {
            _this.isMakingRequest = false;
          });
        }
      }).catch(function () {
        _this.isMakingRequest = false;
        Object(flash["a" /* default */])(Object(locale["a" /* __ */])('Something went wrong. Please try again.'));
      });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-747e4197","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_merged.vue
var mr_widget_merged_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"success"}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('div',{staticClass:"space-children"},[_c('mr-widget-author-time',{attrs:{"action-text":_vm.s__('mrWidget|Merged by'),"author":_vm.mr.metrics.mergedBy,"date-title":_vm.mr.metrics.mergedAt,"date-readable":_vm.mr.metrics.readableMergedAt}}),_vm._v(" "),(_vm.mr.canRevertInCurrentMR)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn btn-close btn-xs",attrs:{"href":"#modal-revert-commit","data-toggle":"modal","data-container":"body","title":_vm.revertTitle}},[_vm._v("\n        "+_vm._s(_vm.revertLabel)+"\n      ")]):(_vm.mr.revertInForkPath)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn btn-close btn-xs",attrs:{"data-method":"post","href":_vm.mr.revertInForkPath,"title":_vm.revertTitle}},[_vm._v("\n        "+_vm._s(_vm.revertLabel)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.mr.canCherryPickInCurrentMR)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn btn-default btn-xs",attrs:{"href":"#modal-cherry-pick-commit","data-toggle":"modal","data-container":"body","title":_vm.cherryPickTitle}},[_vm._v("\n        "+_vm._s(_vm.cherryPickLabel)+"\n      ")]):(_vm.mr.cherryPickInForkPath)?_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn btn-default btn-xs",attrs:{"data-method":"post","href":_vm.mr.cherryPickInForkPath,"title":_vm.cherryPickTitle}},[_vm._v("\n        "+_vm._s(_vm.cherryPickLabel)+"\n      ")]):_vm._e()],1),_vm._v(" "),_c('section',{staticClass:"mr-info-list"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|The changes were merged into"))+"\n        "),_c('span',{staticClass:"label-branch"},[_c('a',{attrs:{"href":_vm.mr.targetBranchPath}},[_vm._v(_vm._s(_vm.mr.targetBranch))])])]),_vm._v(" "),(_vm.mr.sourceBranchRemoved)?_c('p',[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|The source branch has been removed"))+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.shouldShowRemoveSourceBranch)?_c('p',{staticClass:"space-children"},[_c('span',[_vm._v(_vm._s(_vm.s__("mrWidget|You can remove source branch now")))]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-default js-remove-branch-button",attrs:{"disabled":_vm.isMakingRequest,"type":"button"},on:{"click":_vm.removeSourceBranch}},[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|Remove Source Branch"))+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.shouldShowSourceBranchRemoving)?_c('p',[_c('loading-icon',{attrs:{"inline":true}}),_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|The source branch is being removed"))+"\n        ")])],1):_vm._e()])])],1)}
var mr_widget_merged_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_merged.vue
/* script */


/* template */

/* template functional */
var mr_widget_merged___vue_template_functional__ = false
/* styles */
var mr_widget_merged___vue_styles__ = null
/* scopeId */
var mr_widget_merged___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_merged___vue_module_identifier__ = null

var mr_widget_merged_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_merged,
  mr_widget_merged_render,
  mr_widget_merged_staticRenderFns,
  mr_widget_merged___vue_template_functional__,
  mr_widget_merged___vue_styles__,
  mr_widget_merged___vue_scopeId__,
  mr_widget_merged___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_merged = (mr_widget_merged_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_failed_to_merge.vue





/* harmony default export */ var mr_widget_failed_to_merge = ({
  name: 'MRWidgetFailedToMerge',

  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },

  props: {
    mr: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },

  data: function data() {
    return {
      timer: 10,
      isRefreshing: false
    };
  },


  computed: {
    timerText: function timerText() {
      return Object(locale["d" /* n__ */])('Refreshing in a second to show the updated status...', 'Refreshing in %d seconds to show the updated status...', this.timer);
    }
  },

  mounted: function mounted() {
    var _this = this;

    setInterval(function () {
      _this.updateTimer();
    }, 1000);
  },
  created: function created() {
    event_hub["a" /* default */].$emit('DisablePolling');
  },


  methods: {
    refresh: function refresh() {
      this.isRefreshing = true;
      event_hub["a" /* default */].$emit('MRWidgetUpdateRequested');
      event_hub["a" /* default */].$emit('EnablePolling');
    },
    updateTimer: function updateTimer() {
      this.timer = this.timer - 1;

      if (this.timer === 0) {
        this.refresh();
      }
    }
  }

});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4338048a","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_failed_to_merge.vue
var mr_widget_failed_to_merge_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[(_vm.isRefreshing)?[_c('status-icon',{attrs:{"status":"loading"}}),_vm._v(" "),_c('span',{staticClass:"media-body bold js-refresh-label"},[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|Refreshing now"))+"\n    ")])]:[_c('status-icon',{attrs:{"status":"warning","show-disabled-button":true}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold"},[(_vm.mr.mergeError)?_c('span',{staticClass:"has-error-message"},[_vm._v("\n          "+_vm._s(_vm.mr.mergeError)+".\n        ")]):_c('span',[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|Merge failed."))+"\n        ")]),_vm._v(" "),_c('span',{class:{ 'has-custom-error': _vm.mr.mergeError }},[_vm._v("\n          "+_vm._s(_vm.timerText)+"\n        ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-xs js-refresh-button",attrs:{"type":"button"},on:{"click":_vm.refresh}},[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|Refresh now"))+"\n      ")])])]],2)}
var mr_widget_failed_to_merge_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_failed_to_merge.vue
/* script */


/* template */

/* template functional */
var mr_widget_failed_to_merge___vue_template_functional__ = false
/* styles */
var mr_widget_failed_to_merge___vue_styles__ = null
/* scopeId */
var mr_widget_failed_to_merge___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_failed_to_merge___vue_module_identifier__ = null

var mr_widget_failed_to_merge_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_failed_to_merge,
  mr_widget_failed_to_merge_render,
  mr_widget_failed_to_merge_staticRenderFns,
  mr_widget_failed_to_merge___vue_template_functional__,
  mr_widget_failed_to_merge___vue_styles__,
  mr_widget_failed_to_merge___vue_scopeId__,
  mr_widget_failed_to_merge___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_failed_to_merge = (mr_widget_failed_to_merge_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_closed.vue




/* harmony default export */ var mr_widget_closed = ({
  name: 'MRWidgetClosed',
  components: {
    mrWidgetAuthorTime: components_mr_widget_author_time,
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  props: {
    /* TODO: This is providing all store and service down when it
    only needs metrics and targetBranch */
    mr: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-712ee8d3","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_closed.vue
var mr_widget_closed_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"warning"}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('mr-widget-author-time',{attrs:{"action-text":_vm.s__('mrWidget|Closed by'),"author":_vm.mr.metrics.closedBy,"date-title":_vm.mr.metrics.closedAt,"date-readable":_vm.mr.metrics.readableClosedAt}}),_vm._v(" "),_c('section',{staticClass:"mr-info-list"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|The changes were not merged into"))+"\n        "),_c('a',{staticClass:"label-branch",attrs:{"href":_vm.mr.targetBranchPath}},[_vm._v("\n          "+_vm._s(_vm.mr.targetBranch)+"\n        ")])])])],1)],1)}
var mr_widget_closed_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_closed.vue
/* script */


/* template */

/* template functional */
var mr_widget_closed___vue_template_functional__ = false
/* styles */
var mr_widget_closed___vue_styles__ = null
/* scopeId */
var mr_widget_closed___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_closed___vue_module_identifier__ = null

var mr_widget_closed_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_closed,
  mr_widget_closed_render,
  mr_widget_closed_staticRenderFns,
  mr_widget_closed___vue_template_functional__,
  mr_widget_closed___vue_styles__,
  mr_widget_closed___vue_scopeId__,
  mr_widget_closed___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_closed = (mr_widget_closed_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_merging.vue



/* harmony default export */ var mr_widget_merging = ({
  name: 'MRWidgetMerging',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef7b084","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_merging.vue
var mr_widget_merging_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body mr-state-locked media"},[_c('status-icon',{attrs:{"status":"loading"}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h4',[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|This merge request is in the process of being merged"))+"\n    ")]),_vm._v(" "),_c('section',{staticClass:"mr-info-list"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|The changes will be merged into"))+"\n        "),_c('span',{staticClass:"label-branch"},[_c('a',{attrs:{"href":_vm.mr.targetBranchPath}},[_vm._v(_vm._s(_vm.mr.targetBranch))])])])])])],1)}
var mr_widget_merging_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_merging.vue
/* script */


/* template */

/* template functional */
var mr_widget_merging___vue_template_functional__ = false
/* styles */
var mr_widget_merging___vue_styles__ = null
/* scopeId */
var mr_widget_merging___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_merging___vue_module_identifier__ = null

var mr_widget_merging_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_merging,
  mr_widget_merging_render,
  mr_widget_merging_staticRenderFns,
  mr_widget_merging___vue_template_functional__,
  mr_widget_merging___vue_styles__,
  mr_widget_merging___vue_scopeId__,
  mr_widget_merging___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_merging = (mr_widget_merging_Component.exports);

// EXTERNAL MODULE: ./vue_merge_request_widget/components/states/mr_widget_wip.js
var mr_widget_wip = __webpack_require__("./vue_merge_request_widget/components/states/mr_widget_wip.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_archived.vue



/* harmony default export */ var mr_widget_archived = ({
  name: 'MRWidgetArchived',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f098ac0c","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_archived.vue
var mr_widget_archived_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('div',{staticClass:"space-children"},[_c('status-icon',{attrs:{"status":"warning"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"button","disabled":"true"}},[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|Merge"))+"\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('span',{staticClass:"bold"},[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|This project is archived, write access has been disabled"))+"\n    ")])])])}
var mr_widget_archived_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_archived.vue
/* script */


/* template */

/* template functional */
var mr_widget_archived___vue_template_functional__ = false
/* styles */
var mr_widget_archived___vue_styles__ = null
/* scopeId */
var mr_widget_archived___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_archived___vue_module_identifier__ = null

var mr_widget_archived_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_archived,
  mr_widget_archived_render,
  mr_widget_archived_staticRenderFns,
  mr_widget_archived___vue_template_functional__,
  mr_widget_archived___vue_styles__,
  mr_widget_archived___vue_scopeId__,
  mr_widget_archived___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_archived = (mr_widget_archived_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_conflicts.vue



/* harmony default export */ var mr_widget_conflicts = ({
  name: 'MRWidgetConflicts',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  props: {
    /* TODO: This is providing all store and service down when it
    only needs a few props */
    mr: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b353dce6","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_conflicts.vue
var mr_widget_conflicts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"warning","show-disabled-button":true}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[(_vm.mr.shouldBeRebased)?_c('span',{staticClass:"bold"},[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|Fast-forward merge is not possible.\nTo merge this request, first rebase locally."))+"\n      ")]):[_c('span',{staticClass:"bold"},[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|There are merge conflicts"))),(!_vm.mr.canMerge)?_c('span',[_vm._v(".")]):_vm._e(),_vm._v(" "),(!_vm.mr.canMerge)?_c('span',[_vm._v("\n            "+_vm._s(_vm.s__("mrWidget|Resolve these conflicts or ask someone\n            with write access to this repository to merge it locally"))+"\n          ")]):_vm._e()]),_vm._v(" "),(_vm.mr.canMerge && _vm.mr.conflictResolutionPath)?_c('a',{staticClass:"js-resolve-conflicts-button btn btn-default btn-xs",attrs:{"href":_vm.mr.conflictResolutionPath}},[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|Resolve conflicts"))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.mr.canMerge)?_c('button',{staticClass:"js-merge-locally-button btn btn-default btn-xs",attrs:{"data-toggle":"modal","data-target":"#modal_merge_info"}},[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|Merge locally"))+"\n        ")]):_vm._e()]],2)],1)}
var mr_widget_conflicts_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_conflicts.vue
/* script */


/* template */

/* template functional */
var mr_widget_conflicts___vue_template_functional__ = false
/* styles */
var mr_widget_conflicts___vue_styles__ = null
/* scopeId */
var mr_widget_conflicts___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_conflicts___vue_module_identifier__ = null

var mr_widget_conflicts_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_conflicts,
  mr_widget_conflicts_render,
  mr_widget_conflicts_staticRenderFns,
  mr_widget_conflicts___vue_template_functional__,
  mr_widget_conflicts___vue_styles__,
  mr_widget_conflicts___vue_scopeId__,
  mr_widget_conflicts___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_conflicts = (mr_widget_conflicts_Component.exports);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/app/views/shared/icons/_mr_widget_empty_state.svg
var _mr_widget_empty_state = __webpack_require__("../../views/shared/icons/_mr_widget_empty_state.svg");
var _mr_widget_empty_state_default = /*#__PURE__*/__webpack_require__.n(_mr_widget_empty_state);

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_nothing_to_merge.js


/* harmony default export */ var mr_widget_nothing_to_merge = ({
  name: 'MRWidgetNothingToMerge',
  props: {
    mr: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return { emptyStateSVG: _mr_widget_empty_state_default.a };
  },

  template: '\n    <div class="mr-widget-body mr-widget-empty-state">\n      <div class="row">\n        <div class="artwork col-sm-5 col-sm-push-7 col-xs-12 text-center">\n          <span v-html="emptyStateSVG"></span>\n        </div>\n        <div class="text col-sm-7 col-sm-pull-5 col-xs-12">\n          <span>\n            Merge requests are a place to propose changes you have made to a project\n            and discuss those changes with others.\n          </span>\n          <p>\n            Interested parties can even contribute by pushing commits if they want to.\n          </p>\n          <p>\n            Currently there are no changes in this merge request\'s source branch.\n            Please push new commits or use a different branch.\n          </p>\n          <div>\n            <a\n              v-if="mr.newBlobPath"\n              :href="mr.newBlobPath"\n              class="btn btn-inverted btn-save">\n              Create file\n            </a>\n          </div>\n        </div>\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_missing_branch.vue






/* harmony default export */ var mr_widget_missing_branch = ({
  name: 'MRWidgetMissingBranch',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    mrWidgetMergeHelp: components_mr_widget_merge_help,
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true
    }
  },
  computed: {
    missingBranchName: function missingBranchName() {
      return this.mr.sourceBranchRemoved ? 'source' : 'target';
    },
    missingBranchNameMessage: function missingBranchNameMessage() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('mrWidget| Please restore it or use a different %{missingBranchName} branch'), {
        missingBranchName: this.missingBranchName
      });
    },
    message: function message() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('mrWidget|If the %{missingBranchName} branch exists in your local repository, you can merge this merge request manually using the command line'), {
        missingBranchName: this.missingBranchName
      });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b14d3ffe","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_missing_branch.vue
var mr_widget_missing_branch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"warning","show-disabled-button":true}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold js-branch-text"},[_c('span',{staticClass:"capitalize"},[_vm._v("\n        "+_vm._s(_vm.missingBranchName)+"\n      ")]),_vm._v(" "+_vm._s(_vm.s__("mrWidget|branch does not exist."))+"\n      "+_vm._s(_vm.missingBranchNameMessage)+"\n      "),_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"fa fa-question-circle",attrs:{"title":_vm.message,"aria-label":_vm.message}})])])],1)}
var mr_widget_missing_branch_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_missing_branch.vue
/* script */


/* template */

/* template functional */
var mr_widget_missing_branch___vue_template_functional__ = false
/* styles */
var mr_widget_missing_branch___vue_styles__ = null
/* scopeId */
var mr_widget_missing_branch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_missing_branch___vue_module_identifier__ = null

var mr_widget_missing_branch_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_missing_branch,
  mr_widget_missing_branch_render,
  mr_widget_missing_branch_staticRenderFns,
  mr_widget_missing_branch___vue_template_functional__,
  mr_widget_missing_branch___vue_styles__,
  mr_widget_missing_branch___vue_scopeId__,
  mr_widget_missing_branch___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_missing_branch = (mr_widget_missing_branch_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_not_allowed.vue



/* harmony default export */ var mr_widget_not_allowed = ({
  name: 'MRWidgetNotAllowed',
  components: {
    StatusIcon: mr_widget_status_icon["a" /* default */]
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e831fe","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_not_allowed.vue
var mr_widget_not_allowed_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"success","show-disabled-button":true}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold"},[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|Ready to be merged automatically.\nAsk someone with write access to this repository to merge this request"))+"\n      ")])])],1)}
var mr_widget_not_allowed_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_not_allowed.vue
/* script */


/* template */

/* template functional */
var mr_widget_not_allowed___vue_template_functional__ = false
/* styles */
var mr_widget_not_allowed___vue_styles__ = null
/* scopeId */
var mr_widget_not_allowed___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_not_allowed___vue_module_identifier__ = null

var mr_widget_not_allowed_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_not_allowed,
  mr_widget_not_allowed_render,
  mr_widget_not_allowed_staticRenderFns,
  mr_widget_not_allowed___vue_template_functional__,
  mr_widget_not_allowed___vue_styles__,
  mr_widget_not_allowed___vue_scopeId__,
  mr_widget_not_allowed___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_not_allowed = (mr_widget_not_allowed_Component.exports);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/app/views/shared/icons/_icon_status_success.svg
var _icon_status_success = __webpack_require__("../../views/shared/icons/_icon_status_success.svg");
var _icon_status_success_default = /*#__PURE__*/__webpack_require__.n(_icon_status_success);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/app/views/shared/icons/_icon_status_warning.svg
var _icon_status_warning = __webpack_require__("../../views/shared/icons/_icon_status_warning.svg");
var _icon_status_warning_default = /*#__PURE__*/__webpack_require__.n(_icon_status_warning);

// CONCATENATED MODULE: ./lib/utils/simple_poll.js
/* harmony default export */ var simple_poll = (function (fn) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60000;

  var startTime = Date.now();

  return new Promise(function (resolve, reject) {
    var stop = function stop(arg) {
      return arg instanceof Error ? reject(arg) : resolve(arg);
    };
    var next = function next() {
      if (Date.now() - startTime < timeout) {
        setTimeout(fn.bind(null, next, stop), interval);
      } else {
        reject(new Error('SIMPLE_POLL_TIMEOUT'));
      }
    };
    fn(next, stop);
  });
});
// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_ready_to_merge.js








/* harmony default export */ var mr_widget_ready_to_merge = ({
  name: 'MRWidgetReadyToMerge',
  props: {
    mr: { type: Object, required: true },
    service: { type: Object, required: true }
  },
  data: function data() {
    return {
      removeSourceBranch: this.mr.shouldRemoveSourceBranch,
      mergeWhenBuildSucceeds: false,
      useCommitMessageWithDescription: false,
      setToMergeWhenPipelineSucceeds: false,
      showCommitMessageEditor: false,
      isMakingRequest: false,
      isMergingImmediately: false,
      commitMessage: this.mr.commitMessage,
      successSvg: _icon_status_success_default.a,
      warningSvg: _icon_status_warning_default.a
    };
  },

  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  computed: {
    shouldShowMergeWhenPipelineSucceedsText: function shouldShowMergeWhenPipelineSucceedsText() {
      return this.mr.isPipelineActive;
    },
    commitMessageLinkTitle: function commitMessageLinkTitle() {
      var withDesc = 'Include description in commit message';
      var withoutDesc = "Don't include description in commit message";

      return this.useCommitMessageWithDescription ? withoutDesc : withDesc;
    },
    status: function status() {
      var _mr = this.mr,
          pipeline = _mr.pipeline,
          isPipelineActive = _mr.isPipelineActive,
          isPipelineFailed = _mr.isPipelineFailed,
          hasCI = _mr.hasCI,
          ciStatus = _mr.ciStatus;


      if (hasCI && !ciStatus) {
        return 'failed';
      } else if (!pipeline) {
        return 'success';
      } else if (isPipelineActive) {
        return 'pending';
      } else if (isPipelineFailed) {
        return 'failed';
      }

      return 'success';
    },
    mergeButtonClass: function mergeButtonClass() {
      var defaultClass = 'btn btn-sm btn-success accept-merge-request';
      var failedClass = defaultClass + ' btn-danger';
      var inActionClass = defaultClass + ' btn-info';

      if (this.status === 'failed') {
        return failedClass;
      } else if (this.status === 'pending') {
        return inActionClass;
      }

      return defaultClass;
    },
    iconClass: function iconClass() {
      if (this.status === 'failed' || !this.commitMessage.length || !this.mr.isMergeAllowed || this.mr.preventMerge) {
        return 'warning';
      }
      return 'success';
    },
    mergeButtonText: function mergeButtonText() {
      if (this.isMergingImmediately) {
        return 'Merge in progress';
      } else if (this.shouldShowMergeWhenPipelineSucceedsText) {
        return 'Merge when pipeline succeeds';
      }

      return 'Merge';
    },
    shouldShowMergeOptionsDropdown: function shouldShowMergeOptionsDropdown() {
      return this.mr.isPipelineActive && !this.mr.onlyAllowMergeIfPipelineSucceeds;
    },
    isMergeButtonDisabled: function isMergeButtonDisabled() {
      var commitMessage = this.commitMessage;

      return Boolean(!commitMessage.length || !this.shouldShowMergeControls() || this.isMakingRequest || this.isApprovalNeeded || this.mr.preventMerge);
    },
    isRemoveSourceBranchButtonDisabled: function isRemoveSourceBranchButtonDisabled() {
      return this.isMergeButtonDisabled || !this.mr.canRemoveSourceBranch;
    },
    shouldShowSquashBeforeMerge: function shouldShowSquashBeforeMerge() {
      var _mr2 = this.mr,
          commitsCount = _mr2.commitsCount,
          enableSquashBeforeMerge = _mr2.enableSquashBeforeMerge;

      return enableSquashBeforeMerge && commitsCount > 1;
    },
    isApprovalNeeded: function isApprovalNeeded() {
      return this.mr.approvalsRequired ? !this.mr.isApproved : false;
    }
  },
  methods: {
    shouldShowMergeControls: function shouldShowMergeControls() {
      return this.mr.isMergeAllowed || this.shouldShowMergeWhenPipelineSucceedsText;
    },
    updateCommitMessage: function updateCommitMessage() {
      var cmwd = this.mr.commitMessageWithDescription;
      this.useCommitMessageWithDescription = !this.useCommitMessageWithDescription;
      this.commitMessage = this.useCommitMessageWithDescription ? cmwd : this.mr.commitMessage;
    },
    toggleCommitMessageEditor: function toggleCommitMessageEditor() {
      this.showCommitMessageEditor = !this.showCommitMessageEditor;
    },
    handleMergeButtonClick: function handleMergeButtonClick(mergeWhenBuildSucceeds, mergeImmediately) {
      var _this = this;

      // TODO: Remove no-param-reassign
      if (mergeWhenBuildSucceeds === undefined) {
        mergeWhenBuildSucceeds = this.mr.isPipelineActive; // eslint-disable-line no-param-reassign
      } else if (mergeImmediately) {
        this.isMergingImmediately = true;
      }

      this.setToMergeWhenPipelineSucceeds = mergeWhenBuildSucceeds === true;

      var options = {
        sha: this.mr.sha,
        commit_message: this.commitMessage,
        merge_when_pipeline_succeeds: this.setToMergeWhenPipelineSucceeds,
        should_remove_source_branch: this.removeSourceBranch === true
      };

      // Only truthy in EE extension of this component
      if (this.setAdditionalParams) {
        this.setAdditionalParams(options);
      }

      this.isMakingRequest = true;
      this.service.merge(options).then(function (res) {
        return res.data;
      }).then(function (data) {
        var hasError = data.status === 'failed' || data.status === 'hook_validation_error';

        if (data.status === 'merge_when_pipeline_succeeds') {
          event_hub["a" /* default */].$emit('MRWidgetUpdateRequested');
        } else if (data.status === 'success') {
          _this.initiateMergePolling();
        } else if (hasError) {
          event_hub["a" /* default */].$emit('FailedToMerge', data.merge_error);
        }
      }).catch(function () {
        _this.isMakingRequest = false;
        new flash["a" /* default */]('Something went wrong. Please try again.'); // eslint-disable-line
      });
    },
    initiateMergePolling: function initiateMergePolling() {
      var _this2 = this;

      simple_poll(function (continuePolling, stopPolling) {
        _this2.handleMergePolling(continuePolling, stopPolling);
      });
    },
    handleMergePolling: function handleMergePolling(continuePolling, stopPolling) {
      var _this3 = this;

      this.service.poll().then(function (res) {
        return res.data;
      }).then(function (data) {
        if (data.state === 'merged') {
          // If state is merged we should update the widget and stop the polling
          event_hub["a" /* default */].$emit('MRWidgetUpdateRequested');
          event_hub["a" /* default */].$emit('FetchActionsContent');
          merge_request["a" /* default */].setStatusBoxToMerged();
          merge_request["a" /* default */].hideCloseButton();
          merge_request["a" /* default */].decreaseCounter();
          stopPolling();

          // If user checked remove source branch and we didn't remove the branch yet
          // we should start another polling for source branch remove process
          if (_this3.removeSourceBranch && data.source_branch_exists) {
            _this3.initiateRemoveSourceBranchPolling();
          }
        } else if (data.merge_error) {
          event_hub["a" /* default */].$emit('FailedToMerge', data.merge_error);
          stopPolling();
        } else {
          // MR is not merged yet, continue polling until the state becomes 'merged'
          continuePolling();
        }
      }).catch(function () {
        new flash["a" /* default */]('Something went wrong while merging this merge request. Please try again.'); // eslint-disable-line
      });
    },
    initiateRemoveSourceBranchPolling: function initiateRemoveSourceBranchPolling() {
      var _this4 = this;

      // We need to show source branch is being removed spinner in another component
      event_hub["a" /* default */].$emit('SetBranchRemoveFlag', [true]);

      simple_poll(function (continuePolling, stopPolling) {
        _this4.handleRemoveBranchPolling(continuePolling, stopPolling);
      });
    },
    handleRemoveBranchPolling: function handleRemoveBranchPolling(continuePolling, stopPolling) {
      this.service.poll().then(function (res) {
        return res.data;
      }).then(function (data) {
        // If source branch exists then we should continue polling
        // because removing a source branch is a background task and takes time
        if (data.source_branch_exists) {
          continuePolling();
        } else {
          // Branch is removed. Update widget, stop polling and hide the spinner
          event_hub["a" /* default */].$emit('MRWidgetUpdateRequested', function () {
            event_hub["a" /* default */].$emit('SetBranchRemoveFlag', [false]);
          });
          stopPolling();
        }
      }).catch(function () {
        new flash["a" /* default */]('Something went wrong while removing the source branch. Please try again.'); // eslint-disable-line
      });
    }
  },
  template: '\n    <div class="mr-widget-body media">\n      <status-icon :status="iconClass" />\n      <div class="media-body">\n        <div class="mr-widget-body-controls media space-children">\n          <span class="btn-group append-bottom-5">\n            <button\n              @click="handleMergeButtonClick()"\n              :disabled="isMergeButtonDisabled"\n              :class="mergeButtonClass"\n              type="button"\n              class="qa-merge-button">\n              <i\n                v-if="isMakingRequest"\n                class="fa fa-spinner fa-spin"\n                aria-hidden="true" />\n              {{mergeButtonText}}\n            </button>\n            <button\n              v-if="shouldShowMergeOptionsDropdown"\n              :disabled="isMergeButtonDisabled"\n              type="button"\n              class="btn btn-sm btn-info dropdown-toggle js-merge-moment"\n              data-toggle="dropdown"\n              aria-label="Select merge moment">\n              <i\n                class="fa fa-chevron-down"\n                aria-hidden="true" />\n            </button>\n            <ul\n              v-if="shouldShowMergeOptionsDropdown"\n              class="dropdown-menu dropdown-menu-right"\n              role="menu">\n              <li>\n                <a\n                  @click.prevent="handleMergeButtonClick(true)"\n                  class="merge_when_pipeline_succeeds"\n                  href="#">\n                  <span class="media">\n                    <span\n                      v-html="successSvg"\n                      class="merge-opt-icon"\n                      aria-hidden="true"></span>\n                    <span class="media-body merge-opt-title">Merge when pipeline succeeds</span>\n                  </span>\n                </a>\n              </li>\n              <li>\n                <a\n                  @click.prevent="handleMergeButtonClick(false, true)"\n                  class="accept-merge-request"\n                  href="#">\n                  <span class="media">\n                    <span\n                      v-html="warningSvg"\n                      class="merge-opt-icon"\n                      aria-hidden="true"></span>\n                    <span class="media-body merge-opt-title">Merge immediately</span>\n                  </span>\n                </a>\n              </li>\n            </ul>\n          </span>\n          <div class="media-body-wrap space-children">\n            <template v-if="shouldShowMergeControls()">\n              <label>\n                <input\n                  id="remove-source-branch-input"\n                  v-model="removeSourceBranch"\n                  class="js-remove-source-branch-checkbox"\n                  :disabled="isRemoveSourceBranchButtonDisabled"\n                  type="checkbox"/> Remove source branch\n              </label>\n\n              <!-- Placeholder for EE extension of this component -->\n              <squash-before-merge\n                v-if="shouldShowSquashBeforeMerge"\n                :mr="mr"\n                :is-merge-button-disabled="isMergeButtonDisabled" />\n\n              <span\n                v-if="mr.ffOnlyEnabled"\n                class="js-fast-forward-message">\n                Fast-forward merge without a merge commit\n              </span>\n              <button\n                v-else\n                @click="toggleCommitMessageEditor"\n                :disabled="isMergeButtonDisabled"\n                class="js-modify-commit-message-button btn btn-default btn-xs"\n                type="button">\n                Modify commit message\n              </button>\n            </template>\n            <template v-else>\n              <span class="bold js-resolve-mr-widget-items-message">\n                You can only merge once the items above are resolved\n              </span>\n            </template>\n          </div>\n        </div>\n        <div\n          v-if="showCommitMessageEditor"\n          class="prepend-top-default commit-message-editor">\n          <div class="form-group clearfix">\n            <label\n              class="control-label"\n              for="commit-message">\n              Commit message\n            </label>\n            <div class="col-sm-10">\n              <div class="commit-message-container">\n                <div class="max-width-marker"></div>\n                <textarea\n                  v-model="commitMessage"\n                  class="form-control js-commit-message"\n                  required="required"\n                  rows="14"\n                  name="Commit message"></textarea>\n              </div>\n              <p class="hint">Try to keep the first line under 52 characters and the others under 72</p>\n              <div class="hint">\n                <a\n                  @click.prevent="updateCommitMessage"\n                  href="#">{{commitMessageLinkTitle}}</a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_squash_before_merge.js
/*
The squash-before-merge button is EE only, but it's located right in the middle
of the readyToMerge state component template.

If we didn't declare this component in CE, we'd need to maintain a separate copy
of the readyToMergeState template in EE, which is pretty big and likely to change.

Instead, in CE, we declare the component, but it's hidden and is configured to do nothing.
In EE, the configuration extends this object to add a functioning squash-before-merge
button.
*/

/* harmony default export */ var mr_widget_squash_before_merge = ({
  template: ''
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_merge_request_widget/components/states/mr_widget_squash_before_merge.js



/* harmony default export */ var states_mr_widget_squash_before_merge = ({
  extends: mr_widget_squash_before_merge,
  props: {
    mr: {
      type: Object,
      required: true
    },
    isMergeButtonDisabled: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      squashBeforeMerge: this.mr.squash
    };
  },

  methods: {
    updateSquashModel: function updateSquashModel() {
      event_hub["a" /* default */].$emit('MRWidgetUpdateSquash', this.squashBeforeMerge);
    }
  },
  template: '\n    <div class="accept-control inline">\n      <label class="merge-param-checkbox">\n        <input\n          type="checkbox"\n          name="squash"\n          class="qa-squash-checkbox"\n          :disabled="isMergeButtonDisabled"\n          v-model="squashBeforeMerge"\n          @change="updateSquashModel"/>\n        Squash commits\n      </label>\n      <a\n        :href="mr.squashBeforeMergeHelpPath"\n        data-title="About this feature"\n        data-toggle="tooltip"\n        data-placement="bottom"\n        target="_blank"\n        rel="noopener noreferrer nofollow"\n        data-container="body">\n        <i\n          class="fa fa-question-circle"\n          aria-hidden="true"></i>\n      </a>\n    </div>'
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_merge_request_widget/components/states/mr_widget_ready_to_merge.js




/* harmony default export */ var states_mr_widget_ready_to_merge = ({
  extends: mr_widget_ready_to_merge,
  name: 'MRWidgetReadyToMerge',
  components: {
    'squash-before-merge': states_mr_widget_squash_before_merge
  },
  data: function data() {
    return {
      additionalParams: {
        squash: this.mr.squash
      }
    };
  },

  methods: {
    // called in CE super component before form submission
    setAdditionalParams: function setAdditionalParams(options) {
      if (this.additionalParams) {
        Object.assign(options, this.additionalParams);
      }
    }
  },
  created: function created() {
    var _this = this;

    event_hub["a" /* default */].$on('MRWidgetUpdateSquash', function (val) {
      _this.additionalParams.squash = val;
    });
  }
});
// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_sha_mismatch.js


/* harmony default export */ var mr_widget_sha_mismatch = ({
  name: 'MRWidgetSHAMismatch',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  template: '\n    <div class="mr-widget-body media">\n      <status-icon status="warning" :show-disabled-button="true" />\n      <div class="media-body space-children">\n        <span class="bold">\n          The source branch HEAD has recently changed. Please reload the page and review the changes before merging\n        </span>\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_unresolved_discussions.js


/* harmony default export */ var mr_widget_unresolved_discussions = ({
  name: 'MRWidgetUnresolvedDiscussions',
  props: {
    mr: { type: Object, required: true }
  },
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  template: '\n    <div class="mr-widget-body media">\n      <status-icon status="warning" :show-disabled-button="true" />\n      <div class="media-body space-children">\n        <span class="bold">\n          There are unresolved discussions. Please resolve these discussions\n        </span>\n        <a\n          v-if="mr.createIssueToResolveDiscussionsPath"\n          :href="mr.createIssueToResolveDiscussionsPath"\n          class="btn btn-default btn-xs js-create-issue">\n          Create an issue to resolve them later\n        </a>\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_pipeline_blocked.vue



/* harmony default export */ var mr_widget_pipeline_blocked = ({
  name: 'MRWidgetPipelineBlocked',
  components: {
    StatusIcon: mr_widget_status_icon["a" /* default */]
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-859ea36c","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_pipeline_blocked.vue
var mr_widget_pipeline_blocked_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"warning","show-disabled-button":true}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold"},[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|Pipeline blocked.\nThe pipeline for this merge request requires a manual action to proceed"))+"\n      ")])])],1)}
var mr_widget_pipeline_blocked_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_pipeline_blocked.vue
/* script */


/* template */

/* template functional */
var mr_widget_pipeline_blocked___vue_template_functional__ = false
/* styles */
var mr_widget_pipeline_blocked___vue_styles__ = null
/* scopeId */
var mr_widget_pipeline_blocked___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_pipeline_blocked___vue_module_identifier__ = null

var mr_widget_pipeline_blocked_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_pipeline_blocked,
  mr_widget_pipeline_blocked_render,
  mr_widget_pipeline_blocked_staticRenderFns,
  mr_widget_pipeline_blocked___vue_template_functional__,
  mr_widget_pipeline_blocked___vue_styles__,
  mr_widget_pipeline_blocked___vue_scopeId__,
  mr_widget_pipeline_blocked___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_pipeline_blocked = (mr_widget_pipeline_blocked_Component.exports);

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_pipeline_failed.js


/* harmony default export */ var mr_widget_pipeline_failed = ({
  name: 'MRWidgetPipelineBlocked',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  template: '\n    <div class="mr-widget-body media">\n      <status-icon status="warning" :show-disabled-button="true" />\n      <div class="media-body space-children">\n        <span class="bold">\n          The pipeline for this merge request failed. Please retry the job or push a new commit to fix the failure\n        </span>\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_merge_when_pipeline_succeeds.vue






/* harmony default export */ var mr_widget_merge_when_pipeline_succeeds = ({
  name: 'MRWidgetMergeWhenPipelineSucceeds',
  components: {
    mrWidgetAuthor: components_mr_widget_author,
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    service: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      isCancellingAutoMerge: false,
      isRemovingSourceBranch: false
    };
  },

  computed: {
    canRemoveSourceBranch: function canRemoveSourceBranch() {
      var _mr = this.mr,
          shouldRemoveSourceBranch = _mr.shouldRemoveSourceBranch,
          canRemoveSourceBranch = _mr.canRemoveSourceBranch,
          mergeUserId = _mr.mergeUserId,
          currentUserId = _mr.currentUserId;


      return !shouldRemoveSourceBranch && canRemoveSourceBranch && mergeUserId === currentUserId;
    }
  },
  methods: {
    cancelAutomaticMerge: function cancelAutomaticMerge() {
      var _this = this;

      this.isCancellingAutoMerge = true;
      this.service.cancelAutomaticMerge().then(function (res) {
        return res.data;
      }).then(function (data) {
        event_hub["a" /* default */].$emit('UpdateWidgetData', data);
      }).catch(function () {
        _this.isCancellingAutoMerge = false;
        Object(flash["a" /* default */])('Something went wrong. Please try again.');
      });
    },
    removeSourceBranch: function removeSourceBranch() {
      var _this2 = this;

      var options = {
        sha: this.mr.sha,
        merge_when_pipeline_succeeds: true,
        should_remove_source_branch: true
      };

      this.isRemovingSourceBranch = true;
      this.service.merge(options).then(function (res) {
        return res.data;
      }).then(function (data) {
        if (data.status === 'merge_when_pipeline_succeeds') {
          event_hub["a" /* default */].$emit('MRWidgetUpdateRequested');
        }
      }).catch(function () {
        _this2.isRemovingSourceBranch = false;
        Object(flash["a" /* default */])('Something went wrong. Please try again.');
      });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-944d95f8","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_merge_when_pipeline_succeeds.vue
var mr_widget_merge_when_pipeline_succeeds_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"success"}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('h4',{staticClass:"flex-container-block"},[_c('span',{staticClass:"append-right-10"},[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|Set by"))+"\n        "),_c('mr-widget-author',{attrs:{"author":_vm.mr.setToMWPSBy}}),_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|to be merged automatically when the pipeline succeeds"))+"\n      ")],1),_vm._v(" "),(_vm.mr.canCancelAutomaticMerge)?_c('a',{staticClass:"btn btn-xs btn-default js-cancel-auto-merge",attrs:{"disabled":_vm.isCancellingAutoMerge,"role":"button","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.cancelAutomaticMerge($event)}}},[(_vm.isCancellingAutoMerge)?_c('i',{staticClass:"fa fa-spinner fa-spin",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|Cancel automatic merge"))+"\n      ")]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"mr-info-list"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|The changes will be merged into"))+"\n        "),_c('a',{staticClass:"label-branch",attrs:{"href":_vm.mr.targetBranchPath}},[_vm._v("\n          "+_vm._s(_vm.mr.targetBranch)+"\n        ")])]),_vm._v(" "),(_vm.mr.shouldRemoveSourceBranch)?_c('p',[_vm._v("\n        "+_vm._s(_vm.s__("mrWidget|The source branch will be removed"))+"\n      ")]):_c('p',{staticClass:"flex-container-block"},[_c('span',{staticClass:"append-right-10"},[_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|The source branch will not be removed"))+"\n        ")]),_vm._v(" "),(_vm.canRemoveSourceBranch)?_c('a',{staticClass:"btn btn-xs btn-default js-remove-source-branch",attrs:{"disabled":_vm.isRemovingSourceBranch,"role":"button","href":"#"},on:{"click":function($event){$event.preventDefault();_vm.removeSourceBranch($event)}}},[(_vm.isRemovingSourceBranch)?_c('i',{staticClass:"fa fa-spinner fa-spin",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v("\n          "+_vm._s(_vm.s__("mrWidget|Remove source branch"))+"\n        ")]):_vm._e()])])])],1)}
var mr_widget_merge_when_pipeline_succeeds_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_merge_when_pipeline_succeeds.vue
/* script */


/* template */

/* template functional */
var mr_widget_merge_when_pipeline_succeeds___vue_template_functional__ = false
/* styles */
var mr_widget_merge_when_pipeline_succeeds___vue_styles__ = null
/* scopeId */
var mr_widget_merge_when_pipeline_succeeds___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_merge_when_pipeline_succeeds___vue_module_identifier__ = null

var mr_widget_merge_when_pipeline_succeeds_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_merge_when_pipeline_succeeds,
  mr_widget_merge_when_pipeline_succeeds_render,
  mr_widget_merge_when_pipeline_succeeds_staticRenderFns,
  mr_widget_merge_when_pipeline_succeeds___vue_template_functional__,
  mr_widget_merge_when_pipeline_succeeds___vue_styles__,
  mr_widget_merge_when_pipeline_succeeds___vue_scopeId__,
  mr_widget_merge_when_pipeline_succeeds___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_merge_when_pipeline_succeeds = (mr_widget_merge_when_pipeline_succeeds_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_rebase.vue







/* harmony default export */ var mr_widget_rebase = ({
  name: 'MRWidgetRebase',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */],
    loadingIcon: loading_icon["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isMakingRequest: false,
      rebasingError: null
    };
  },

  computed: {
    status: function status() {
      if (this.mr.rebaseInProgress || this.isMakingRequest) {
        return 'loading';
      }
      if (!this.mr.canPushToSourceBranch && !this.mr.rebaseInProgress) {
        return 'warning';
      }
      return 'success';
    },
    showDisabledButton: function showDisabledButton() {
      return ['failed', 'loading'].includes(this.status);
    }
  },
  methods: {
    rebase: function rebase() {
      var _this = this;

      this.isMakingRequest = true;
      this.rebasingError = null;

      this.service.rebase().then(function () {
        simple_poll(_this.checkRebaseStatus);
      }).catch(function (error) {
        _this.rebasingError = error.merge_error;
        _this.isMakingRequest = false;
        Object(flash["a" /* default */])('Something went wrong. Please try again.');
      });
    },
    checkRebaseStatus: function checkRebaseStatus(continuePolling, stopPolling) {
      var _this2 = this;

      this.service.poll().then(function (res) {
        return res.data;
      }).then(function (res) {
        if (res.rebase_in_progress) {
          continuePolling();
        } else {
          _this2.isMakingRequest = false;

          if (res.merge_error && res.merge_error.length) {
            _this2.rebasingError = res.merge_error;
            Object(flash["a" /* default */])('Something went wrong. Please try again.');
          }

          event_hub["a" /* default */].$emit('MRWidgetUpdateRequested');
          stopPolling();
        }
      }).catch(function () {
        _this2.isMakingRequest = false;
        Object(flash["a" /* default */])('Something went wrong. Please try again.');
        stopPolling();
      });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e3e33a","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_rebase.vue
var mr_widget_rebase_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":_vm.status,"show-disabled-button":_vm.showDisabledButton}}),_vm._v(" "),_c('div',{staticClass:"rebase-state-find-class-convention media media-body space-children"},[(_vm.mr.rebaseInProgress || _vm.isMakingRequest)?[_c('span',{staticClass:"bold"},[_vm._v("\n          Rebase in progress\n        ")])]:_vm._e(),_vm._v(" "),(!_vm.mr.rebaseInProgress && !_vm.mr.canPushToSourceBranch)?[_c('span',{staticClass:"bold"},[_vm._v("\n          Fast-forward merge is not possible.\n          Rebase the source branch onto\n          "),_c('span',{staticClass:"label-branch"},[_vm._v(_vm._s(_vm.mr.targetBranch))]),_vm._v("\n          to allow this merge request to be merged.\n        ")])]:_vm._e(),_vm._v(" "),(!_vm.mr.rebaseInProgress && _vm.mr.canPushToSourceBranch && !_vm.isMakingRequest)?[_c('div',{staticClass:"accept-merge-holder clearfix\njs-toggle-container accept-action media space-children"},[_c('button',{staticClass:"btn btn-sm btn-reopen btn-success qa-mr-rebase-button",attrs:{"type":"button","disabled":_vm.isMakingRequest},on:{"click":_vm.rebase}},[(_vm.isMakingRequest)?_c('loading-icon'):_vm._e(),_vm._v("\n            Rebase\n          ")],1),_vm._v(" "),(!_vm.rebasingError)?_c('span',{staticClass:"bold"},[_vm._v("\n            Fast-forward merge is not possible.\n            Rebase the source branch onto the target branch or merge target\n            branch into source branch to allow this merge request to be merged.\n          ")]):_c('span',{staticClass:"bold danger"},[_vm._v("\n            "+_vm._s(_vm.rebasingError)+"\n          ")])])]:_vm._e()],2)],1)}
var mr_widget_rebase_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_rebase.vue
/* script */


/* template */

/* template functional */
var mr_widget_rebase___vue_template_functional__ = false
/* styles */
var mr_widget_rebase___vue_styles__ = null
/* scopeId */
var mr_widget_rebase___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_rebase___vue_module_identifier__ = null

var mr_widget_rebase_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_rebase,
  mr_widget_rebase_render,
  mr_widget_rebase_staticRenderFns,
  mr_widget_rebase___vue_template_functional__,
  mr_widget_rebase___vue_styles__,
  mr_widget_rebase___vue_scopeId__,
  mr_widget_rebase___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_rebase = (mr_widget_rebase_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_auto_merge_failed.vue





/* harmony default export */ var mr_widget_auto_merge_failed = ({
  name: 'MRWidgetAutoMergeFailed',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */],
    loadingIcon: loading_icon["a" /* default */]
  },
  props: {
    mr: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isRefreshing: false
    };
  },

  methods: {
    refreshWidget: function refreshWidget() {
      var _this = this;

      this.isRefreshing = true;
      event_hub["a" /* default */].$emit('MRWidgetUpdateRequested', function () {
        _this.isRefreshing = false;
      });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-122e13b6","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_auto_merge_failed.vue
var mr_widget_auto_merge_failed_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"warning"}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold"},[(_vm.mr.mergeError)?[_vm._v(_vm._s(_vm.mr.mergeError)+".")]:_vm._e(),_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|This merge request failed to be merged automatically"))+"\n    ")],2),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-default",attrs:{"disabled":_vm.isRefreshing,"type":"button"},on:{"click":_vm.refreshWidget}},[(_vm.isRefreshing)?_c('loading-icon',{attrs:{"inline":true}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|Refresh"))+"\n    ")],1)])],1)}
var mr_widget_auto_merge_failed_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_auto_merge_failed.vue
/* script */


/* template */

/* template functional */
var mr_widget_auto_merge_failed___vue_template_functional__ = false
/* styles */
var mr_widget_auto_merge_failed___vue_styles__ = null
/* scopeId */
var mr_widget_auto_merge_failed___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_auto_merge_failed___vue_module_identifier__ = null

var mr_widget_auto_merge_failed_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_auto_merge_failed,
  mr_widget_auto_merge_failed_render,
  mr_widget_auto_merge_failed_staticRenderFns,
  mr_widget_auto_merge_failed___vue_template_functional__,
  mr_widget_auto_merge_failed___vue_styles__,
  mr_widget_auto_merge_failed___vue_scopeId__,
  mr_widget_auto_merge_failed___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_auto_merge_failed = (mr_widget_auto_merge_failed_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/states/mr_widget_checking.vue



/* harmony default export */ var mr_widget_checking = ({
  name: 'MRWidgetChecking',
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56dde2de","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_checking.vue
var mr_widget_checking_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"loading","show-disabled-button":true}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold"},[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|Checking ability to merge automatically"))+"\n    ")])])],1)}
var mr_widget_checking_staticRenderFns = []

// CONCATENATED MODULE: ./vue_merge_request_widget/components/states/mr_widget_checking.vue
/* script */


/* template */

/* template functional */
var mr_widget_checking___vue_template_functional__ = false
/* styles */
var mr_widget_checking___vue_styles__ = null
/* scopeId */
var mr_widget_checking___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var mr_widget_checking___vue_module_identifier__ = null

var mr_widget_checking_Component = Object(component_normalizer["a" /* default */])(
  mr_widget_checking,
  mr_widget_checking_render,
  mr_widget_checking_staticRenderFns,
  mr_widget_checking___vue_template_functional__,
  mr_widget_checking___vue_styles__,
  mr_widget_checking___vue_scopeId__,
  mr_widget_checking___vue_module_identifier__
)

/* harmony default export */ var states_mr_widget_checking = (mr_widget_checking_Component.exports);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/timeago.js/dist/timeago.min.js
var timeago_min = __webpack_require__("../../../node_modules/timeago.js/dist/timeago.min.js");
var timeago_min_default = /*#__PURE__*/__webpack_require__.n(timeago_min);

// CONCATENATED MODULE: ./vue_merge_request_widget/stores/state_maps.js
var stateToComponentMap = {
  merged: 'mr-widget-merged',
  closed: 'mr-widget-closed',
  merging: 'mr-widget-merging',
  conflicts: 'mr-widget-conflicts',
  missingBranch: 'mr-widget-missing-branch',
  workInProgress: 'mr-widget-wip',
  readyToMerge: 'mr-widget-ready-to-merge',
  nothingToMerge: 'mr-widget-nothing-to-merge',
  notAllowedToMerge: 'mr-widget-not-allowed',
  archived: 'mr-widget-archived',
  checking: 'mr-widget-checking',
  unresolvedDiscussions: 'mr-widget-unresolved-discussions',
  pipelineBlocked: 'mr-widget-pipeline-blocked',
  pipelineFailed: 'mr-widget-pipeline-failed',
  mergeWhenPipelineSucceeds: 'mr-widget-merge-when-pipeline-succeeds',
  failedToMerge: 'mr-widget-failed-to-merge',
  autoMergeFailed: 'mr-widget-auto-merge-failed',
  shaMismatch: 'mr-widget-sha-mismatch',
  rebase: 'mr-widget-rebase'
};

var statesToShowHelpWidget = ['merging', 'conflicts', 'workInProgress', 'readyToMerge', 'checking', 'unresolvedDiscussions', 'pipelineFailed', 'pipelineBlocked', 'autoMergeFailed', 'rebase'];

var stateKey = {
  archived: 'archived',
  missingBranch: 'missingBranch',
  nothingToMerge: 'nothingToMerge',
  checking: 'checking',
  conflicts: 'conflicts',
  workInProgress: 'workInProgress',
  pipelineFailed: 'pipelineFailed',
  unresolvedDiscussions: 'unresolvedDiscussions',
  pipelineBlocked: 'pipelineBlocked',
  shaMismatch: 'shaMismatch',
  autoMergeFailed: 'autoMergeFailed',
  mergeWhenPipelineSucceeds: 'mergeWhenPipelineSucceeds',
  notAllowedToMerge: 'notAllowedToMerge',
  readyToMerge: 'readyToMerge',
  rebase: 'rebase'
};

/* harmony default export */ var state_maps = ({
  stateToComponentMap: stateToComponentMap,
  statesToShowHelpWidget: statesToShowHelpWidget
});
// CONCATENATED MODULE: ./vue_merge_request_widget/stores/mr_widget_store.js
var mr_widget_store__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function mr_widget_store__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var mr_widget_store_MergeRequestStore = function () {
  function MergeRequestStore(data) {
    mr_widget_store__classCallCheck(this, MergeRequestStore);

    this.sha = data.diff_head_sha;
    this.gitlabLogo = data.gitlabLogo;

    this.setData(data);
  }

  mr_widget_store__createClass(MergeRequestStore, [{
    key: 'setData',
    value: function setData(data) {
      var currentUser = data.current_user;
      var pipelineStatus = data.pipeline ? data.pipeline.details.status : null;

      // EE specific
      this.squash = data.squash;

      this.title = data.title;
      this.targetBranch = data.target_branch;
      this.sourceBranch = data.source_branch;
      this.mergeStatus = data.merge_status;
      this.commitMessage = data.merge_commit_message;
      this.commitMessageWithDescription = data.merge_commit_message_with_description;
      this.commitsCount = data.commits_count;
      this.divergedCommitsCount = data.diverged_commits_count;
      this.pipeline = data.pipeline || {};
      this.deployments = this.deployments || data.deployments || [];
      this.initRebase(data);

      if (data.issues_links) {
        var links = data.issues_links;
        var closing = links.closing;

        var mentioned = links.mentioned_but_not_closing;
        var assignToMe = links.assign_to_closing;

        if (closing || mentioned || assignToMe) {
          this.relatedLinks = { closing: closing, mentioned: mentioned, assignToMe: assignToMe };
        }
      }

      this.updatedAt = data.updated_at;
      this.metrics = MergeRequestStore.buildMetrics(data.metrics);
      this.setToMWPSBy = MergeRequestStore.formatUserObject(data.merge_user || {});
      this.mergeUserId = data.merge_user_id;
      this.currentUserId = gon.current_user_id;
      this.sourceBranchPath = data.source_branch_path;
      this.sourceBranchLink = data.source_branch_with_namespace_link;
      this.mergeError = data.merge_error;
      this.targetBranchPath = data.target_branch_commits_path;
      this.targetBranchTreePath = data.target_branch_tree_path;
      this.conflictResolutionPath = data.conflict_resolution_path;
      this.cancelAutoMergePath = data.cancel_merge_when_pipeline_succeeds_path;
      this.removeWIPPath = data.remove_wip_path;
      this.sourceBranchRemoved = !data.source_branch_exists;
      this.shouldRemoveSourceBranch = data.remove_source_branch || false;
      this.onlyAllowMergeIfPipelineSucceeds = data.only_allow_merge_if_pipeline_succeeds || false;
      this.mergeWhenPipelineSucceeds = data.merge_when_pipeline_succeeds || false;
      this.mergePath = data.merge_path;
      this.ffOnlyEnabled = data.ff_only_enabled;
      this.shouldBeRebased = !!data.should_be_rebased;
      this.statusPath = data.status_path;
      this.emailPatchesPath = data.email_patches_path;
      this.plainDiffPath = data.plain_diff_path;
      this.newBlobPath = data.new_blob_path;
      this.createIssueToResolveDiscussionsPath = data.create_issue_to_resolve_discussions_path;
      this.mergeCheckPath = data.merge_check_path;
      this.mergeActionsContentPath = data.commit_change_content_path;
      this.isRemovingSourceBranch = this.isRemovingSourceBranch || false;
      this.isOpen = data.state === 'opened';
      this.hasMergeableDiscussionsState = data.mergeable_discussions_state === false;
      this.canRemoveSourceBranch = currentUser.can_remove_source_branch || false;
      this.canMerge = !!data.merge_path;
      this.canCreateIssue = currentUser.can_create_issue || false;
      this.canCancelAutomaticMerge = !!data.cancel_merge_when_pipeline_succeeds_path;
      this.hasSHAChanged = this.sha !== data.diff_head_sha;
      this.canBeMerged = data.can_be_merged || false;
      this.isMergeAllowed = data.mergeable || false;
      this.mergeOngoing = data.merge_ongoing;
      this.maintainerEditAllowed = data.allow_maintainer_to_push;

      // Cherry-pick and Revert actions related
      this.canCherryPickInCurrentMR = currentUser.can_cherry_pick_on_current_merge_request || false;
      this.canRevertInCurrentMR = currentUser.can_revert_on_current_merge_request || false;
      this.cherryPickInForkPath = currentUser.cherry_pick_in_fork_path;
      this.revertInForkPath = currentUser.revert_in_fork_path;

      // CI related
      this.ciEnvironmentsStatusPath = data.ci_environments_status_path;
      this.hasCI = data.has_ci;
      this.ciStatus = data.ci_status;
      this.isPipelineFailed = this.ciStatus === 'failed' || this.ciStatus === 'canceled';
      this.isPipelinePassing = this.ciStatus === 'success' || this.ciStatus === 'success_with_warnings';
      this.isPipelineSkipped = this.ciStatus === 'skipped';
      this.pipelineDetailedStatus = pipelineStatus;
      this.isPipelineActive = data.pipeline ? data.pipeline.active : false;
      this.isPipelineBlocked = pipelineStatus ? pipelineStatus.group === 'manual' : false;
      this.ciStatusFaviconPath = pipelineStatus ? pipelineStatus.favicon : null;

      this.setState(data);
    }
  }, {
    key: 'setState',
    value: function setState(data) {
      if (this.mergeOngoing) {
        this.state = 'merging';
        return;
      }

      if (this.isOpen) {
        this.state = get_state_key.call(this, data);
      } else {
        switch (data.state) {
          case 'merged':
            this.state = 'merged';
            break;
          case 'closed':
            this.state = 'closed';
            break;
          default:
            this.state = null;
        }
      }
    }
  }, {
    key: 'initRebase',
    value: function initRebase(data) {
      this.canPushToSourceBranch = data.can_push_to_source_branch;
      this.rebaseInProgress = data.rebase_in_progress;
      this.approvalsLeft = !data.approved;
      this.rebasePath = data.rebase_path;
    }
  }, {
    key: 'isNothingToMergeState',
    get: function get() {
      return this.state === stateKey.nothingToMerge;
    }
  }], [{
    key: 'buildMetrics',
    value: function buildMetrics(metrics) {
      if (!metrics) {
        return {};
      }

      return {
        mergedBy: MergeRequestStore.formatUserObject(metrics.merged_by),
        closedBy: MergeRequestStore.formatUserObject(metrics.closed_by),
        mergedAt: Object(datetime_utility["b" /* formatDate */])(metrics.merged_at),
        closedAt: Object(datetime_utility["b" /* formatDate */])(metrics.closed_at),
        readableMergedAt: MergeRequestStore.getReadableDate(metrics.merged_at),
        readableClosedAt: MergeRequestStore.getReadableDate(metrics.closed_at)
      };
    }
  }, {
    key: 'formatUserObject',
    value: function formatUserObject(user) {
      if (!user) {
        return {};
      }

      return {
        name: user.name || '',
        username: user.username || '',
        webUrl: user.web_url || '',
        avatarUrl: user.avatar_url || ''
      };
    }
  }, {
    key: 'getReadableDate',
    value: function getReadableDate(date) {
      if (!date) {
        return '';
      }

      var timeagoInstance = new timeago_min_default.a();

      return timeagoInstance.format(date);
    }
  }]);

  return MergeRequestStore;
}();

/* harmony default export */ var mr_widget_store = (mr_widget_store_MergeRequestStore);
// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_shared/security_reports/helpers/utils.js
var utils = __webpack_require__("../../../ee/app/assets/javascripts/vue_shared/security_reports/helpers/utils.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_merge_request_widget/stores/mr_widget_store.js
var stores_mr_widget_store__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function stores_mr_widget_store__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var stores_mr_widget_store_MergeRequestStore = function (_CEMergeRequestStore) {
  _inherits(MergeRequestStore, _CEMergeRequestStore);

  function MergeRequestStore(data) {
    stores_mr_widget_store__classCallCheck(this, MergeRequestStore);

    var _this = _possibleConstructorReturn(this, (MergeRequestStore.__proto__ || Object.getPrototypeOf(MergeRequestStore)).call(this, data));

    var blobPath = data.blob_path || {};
    _this.headBlobPath = blobPath.head_path || '';
    _this.baseBlobPath = blobPath.base_path || '';

    _this.initCodeclimate(data);
    _this.initPerformanceReport(data);
    _this.initSecurityReport(data);
    _this.initDockerReport(data);
    _this.initDastReport(data);
    return _this;
  }

  stores_mr_widget_store__createClass(MergeRequestStore, [{
    key: 'setData',
    value: function setData(data) {
      this.initGeo(data);
      this.initSquashBeforeMerge(data);
      this.initApprovals(data);

      _get(MergeRequestStore.prototype.__proto__ || Object.getPrototypeOf(MergeRequestStore.prototype), 'setData', this).call(this, data);
    }
  }, {
    key: 'initSquashBeforeMerge',
    value: function initSquashBeforeMerge(data) {
      this.squashBeforeMergeHelpPath = this.squashBeforeMergeHelpPath || data.squash_before_merge_help_path;
      this.enableSquashBeforeMerge = this.enableSquashBeforeMerge || data.enable_squash_before_merge;
    }
  }, {
    key: 'initGeo',
    value: function initGeo(data) {
      this.isGeoSecondaryNode = this.isGeoSecondaryNode || data.is_geo_secondary_node;
      this.geoSecondaryHelpPath = this.geoSecondaryHelpPath || data.geo_secondary_help_path;
    }
  }, {
    key: 'initApprovals',
    value: function initApprovals(data) {
      this.isApproved = this.isApproved || false;
      this.approvals = this.approvals || null;
      this.approvalsPath = data.approvals_path || this.approvalsPath;
      this.approvalsRequired = data.approvalsRequired || Boolean(this.approvalsPath);
    }
  }, {
    key: 'setApprovals',
    value: function setApprovals(data) {
      this.approvals = data;
      this.approvalsLeft = !!data.approvals_left;
      this.isApproved = !this.approvalsLeft || false;
      this.preventMerge = this.approvalsRequired && this.approvalsLeft;
    }
  }, {
    key: 'initCodeclimate',
    value: function initCodeclimate(data) {
      this.codeclimate = data.codeclimate;
      this.codeclimateMetrics = {
        newIssues: [],
        resolvedIssues: []
      };
    }
  }, {
    key: 'initPerformanceReport',
    value: function initPerformanceReport(data) {
      this.performance = data.performance;
      this.performanceMetrics = {
        improved: [],
        degraded: []
      };
    }
  }, {
    key: 'initSecurityReport',
    value: function initSecurityReport(data) {
      this.sast = data.sast;
      this.securityReport = {
        newIssues: [],
        resolvedIssues: [],
        allIssues: []
      };
    }
  }, {
    key: 'initDockerReport',
    value: function initDockerReport(data) {
      this.sastContainer = data.sast_container;
      this.dockerReport = {
        approved: [],
        unapproved: [],
        vulnerabilities: []
      };
    }
  }, {
    key: 'initDastReport',
    value: function initDastReport(data) {
      this.dast = data.dast;
      this.dastReport = [];
    }
  }, {
    key: 'setSecurityReport',
    value: function setSecurityReport(data) {
      var report = Object(utils["e" /* setSastReport */])(data);
      this.securityReport.newIssues = report.newIssues;
      this.securityReport.resolvedIssues = report.resolvedIssues;
      this.securityReport.allIssues = report.allIssues;
    }
  }, {
    key: 'setDockerReport',
    value: function setDockerReport() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var report = Object(utils["d" /* setSastContainerReport */])(data);
      this.dockerReport.approved = report.approved;
      this.dockerReport.unapproved = report.unapproved;
      this.dockerReport.vulnerabilities = report.vulnerabilities;
    }
  }, {
    key: 'setDastReport',
    value: function setDastReport(data) {
      this.dastReport = Object(utils["c" /* setDastReport */])(data);
    }
  }, {
    key: 'compareCodeclimateMetrics',
    value: function compareCodeclimateMetrics(headIssues, baseIssues, headBlobPath, baseBlobPath) {
      var parsedHeadIssues = Object(utils["b" /* parseIssues */])(headIssues, headBlobPath);
      var parsedBaseIssues = Object(utils["b" /* parseIssues */])(baseIssues, baseBlobPath);

      this.codeclimateMetrics.newIssues = Object(utils["a" /* filterByKey */])(parsedHeadIssues, parsedBaseIssues, 'fingerprint');
      this.codeclimateMetrics.resolvedIssues = Object(utils["a" /* filterByKey */])(parsedBaseIssues, parsedHeadIssues, 'fingerprint');
    }
  }, {
    key: 'comparePerformanceMetrics',
    value: function comparePerformanceMetrics(headMetrics, baseMetrics) {
      var headMetricsIndexed = MergeRequestStore.normalizePerformanceMetrics(headMetrics);
      var baseMetricsIndexed = MergeRequestStore.normalizePerformanceMetrics(baseMetrics);

      var improved = [];
      var degraded = [];
      var neutral = [];

      Object.keys(headMetricsIndexed).forEach(function (subject) {
        var subjectMetrics = headMetricsIndexed[subject];
        Object.keys(subjectMetrics).forEach(function (metric) {
          var headMetricData = subjectMetrics[metric];

          if (baseMetricsIndexed[subject] && baseMetricsIndexed[subject][metric]) {
            var baseMetricData = baseMetricsIndexed[subject][metric];
            var metricDirection = 'desiredSize' in headMetricData && headMetricData.desiredSize === 'smaller' ? -1 : 1;
            var metricData = {
              name: metric,
              path: subject,
              score: headMetricData.value,
              delta: headMetricData.value - baseMetricData.value
            };

            if (metricData.delta === 0) {
              neutral.push(metricData);
            } else if (metricData.delta * metricDirection > 0) {
              improved.push(metricData);
            } else {
              degraded.push(metricData);
            }
          } else {
            neutral.push({
              name: metric,
              path: subject,
              score: headMetricData.value
            });
          }
        });
      });

      this.performanceMetrics = { improved: improved, degraded: degraded, neutral: neutral };
    }

    // normalize performance metrics by indexing on performance subject and metric name

  }], [{
    key: 'normalizePerformanceMetrics',
    value: function normalizePerformanceMetrics(performanceData) {
      var indexedSubjects = {};
      performanceData.forEach(function (_ref) {
        var subject = _ref.subject,
            metrics = _ref.metrics;

        var indexedMetrics = {};
        metrics.forEach(function (_ref2) {
          var name = _ref2.name,
              data = _objectWithoutProperties(_ref2, ['name']);

          indexedMetrics[name] = data;
        });
        indexedSubjects[subject] = indexedMetrics;
      });

      return indexedSubjects;
    }
  }]);

  return MergeRequestStore;
}(mr_widget_store);

/* harmony default export */ var stores_mr_widget_store = (stores_mr_widget_store_MergeRequestStore);
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_merge_request_widget/services/mr_widget_service.js
var mr_widget_service__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function mr_widget_service__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function mr_widget_service__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function mr_widget_service__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var services_mr_widget_service_MRWidgetService = function (_CEWidgetService) {
  mr_widget_service__inherits(MRWidgetService, _CEWidgetService);

  function MRWidgetService(mr) {
    mr_widget_service__classCallCheck(this, MRWidgetService);

    var _this = mr_widget_service__possibleConstructorReturn(this, (MRWidgetService.__proto__ || Object.getPrototypeOf(MRWidgetService)).call(this, mr));

    _this.approvalsPath = mr.approvalsPath;
    return _this;
  }

  mr_widget_service__createClass(MRWidgetService, [{
    key: 'fetchApprovals',
    value: function fetchApprovals() {
      return axios_utils["a" /* default */].get(this.approvalsPath).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: 'approveMergeRequest',
    value: function approveMergeRequest() {
      return axios_utils["a" /* default */].post(this.approvalsPath).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: 'unapproveMergeRequest',
    value: function unapproveMergeRequest() {
      return axios_utils["a" /* default */].delete(this.approvalsPath).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: 'fetchReport',
    value: function fetchReport(endpoint) {
      // eslint-disable-line
      return axios_utils["a" /* default */].get(endpoint).then(function (res) {
        return res.data;
      });
    }
  }]);

  return MRWidgetService;
}(mr_widget_service);

/* harmony default export */ var services_mr_widget_service = (services_mr_widget_service_MRWidgetService);
// CONCATENATED MODULE: ./vue_merge_request_widget/stores/get_state_key.js


function deviseState(data) {
  if (data.project_archived) {
    return stateKey.archived;
  } else if (data.branch_missing) {
    return stateKey.missingBranch;
  } else if (!data.commits_count) {
    return stateKey.nothingToMerge;
  } else if (this.mergeStatus === 'unchecked') {
    return stateKey.checking;
  } else if (data.has_conflicts) {
    return stateKey.conflicts;
  } else if (data.work_in_progress) {
    return stateKey.workInProgress;
  } else if (this.onlyAllowMergeIfPipelineSucceeds && this.isPipelineFailed) {
    return stateKey.pipelineFailed;
  } else if (this.hasMergeableDiscussionsState) {
    return stateKey.unresolvedDiscussions;
  } else if (this.isPipelineBlocked) {
    return stateKey.pipelineBlocked;
  } else if (this.hasSHAChanged) {
    return stateKey.shaMismatch;
  } else if (this.mergeWhenPipelineSucceeds) {
    return this.mergeError ? stateKey.autoMergeFailed : stateKey.mergeWhenPipelineSucceeds;
  } else if (!this.canMerge) {
    return stateKey.notAllowedToMerge;
  } else if (this.shouldBeRebased) {
    return stateKey.rebase;
  } else if (this.canBeMerged) {
    return stateKey.readyToMerge;
  }
  return null;
}
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_merge_request_widget/stores/get_state_key.js


/* harmony default export */ var get_state_key = (function (data) {
  if (this.isGeoSecondaryNode) {
    return 'geoSecondaryNode';
  }

  return deviseState.call(this, data);
});
// EXTERNAL MODULE: ./pages/projects/project.js
var project = __webpack_require__("./pages/projects/project.js");

// CONCATENATED MODULE: ./vue_merge_request_widget/mr_widget_options.js






/* harmony default export */ var mr_widget_options = ({
  el: '#js-vue-mr-widget',
  name: 'MRWidget',
  props: {
    mrData: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    var store = new stores_mr_widget_store(this.mrData || window.gl.mrWidgetData);
    var service = this.createService(store);
    return {
      mr: store,
      service: service
    };
  },

  computed: {
    componentName: function componentName() {
      return stores_state_maps.stateToComponentMap[this.mr.state];
    },
    shouldRenderMergeHelp: function shouldRenderMergeHelp() {
      return stores_state_maps.statesToShowHelpWidget.indexOf(this.mr.state) > -1;
    },
    shouldRenderPipelines: function shouldRenderPipelines() {
      return this.mr.hasCI;
    },
    shouldRenderRelatedLinks: function shouldRenderRelatedLinks() {
      return !!this.mr.relatedLinks && !this.mr.isNothingToMergeState;
    },
    shouldRenderDeployments: function shouldRenderDeployments() {
      return this.mr.deployments.length;
    }
  },
  methods: {
    createService: function createService(store) {
      var endpoints = {
        mergePath: store.mergePath,
        mergeCheckPath: store.mergeCheckPath,
        cancelAutoMergePath: store.cancelAutoMergePath,
        removeWIPPath: store.removeWIPPath,
        sourceBranchPath: store.sourceBranchPath,
        ciEnvironmentsStatusPath: store.ciEnvironmentsStatusPath,
        statusPath: store.statusPath,
        mergeActionsContentPath: store.mergeActionsContentPath,
        rebasePath: store.rebasePath,
        approvalsPath: store.approvalsPath
      };
      return new services_mr_widget_service(endpoints);
    },
    checkStatus: function checkStatus(cb) {
      var _this = this;

      return this.service.checkStatus().then(function (res) {
        return res.data;
      }).then(function (data) {
        _this.handleNotification(data);
        _this.mr.setData(data);
        _this.setFaviconHelper();

        if (cb) {
          cb.call(null, data);
        }
      }).catch(function () {
        return new flash["a" /* default */]('Something went wrong. Please try again.');
      });
    },
    initPolling: function initPolling() {
      this.pollingInterval = new smart_interval["a" /* default */]({
        callback: this.checkStatus,
        startingInterval: 10000,
        maxInterval: 30000,
        hiddenInterval: 120000,
        incrementByFactorOf: 5000
      });
    },
    initDeploymentsPolling: function initDeploymentsPolling() {
      this.deploymentsInterval = new smart_interval["a" /* default */]({
        callback: this.fetchDeployments,
        startingInterval: 30000,
        maxInterval: 120000,
        hiddenInterval: 240000,
        incrementByFactorOf: 15000,
        immediateExecution: true
      });
    },
    setFaviconHelper: function setFaviconHelper() {
      if (this.mr.ciStatusFaviconPath) {
        Object(common_utils["F" /* setFavicon */])(this.mr.ciStatusFaviconPath);
      }
    },
    fetchDeployments: function fetchDeployments() {
      var _this2 = this;

      return this.service.fetchDeployments().then(function (res) {
        return res.data;
      }).then(function (data) {
        if (data.length) {
          _this2.mr.deployments = data;
        }
      }).catch(function () {
        new flash["a" /* default */]('Something went wrong while fetching the environments for this merge request. Please try again.'); // eslint-disable-line
      });
    },
    fetchActionsContent: function fetchActionsContent() {
      this.service.fetchMergeActionsContent().then(function (res) {
        if (res.data) {
          var el = document.createElement('div');
          el.innerHTML = res.data;
          document.body.appendChild(el);
          project["a" /* default */].initRefSwitcher();
        }
      }).catch(function () {
        return new flash["a" /* default */]('Something went wrong. Please try again.');
      });
    },
    handleNotification: function handleNotification(data) {
      if (data.ci_status === this.mr.ciStatus) return;
      if (!data.pipeline) return;

      var label = data.pipeline.details.status.label;
      var title = 'Pipeline ' + label;
      var message = 'Pipeline ' + label + ' for "' + data.title + '"';

      utils_notify.notifyMe(title, message, this.mr.gitlabLogo);
    },
    resumePolling: function resumePolling() {
      this.pollingInterval.resume();
    },
    stopPolling: function stopPolling() {
      this.pollingInterval.stopTimer();
    },
    bindEventHubListeners: function bindEventHubListeners() {
      var _this3 = this;

      event_hub["a" /* default */].$on('MRWidgetUpdateRequested', function (cb) {
        _this3.checkStatus(cb);
      });

      // `params` should be an Array contains a Boolean, like `[true]`
      // Passing parameter as Boolean didn't work.
      event_hub["a" /* default */].$on('SetBranchRemoveFlag', function (params) {
        _this3.mr.isRemovingSourceBranch = params[0];
      });

      event_hub["a" /* default */].$on('FailedToMerge', function (mergeError) {
        _this3.mr.state = 'failedToMerge';
        _this3.mr.mergeError = mergeError;
      });

      event_hub["a" /* default */].$on('UpdateWidgetData', function (data) {
        _this3.mr.setData(data);
      });

      event_hub["a" /* default */].$on('FetchActionsContent', function () {
        _this3.fetchActionsContent();
      });

      event_hub["a" /* default */].$on('EnablePolling', function () {
        _this3.resumePolling();
      });

      event_hub["a" /* default */].$on('DisablePolling', function () {
        _this3.stopPolling();
      });
    },
    handleMounted: function handleMounted() {
      this.setFaviconHelper();
      this.initDeploymentsPolling();
    }
  },
  created: function created() {
    this.initPolling();
    this.bindEventHubListeners();
  },
  mounted: function mounted() {
    this.handleMounted();
  },

  components: {
    'mr-widget-header': components_mr_widget_header,
    'mr-widget-merge-help': components_mr_widget_merge_help,
    'mr-widget-pipeline': components_mr_widget_pipeline,
    'mr-widget-deployment': mr_widget_deployment,
    'mr-widget-maintainer-edit': components_mr_widget_maintainer_edit,
    'mr-widget-related-links': components_mr_widget_related_links,
    'mr-widget-merged': states_mr_widget_merged,
    'mr-widget-closed': states_mr_widget_closed,
    'mr-widget-merging': states_mr_widget_merging,
    'mr-widget-failed-to-merge': states_mr_widget_failed_to_merge,
    'mr-widget-wip': mr_widget_wip["a" /* default */],
    'mr-widget-archived': states_mr_widget_archived,
    'mr-widget-conflicts': states_mr_widget_conflicts,
    'mr-widget-nothing-to-merge': mr_widget_nothing_to_merge,
    'mr-widget-not-allowed': states_mr_widget_not_allowed,
    'mr-widget-missing-branch': states_mr_widget_missing_branch,
    'mr-widget-ready-to-merge': states_mr_widget_ready_to_merge,
    'mr-widget-sha-mismatch': mr_widget_sha_mismatch,
    'mr-widget-squash-before-merge': states_mr_widget_squash_before_merge,
    'mr-widget-checking': states_mr_widget_checking,
    'mr-widget-unresolved-discussions': mr_widget_unresolved_discussions,
    'mr-widget-pipeline-blocked': states_mr_widget_pipeline_blocked,
    'mr-widget-pipeline-failed': mr_widget_pipeline_failed,
    'mr-widget-merge-when-pipeline-succeeds': states_mr_widget_merge_when_pipeline_succeeds,
    'mr-widget-auto-merge-failed': states_mr_widget_auto_merge_failed,
    'mr-widget-rebase': states_mr_widget_rebase
  },
  template: '\n    <div class="mr-state-widget prepend-top-default">\n      <mr-widget-header :mr="mr" />\n      <mr-widget-pipeline\n        v-if="shouldRenderPipelines"\n        :pipeline="mr.pipeline"\n        :ci-status="mr.ciStatus"\n        :has-ci="mr.hasCI"\n        />\n      <mr-widget-deployment\n        v-if="shouldRenderDeployments"\n        :mr="mr"\n        :service="service" />\n      <div class="mr-widget-section">\n        <component\n          :is="componentName"\n          :mr="mr"\n          :service="service" />\n        <mr-widget-maintainer-edit\n          :maintainerEditAllowed="mr.maintainerEditAllowed" />\n        <mr-widget-related-links\n          v-if="shouldRenderRelatedLinks"\n          :state="mr.state"\n          :related-links="mr.relatedLinks" />\n      </div>\n      <div\n        class="mr-widget-footer"\n        v-if="shouldRenderMergeHelp">\n        <mr-widget-merge-help />\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_merge_request_widget/components/approvals/approvals_body.js





/* harmony default export */ var approvals_body = ({
  name: 'approvals-body',
  props: {
    mr: {
      type: Object,
      required: true
    },
    service: {
      type: Object,
      required: true
    },
    approvedBy: {
      type: Array,
      required: false
    },
    approvalsLeft: {
      type: Number,
      required: false
    },
    userCanApprove: {
      type: Boolean,
      required: false
    },
    userHasApproved: {
      type: Boolean,
      required: false
    },
    suggestedApprovers: {
      type: Array,
      required: false
    }
  },
  components: {
    'mr-widget-author': components_mr_widget_author
  },
  data: function data() {
    return {
      approving: false
    };
  },

  computed: {
    approvalsRequiredStringified: function approvalsRequiredStringified() {
      var approvedString = Object(locale["e" /* s__ */])('MergeRequest|Approved');
      if (this.approvalsLeft >= 1) {
        approvedString = Object(locale["f" /* sprintf */])(Object(locale["d" /* n__ */])('mrWidget|Requires 1 more approval by', 'MergeRequest|Requires %d more approvals by', this.approvalsLeft));
      }
      return approvedString;
    },
    approveButtonText: function approveButtonText() {
      var approveButtonText = Object(locale["e" /* s__ */])('mrWidget|Approve');
      if (this.approvalsLeft <= 0) {
        approveButtonText = Object(locale["e" /* s__ */])('mrWidget|Add approval');
      }
      return approveButtonText;
    },
    approveButtonClass: function approveButtonClass() {
      return {
        'btn-inverted': this.showApproveButton && this.approvalsLeft <= 0
      };
    },
    showApproveButton: function showApproveButton() {
      return this.userCanApprove && !this.userHasApproved && this.mr.isOpen;
    },
    showSuggestedApprovers: function showSuggestedApprovers() {
      return this.suggestedApprovers && this.suggestedApprovers.length;
    }
  },
  methods: {
    approveMergeRequest: function approveMergeRequest() {
      var _this = this;

      this.approving = true;
      this.service.approveMergeRequest().then(function (data) {
        _this.mr.setApprovals(data);
        event_hub["a" /* default */].$emit('MRWidgetUpdateRequested');
        _this.approving = false;
      }).catch(function () {
        _this.approving = false;
        Object(flash["a" /* default */])(Object(locale["e" /* s__ */])('mrWidget|An error occured while submitting your approval.'));
      });
    }
  },
  template: '\n    <div class="approvals-body space-children">\n      <span v-if="showApproveButton" class="approvals-approve-button-wrap">\n        <button\n          :disabled="approving"\n          @click="approveMergeRequest"\n          class="btn btn-primary btn-sm approve-btn"\n          :class="approveButtonClass">\n          <i\n            v-if="approving"\n            class="fa fa-spinner fa-spin"\n            aria-hidden="true" />\n          {{approveButtonText}}\n        </button>\n      </span>\n      <span class="approvals-required-text bold">\n        {{approvalsRequiredStringified}}\n        <span v-if="showSuggestedApprovers">\n          <mr-widget-author\n            v-for="approver in suggestedApprovers"\n            :key="approver.username"\n            :author="approver"\n            :show-author-name="false"\n            :show-author-tooltip="true" />\n        </span>\n      </span>\n    </div>\n  '
});
// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/views/shared/icons/_icon_dotted_circle.svg
var _icon_dotted_circle = __webpack_require__("../../../ee/app/views/shared/icons/_icon_dotted_circle.svg");
var _icon_dotted_circle_default = /*#__PURE__*/__webpack_require__.n(_icon_dotted_circle);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_shared/components/link_to_member_avatar.js
// Analogue of link_to_member_avatar in app/helpers/projects_helper.rb


/* harmony default export */ var link_to_member_avatar = ({
  props: {
    avatarUrl: {
      type: String,
      required: false
    },
    profileUrl: {
      type: String,
      required: false,
      default: ''
    },
    displayName: {
      type: String,
      required: false
    },
    extraAvatarClass: {
      type: String,
      default: '',
      required: false
    },
    extraLinkClass: {
      type: String,
      default: '',
      required: false
    },
    showTooltip: {
      type: Boolean,
      required: false,
      default: true
    },
    clickable: {
      type: Boolean,
      default: true,
      required: false
    },
    tooltipContainer: {
      type: String,
      required: false
    },
    avatarHtml: {
      type: String,
      required: false
    },
    avatarSize: {
      type: Number,
      required: false,
      default: 32
    }
  },
  data: function data() {
    return {
      avatarBaseClass: 'avatar avatar-inline',
      pendingAvatarSvg: _icon_dotted_circle_default.a
    };
  },

  computed: {
    avatarSizeClass: function avatarSizeClass() {
      return 's' + this.avatarSize;
    },
    avatarHtmlClass: function avatarHtmlClass() {
      return this.avatarSizeClass + ' ' + this.avatarBaseClass + ' avatar-placeholder';
    },
    tooltipClass: function tooltipClass() {
      return this.showTooltip ? 'has-tooltip' : '';
    },
    avatarClass: function avatarClass() {
      return this.avatarBaseClass + ' ' + this.avatarSizeClass + ' ' + this.extraAvatarClass;
    },
    disabledClass: function disabledClass() {
      return !this.clickable ? 'disabled' : '';
    },
    linkClass: function linkClass() {
      return 'author_link ' + this.tooltipClass + ' ' + this.extraLinkClass + ' ' + this.disabledClass;
    },
    tooltipContainerAttr: function tooltipContainerAttr() {
      return this.tooltipContainer || 'body';
    }
  },
  template: '\n    <div class="link-to-member-avatar">\n      <a\n        :href="profileUrl"\n        :class="linkClass"\n        :title="displayName"\n        :data-container="tooltipContainerAttr">\n        <img\n          v-if="avatarUrl"\n          :class="avatarClass"\n          :src="avatarUrl"\n          :width="avatarSize"\n          :height="avatarSize"\n          :alt="displayName"/>\n        <span\n          v-else\n          v-html="pendingAvatarSvg"\n          :class="avatarHtmlClass"\n          :width="avatarSize"\n          :height="avatarSize">\n        </span>\n      </a>\n    </div>\n  '
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_merge_request_widget/components/approvals/approvals_footer.js





/* harmony default export */ var approvals_footer = ({
  name: 'approvals-footer',
  props: {
    mr: {
      type: Object,
      required: true
    },
    service: {
      type: Object,
      required: true
    },
    approvedBy: {
      type: Array,
      required: false
    },
    approvalsLeft: {
      type: Number,
      required: false
    },
    userCanApprove: {
      type: Boolean,
      required: false
    },
    userHasApproved: {
      type: Boolean,
      required: false
    },
    suggestedApprovers: {
      type: Array,
      required: false
    }
  },
  data: function data() {
    return {
      unapproving: false
    };
  },

  components: {
    'link-to-member-avatar': link_to_member_avatar
  },
  computed: {
    showUnapproveButton: function showUnapproveButton() {
      var isMerged = this.mr.state === 'merged';
      return this.userHasApproved && !this.userCanApprove && !isMerged;
    },
    approvedByText: function approvedByText() {
      return Object(locale["e" /* s__ */])('mrWidget|Approved by');
    },
    removeApprovalText: function removeApprovalText() {
      return Object(locale["e" /* s__ */])('mrWidget|Remove your approval');
    }
  },
  methods: {
    unapproveMergeRequest: function unapproveMergeRequest() {
      var _this = this;

      this.unapproving = true;
      this.service.unapproveMergeRequest().then(function (data) {
        _this.mr.setApprovals(data);
        event_hub["a" /* default */].$emit('MRWidgetUpdateRequested');
        _this.unapproving = false;
      }).catch(function () {
        _this.unapproving = false;
        Object(flash["a" /* default */])(Object(locale["e" /* s__ */])('mrWidget|An error occured while removing your approval.'));
      });
    }
  },
  template: '\n    <div\n      v-if="approvedBy.length"\n      class="approved-by-users approvals-footer clearfix mr-info-list">\n      <div class="approvers-prefix">\n        <p>{{approvedByText}}</p>\n        <div class="approvers-list">\n          <link-to-member-avatar\n            v-for="(approver, index) in approvedBy"\n            :key="index"\n            :avatar-size="20"\n            :avatar-url="approver.user.avatar_url"\n            extra-link-class="approver-avatar js-approver-list-member"\n            :display-name="approver.user.name"\n            :profile-url="approver.user.web_url"\n            :show-tooltip="true"\n            />\n          <link-to-member-avatar\n            v-for="n in approvalsLeft"\n            :key="n"\n            :avatar-size="20"\n            :clickable="false"\n            :show-tooltip="false"\n            />\n        </div>\n        <button\n          v-if="showUnapproveButton"\n          type="button"\n          :disabled="unapproving"\n          @click="unapproveMergeRequest"\n          class="btn btn-sm unapprove-btn-wrap">\n          <i\n            v-if="unapproving"\n            class="fa fa-spinner fa-spin"\n            aria-hidden="true">\n          </i>\n          {{removeApprovalText}}\n        </button>\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_merge_request_widget/components/approvals/mr_widget_approvals.js






/* harmony default export */ var mr_widget_approvals = ({
  name: 'MRWidgetApprovals',
  props: {
    mr: {
      type: Object,
      required: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      fetchingApprovals: true
    };
  },

  components: {
    'approvals-body': approvals_body,
    'approvals-footer': approvals_footer,
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  computed: {
    status: function status() {
      if (this.mr.approvals.approvals_left > 0) {
        return 'warning';
      }
      return 'success';
    }
  },
  created: function created() {
    var _this = this;

    var flashErrorMessage = Object(locale["e" /* s__ */])('mrWidget|An error occured while retrieving approval data for this merge request.');

    this.service.fetchApprovals().then(function (data) {
      _this.mr.setApprovals(data);
      _this.fetchingApprovals = false;
    }).catch(function () {
      return new flash["a" /* default */](flashErrorMessage);
    });
  },

  template: '\n    <div\n      v-if="mr.approvalsRequired"\n      class="mr-widget-approvals-container mr-widget-body mr-widget-section media">\n      <div\n        v-if="fetchingApprovals"\n        class="mr-widget-icon">\n        <i class="fa fa-spinner fa-spin" />\n      </div>\n      <status-icon v-else :status="status" />\n      <div\n        v-show="fetchingApprovals"\n        class="mr-approvals-loading-state media-body">\n        <span class="approvals-loading-text">\n          Checking approval status\n        </span>\n      </div>\n      <div\n        v-if="!fetchingApprovals"\n        class="approvals-components media-body">\n        <approvals-body\n          :mr="mr"\n          :service="service"\n          :user-can-approve="mr.approvals.user_can_approve"\n          :user-has-approved="mr.approvals.user_has_approved"\n          :approved-by="mr.approvals.approved_by"\n          :approvals-left="mr.approvals.approvals_left"\n          :suggested-approvers="mr.approvals.suggested_approvers" />\n        <approvals-footer\n          :mr="mr"\n          :service="service"\n          :user-can-approve="mr.approvals.user_can_approve"\n          :user-has-approved="mr.approvals.user_has_approved"\n          :approved-by="mr.approvals.approved_by"\n          :approvals-left="mr.approvals.approvals_left" />\n      </div>\n    </div>\n    '
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_merge_request_widget/components/states/mr_widget_secondary_geo_node.js


/* harmony default export */ var mr_widget_secondary_geo_node = ({
  props: {
    mr: {
      type: Object,
      required: true
    }
  },
  components: {
    statusIcon: mr_widget_status_icon["a" /* default */]
  },
  template: '\n    <div class="media">\n      <status-icon status="warning" showDisabledButton />\n      <div class="media-body">\n        <span class="bold">\n          Merge requests are read-only in a secondary Geo node\n        </span>\n        <a\n          :href="mr.geoSecondaryHelpPath"\n          data-title="About this feature"\n          data-toggle="tooltip"\n          data-placement="bottom"\n          target="_blank"\n          rel="noopener noreferrer nofollow"\n          data-container="body">\n          <i class="fa fa-question-circle"></i>\n        </a>\n      </div>\n    </div>\n  '
});
// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_shared/security_reports/components/report_section.vue + 4 modules
var report_section = __webpack_require__("../../../ee/app/assets/javascripts/vue_shared/security_reports/components/report_section.vue");

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_shared/security_reports/mixins/security_report_mixin.js
var security_report_mixin = __webpack_require__("../../../ee/app/assets/javascripts/vue_shared/security_reports/mixins/security_report_mixin.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_merge_request_widget/mr_widget_options.js







/* harmony default export */ var vue_merge_request_widget_mr_widget_options = ({
  extends: mr_widget_options,
  components: {
    'mr-widget-approvals': mr_widget_approvals,
    'mr-widget-geo-secondary-node': mr_widget_secondary_geo_node,
    ReportSection: report_section["a" /* default */]
  },
  mixins: [security_report_mixin["a" /* default */]],
  data: function data() {
    return {
      isLoadingCodequality: false,
      isLoadingPerformance: false,
      isLoadingSecurity: false,
      isLoadingDocker: false,
      isLoadingDast: false,
      loadingCodequalityFailed: false,
      loadingPerformanceFailed: false,
      loadingSecurityFailed: false,
      loadingDockerFailed: false,
      loadingDastFailed: false
    };
  },

  computed: {
    shouldRenderApprovals: function shouldRenderApprovals() {
      return this.mr.approvalsRequired && this.mr.state !== 'nothingToMerge';
    },
    shouldRenderCodeQuality: function shouldRenderCodeQuality() {
      var codeclimate = this.mr.codeclimate;

      return codeclimate && codeclimate.head_path && codeclimate.base_path;
    },
    shouldRenderPerformance: function shouldRenderPerformance() {
      var performance = this.mr.performance;

      return performance && performance.head_path && performance.base_path;
    },
    shouldRenderSecurityReport: function shouldRenderSecurityReport() {
      return this.mr.sast && this.mr.sast.head_path;
    },
    shouldRenderDockerReport: function shouldRenderDockerReport() {
      return this.mr.sastContainer;
    },
    shouldRenderDastReport: function shouldRenderDastReport() {
      return this.mr.dast;
    },
    codequalityText: function codequalityText() {
      var _mr$codeclimateMetric = this.mr.codeclimateMetrics,
          newIssues = _mr$codeclimateMetric.newIssues,
          resolvedIssues = _mr$codeclimateMetric.resolvedIssues;

      var text = [];

      if (!newIssues.length && !resolvedIssues.length) {
        text.push(Object(locale["e" /* s__ */])('ciReport|No changes to code quality'));
      } else if (newIssues.length || resolvedIssues.length) {
        text.push(Object(locale["e" /* s__ */])('ciReport|Code quality'));

        if (resolvedIssues.length) {
          text.push(Object(locale["d" /* n__ */])(' improved on %d point', ' improved on %d points', resolvedIssues.length));
        }

        if (newIssues.length > 0 && resolvedIssues.length > 0) {
          text.push(Object(locale["a" /* __ */])(' and'));
        }

        if (newIssues.length) {
          text.push(Object(locale["d" /* n__ */])(' degraded on %d point', ' degraded on %d points', newIssues.length));
        }
      }

      return text.join('');
    },
    performanceText: function performanceText() {
      var _mr$performanceMetric = this.mr.performanceMetrics,
          improved = _mr$performanceMetric.improved,
          degraded = _mr$performanceMetric.degraded;

      var text = [];

      if (!improved.length && !degraded.length) {
        text.push(Object(locale["e" /* s__ */])('ciReport|No changes to performance metrics'));
      } else if (improved.length || degraded.length) {
        text.push(Object(locale["e" /* s__ */])('ciReport|Performance metrics'));

        if (improved.length) {
          text.push(Object(locale["d" /* n__ */])(' improved on %d point', ' improved on %d points', improved.length));
        }

        if (improved.length > 0 && degraded.length > 0) {
          text.push(Object(locale["a" /* __ */])(' and'));
        }

        if (degraded.length) {
          text.push(Object(locale["d" /* n__ */])(' degraded on %d point', ' degraded on %d points', degraded.length));
        }
      }

      return text.join('');
    },
    securityText: function securityText() {
      var _mr$securityReport = this.mr.securityReport,
          newIssues = _mr$securityReport.newIssues,
          resolvedIssues = _mr$securityReport.resolvedIssues,
          allIssues = _mr$securityReport.allIssues;

      return this.sastText(newIssues, resolvedIssues, allIssues);
    },
    dockerText: function dockerText() {
      var _mr$dockerReport = this.mr.dockerReport,
          vulnerabilities = _mr$dockerReport.vulnerabilities,
          approved = _mr$dockerReport.approved,
          unapproved = _mr$dockerReport.unapproved;

      return this.sastContainerText(vulnerabilities, approved, unapproved);
    },
    getDastText: function getDastText() {
      return this.dastText(this.mr.dastReport);
    },
    codequalityStatus: function codequalityStatus() {
      return this.checkReportStatus(this.isLoadingCodequality, this.loadingCodequalityFailed);
    },
    performanceStatus: function performanceStatus() {
      return this.checkReportStatus(this.isLoadingPerformance, this.loadingPerformanceFailed);
    },
    securityStatus: function securityStatus() {
      return this.checkReportStatus(this.isLoadingSecurity, this.loadingSecurityFailed);
    },
    dockerStatus: function dockerStatus() {
      return this.checkReportStatus(this.isLoadingDocker, this.loadingDockerFailed);
    },
    dastStatus: function dastStatus() {
      return this.checkReportStatus(this.isLoadingDast, this.loadingDastFailed);
    }
  },
  methods: {
    fetchCodeQuality: function fetchCodeQuality() {
      var _this = this;

      var _mr$codeclimate = this.mr.codeclimate,
          head_path = _mr$codeclimate.head_path,
          base_path = _mr$codeclimate.base_path;


      this.isLoadingCodequality = true;

      Promise.all([this.service.fetchReport(head_path), this.service.fetchReport(base_path)]).then(function (values) {
        _this.mr.compareCodeclimateMetrics(values[0], values[1], _this.mr.headBlobPath, _this.mr.baseBlobPath);
        _this.isLoadingCodequality = false;
      }).catch(function () {
        _this.isLoadingCodequality = false;
        _this.loadingCodequalityFailed = true;
      });
    },
    fetchPerformance: function fetchPerformance() {
      var _this2 = this;

      var _mr$performance = this.mr.performance,
          head_path = _mr$performance.head_path,
          base_path = _mr$performance.base_path;


      this.isLoadingPerformance = true;

      Promise.all([this.service.fetchReport(head_path), this.service.fetchReport(base_path)]).then(function (values) {
        _this2.mr.comparePerformanceMetrics(values[0], values[1]);
        _this2.isLoadingPerformance = false;
      }).catch(function () {
        _this2.isLoadingPerformance = false;
        _this2.loadingPerformanceFailed = true;
      });
    },

    /**
     * Sast report can either have 2 reports or just 1
     * When it has 2 we need to compare them
     * When it has 1 we render the output given
     */
    fetchSecurity: function fetchSecurity() {
      var _this3 = this;

      var sast = this.mr.sast;


      this.isLoadingSecurity = true;

      if (sast.base_path && sast.head_path) {
        Promise.all([this.service.fetchReport(sast.head_path), this.service.fetchReport(sast.base_path)]).then(function (values) {
          _this3.handleSecuritySuccess({
            head: values[0],
            headBlobPath: _this3.mr.headBlobPath,
            base: values[1],
            baseBlobPath: _this3.mr.baseBlobPath
          });
        }).catch(function () {
          return _this3.handleSecurityError();
        });
      } else if (sast.head_path) {
        this.service.fetchReport(sast.head_path).then(function (data) {
          _this3.handleSecuritySuccess({
            head: data,
            headBlobPath: _this3.mr.headBlobPath
          });
        }).catch(function () {
          return _this3.handleSecurityError();
        });
      }
    },
    handleSecuritySuccess: function handleSecuritySuccess(data) {
      this.mr.setSecurityReport(data);
      this.isLoadingSecurity = false;
    },
    handleSecurityError: function handleSecurityError() {
      this.isLoadingSecurity = false;
      this.loadingSecurityFailed = true;
    },
    fetchDockerReport: function fetchDockerReport() {
      var _this4 = this;

      var path = this.mr.sastContainer.path;

      this.isLoadingDocker = true;

      this.service.fetchReport(path).then(function (data) {
        _this4.mr.setDockerReport(data);
        _this4.isLoadingDocker = false;
      }).catch(function () {
        _this4.isLoadingDocker = false;
        _this4.loadingDockerFailed = true;
      });
    },
    fetchDastReport: function fetchDastReport() {
      var _this5 = this;

      this.isLoadingDast = true;

      this.service.fetchReport(this.mr.dast.path).then(function (data) {
        _this5.mr.setDastReport(data);
        _this5.isLoadingDast = false;
      }).catch(function () {
        _this5.isLoadingDast = false;
        _this5.loadingDastFailed = true;
      });
    }
  },
  created: function created() {
    if (this.shouldRenderCodeQuality) {
      this.fetchCodeQuality();
    }

    if (this.shouldRenderPerformance) {
      this.fetchPerformance();
    }

    if (this.shouldRenderSecurityReport) {
      this.fetchSecurity();
    }

    if (this.shouldRenderDockerReport) {
      this.fetchDockerReport();
    }

    if (this.shouldRenderDastReport) {
      this.fetchDastReport();
    }
  },

  template: '\n    <div class="mr-state-widget prepend-top-default">\n      <mr-widget-header :mr="mr" />\n      <mr-widget-pipeline\n        v-if="shouldRenderPipelines"\n        :pipeline="mr.pipeline"\n        :ci-status="mr.ciStatus"\n        :has-ci="mr.hasCI"\n        />\n      <mr-widget-deployment\n        v-if="shouldRenderDeployments"\n        :mr="mr"\n        :service="service"\n        />\n      <mr-widget-approvals\n        v-if="shouldRenderApprovals"\n        :mr="mr"\n        :service="service"\n        />\n      <report-section\n        class="js-codequality-widget"\n        v-if="shouldRenderCodeQuality"\n        type="codequality"\n        :status="codequalityStatus"\n        :loading-text="translateText(\'codeclimate\').loading"\n        :error-text="translateText(\'codeclimate\').error"\n        :success-text="codequalityText"\n        :unresolved-issues="mr.codeclimateMetrics.newIssues"\n        :resolved-issues="mr.codeclimateMetrics.resolvedIssues"\n        />\n      <report-section\n        class="js-performance-widget"\n        v-if="shouldRenderPerformance"\n        type="performance"\n        :status="performanceStatus"\n        :loading-text="translateText(\'performance\').loading"\n        :error-text="translateText(\'performance\').error"\n        :success-text="performanceText"\n        :unresolved-issues="mr.performanceMetrics.degraded"\n        :resolved-issues="mr.performanceMetrics.improved"\n        :neutral-issues="mr.performanceMetrics.neutral"\n        />\n      <report-section\n        class="js-sast-widget"\n        v-if="shouldRenderSecurityReport"\n        type="security"\n        :status="securityStatus"\n        :loading-text="translateText(\'security\').loading"\n        :error-text="translateText(\'security\').error"\n        :success-text="securityText"\n        :unresolved-issues="mr.securityReport.newIssues"\n        :resolved-issues="mr.securityReport.resolvedIssues"\n        :all-issues="mr.securityReport.allIssues"\n        :has-priority="true"\n        />\n      <report-section\n        class="js-docker-widget"\n        v-if="shouldRenderDockerReport"\n        type="docker"\n        :status="dockerStatus"\n        :loading-text="translateText(\'sast:container\').loading"\n        :error-text="translateText(\'sast:container\').error"\n        :success-text="dockerText"\n        :unresolved-issues="mr.dockerReport.unapproved"\n        :neutral-issues="mr.dockerReport.approved"\n        :info-text="sastContainerInformationText()"\n        :has-priority="true"\n        />\n      <report-section\n        class="js-dast-widget"\n        v-if="shouldRenderDastReport"\n        type="dast"\n        :status="dastStatus"\n        :loading-text="translateText(\'DAST\').loading"\n        :error-text="translateText(\'DAST\').error"\n        :success-text="getDastText"\n        :unresolved-issues="mr.dastReport"\n        :has-priority="true"\n        />\n      <div class="mr-widget-section">\n        <component\n          :is="componentName"\n          :mr="mr"\n          :service="service" />\n        <mr-widget-related-links\n          v-if="shouldRenderRelatedLinks"\n          :related-links="mr.relatedLinks"\n          />\n        <mr-widget-maintainer-edit\n          :maintainerEditAllowed="mr.maintainerEditAllowed" />\n      </div>\n      <div class="mr-widget-footer" v-if="shouldRenderMergeHelp">\n        <mr-widget-merge-help />\n      </div>\n    </div>\n  '
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_merge_request_widget/stores/state_maps.js


state_maps.stateToComponentMap.geoSecondaryNode = 'mr-widget-geo-secondary-node';

/* harmony default export */ var stores_state_maps = ({
  stateToComponentMap: state_maps.stateToComponentMap,
  statesToShowHelpWidget: state_maps.statesToShowHelpWidget
});
// CONCATENATED MODULE: ./lib/utils/notify.js
/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, one-var, one-var-declaration-per-line, consistent-return, prefer-arrow-callback, no-return-assign, object-shorthand, comma-dangle, no-param-reassign, max-len */

function notificationGranted(message, opts, onclick) {
  var notification;
  notification = new Notification(message, opts);
  setTimeout(function () {
    // Hide the notification after X amount of seconds
    return notification.close();
  }, 8000);

  return notification.onclick = onclick || notification.close;
}

function notifyPermissions() {
  if ('Notification' in window) {
    return Notification.requestPermission();
  }
}

function notifyMe(message, body, icon, onclick) {
  var opts;
  opts = {
    body: body,
    icon: icon
  };
  // Let's check if the browser supports notifications
  if (!('Notification' in window)) {
    // do nothing
  } else if (Notification.permission === 'granted') {
    // If it's okay let's create a notification
    return notificationGranted(message, opts, onclick);
  } else if (Notification.permission !== 'denied') {
    return Notification.requestPermission(function (permission) {
      // If the user accepts, let's create a notification
      if (permission === 'granted') {
        return notificationGranted(message, opts, onclick);
      }
    });
  }
}

var notify = {
  notificationGranted: notificationGranted,
  notifyPermissions: notifyPermissions,
  notifyMe: notifyMe
};

/* harmony default export */ var utils_notify = (notify);
// CONCATENATED MODULE: ./vue_merge_request_widget/dependencies.js
/**
 * This file is the centerpiece of an attempt to reduce potential conflicts
 * between the CE and EE versions of the MR widget. EE additions to the MR widget should
 * be contained in the ee/vue_merge_request_widget directory, and should **extend**
 * rather than mutate CE MR Widget code.
 *
 * This file should be the only source of conflicts between EE and CE. EE-only components should
 * imported directly where they are needed, and import paths for EE extensions of CE components
 * should overwrite import paths **without** changing the order of dependencies listed here.
 */




































// EXTERNAL MODULE: ./vue_shared/translate.js
var translate = __webpack_require__("./vue_shared/translate.js");

// CONCATENATED MODULE: ./vue_merge_request_widget/index.js



vue_esm["a" /* default */].use(translate["a" /* default */]);

/* harmony default export */ var vue_merge_request_widget = (function () {
  gl.mrWidgetData.gitlabLogo = gon.gitlab_logo;

  var vm = new vue_esm["a" /* default */](vue_merge_request_widget_mr_widget_options);

  window.gl.mrWidget = {
    checkStatus: vm.checkStatus
  };
});
// CONCATENATED MODULE: ./pages/projects/merge_requests/init_merge_request_show.js












/* harmony default export */ var init_merge_request_show = (function () {
  new diff["a" /* default */](); // eslint-disable-line no-new
  new zen_mode["a" /* default */](); // eslint-disable-line no-new

  Object(init_issuable_sidebar["a" /* default */])();
  Object(init_notes["a" /* default */])();
  Object(diff_notes_bundle["a" /* default */])();
  Object(pipelines_bundle["a" /* default */])();

  var mrShowNode = document.querySelector('.merge-request');

  window.mergeRequest = new merge_request["a" /* default */]({
    action: mrShowNode.dataset.mrAction
  });

  new shortcuts_issuable["a" /* default */](true); // eslint-disable-line no-new
  Object(common_utils["m" /* handleLocationHash */])();
  Object(how_to_merge["a" /* default */])();
  vue_merge_request_widget();
});
// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/sidebar_bundle.js + 8 modules
var sidebar_bundle = __webpack_require__("../../../ee/app/assets/javascripts/sidebar/sidebar_bundle.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/pages/projects/merge_requests/show/index.js



document.addEventListener('DOMContentLoaded', function () {
  init_merge_request_show();
  Object(sidebar_bundle["a" /* default */])();
});

/***/ }),

/***/ "../../../ee/app/assets/javascripts/sidebar/components/weight/weight.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!/var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/components/weight/weight.vue
var weight = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!../../../ee/app/assets/javascripts/sidebar/components/weight/weight.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b28f0dd","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!/var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/components/weight/weight.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block weight",class:{ 'collapse-after-update': _vm.collapseAfterDropdownCloses }},[_c('div',{staticClass:"sidebar-collapsed-icon js-weight-collapsed-block",on:{"click":_vm.onCollapsedClick}},[_c('icon',{attrs:{"name":"scale","size":16}}),_vm._v(" "),(_vm.fetching)?_c('loading-icon',{staticClass:"js-weight-collapsed-loading-icon"}):_c('span',{staticClass:"js-weight-collapsed-weight-label"},[_vm._v("\n      "+_vm._s(_vm.collapsedWeightLabel)+"\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"title hide-collapsed"},[_vm._v("\n    "+_vm._s(_vm.s__('Sidebar|Weight'))+"\n    "),(_vm.fetching || _vm.loading)?_c('loading-icon',{staticClass:"js-weight-loading-icon",attrs:{"inline":true}}):_vm._e(),_vm._v(" "),(_vm.editable)?_c('a',{staticClass:"pull-right js-weight-edit-link",attrs:{"href":"#"},on:{"click":_vm.showDropdown}},[_vm._v("\n      "+_vm._s(_vm.__('Edit'))+"\n    ")]):_vm._e()],1),_vm._v(" "),(_vm.shouldShowWeight)?_c('div',{staticClass:"value hide-collapsed js-weight-weight-label"},[(!_vm.isNoValue)?_c('strong',[_vm._v("\n      "+_vm._s(_vm.weight)+"\n    ")]):_c('span',{staticClass:"no-value"},[_vm._v("\n      "+_vm._s(_vm.noValueLabel)+"\n    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"selectbox hide-collapsed",class:{ show: _vm.shouldShowDropdown }},[_c('div',{ref:"weightDropdown",staticClass:"dropdown"},[_c('button',{ref:"dropdownToggle",staticClass:"dropdown-menu-toggle js-gl-dropdown-refresh-on-open",attrs:{"type":"button","data-toggle":"dropdown"}},[_c('span',{staticClass:"dropdown-toggle-text js-weight-dropdown-toggle-text",class:{ 'is-default': _vm.isNoValue }},[_vm._v("\n          "+_vm._s(_vm.dropdownToggleLabel)+"\n        ")]),_vm._v(" "),_c('i',{staticClass:"fa fa-chevron-down",attrs:{"aria-hidden":"true","data-hidden":"true"}})]),_vm._v(" "),_vm._m(1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"dropdown-title-button dropdown-menu-close",attrs:{"aria-label":"Close","type":"button"}},[_c('i',{staticClass:"fa fa-times dropdown-menu-close-icon",attrs:{"aria-hidden":"true","data-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-menu dropdown-select dropdown-menu-selectable dropdown-menu-weight"},[_c('div',{staticClass:"dropdown-title"},[_c('span',[_vm._v("\n            "+_vm._s(_vm.changeWeightLabel)+"\n          ")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"dropdown-content js-weight-dropdown-content"})])}]

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/components/weight/weight.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  weight["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var weight_weight = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "../../../ee/app/assets/javascripts/sidebar/sidebar_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./sidebar/mount_sidebar.js
var mount_sidebar = __webpack_require__("./sidebar/mount_sidebar.js");

// EXTERNAL MODULE: ./sidebar/sidebar_mediator.js + 1 modules
var sidebar_mediator = __webpack_require__("./sidebar/sidebar_mediator.js");

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/stores/sidebar_store.js
var sidebar_store = __webpack_require__("../../../ee/app/assets/javascripts/sidebar/stores/sidebar_store.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/sidebar_mediator.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var sidebar_mediator_SidebarMediator = function (_CESidebarMediator) {
  _inherits(SidebarMediator, _CESidebarMediator);

  function SidebarMediator() {
    _classCallCheck(this, SidebarMediator);

    return _possibleConstructorReturn(this, (SidebarMediator.__proto__ || Object.getPrototypeOf(SidebarMediator)).apply(this, arguments));
  }

  _createClass(SidebarMediator, [{
    key: 'initSingleton',
    value: function initSingleton(options) {
      _get(SidebarMediator.prototype.__proto__ || Object.getPrototypeOf(SidebarMediator.prototype), 'initSingleton', this).call(this, options);
      this.store = new sidebar_store["a" /* default */](options);
    }
  }, {
    key: 'processFetchedData',
    value: function processFetchedData(data) {
      _get(SidebarMediator.prototype.__proto__ || Object.getPrototypeOf(SidebarMediator.prototype), 'processFetchedData', this).call(this, data);
      this.store.setWeightData(data);
      this.store.setEpicData(data);
    }
  }, {
    key: 'updateWeight',
    value: function updateWeight(newWeight) {
      var _this2 = this;

      this.store.setLoadingState('weight', true);
      return this.service.update('issue[weight]', newWeight).then(function (res) {
        return res.json();
      }).then(function (data) {
        _this2.store.setWeight(data.weight);
        _this2.store.setLoadingState('weight', false);
      }).catch(function (err) {
        _this2.store.setLoadingState('weight', false);
        throw err;
      });
    }
  }]);

  return SidebarMediator;
}(sidebar_mediator["a" /* default */]);

/* harmony default export */ var sidebar_sidebar_mediator = (sidebar_mediator_SidebarMediator);
// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./sidebar/event_hub.js
var event_hub = __webpack_require__("./sidebar/event_hub.js");

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/components/weight/weight.vue + 1 modules
var weight = __webpack_require__("../../../ee/app/assets/javascripts/sidebar/components/weight/weight.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!/var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/components/weight/sidebar_weight.vue





/* harmony default export */ var sidebar_weight = ({
  components: {
    weight: weight["a" /* default */]
  },
  props: {
    mediator: {
      required: true,
      type: Object,
      validator: function validator(mediatorObject) {
        return mediatorObject.updateWeight && mediatorObject.store;
      }
    }
  },

  created: function created() {
    event_hub["a" /* default */].$on('updateWeight', this.onUpdateWeight);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('updateWeight', this.onUpdateWeight);
  },


  methods: {
    onUpdateWeight: function onUpdateWeight(newWeight) {
      this.mediator.updateWeight(newWeight).catch(function () {
        Object(flash["a" /* default */])('Error occurred while updating the issue weight');
      });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-929e05f8","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!/var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/components/weight/sidebar_weight.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('weight',{attrs:{"fetching":_vm.mediator.store.isFetching.weight,"loading":_vm.mediator.store.isLoading.weight,"weight":_vm.mediator.store.weight,"weight-options":_vm.mediator.store.weightOptions,"weight-none-value":_vm.mediator.store.weightNoneValue,"editable":_vm.mediator.store.editable}})}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/components/weight/sidebar_weight.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sidebar_weight,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var weight_sidebar_weight = (Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!/var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/components/sidebar_item_epic.vue






/* harmony default export */ var sidebar_item_epic = ({
  name: 'SidebarItemEpic',
  components: {
    LoadingIcon: loading_icon["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  data: function data() {
    return {
      store: new sidebar_store["a" /* default */]()
    };
  },

  computed: {
    isLoading: function isLoading() {
      return this.store.isFetching.epic;
    },
    epicIcon: function epicIcon() {
      return Object(common_utils["G" /* spriteIcon */])('epic');
    },
    epicUrl: function epicUrl() {
      return this.store.epic.url;
    },
    epicTitle: function epicTitle() {
      return this.store.epic.title;
    },
    hasEpic: function hasEpic() {
      return this.epicUrl && this.epicTitle;
    },
    collapsedTitle: function collapsedTitle() {
      return this.hasEpic ? this.epicTitle : 'None';
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce811568","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!/var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/components/sidebar_item_epic.vue
var sidebar_item_epic_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar-collapsed-icon"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.epicIcon)}}),_vm._v(" "),(!_vm.isLoading)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"collapse-truncated-title",attrs:{"title":_vm.epicTitle,"data-container":"body","data-placement":"left"}},[_vm._v("\n      "+_vm._s(_vm.collapsedTitle)+"\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"title hide-collapsed"},[_vm._v("\n    Epic\n    "),(_vm.isLoading)?_c('loading-icon',{attrs:{"inline":true}}):_vm._e()],1),_vm._v(" "),(!_vm.isLoading)?_c('div',{staticClass:"value hide-collapsed"},[(_vm.hasEpic)?_c('a',{staticClass:"bold",attrs:{"href":_vm.epicUrl}},[_vm._v("\n      "+_vm._s(_vm.epicTitle)+"\n    ")]):_c('span',{staticClass:"no-value"},[_vm._v("\n      None\n    ")])]):_vm._e()])}
var sidebar_item_epic_staticRenderFns = []

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/components/sidebar_item_epic.vue
/* script */


/* template */

/* template functional */
var sidebar_item_epic___vue_template_functional__ = false
/* styles */
var sidebar_item_epic___vue_styles__ = null
/* scopeId */
var sidebar_item_epic___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sidebar_item_epic___vue_module_identifier__ = null

var sidebar_item_epic_Component = Object(component_normalizer["a" /* default */])(
  sidebar_item_epic,
  sidebar_item_epic_render,
  sidebar_item_epic_staticRenderFns,
  sidebar_item_epic___vue_template_functional__,
  sidebar_item_epic___vue_styles__,
  sidebar_item_epic___vue_scopeId__,
  sidebar_item_epic___vue_module_identifier__
)

/* harmony default export */ var components_sidebar_item_epic = (sidebar_item_epic_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/mount_sidebar.js





function mountWeightComponent(mediator) {
  var el = document.querySelector('.js-sidebar-weight-entry-point');

  if (!el) return;

  // eslint-disable-next-line no-new
  new vue_esm["a" /* default */]({
    el: el,
    components: {
      sidebarWeight: weight_sidebar_weight
    },
    render: function render(createElement) {
      return createElement('sidebar-weight', {
        props: {
          mediator: mediator
        }
      });
    }
  });
}

function mountEpic() {
  var el = document.querySelector('#js-vue-sidebar-item-epic');

  if (!el) return;

  // eslint-disable-next-line no-new
  new vue_esm["a" /* default */]({
    el: el,
    components: {
      SidebarItemEpic: components_sidebar_item_epic
    },
    render: function render(createElement) {
      return createElement('sidebar-item-epic', {});
    }
  });
}

function mountSidebar(mediator) {
  mount_sidebar["b" /* mountSidebar */](mediator);
  mountWeightComponent(mediator);
  mountEpic();
}
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/sidebar_bundle.js




/* harmony default export */ var sidebar_bundle = __webpack_exports__["a"] = (function () {
  var mediator = new sidebar_sidebar_mediator(Object(mount_sidebar["a" /* getSidebarOptions */])());
  mediator.fetch();

  mountSidebar(mediator);
});

/***/ }),

/***/ "../../../ee/app/assets/javascripts/sidebar/stores/sidebar_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sidebar_stores_sidebar_store__ = __webpack_require__("./sidebar/stores/sidebar_store.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SidebarStore = function (_CESidebarStore) {
  _inherits(SidebarStore, _CESidebarStore);

  function SidebarStore() {
    _classCallCheck(this, SidebarStore);

    return _possibleConstructorReturn(this, (SidebarStore.__proto__ || Object.getPrototypeOf(SidebarStore)).apply(this, arguments));
  }

  _createClass(SidebarStore, [{
    key: 'initSingleton',
    value: function initSingleton(options) {
      _get(SidebarStore.prototype.__proto__ || Object.getPrototypeOf(SidebarStore.prototype), 'initSingleton', this).call(this, options);

      this.isFetching.weight = true;
      this.isFetching.epic = true;
      this.isLoading.weight = false;
      this.weight = null;
      this.weightOptions = options.weightOptions;
      this.weightNoneValue = options.weightNoneValue;
      this.epic = {};
    }
  }, {
    key: 'setWeightData',
    value: function setWeightData(data) {
      this.isFetching.weight = false;
      this.weight = data.weight || null;
    }
  }, {
    key: 'setWeight',
    value: function setWeight(newWeight) {
      this.weight = newWeight;
    }
  }, {
    key: 'setEpicData',
    value: function setEpicData(data) {
      this.isFetching.epic = false;
      this.epic = data.epic || {};
    }
  }]);

  return SidebarStore;
}(__WEBPACK_IMPORTED_MODULE_0__sidebar_stores_sidebar_store__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SidebarStore);

/***/ }),

/***/ "../../../ee/app/assets/javascripts/vue_shared/security_reports/components/report_section.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./vue_merge_request_widget/components/mr_widget_status_icon.vue + 2 modules
var mr_widget_status_icon = __webpack_require__("./vue_merge_request_widget/components/mr_widget_status_icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!/var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_shared/security_reports/components/report_issues.vue
var report_issues = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!../../../ee/app/assets/javascripts/vue_shared/security_reports/components/report_issues.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20bbd4a3","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!/var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_shared/security_reports/components/report_issues.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"report-block-list"},_vm._l((_vm.issues),function(issue,index){return _c('li',{key:index,staticClass:"report-block-list-issue"},[_c('div',{staticClass:"report-block-list-icon append-right-5",class:{
          failed: _vm.isStatusFailed,
          success: _vm.isStatusSuccess,
          neutral: _vm.isStatusNeutral,
        }},[_c('icon',{attrs:{"name":_vm.iconName,"size":32}})],1),_vm._v(" "),_c('div',{staticClass:"report-block-list-issue-description prepend-top-5 append-bottom-5"},[_c('div',{staticClass:"report-block-list-issue-description-text append-right-5"},[(_vm.isStatusSuccess && _vm.isTypeQuality)?[_vm._v(_vm._s(_vm.fixedLabel))]:_vm._e(),_vm._v(" "),(_vm.shouldRenderPriority(issue))?[_vm._v(_vm._s(issue.priority)+":")]:_vm._e(),_vm._v(" "),(_vm.isTypeDocker)?[(issue.nameLink)?_c('a',{attrs:{"href":issue.nameLink,"target":"_blank","rel":"noopener noreferrer nofollow"}},[_vm._v(_vm._s(issue.name))]):[_vm._v("\n              "+_vm._s(issue.name)+"\n            ")]]:(_vm.isTypeDast)?[_c('button',{staticClass:"js-modal-dast btn-link btn-blank text-left break-link",attrs:{"type":"button","data-toggle":"modal","data-target":_vm.modalTargetId},on:{"click":function($event){_vm.openDastModal(issue, index)}}},[_vm._v("\n              "+_vm._s(issue.name)+"\n            ")])]:[_vm._v("\n            "+_vm._s(issue.name)),(issue.score)?[_vm._v(":\n            "),_c('strong',[_vm._v(_vm._s(_vm.formatScore(issue.score)))])]:_vm._e()],_vm._v(" "),(_vm.isTypePerformance && issue.delta != null)?[_vm._v("\n            ("+_vm._s(issue.delta >= 0 ? '+' : '')+_vm._s(_vm.formatScore(issue.delta))+")\n          ")]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"report-block-list-issue-description-link"},[(issue.path)?[_vm._v("\n            in\n\n            "),(issue.urlPath)?_c('a',{staticClass:"break-link",attrs:{"href":issue.urlPath,"target":"_blank","rel":"noopener noreferrer nofollow"}},[_vm._v("\n              "+_vm._s(issue.path)),(issue.line)?[_vm._v(":"+_vm._s(issue.line))]:_vm._e()],2):[_vm._v("\n              "+_vm._s(issue.path)),(issue.line)?[_vm._v(":"+_vm._s(issue.line))]:_vm._e()]]:_vm._e()],2)])])})),_vm._v(" "),(_vm.isTypeDast)?_c('modal',{ref:"modal",staticClass:"modal-security-report-dast",attrs:{"id":_vm.modalId,"header-title-text":_vm.modalTitle}},[_vm._t("default",[_vm._v("\n      "+_vm._s(_vm.modalDesc)+"\n\n      "),_c('h5',{staticClass:"prepend-top-20"},[_vm._v("\n        "+_vm._s(_vm.s__('ciReport|Instances'))+"\n      ")]),_vm._v(" "),(_vm.modalInstances)?_c('ul',{staticClass:"report-block-list"},_vm._l((_vm.modalInstances),function(instance,i){return _c('li',{key:i,staticClass:"report-block-list-issue"},[_c('div',{staticClass:"report-block-list-icon append-right-5 failed"},[_c('icon',{attrs:{"name":"status_failed_borderless","size":32}})],1),_vm._v(" "),_c('div',{staticClass:"report-block-list-issue-description prepend-top-5 append-bottom-5"},[_c('div',{staticClass:"report-block-list-issue-description-text append-right-5"},[_vm._v("\n              "+_vm._s(instance.method)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"report-block-list-issue-description-link"},[_c('a',{staticClass:"break-link",attrs:{"href":instance.uri,"target":"_blank","rel":"noopener noreferrer nofollow"}},[_vm._v("\n                "+_vm._s(instance.uri)+"\n              ")])]),_vm._v(" "),(instance.evidence)?_c('expand-button',[_c('pre',{staticClass:"block report-block-dast-code prepend-top-10 report-block-issue-code",attrs:{"slot":"expanded"},slot:"expanded"},[_vm._v(_vm._s(instance.evidence))])]):_vm._e()],1)])})):_vm._e()]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"})],2):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_shared/security_reports/components/report_issues.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  report_issues["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_report_issues = (Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!/var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_shared/security_reports/components/report_section.vue






/* harmony default export */ var report_section = ({
  name: 'ReportSection',
  components: {
    IssuesBlock: components_report_issues,
    LoadingIcon: loading_icon["a" /* default */],
    StatusIcon: mr_widget_status_icon["a" /* default */]
  },
  props: {
    isCollapsible: {
      type: Boolean,
      required: false,
      default: true
    },
    // security | codequality | performance | docker
    type: {
      type: String,
      required: true
    },
    // loading | success | error
    status: {
      type: String,
      required: true
    },
    loadingText: {
      type: String,
      required: true
    },
    errorText: {
      type: String,
      required: true
    },
    successText: {
      type: String,
      required: true
    },
    unresolvedIssues: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    resolvedIssues: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    neutralIssues: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    allIssues: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    infoText: {
      type: [String, Boolean],
      required: false,
      default: false
    },
    hasPriority: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function data() {
    if (this.isCollapsible) {
      return {
        collapseText: Object(locale["a" /* __ */])('Expand'),
        isCollapsed: true,
        isFullReportVisible: false
      };
    }

    return {
      isFullReportVisible: true
    };
  },


  computed: {
    isLoading: function isLoading() {
      return this.status === 'loading';
    },
    loadingFailed: function loadingFailed() {
      return this.status === 'error';
    },
    isSuccess: function isSuccess() {
      return this.status === 'success';
    },
    statusIconName: function statusIconName() {
      if (this.loadingFailed || this.unresolvedIssues.length || this.neutralIssues.length) {
        return 'warning';
      }
      return 'success';
    },
    hasIssues: function hasIssues() {
      return this.unresolvedIssues.length || this.resolvedIssues.length || this.allIssues.length || this.neutralIssues.length;
    }
  },

  methods: {
    toggleCollapsed: function toggleCollapsed() {
      this.isCollapsed = !this.isCollapsed;

      var text = this.isCollapsed ? Object(locale["a" /* __ */])('Expand') : Object(locale["a" /* __ */])('Collapse');
      this.collapseText = text;
    },
    openFullReport: function openFullReport() {
      this.isFullReportVisible = true;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30448db2","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!/var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_shared/security_reports/components/report_section.vue
var report_section_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"report-block mr-widget-section"},[(_vm.isLoading)?_c('div',{staticClass:"media"},[_c('div',{staticClass:"mr-widget-icon"},[_c('loading-icon')],1),_vm._v(" "),_c('div',{staticClass:"media-body"},[_vm._v("\n      "+_vm._s(_vm.loadingText)+"\n    ")])]):(_vm.isSuccess)?_c('div',{staticClass:"media"},[_c('status-icon',{attrs:{"status":_vm.statusIconName}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"js-code-text"},[_vm._v("\n        "+_vm._s(_vm.successText)+"\n      ")]),_vm._v(" "),(_vm.isCollapsible && _vm.hasIssues)?_c('button',{staticClass:"js-collapse-btn btn bt-default pull-right btn-sm",attrs:{"type":"button"},on:{"click":_vm.toggleCollapsed}},[_vm._v("\n        "+_vm._s(_vm.collapseText)+"\n      ")]):_vm._e()])],1):_vm._e(),_vm._v(" "),(_vm.hasIssues)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCollapsible || (_vm.isCollapsible && !_vm.isCollapsed)),expression:"!isCollapsible || (isCollapsible && !isCollapsed)"}],staticClass:"report-block-container"},[(_vm.type === 'docker' && _vm.infoText)?_c('p',{staticClass:"js-mr-code-quality-info prepend-left-10 report-block-info",domProps:{"innerHTML":_vm._s(_vm.infoText)}}):_vm._e(),_vm._v(" "),(_vm.unresolvedIssues.length)?_c('issues-block',{staticClass:"js-mr-code-new-issues",attrs:{"type":_vm.type,"status":"failed","issues":_vm.unresolvedIssues,"has-priority":_vm.hasPriority}}):_vm._e(),_vm._v(" "),(_vm.isFullReportVisible)?_c('issues-block',{staticClass:"js-mr-code-all-issues",attrs:{"type":_vm.type,"status":"failed","issues":_vm.allIssues,"has-priority":_vm.hasPriority}}):_vm._e(),_vm._v(" "),(_vm.neutralIssues.length)?_c('issues-block',{staticClass:"js-mr-code-non-issues",attrs:{"type":_vm.type,"status":"neutral","issues":_vm.neutralIssues,"has-priority":_vm.hasPriority}}):_vm._e(),_vm._v(" "),(_vm.resolvedIssues.length)?_c('issues-block',{staticClass:"js-mr-code-resolved-issues",attrs:{"type":_vm.type,"status":"success","issues":_vm.resolvedIssues,"has-priority":_vm.hasPriority}}):_vm._e(),_vm._v(" "),(_vm.allIssues.length && !_vm.isFullReportVisible)?_c('button',{staticClass:"btn-link btn-blank prepend-left-10 js-expand-full-list break-link",attrs:{"type":"button"},on:{"click":_vm.openFullReport}},[_vm._v("\n      "+_vm._s(_vm.s__("ciReport|Show complete code vulnerabilities report"))+"\n    ")]):_vm._e()],1):(_vm.loadingFailed)?_c('div',{staticClass:"media"},[_c('status-icon',{attrs:{"status":"notfound"}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_vm._v("\n      "+_vm._s(_vm.errorText)+"\n    ")])],1):_vm._e()])}
var report_section_staticRenderFns = []

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/vue_shared/security_reports/components/report_section.vue
/* script */


/* template */

/* template functional */
var report_section___vue_template_functional__ = false
/* styles */
var report_section___vue_styles__ = null
/* scopeId */
var report_section___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var report_section___vue_module_identifier__ = null

var report_section_Component = Object(component_normalizer["a" /* default */])(
  report_section,
  report_section_render,
  report_section_staticRenderFns,
  report_section___vue_template_functional__,
  report_section___vue_styles__,
  report_section___vue_scopeId__,
  report_section___vue_module_identifier__
)

/* harmony default export */ var components_report_section = __webpack_exports__["a"] = (report_section_Component.exports);


/***/ }),

/***/ "../../../ee/app/assets/javascripts/vue_shared/security_reports/helpers/utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseIssues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterByKey; });
/* unused harmony export parseSastContainer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setSastReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setSastContainerReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setDastReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_text_utility__ = __webpack_require__("./lib/utils/text_utility.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Parses SAST and Codeclimate Issues into a common and reusable format
 * to reuse the same vue component.
 * [
 *   {
 *     name: String,
 *     priority: String,
 *     fingerprint: String,
 *     path: String,
 *     line: Number,
 *     urlPath: String
 *   }
 * ]
 * @param {array} issues
 * @return {array}
 */
var parseIssues = function parseIssues() {
  var issues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return issues.map(function (issue) {
    var parsedIssue = _extends({
      name: issue.description || issue.message
    }, issue);

    // code quality
    if (issue.location) {
      var parseCodeQualityUrl = void 0;

      if (issue.location.path) {
        parseCodeQualityUrl = path + '/' + issue.location.path;
        parsedIssue.path = issue.location.path;
      }

      if (issue.location.lines && issue.location.lines.begin) {
        parsedIssue.line = issue.location.lines.begin;
        parseCodeQualityUrl += '#L' + issue.location.lines.begin;
      }

      parsedIssue.urlPath = parseCodeQualityUrl;

      // security
    } else if (issue.file) {
      var parsedSecurityUrl = path + '/' + issue.file;
      parsedIssue.path = issue.file;

      if (issue.line) {
        parsedSecurityUrl += '#L' + issue.line;
      }
      parsedIssue.urlPath = parsedSecurityUrl;
    }

    return parsedIssue;
  });
};

/**
 * Compares two arrays by the given key and returns the difference
 *
 * @param {Array} firstArray
 * @param {Array} secondArray
 * @param {String} key
 * @returns {Array}
 */
var filterByKey = function filterByKey() {
  var firstArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var secondArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return firstArray.filter(function (item) {
    return !secondArray.find(function (el) {
      return el[key] === item[key];
    });
  });
};

/**
 * Parses DAST results into a common format to allow to use the same Vue component
 * And adds an external link
 *
 * @param {Array} data
 * @returns {Array}
 */
var parseSastContainer = function parseSastContainer() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return data.map(function (el) {
    return _extends({
      name: el.vulnerability,
      priority: el.severity,
      path: el.namespace,
      // external link to provide better description
      nameLink: 'https://cve.mitre.org/cgi-bin/cvename.cgi?name=' + el.vulnerability
    }, el);
  });
};

/**
 * Utils functions to set the reports
 */

/**
 * Compares sast results and returns the formatted report
 *
 * Security report has 3 types of issues, newIssues, resolvedIssues and allIssues.
 *
 * When we have both base and head:
 * - newIssues = head - base
 * - resolvedIssues = base - head
 * - allIssues = head - newIssues - resolvedIssues
 *
 * When we only have head
 * - newIssues = head
 * - resolvedIssues = 0
 * - allIssues = 0
 * @param {*} data
 * @returns {Object}
 */
var setSastReport = function setSastReport() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var securityReport = {};

  if (data.base) {
    var filterKey = 'cve';
    var parsedHead = parseIssues(data.head, data.headBlobPath);
    var parsedBase = parseIssues(data.base, data.baseBlobPath);

    securityReport.newIssues = filterByKey(parsedHead, parsedBase, filterKey);
    securityReport.resolvedIssues = filterByKey(parsedBase, parsedHead, filterKey);

    // Remove the new Issues and the added issues
    securityReport.allIssues = filterByKey(parsedHead, securityReport.newIssues.concat(securityReport.resolvedIssues), filterKey);
  } else {
    securityReport.newIssues = parseIssues(data.head, data.headBlobPath);
  }

  return securityReport;
};

var setSastContainerReport = function setSastContainerReport() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var unapproved = data.unapproved || [];

  var parsedVulnerabilities = parseSastContainer(data.vulnerabilities);

  // Approved can be calculated by subtracting unapproved from vulnerabilities.
  return {
    vulnerabilities: parsedVulnerabilities || [],
    approved: parsedVulnerabilities.filter(function (item) {
      return !unapproved.find(function (el) {
        return el === item.vulnerability;
      });
    }) || [],
    unapproved: parsedVulnerabilities.filter(function (item) {
      return unapproved.find(function (el) {
        return el === item.vulnerability;
      });
    }) || []
  };
};

/**
 * Dast Report sends some keys in HTML, we need to strip the `<p>` tags.
 * This should be moved to the backend.
 *
 * @param {Array} data
 * @returns {Array}
 */
var setDastReport = function setDastReport(data) {
  return data.site.alerts.map(function (alert) {
    return _extends({
      name: alert.name,
      parsedDescription: Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_text_utility__["i" /* stripHtml */])(alert.desc, ' '),
      priority: alert.riskdesc
    }, alert);
  });
};

/***/ }),

/***/ "../../../ee/app/assets/javascripts/vue_shared/security_reports/mixins/security_report_mixin.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    sastText: function sastText() {
      var newIssues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var resolvedIssues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var allIssues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      var text = [];

      if (!newIssues.length && !resolvedIssues.length && !allIssues.length) {
        text.push(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('ciReport|SAST detected no security vulnerabilities'));
      } else if (!newIssues.length && !resolvedIssues.length && allIssues.length) {
        text.push(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('ciReport|SAST detected no new security vulnerabilities'));
      } else if (newIssues.length || resolvedIssues.length) {
        text.push(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('ciReport|SAST'));
      }

      if (resolvedIssues.length) {
        text.push(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["d" /* n__ */])(' improved on %d security vulnerability', ' improved on %d security vulnerabilities', resolvedIssues.length));
      }

      if (newIssues.length > 0 && resolvedIssues.length > 0) {
        text.push(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */])(' and'));
      }

      if (newIssues.length) {
        text.push(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["d" /* n__ */])(' degraded on %d security vulnerability', ' degraded on %d security vulnerabilities', newIssues.length));
      }

      return text.join('');
    },
    translateText: function translateText(type) {
      return {
        error: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["f" /* sprintf */])(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('ciReport|Failed to load %{reportName} report'), { reportName: type }),
        loading: Object(__WEBPACK_IMPORTED_MODULE_0__locale__["f" /* sprintf */])(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('ciReport|Loading %{reportName} report'), { reportName: type })
      };
    },
    checkReportStatus: function checkReportStatus(loading, error) {
      if (loading) {
        return 'loading';
      } else if (error) {
        return 'error';
      }

      return 'success';
    },
    sastContainerText: function sastContainerText() {
      var vulnerabilities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var approved = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var unapproved = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      if (!vulnerabilities.length) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('ciReport|SAST:container no vulnerabilities were found');
      }

      if (!unapproved.length && approved.length) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__locale__["d" /* n__ */])('SAST:container found %d approved vulnerability', 'SAST:container found %d approved vulnerabilities', approved.length);
      } else if (unapproved.length && !approved.length) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__locale__["d" /* n__ */])('SAST:container found %d vulnerability', 'SAST:container found %d vulnerabilities', unapproved.length);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0__locale__["d" /* n__ */])('SAST:container found %d vulnerability,', 'SAST:container found %d vulnerabilities,', vulnerabilities.length) + ' ' + Object(__WEBPACK_IMPORTED_MODULE_0__locale__["d" /* n__ */])('of which %d is approved', 'of which %d are approved', approved.length);
    },
    dastText: function dastText() {
      var dast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (dast.length) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__locale__["d" /* n__ */])('DAST detected %d alert by analyzing the review app', 'DAST detected %d alerts by analyzing the review app', dast.length);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('ciReport|DAST detected no alerts by analyzing the review app');
    },
    sastContainerInformationText: function sastContainerInformationText() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__locale__["f" /* sprintf */])(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('ciReport|Unapproved vulnerabilities (red) can be marked as approved. %{helpLink}'), {
        helpLink: '<a href="https://gitlab.com/gitlab-org/clair-scanner#example-whitelist-yaml-file" target="_blank" rel="noopener noreferrer nofollow">\n            ' + Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('ciReport|Learn more about whitelisting') + '\n          </a>'
      }, false);
    }
  }
});

/***/ }),

/***/ "../../../ee/app/views/shared/icons/_arrow_mini_pipeline_graph.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"16\" height=\"8\" viewBox=\"0 0 16 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 3H0v2h10v3l5.549-3.7c.251-.167.25-.435 0-.6L10 0v3z\" fill-rule=\"nonzero\"/></svg>\n"

/***/ }),

/***/ "../../../ee/app/views/shared/icons/_icon_dotted_circle.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27 27\"><path fill=\"#bfbfbf\" fill-rule=\"evenodd\" d=\"m13.5 26.5c1.412 0 2.794-.225 4.107-.662l-.316-.949c-1.212.403-2.487.611-3.792.611v1m6.06-1.495c1.234-.651 2.355-1.498 3.321-2.504l-.721-.692c-.892.929-1.928 1.711-3.067 2.312l.467.884m4.66-4.147c.79-1.149 1.391-2.418 1.777-3.762l-.961-.276c-.356 1.24-.911 2.411-1.64 3.471l.824.567m2.184-5.761c.063-.518.096-1.041.097-1.568 0-.896-.085-1.758-.255-2.603l-.98.197c.157.78.236 1.576.236 2.405-.001.486-.031.97-.09 1.448l.993.122m-.738-6.189c-.493-1.307-1.195-2.523-2.075-3.605l-.776.631c.812.999 1.46 2.122 1.916 3.327l.935-.353m-3.539-5.133c-1.043-.926-2.229-1.68-3.512-2.229l-.394.919c1.184.507 2.279 1.203 3.242 2.058l.664-.748m-5.463-2.886c-1.012-.253-2.058-.384-3.119-.388-.378 0-.717.013-1.059.039l.077.997c.316-.024.629-.036.98-.036.979.003 1.944.124 2.879.358l.243-.97m-6.238-.022c-1.361.33-2.653.878-3.832 1.619l.532.847c1.089-.684 2.281-1.189 3.536-1.494l-.236-.972m-5.517 2.878c-1.047.922-1.94 2.01-2.643 3.212l.864.504c.649-1.112 1.474-2.114 2.441-2.966l-.661-.75m-3.54 5.076c-.499 1.293-.789 2.664-.854 4.072l.999.046c.06-1.3.328-2.564.788-3.758l-.933-.36m-.78 6.202c.163 1.396.549 2.744 1.14 4l.905-.425c-.545-1.16-.902-2.404-1.052-3.692l-.993.116m2.177 5.814c.788 1.151 1.756 2.169 2.866 3.01l.606-.796c-1.025-.78-1.919-1.721-2.646-2.783l-.825.565m4.665 4.164c1.23.65 2.559 1.1 3.943 1.328l.162-.987c-1.278-.21-2.503-.625-3.638-1.225l-.468.884m6.02 1.501c.024 0 .024 0 .048 0v-1c-.022 0-.022 0-.044 0l-.004 1\"/></svg>"

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!../../../ee/app/assets/javascripts/sidebar/components/weight/weight.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__ = __webpack_require__("./sidebar/event_hub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_icon_vue__ = __webpack_require__("./vue_shared/components/icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");

/* eslint-disable vue/require-default-prop */






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    icon: __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_icon_vue__["a" /* default */],
    loadingIcon: __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_loading_icon_vue__["a" /* default */]
  },
  props: {
    fetching: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    weight: {
      type: Number,
      required: false
    },
    weightOptions: {
      type: Array,
      required: true
    },
    weightNoneValue: {
      type: String,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: false
    },
    id: {
      type: Number,
      required: false
    }
  },
  data: function data() {
    return {
      shouldShowDropdown: false,
      collapseAfterDropdownCloses: false
    };
  },

  computed: {
    isNoValue: function isNoValue() {
      return this.checkIfNoValue(this.weight);
    },
    collapsedWeightLabel: function collapsedWeightLabel() {
      var label = this.weight;
      if (this.checkIfNoValue(this.weight)) {
        label = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('Sidebar|No');
      }

      return label;
    },
    noValueLabel: function noValueLabel() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('Sidebar|None');
    },
    changeWeightLabel: function changeWeightLabel() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('Sidebar|Change weight');
    },
    dropdownToggleLabel: function dropdownToggleLabel() {
      var label = this.weight;
      if (this.checkIfNoValue(this.weight)) {
        label = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('Sidebar|Weight');
      }

      return label;
    },
    shouldShowWeight: function shouldShowWeight() {
      return !this.fetching && !this.shouldShowDropdown;
    }
  },
  mounted: function mounted() {
    var _this = this;

    $(this.$refs.weightDropdown).glDropdown({
      showMenuAbove: false,
      selectable: true,
      filterable: false,
      multiSelect: false,
      data: function data(searchTerm, callback) {
        callback(_this.weightOptions);
      },
      renderRow: function renderRow(weight) {
        var isActive = weight === _this.weight || _this.checkIfNoValue(weight) && _this.checkIfNoValue(_this.weight);

        return '\n          <li>\n            <a href="#" class="' + (isActive ? 'is-active' : '') + '">\n              ' + weight + '\n            </a>\n          </li>\n        ';
      },
      hidden: function hidden() {
        _this.shouldShowDropdown = false;
        _this.collapseAfterDropdownCloses = false;
      },
      clicked: function clicked(options) {
        var selectedValue = _this.checkIfNoValue(options.selectedObj) ? null : options.selectedObj;
        var resultantValue = options.isMarking ? selectedValue : null;
        __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$emit('updateWeight', resultantValue, _this.id);
      }
    });
  },

  methods: {
    checkIfNoValue: function checkIfNoValue(weight) {
      return weight === undefined || weight === null || weight === 0 || weight === this.weightNoneValue;
    },
    showDropdown: function showDropdown() {
      var _this2 = this;

      this.shouldShowDropdown = true;
      // Trigger the bootstrap dropdown
      setTimeout(function () {
        $(_this2.$refs.dropdownToggle).dropdown('toggle');
      });
    },
    onCollapsedClick: function onCollapsedClick() {
      this.collapseAfterDropdownCloses = true;
      this.showDropdown();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!../../../ee/app/assets/javascripts/vue_shared/security_reports/components/report_issues.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_icon_vue__ = __webpack_require__("./vue_shared/components/icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_gl_modal_vue__ = __webpack_require__("./vue_shared/components/gl_modal.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_expand_button_vue__ = __webpack_require__("./vue_shared/components/expand_button.vue");






var modalDefaultData = {
  modalId: 'modal-mrwidget-issue',
  modalDesc: '',
  modalTitle: '',
  modalInstances: [],
  modalTargetId: '#modal-mrwidget-issue'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReportIssues',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_gl_modal_vue__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_icon_vue__["a" /* default */],
    ExpandButton: __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_expand_button_vue__["a" /* default */]
  },
  props: {
    issues: {
      type: Array,
      required: true
    },
    // security || codequality || performance || docker || dast
    type: {
      type: String,
      required: true
    },
    // failed || success
    status: {
      type: String,
      required: true
    },
    hasPriority: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return modalDefaultData;
  },

  computed: {
    fixedLabel: function fixedLabel() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__locale__["e" /* s__ */])('ciReport|Fixed:');
    },
    iconName: function iconName() {
      if (this.isStatusFailed) {
        return 'status_failed_borderless';
      } else if (this.isStatusSuccess) {
        return 'status_success_borderless';
      }

      return 'status_created_borderless';
    },
    isStatusFailed: function isStatusFailed() {
      return this.status === 'failed';
    },
    isStatusSuccess: function isStatusSuccess() {
      return this.status === 'success';
    },
    isStatusNeutral: function isStatusNeutral() {
      return this.status === 'neutral';
    },
    isTypeQuality: function isTypeQuality() {
      return this.type === 'codequality';
    },
    isTypePerformance: function isTypePerformance() {
      return this.type === 'performance';
    },
    isTypeSecurity: function isTypeSecurity() {
      return this.type === 'security';
    },
    isTypeDocker: function isTypeDocker() {
      return this.type === 'docker';
    },
    isTypeDast: function isTypeDast() {
      return this.type === 'dast';
    }
  },
  mounted: function mounted() {
    var _this = this;

    $(this.$refs.modal).on('hidden.bs.modal', function () {
      _this.clearModalData();
    });
  },

  methods: {
    shouldRenderPriority: function shouldRenderPriority(issue) {
      return this.hasPriority && issue.priority;
    },
    getmodalId: function getmodalId(index) {
      return 'modal-mrwidget-issue-' + index;
    },
    modalIdTarget: function modalIdTarget(index) {
      return '#' + this.getmodalId(index);
    },
    formatScore: function formatScore(value) {
      if (Math.floor(value) !== value) {
        return parseFloat(value).toFixed(2);
      }
      return value;
    },
    openDastModal: function openDastModal(issue, index) {
      this.modalId = this.getmodalId(index);
      this.modalTitle = issue.priority + ': ' + issue.name;
      this.modalTargetId = '#' + this.getmodalId(index);
      this.modalInstances = issue.instances;
      this.modalDesc = issue.parsedDescription;
    },

    /**
     * Because of https://vuejs.org/v2/guide/list.html#Caveats
     * we need to clear the instances to make sure everything is properly reset.
     */
    clearModalData: function clearModalData() {
      this.modalId = modalDefaultData.modalId;
      this.modalDesc = modalDefaultData.modalDesc;
      this.modalTitle = modalDefaultData.modalTitle;
      this.modalInstances = modalDefaultData.modalInstances;
      this.modalTargetId = modalDefaultData.modalTargetId;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_icon_vue__ = __webpack_require__("./vue_shared/components/icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");


/**
 * Renders each stage of the pipeline mini graph.
 *
 * Given the provided endpoint will make a request to
 * fetch the dropdown data when the stage is clicked.
 *
 * Request is made inside this component to make it reusable between:
 * 1. Pipelines main table
 * 2. Pipelines table in commit and Merge request views
 * 3. Merge request widget
 * 4. Commit widget
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    loadingIcon: __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__["a" /* default */],
    icon: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_icon_vue__["a" /* default */]
  },

  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_3__vue_shared_directives_tooltip__["a" /* default */]
  },

  props: {
    stage: {
      type: Object,
      required: true
    },

    updateDropdown: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function data() {
    return {
      isLoading: false,
      dropdownContent: ''
    };
  },


  computed: {
    dropdownClass: function dropdownClass() {
      return this.dropdownContent.length > 0 ? 'js-builds-dropdown-container' : 'js-builds-dropdown-loading';
    },
    triggerButtonClass: function triggerButtonClass() {
      return 'ci-status-icon-' + this.stage.status.group;
    },
    borderlessIcon: function borderlessIcon() {
      return this.stage.status.icon + '_borderless';
    }
  },

  watch: {
    updateDropdown: function updateDropdown() {
      if (this.updateDropdown && this.isDropdownOpen() && !this.isLoading) {
        this.fetchJobs();
      }
    }
  },

  updated: function updated() {
    if (this.dropdownContent.length > 0) {
      this.stopDropdownClickPropagation();
    }
  },


  methods: {
    onClickStage: function onClickStage() {
      if (!this.isDropdownOpen()) {
        this.isLoading = true;
        this.fetchJobs();
      }
    },
    fetchJobs: function fetchJobs() {
      var _this = this;

      this.$http.get(this.stage.dropdown_path).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this.dropdownContent = data.html;
        _this.isLoading = false;
      }).catch(function () {
        _this.closeDropdown();
        _this.isLoading = false;

        var flash = new __WEBPACK_IMPORTED_MODULE_0__flash__["a" /* default */]('Something went wrong on our end.');
        return flash;
      });
    },


    /**
     * When the user right clicks or cmd/ctrl + click in the job name
     * the dropdown should not be closed and the link should open in another tab,
     * so we stop propagation of the click event inside the dropdown.
     *
     * Since this component is rendered multiple times per page we need to guarantee we only
     * target the click event of this component.
     */
    stopDropdownClickPropagation: function stopDropdownClickPropagation() {
      $(this.$el.querySelectorAll('.js-builds-dropdown-list a.mini-pipeline-graph-dropdown-item')).on('click', function (e) {
        e.stopPropagation();
      });
    },
    closeDropdown: function closeDropdown() {
      if (this.isDropdownOpen()) {
        $(this.$refs.dropdown).dropdown('toggle');
      }
    },
    isDropdownOpen: function isDropdownOpen() {
      return this.$el.classList.contains('open');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/deckar01-task_list/dist/task_list.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["TaskList"] = factory();
	else
		root["TaskList"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var NodeArray, TaskList, closest, createEvent,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

NodeArray = function(nodeList) {
  return Array.prototype.slice.apply(nodeList);
};

closest = function(el, className) {
  while (el && !el.classList.contains(className)) {
    el = el.parentNode;
  }
  return el;
};

createEvent = function(eventName, detail) {
  var event;
  if (typeof Event === 'function') {
    event = new Event(eventName, {
      bubbles: true,
      cancelable: true
    });
    event.detail = detail;
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, detail);
  }
  return event;
};

TaskList = (function() {
  function TaskList(el1) {
    this.el = el1;
    this.container = closest(this.el, 'js-task-list-container');
    this.field = this.container.querySelector('.js-task-list-field');
    this.container.addEventListener('change', (function(_this) {
      return function(event) {
        if (event.target.classList.contains('task-list-item-checkbox')) {
          return _this.updateTaskList(event.target);
        }
      };
    })(this));
    this.enable();
  }

  TaskList.prototype.enable = function() {
    var event;
    if (this.container.querySelectorAll('.js-task-list-field').length > 0) {
      NodeArray(this.container.querySelectorAll('.task-list-item')).forEach(function(item) {
        return item.classList.add('enabled');
      });
      NodeArray(this.container.querySelectorAll('.task-list-item-checkbox')).forEach(function(checkbox) {
        return checkbox.disabled = false;
      });
      this.container.classList.add('is-task-list-enabled');
      event = createEvent('tasklist:enabled');
      return this.container.dispatchEvent(event);
    }
  };

  TaskList.prototype.disable = function() {
    var event;
    NodeArray(this.container.querySelectorAll('.task-list-item')).forEach(function(item) {
      return item.classList.remove('enabled');
    });
    NodeArray(this.container.querySelectorAll('.task-list-item-checkbox')).forEach(function(checkbox) {
      return checkbox.disabled = true;
    });
    this.container.classList.remove('is-task-list-enabled');
    event = createEvent('tasklist:disabled');
    return this.container.dispatchEvent(event);
  };

  TaskList.prototype.updateTaskList = function(item) {
    var changeEvent, changedEvent, checkboxes, index;
    checkboxes = this.container.querySelectorAll('.task-list-item-checkbox');
    index = 1 + NodeArray(checkboxes).indexOf(item);
    changeEvent = createEvent('tasklist:change', {
      index: index,
      checked: item.checked
    });
    this.field.dispatchEvent(changeEvent);
    if (!changeEvent.defaultPrevented) {
      this.field.value = TaskList.updateSource(this.field.value, index, item.checked);
      changeEvent = createEvent('change');
      this.field.dispatchEvent(changeEvent);
      changedEvent = createEvent('tasklist:changed', {
        index: index,
        checked: item.checked
      });
      return this.field.dispatchEvent(changedEvent);
    }
  };

  TaskList.incomplete = "[ ]";

  TaskList.complete = "[x]";

  TaskList.escapePattern = function(str) {
    return str.replace(/([\[\]])/g, "\\$1").replace(/\s/, "\\s").replace("x", "[xX]");
  };

  TaskList.incompletePattern = RegExp("" + (TaskList.escapePattern(TaskList.incomplete)));

  TaskList.completePattern = RegExp("" + (TaskList.escapePattern(TaskList.complete)));

  TaskList.itemPattern = RegExp("^(?:\\s*(?:>\\s*)*(?:[-+*]|(?:\\d+\\.)))\\s*(" + (TaskList.escapePattern(TaskList.complete)) + "|" + (TaskList.escapePattern(TaskList.incomplete)) + ")\\s+(?!\\(.*?\\))(?=(?:\\[.*?\\]\\s*(?:\\[.*?\\]|\\(.*?\\))\\s*)*(?:[^\\[]|$))");

  TaskList.startFencesPattern = /^`{3}.*$/;

  TaskList.endFencesPattern = /^`{3}$/;

  TaskList.itemsInParasPattern = RegExp("^(" + (TaskList.escapePattern(TaskList.complete)) + "|" + (TaskList.escapePattern(TaskList.incomplete)) + ").+$", "g");

  TaskList.updateSource = function(source, itemIndex, checked) {
    var clean, inCodeBlock, index, line, result;
    clean = source.replace(/\r/g, '').replace(this.itemsInParasPattern, '').split("\n");
    index = 0;
    inCodeBlock = false;
    result = (function() {
      var i, len, ref, results;
      ref = source.split("\n");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        line = ref[i];
        if (inCodeBlock) {
          if (line.match(this.endFencesPattern)) {
            inCodeBlock = false;
          }
        } else if (line.match(this.startFencesPattern)) {
          inCodeBlock = true;
        } else if (indexOf.call(clean, line) >= 0 && line.match(this.itemPattern)) {
          index += 1;
          if (index === itemIndex) {
            line = checked ? line.replace(this.incompletePattern, this.complete) : line.replace(this.completePattern, this.incomplete);
          }
        }
        results.push(line);
      }
      return results;
    }).call(this);
    return result.join("\n");
  };

  return TaskList;

})();

if (typeof jQuery !== 'undefined') {
  jQuery.fn.taskList = function(method) {
    return this.each(function(index, el) {
      var taskList;
      taskList = jQuery(el).data('task-list');
      if (!taskList) {
        taskList = new TaskList(el);
        jQuery(el).data('task-list', taskList);
        if (!method || method === 'enable') {
          return;
        }
      }
      return taskList[method || 'enable']();
    });
  };
}

module.exports = TaskList;


/***/ })
/******/ ]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/dropzone/dist/dropzone.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, module) {
/*
 *
 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
 *
 * Copyright (c) 2012, Matias Meno
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

(function() {
  var Dropzone, Emitter, camelize, contentLoaded, detectVerticalSquash, drawImageIOSFix, noop, without,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  noop = function() {};

  Emitter = (function() {
    function Emitter() {}

    Emitter.prototype.addEventListener = Emitter.prototype.on;

    Emitter.prototype.on = function(event, fn) {
      this._callbacks = this._callbacks || {};
      if (!this._callbacks[event]) {
        this._callbacks[event] = [];
      }
      this._callbacks[event].push(fn);
      return this;
    };

    Emitter.prototype.emit = function() {
      var args, callback, callbacks, event, _i, _len;
      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      this._callbacks = this._callbacks || {};
      callbacks = this._callbacks[event];
      if (callbacks) {
        for (_i = 0, _len = callbacks.length; _i < _len; _i++) {
          callback = callbacks[_i];
          callback.apply(this, args);
        }
      }
      return this;
    };

    Emitter.prototype.removeListener = Emitter.prototype.off;

    Emitter.prototype.removeAllListeners = Emitter.prototype.off;

    Emitter.prototype.removeEventListener = Emitter.prototype.off;

    Emitter.prototype.off = function(event, fn) {
      var callback, callbacks, i, _i, _len;
      if (!this._callbacks || arguments.length === 0) {
        this._callbacks = {};
        return this;
      }
      callbacks = this._callbacks[event];
      if (!callbacks) {
        return this;
      }
      if (arguments.length === 1) {
        delete this._callbacks[event];
        return this;
      }
      for (i = _i = 0, _len = callbacks.length; _i < _len; i = ++_i) {
        callback = callbacks[i];
        if (callback === fn) {
          callbacks.splice(i, 1);
          break;
        }
      }
      return this;
    };

    return Emitter;

  })();

  Dropzone = (function(_super) {
    var extend, resolveOption;

    __extends(Dropzone, _super);

    Dropzone.prototype.Emitter = Emitter;


    /*
    This is a list of all available events you can register on a dropzone object.
    
    You can register an event handler like this:
    
        dropzone.on("dragEnter", function() { });
     */

    Dropzone.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];

    Dropzone.prototype.defaultOptions = {
      url: null,
      method: "post",
      withCredentials: false,
      parallelUploads: 2,
      uploadMultiple: false,
      maxFilesize: 256,
      paramName: "file",
      createImageThumbnails: true,
      maxThumbnailFilesize: 10,
      thumbnailWidth: 120,
      thumbnailHeight: 120,
      filesizeBase: 1000,
      maxFiles: null,
      params: {},
      clickable: true,
      ignoreHiddenFiles: true,
      acceptedFiles: null,
      acceptedMimeTypes: null,
      autoProcessQueue: true,
      autoQueue: true,
      addRemoveLinks: false,
      previewsContainer: null,
      hiddenInputContainer: "body",
      capture: null,
      dictDefaultMessage: "Drop files here to upload",
      dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
      dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
      dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
      dictInvalidFileType: "You can't upload files of this type.",
      dictResponseError: "Server responded with {{statusCode}} code.",
      dictCancelUpload: "Cancel upload",
      dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
      dictRemoveFile: "Remove file",
      dictRemoveFileConfirmation: null,
      dictMaxFilesExceeded: "You can not upload any more files.",
      accept: function(file, done) {
        return done();
      },
      init: function() {
        return noop;
      },
      forceFallback: false,
      fallback: function() {
        var child, messageElement, span, _i, _len, _ref;
        this.element.className = "" + this.element.className + " dz-browser-not-supported";
        _ref = this.element.getElementsByTagName("div");
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          child = _ref[_i];
          if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message";
            continue;
          }
        }
        if (!messageElement) {
          messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
          this.element.appendChild(messageElement);
        }
        span = messageElement.getElementsByTagName("span")[0];
        if (span) {
          if (span.textContent != null) {
            span.textContent = this.options.dictFallbackMessage;
          } else if (span.innerText != null) {
            span.innerText = this.options.dictFallbackMessage;
          }
        }
        return this.element.appendChild(this.getFallbackForm());
      },
      resize: function(file) {
        var info, srcRatio, trgRatio;
        info = {
          srcX: 0,
          srcY: 0,
          srcWidth: file.width,
          srcHeight: file.height
        };
        srcRatio = file.width / file.height;
        info.optWidth = this.options.thumbnailWidth;
        info.optHeight = this.options.thumbnailHeight;
        if ((info.optWidth == null) && (info.optHeight == null)) {
          info.optWidth = info.srcWidth;
          info.optHeight = info.srcHeight;
        } else if (info.optWidth == null) {
          info.optWidth = srcRatio * info.optHeight;
        } else if (info.optHeight == null) {
          info.optHeight = (1 / srcRatio) * info.optWidth;
        }
        trgRatio = info.optWidth / info.optHeight;
        if (file.height < info.optHeight || file.width < info.optWidth) {
          info.trgHeight = info.srcHeight;
          info.trgWidth = info.srcWidth;
        } else {
          if (srcRatio > trgRatio) {
            info.srcHeight = file.height;
            info.srcWidth = info.srcHeight * trgRatio;
          } else {
            info.srcWidth = file.width;
            info.srcHeight = info.srcWidth / trgRatio;
          }
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        return info;
      },

      /*
      Those functions register themselves to the events on init and handle all
      the user interface specific stuff. Overwriting them won't break the upload
      but can break the way it's displayed.
      You can overwrite them if you don't like the default behavior. If you just
      want to add an additional event handler, register it on the dropzone object
      and don't overwrite those options.
       */
      drop: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragstart: noop,
      dragend: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragenter: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragover: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragleave: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      paste: noop,
      reset: function() {
        return this.element.classList.remove("dz-started");
      },
      addedfile: function(file) {
        var node, removeFileEvent, removeLink, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _results;
        if (this.element === this.previewsContainer) {
          this.element.classList.add("dz-started");
        }
        if (this.previewsContainer) {
          file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
          file.previewTemplate = file.previewElement;
          this.previewsContainer.appendChild(file.previewElement);
          _ref = file.previewElement.querySelectorAll("[data-dz-name]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            node.textContent = file.name;
          }
          _ref1 = file.previewElement.querySelectorAll("[data-dz-size]");
          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
            node = _ref1[_j];
            node.innerHTML = this.filesize(file.size);
          }
          if (this.options.addRemoveLinks) {
            file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
            file.previewElement.appendChild(file._removeLink);
          }
          removeFileEvent = (function(_this) {
            return function(e) {
              e.preventDefault();
              e.stopPropagation();
              if (file.status === Dropzone.UPLOADING) {
                return Dropzone.confirm(_this.options.dictCancelUploadConfirmation, function() {
                  return _this.removeFile(file);
                });
              } else {
                if (_this.options.dictRemoveFileConfirmation) {
                  return Dropzone.confirm(_this.options.dictRemoveFileConfirmation, function() {
                    return _this.removeFile(file);
                  });
                } else {
                  return _this.removeFile(file);
                }
              }
            };
          })(this);
          _ref2 = file.previewElement.querySelectorAll("[data-dz-remove]");
          _results = [];
          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
            removeLink = _ref2[_k];
            _results.push(removeLink.addEventListener("click", removeFileEvent));
          }
          return _results;
        }
      },
      removedfile: function(file) {
        var _ref;
        if (file.previewElement) {
          if ((_ref = file.previewElement) != null) {
            _ref.parentNode.removeChild(file.previewElement);
          }
        }
        return this._updateMaxFilesReachedClass();
      },
      thumbnail: function(file, dataUrl) {
        var thumbnailElement, _i, _len, _ref;
        if (file.previewElement) {
          file.previewElement.classList.remove("dz-file-preview");
          _ref = file.previewElement.querySelectorAll("[data-dz-thumbnail]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            thumbnailElement = _ref[_i];
            thumbnailElement.alt = file.name;
            thumbnailElement.src = dataUrl;
          }
          return setTimeout(((function(_this) {
            return function() {
              return file.previewElement.classList.add("dz-image-preview");
            };
          })(this)), 1);
        }
      },
      error: function(file, message) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          file.previewElement.classList.add("dz-error");
          if (typeof message !== "String" && message.error) {
            message = message.error;
          }
          _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            _results.push(node.textContent = message);
          }
          return _results;
        }
      },
      errormultiple: noop,
      processing: function(file) {
        if (file.previewElement) {
          file.previewElement.classList.add("dz-processing");
          if (file._removeLink) {
            return file._removeLink.textContent = this.options.dictCancelUpload;
          }
        }
      },
      processingmultiple: noop,
      uploadprogress: function(file, progress, bytesSent) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          _ref = file.previewElement.querySelectorAll("[data-dz-uploadprogress]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            if (node.nodeName === 'PROGRESS') {
              _results.push(node.value = progress);
            } else {
              _results.push(node.style.width = "" + progress + "%");
            }
          }
          return _results;
        }
      },
      totaluploadprogress: noop,
      sending: noop,
      sendingmultiple: noop,
      success: function(file) {
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-success");
        }
      },
      successmultiple: noop,
      canceled: function(file) {
        return this.emit("error", file, "Upload canceled.");
      },
      canceledmultiple: noop,
      complete: function(file) {
        if (file._removeLink) {
          file._removeLink.textContent = this.options.dictRemoveFile;
        }
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-complete");
        }
      },
      completemultiple: noop,
      maxfilesexceeded: noop,
      maxfilesreached: noop,
      queuecomplete: noop,
      addedfiles: noop,
      previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>"
    };

    extend = function() {
      var key, object, objects, target, val, _i, _len;
      target = arguments[0], objects = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      for (_i = 0, _len = objects.length; _i < _len; _i++) {
        object = objects[_i];
        for (key in object) {
          val = object[key];
          target[key] = val;
        }
      }
      return target;
    };

    function Dropzone(element, options) {
      var elementOptions, fallback, _ref;
      this.element = element;
      this.version = Dropzone.version;
      this.defaultOptions.previewTemplate = this.defaultOptions.previewTemplate.replace(/\n*/g, "");
      this.clickableElements = [];
      this.listeners = [];
      this.files = [];
      if (typeof this.element === "string") {
        this.element = document.querySelector(this.element);
      }
      if (!(this.element && (this.element.nodeType != null))) {
        throw new Error("Invalid dropzone element.");
      }
      if (this.element.dropzone) {
        throw new Error("Dropzone already attached.");
      }
      Dropzone.instances.push(this);
      this.element.dropzone = this;
      elementOptions = (_ref = Dropzone.optionsForElement(this.element)) != null ? _ref : {};
      this.options = extend({}, this.defaultOptions, elementOptions, options != null ? options : {});
      if (this.options.forceFallback || !Dropzone.isBrowserSupported()) {
        return this.options.fallback.call(this);
      }
      if (this.options.url == null) {
        this.options.url = this.element.getAttribute("action");
      }
      if (!this.options.url) {
        throw new Error("No URL provided.");
      }
      if (this.options.acceptedFiles && this.options.acceptedMimeTypes) {
        throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
      }
      if (this.options.acceptedMimeTypes) {
        this.options.acceptedFiles = this.options.acceptedMimeTypes;
        delete this.options.acceptedMimeTypes;
      }
      this.options.method = this.options.method.toUpperCase();
      if ((fallback = this.getExistingFallback()) && fallback.parentNode) {
        fallback.parentNode.removeChild(fallback);
      }
      if (this.options.previewsContainer !== false) {
        if (this.options.previewsContainer) {
          this.previewsContainer = Dropzone.getElement(this.options.previewsContainer, "previewsContainer");
        } else {
          this.previewsContainer = this.element;
        }
      }
      if (this.options.clickable) {
        if (this.options.clickable === true) {
          this.clickableElements = [this.element];
        } else {
          this.clickableElements = Dropzone.getElements(this.options.clickable, "clickable");
        }
      }
      this.init();
    }

    Dropzone.prototype.getAcceptedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getRejectedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (!file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getFilesWithStatus = function(status) {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === status) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getQueuedFiles = function() {
      return this.getFilesWithStatus(Dropzone.QUEUED);
    };

    Dropzone.prototype.getUploadingFiles = function() {
      return this.getFilesWithStatus(Dropzone.UPLOADING);
    };

    Dropzone.prototype.getAddedFiles = function() {
      return this.getFilesWithStatus(Dropzone.ADDED);
    };

    Dropzone.prototype.getActiveFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.init = function() {
      var eventName, noPropagation, setupHiddenFileInput, _i, _len, _ref, _ref1;
      if (this.element.tagName === "form") {
        this.element.setAttribute("enctype", "multipart/form-data");
      }
      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
      }
      if (this.clickableElements.length) {
        setupHiddenFileInput = (function(_this) {
          return function() {
            if (_this.hiddenFileInput) {
              _this.hiddenFileInput.parentNode.removeChild(_this.hiddenFileInput);
            }
            _this.hiddenFileInput = document.createElement("input");
            _this.hiddenFileInput.setAttribute("type", "file");
            if ((_this.options.maxFiles == null) || _this.options.maxFiles > 1) {
              _this.hiddenFileInput.setAttribute("multiple", "multiple");
            }
            _this.hiddenFileInput.className = "dz-hidden-input";
            if (_this.options.acceptedFiles != null) {
              _this.hiddenFileInput.setAttribute("accept", _this.options.acceptedFiles);
            }
            if (_this.options.capture != null) {
              _this.hiddenFileInput.setAttribute("capture", _this.options.capture);
            }
            _this.hiddenFileInput.style.visibility = "hidden";
            _this.hiddenFileInput.style.position = "absolute";
            _this.hiddenFileInput.style.top = "0";
            _this.hiddenFileInput.style.left = "0";
            _this.hiddenFileInput.style.height = "0";
            _this.hiddenFileInput.style.width = "0";
            document.querySelector(_this.options.hiddenInputContainer).appendChild(_this.hiddenFileInput);
            return _this.hiddenFileInput.addEventListener("change", function() {
              var file, files, _i, _len;
              files = _this.hiddenFileInput.files;
              if (files.length) {
                for (_i = 0, _len = files.length; _i < _len; _i++) {
                  file = files[_i];
                  _this.addFile(file);
                }
              }
              _this.emit("addedfiles", files);
              return setupHiddenFileInput();
            });
          };
        })(this);
        setupHiddenFileInput();
      }
      this.URL = (_ref = window.URL) != null ? _ref : window.webkitURL;
      _ref1 = this.events;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        eventName = _ref1[_i];
        this.on(eventName, this.options[eventName]);
      }
      this.on("uploadprogress", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("removedfile", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("canceled", (function(_this) {
        return function(file) {
          return _this.emit("complete", file);
        };
      })(this));
      this.on("complete", (function(_this) {
        return function(file) {
          if (_this.getAddedFiles().length === 0 && _this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) {
            return setTimeout((function() {
              return _this.emit("queuecomplete");
            }), 0);
          }
        };
      })(this));
      noPropagation = function(e) {
        e.stopPropagation();
        if (e.preventDefault) {
          return e.preventDefault();
        } else {
          return e.returnValue = false;
        }
      };
      this.listeners = [
        {
          element: this.element,
          events: {
            "dragstart": (function(_this) {
              return function(e) {
                return _this.emit("dragstart", e);
              };
            })(this),
            "dragenter": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.emit("dragenter", e);
              };
            })(this),
            "dragover": (function(_this) {
              return function(e) {
                var efct;
                try {
                  efct = e.dataTransfer.effectAllowed;
                } catch (_error) {}
                e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';
                noPropagation(e);
                return _this.emit("dragover", e);
              };
            })(this),
            "dragleave": (function(_this) {
              return function(e) {
                return _this.emit("dragleave", e);
              };
            })(this),
            "drop": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.drop(e);
              };
            })(this),
            "dragend": (function(_this) {
              return function(e) {
                return _this.emit("dragend", e);
              };
            })(this)
          }
        }
      ];
      this.clickableElements.forEach((function(_this) {
        return function(clickableElement) {
          return _this.listeners.push({
            element: clickableElement,
            events: {
              "click": function(evt) {
                if ((clickableElement !== _this.element) || (evt.target === _this.element || Dropzone.elementInside(evt.target, _this.element.querySelector(".dz-message")))) {
                  _this.hiddenFileInput.click();
                }
                return true;
              }
            }
          });
        };
      })(this));
      this.enable();
      return this.options.init.call(this);
    };

    Dropzone.prototype.destroy = function() {
      var _ref;
      this.disable();
      this.removeAllFiles(true);
      if ((_ref = this.hiddenFileInput) != null ? _ref.parentNode : void 0) {
        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
        this.hiddenFileInput = null;
      }
      delete this.element.dropzone;
      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
    };

    Dropzone.prototype.updateTotalUploadProgress = function() {
      var activeFiles, file, totalBytes, totalBytesSent, totalUploadProgress, _i, _len, _ref;
      totalBytesSent = 0;
      totalBytes = 0;
      activeFiles = this.getActiveFiles();
      if (activeFiles.length) {
        _ref = this.getActiveFiles();
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          totalBytesSent += file.upload.bytesSent;
          totalBytes += file.upload.total;
        }
        totalUploadProgress = 100 * totalBytesSent / totalBytes;
      } else {
        totalUploadProgress = 100;
      }
      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    };

    Dropzone.prototype._getParamName = function(n) {
      if (typeof this.options.paramName === "function") {
        return this.options.paramName(n);
      } else {
        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
      }
    };

    Dropzone.prototype.getFallbackForm = function() {
      var existingFallback, fields, fieldsString, form;
      if (existingFallback = this.getExistingFallback()) {
        return existingFallback;
      }
      fieldsString = "<div class=\"dz-fallback\">";
      if (this.options.dictFallbackText) {
        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
      }
      fieldsString += "<input type=\"file\" name=\"" + (this._getParamName(0)) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + " /><input type=\"submit\" value=\"Upload!\"></div>";
      fields = Dropzone.createElement(fieldsString);
      if (this.element.tagName !== "FORM") {
        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
        form.appendChild(fields);
      } else {
        this.element.setAttribute("enctype", "multipart/form-data");
        this.element.setAttribute("method", this.options.method);
      }
      return form != null ? form : fields;
    };

    Dropzone.prototype.getExistingFallback = function() {
      var fallback, getFallback, tagName, _i, _len, _ref;
      getFallback = function(elements) {
        var el, _i, _len;
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )fallback($| )/.test(el.className)) {
            return el;
          }
        }
      };
      _ref = ["div", "form"];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        tagName = _ref[_i];
        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
          return fallback;
        }
      }
    };

    Dropzone.prototype.setupEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.addEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.removeEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.removeEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.disable = function() {
      var file, _i, _len, _ref, _results;
      this.clickableElements.forEach(function(element) {
        return element.classList.remove("dz-clickable");
      });
      this.removeEventListeners();
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        _results.push(this.cancelUpload(file));
      }
      return _results;
    };

    Dropzone.prototype.enable = function() {
      this.clickableElements.forEach(function(element) {
        return element.classList.add("dz-clickable");
      });
      return this.setupEventListeners();
    };

    Dropzone.prototype.filesize = function(size) {
      var cutoff, i, selectedSize, selectedUnit, unit, units, _i, _len;
      selectedSize = 0;
      selectedUnit = "b";
      if (size > 0) {
        units = ['TB', 'GB', 'MB', 'KB', 'b'];
        for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
          unit = units[i];
          cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
          if (size >= cutoff) {
            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
            selectedUnit = unit;
            break;
          }
        }
        selectedSize = Math.round(10 * selectedSize) / 10;
      }
      return "<strong>" + selectedSize + "</strong> " + selectedUnit;
    };

    Dropzone.prototype._updateMaxFilesReachedClass = function() {
      if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        if (this.getAcceptedFiles().length === this.options.maxFiles) {
          this.emit('maxfilesreached', this.files);
        }
        return this.element.classList.add("dz-max-files-reached");
      } else {
        return this.element.classList.remove("dz-max-files-reached");
      }
    };

    Dropzone.prototype.drop = function(e) {
      var files, items;
      if (!e.dataTransfer) {
        return;
      }
      this.emit("drop", e);
      files = e.dataTransfer.files;
      this.emit("addedfiles", files);
      if (files.length) {
        items = e.dataTransfer.items;
        if (items && items.length && (items[0].webkitGetAsEntry != null)) {
          this._addFilesFromItems(items);
        } else {
          this.handleFiles(files);
        }
      }
    };

    Dropzone.prototype.paste = function(e) {
      var items, _ref;
      if ((e != null ? (_ref = e.clipboardData) != null ? _ref.items : void 0 : void 0) == null) {
        return;
      }
      this.emit("paste", e);
      items = e.clipboardData.items;
      if (items.length) {
        return this._addFilesFromItems(items);
      }
    };

    Dropzone.prototype.handleFiles = function(files) {
      var file, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        _results.push(this.addFile(file));
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromItems = function(items) {
      var entry, item, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = items.length; _i < _len; _i++) {
        item = items[_i];
        if ((item.webkitGetAsEntry != null) && (entry = item.webkitGetAsEntry())) {
          if (entry.isFile) {
            _results.push(this.addFile(item.getAsFile()));
          } else if (entry.isDirectory) {
            _results.push(this._addFilesFromDirectory(entry, entry.name));
          } else {
            _results.push(void 0);
          }
        } else if (item.getAsFile != null) {
          if ((item.kind == null) || item.kind === "file") {
            _results.push(this.addFile(item.getAsFile()));
          } else {
            _results.push(void 0);
          }
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromDirectory = function(directory, path) {
      var dirReader, entriesReader;
      dirReader = directory.createReader();
      entriesReader = (function(_this) {
        return function(entries) {
          var entry, _i, _len;
          for (_i = 0, _len = entries.length; _i < _len; _i++) {
            entry = entries[_i];
            if (entry.isFile) {
              entry.file(function(file) {
                if (_this.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
                  return;
                }
                file.fullPath = "" + path + "/" + file.name;
                return _this.addFile(file);
              });
            } else if (entry.isDirectory) {
              _this._addFilesFromDirectory(entry, "" + path + "/" + entry.name);
            }
          }
        };
      })(this);
      return dirReader.readEntries(entriesReader, function(error) {
        return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log(error) : void 0 : void 0;
      });
    };

    Dropzone.prototype.accept = function(file, done) {
      if (file.size > this.options.maxFilesize * 1024 * 1024) {
        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
        return done(this.options.dictInvalidFileType);
      } else if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
        return this.emit("maxfilesexceeded", file);
      } else {
        return this.options.accept.call(this, file, done);
      }
    };

    Dropzone.prototype.addFile = function(file) {
      file.upload = {
        progress: 0,
        total: file.size,
        bytesSent: 0
      };
      this.files.push(file);
      file.status = Dropzone.ADDED;
      this.emit("addedfile", file);
      this._enqueueThumbnail(file);
      return this.accept(file, (function(_this) {
        return function(error) {
          if (error) {
            file.accepted = false;
            _this._errorProcessing([file], error);
          } else {
            file.accepted = true;
            if (_this.options.autoQueue) {
              _this.enqueueFile(file);
            }
          }
          return _this._updateMaxFilesReachedClass();
        };
      })(this));
    };

    Dropzone.prototype.enqueueFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        this.enqueueFile(file);
      }
      return null;
    };

    Dropzone.prototype.enqueueFile = function(file) {
      if (file.status === Dropzone.ADDED && file.accepted === true) {
        file.status = Dropzone.QUEUED;
        if (this.options.autoProcessQueue) {
          return setTimeout(((function(_this) {
            return function() {
              return _this.processQueue();
            };
          })(this)), 0);
        }
      } else {
        throw new Error("This file can't be queued because it has already been processed or was rejected.");
      }
    };

    Dropzone.prototype._thumbnailQueue = [];

    Dropzone.prototype._processingThumbnail = false;

    Dropzone.prototype._enqueueThumbnail = function(file) {
      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
        this._thumbnailQueue.push(file);
        return setTimeout(((function(_this) {
          return function() {
            return _this._processThumbnailQueue();
          };
        })(this)), 0);
      }
    };

    Dropzone.prototype._processThumbnailQueue = function() {
      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
        return;
      }
      this._processingThumbnail = true;
      return this.createThumbnail(this._thumbnailQueue.shift(), (function(_this) {
        return function() {
          _this._processingThumbnail = false;
          return _this._processThumbnailQueue();
        };
      })(this));
    };

    Dropzone.prototype.removeFile = function(file) {
      if (file.status === Dropzone.UPLOADING) {
        this.cancelUpload(file);
      }
      this.files = without(this.files, file);
      this.emit("removedfile", file);
      if (this.files.length === 0) {
        return this.emit("reset");
      }
    };

    Dropzone.prototype.removeAllFiles = function(cancelIfNecessary) {
      var file, _i, _len, _ref;
      if (cancelIfNecessary == null) {
        cancelIfNecessary = false;
      }
      _ref = this.files.slice();
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
          this.removeFile(file);
        }
      }
      return null;
    };

    Dropzone.prototype.createThumbnail = function(file, callback) {
      var fileReader;
      fileReader = new FileReader;
      fileReader.onload = (function(_this) {
        return function() {
          if (file.type === "image/svg+xml") {
            _this.emit("thumbnail", file, fileReader.result);
            if (callback != null) {
              callback();
            }
            return;
          }
          return _this.createThumbnailFromUrl(file, fileReader.result, callback);
        };
      })(this);
      return fileReader.readAsDataURL(file);
    };

    Dropzone.prototype.createThumbnailFromUrl = function(file, imageUrl, callback, crossOrigin) {
      var img;
      img = document.createElement("img");
      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }
      img.onload = (function(_this) {
        return function() {
          var canvas, ctx, resizeInfo, thumbnail, _ref, _ref1, _ref2, _ref3;
          file.width = img.width;
          file.height = img.height;
          resizeInfo = _this.options.resize.call(_this, file);
          if (resizeInfo.trgWidth == null) {
            resizeInfo.trgWidth = resizeInfo.optWidth;
          }
          if (resizeInfo.trgHeight == null) {
            resizeInfo.trgHeight = resizeInfo.optHeight;
          }
          canvas = document.createElement("canvas");
          ctx = canvas.getContext("2d");
          canvas.width = resizeInfo.trgWidth;
          canvas.height = resizeInfo.trgHeight;
          drawImageIOSFix(ctx, img, (_ref = resizeInfo.srcX) != null ? _ref : 0, (_ref1 = resizeInfo.srcY) != null ? _ref1 : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, (_ref2 = resizeInfo.trgX) != null ? _ref2 : 0, (_ref3 = resizeInfo.trgY) != null ? _ref3 : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
          thumbnail = canvas.toDataURL("image/png");
          _this.emit("thumbnail", file, thumbnail);
          if (callback != null) {
            return callback();
          }
        };
      })(this);
      if (callback != null) {
        img.onerror = callback;
      }
      return img.src = imageUrl;
    };

    Dropzone.prototype.processQueue = function() {
      var i, parallelUploads, processingLength, queuedFiles;
      parallelUploads = this.options.parallelUploads;
      processingLength = this.getUploadingFiles().length;
      i = processingLength;
      if (processingLength >= parallelUploads) {
        return;
      }
      queuedFiles = this.getQueuedFiles();
      if (!(queuedFiles.length > 0)) {
        return;
      }
      if (this.options.uploadMultiple) {
        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
      } else {
        while (i < parallelUploads) {
          if (!queuedFiles.length) {
            return;
          }
          this.processFile(queuedFiles.shift());
          i++;
        }
      }
    };

    Dropzone.prototype.processFile = function(file) {
      return this.processFiles([file]);
    };

    Dropzone.prototype.processFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.processing = true;
        file.status = Dropzone.UPLOADING;
        this.emit("processing", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("processingmultiple", files);
      }
      return this.uploadFiles(files);
    };

    Dropzone.prototype._getFilesWithXhr = function(xhr) {
      var file, files;
      return files = (function() {
        var _i, _len, _ref, _results;
        _ref = this.files;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          if (file.xhr === xhr) {
            _results.push(file);
          }
        }
        return _results;
      }).call(this);
    };

    Dropzone.prototype.cancelUpload = function(file) {
      var groupedFile, groupedFiles, _i, _j, _len, _len1, _ref;
      if (file.status === Dropzone.UPLOADING) {
        groupedFiles = this._getFilesWithXhr(file.xhr);
        for (_i = 0, _len = groupedFiles.length; _i < _len; _i++) {
          groupedFile = groupedFiles[_i];
          groupedFile.status = Dropzone.CANCELED;
        }
        file.xhr.abort();
        for (_j = 0, _len1 = groupedFiles.length; _j < _len1; _j++) {
          groupedFile = groupedFiles[_j];
          this.emit("canceled", groupedFile);
        }
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", groupedFiles);
        }
      } else if ((_ref = file.status) === Dropzone.ADDED || _ref === Dropzone.QUEUED) {
        file.status = Dropzone.CANCELED;
        this.emit("canceled", file);
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", [file]);
        }
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    resolveOption = function() {
      var args, option;
      option = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      if (typeof option === 'function') {
        return option.apply(this, args);
      }
      return option;
    };

    Dropzone.prototype.uploadFile = function(file) {
      return this.uploadFiles([file]);
    };

    Dropzone.prototype.uploadFiles = function(files) {
      var file, formData, handleError, headerName, headerValue, headers, i, input, inputName, inputType, key, method, option, progressObj, response, updateProgress, url, value, xhr, _i, _j, _k, _l, _len, _len1, _len2, _len3, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
      xhr = new XMLHttpRequest();
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.xhr = xhr;
      }
      method = resolveOption(this.options.method, files);
      url = resolveOption(this.options.url, files);
      xhr.open(method, url, true);
      xhr.withCredentials = !!this.options.withCredentials;
      response = null;
      handleError = (function(_this) {
        return function() {
          var _j, _len1, _results;
          _results = [];
          for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
            file = files[_j];
            _results.push(_this._errorProcessing(files, response || _this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr));
          }
          return _results;
        };
      })(this);
      updateProgress = (function(_this) {
        return function(e) {
          var allFilesFinished, progress, _j, _k, _l, _len1, _len2, _len3, _results;
          if (e != null) {
            progress = 100 * e.loaded / e.total;
            for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
              file = files[_j];
              file.upload = {
                progress: progress,
                total: e.total,
                bytesSent: e.loaded
              };
            }
          } else {
            allFilesFinished = true;
            progress = 100;
            for (_k = 0, _len2 = files.length; _k < _len2; _k++) {
              file = files[_k];
              if (!(file.upload.progress === 100 && file.upload.bytesSent === file.upload.total)) {
                allFilesFinished = false;
              }
              file.upload.progress = progress;
              file.upload.bytesSent = file.upload.total;
            }
            if (allFilesFinished) {
              return;
            }
          }
          _results = [];
          for (_l = 0, _len3 = files.length; _l < _len3; _l++) {
            file = files[_l];
            _results.push(_this.emit("uploadprogress", file, progress, file.upload.bytesSent));
          }
          return _results;
        };
      })(this);
      xhr.onload = (function(_this) {
        return function(e) {
          var _ref;
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          if (xhr.readyState !== 4) {
            return;
          }
          response = xhr.responseText;
          if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
            try {
              response = JSON.parse(response);
            } catch (_error) {
              e = _error;
              response = "Invalid JSON response from server.";
            }
          }
          updateProgress();
          if (!((200 <= (_ref = xhr.status) && _ref < 300))) {
            return handleError();
          } else {
            return _this._finished(files, response, e);
          }
        };
      })(this);
      xhr.onerror = (function(_this) {
        return function() {
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          return handleError();
        };
      })(this);
      progressObj = (_ref = xhr.upload) != null ? _ref : xhr;
      progressObj.onprogress = updateProgress;
      headers = {
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      };
      if (this.options.headers) {
        extend(headers, this.options.headers);
      }
      for (headerName in headers) {
        headerValue = headers[headerName];
        if (headerValue) {
          xhr.setRequestHeader(headerName, headerValue);
        }
      }
      formData = new FormData();
      if (this.options.params) {
        _ref1 = this.options.params;
        for (key in _ref1) {
          value = _ref1[key];
          formData.append(key, value);
        }
      }
      for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
        file = files[_j];
        this.emit("sending", file, xhr, formData);
      }
      if (this.options.uploadMultiple) {
        this.emit("sendingmultiple", files, xhr, formData);
      }
      if (this.element.tagName === "FORM") {
        _ref2 = this.element.querySelectorAll("input, textarea, select, button");
        for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
          input = _ref2[_k];
          inputName = input.getAttribute("name");
          inputType = input.getAttribute("type");
          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
            _ref3 = input.options;
            for (_l = 0, _len3 = _ref3.length; _l < _len3; _l++) {
              option = _ref3[_l];
              if (option.selected) {
                formData.append(inputName, option.value);
              }
            }
          } else if (!inputType || ((_ref4 = inputType.toLowerCase()) !== "checkbox" && _ref4 !== "radio") || input.checked) {
            formData.append(inputName, input.value);
          }
        }
      }
      for (i = _m = 0, _ref5 = files.length - 1; 0 <= _ref5 ? _m <= _ref5 : _m >= _ref5; i = 0 <= _ref5 ? ++_m : --_m) {
        formData.append(this._getParamName(i), files[i], files[i].name);
      }
      return this.submitRequest(xhr, formData, files);
    };

    Dropzone.prototype.submitRequest = function(xhr, formData, files) {
      return xhr.send(formData);
    };

    Dropzone.prototype._finished = function(files, responseText, e) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.SUCCESS;
        this.emit("success", file, responseText, e);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("successmultiple", files, responseText, e);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    Dropzone.prototype._errorProcessing = function(files, message, xhr) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.ERROR;
        this.emit("error", file, message, xhr);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("errormultiple", files, message, xhr);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    return Dropzone;

  })(Emitter);

  Dropzone.version = "4.2.0";

  Dropzone.options = {};

  Dropzone.optionsForElement = function(element) {
    if (element.getAttribute("id")) {
      return Dropzone.options[camelize(element.getAttribute("id"))];
    } else {
      return void 0;
    }
  };

  Dropzone.instances = [];

  Dropzone.forElement = function(element) {
    if (typeof element === "string") {
      element = document.querySelector(element);
    }
    if ((element != null ? element.dropzone : void 0) == null) {
      throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    }
    return element.dropzone;
  };

  Dropzone.autoDiscover = true;

  Dropzone.discover = function() {
    var checkElements, dropzone, dropzones, _i, _len, _results;
    if (document.querySelectorAll) {
      dropzones = document.querySelectorAll(".dropzone");
    } else {
      dropzones = [];
      checkElements = function(elements) {
        var el, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )dropzone($| )/.test(el.className)) {
            _results.push(dropzones.push(el));
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      };
      checkElements(document.getElementsByTagName("div"));
      checkElements(document.getElementsByTagName("form"));
    }
    _results = [];
    for (_i = 0, _len = dropzones.length; _i < _len; _i++) {
      dropzone = dropzones[_i];
      if (Dropzone.optionsForElement(dropzone) !== false) {
        _results.push(new Dropzone(dropzone));
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };

  Dropzone.blacklistedBrowsers = [/opera.*Macintosh.*version\/12/i];

  Dropzone.isBrowserSupported = function() {
    var capableBrowser, regex, _i, _len, _ref;
    capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
      if (!("classList" in document.createElement("a"))) {
        capableBrowser = false;
      } else {
        _ref = Dropzone.blacklistedBrowsers;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          regex = _ref[_i];
          if (regex.test(navigator.userAgent)) {
            capableBrowser = false;
            continue;
          }
        }
      }
    } else {
      capableBrowser = false;
    }
    return capableBrowser;
  };

  without = function(list, rejectedItem) {
    var item, _i, _len, _results;
    _results = [];
    for (_i = 0, _len = list.length; _i < _len; _i++) {
      item = list[_i];
      if (item !== rejectedItem) {
        _results.push(item);
      }
    }
    return _results;
  };

  camelize = function(str) {
    return str.replace(/[\-_](\w)/g, function(match) {
      return match.charAt(1).toUpperCase();
    });
  };

  Dropzone.createElement = function(string) {
    var div;
    div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
  };

  Dropzone.elementInside = function(element, container) {
    if (element === container) {
      return true;
    }
    while (element = element.parentNode) {
      if (element === container) {
        return true;
      }
    }
    return false;
  };

  Dropzone.getElement = function(el, name) {
    var element;
    if (typeof el === "string") {
      element = document.querySelector(el);
    } else if (el.nodeType != null) {
      element = el;
    }
    if (element == null) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
    }
    return element;
  };

  Dropzone.getElements = function(els, name) {
    var e, el, elements, _i, _j, _len, _len1, _ref;
    if (els instanceof Array) {
      elements = [];
      try {
        for (_i = 0, _len = els.length; _i < _len; _i++) {
          el = els[_i];
          elements.push(this.getElement(el, name));
        }
      } catch (_error) {
        e = _error;
        elements = null;
      }
    } else if (typeof els === "string") {
      elements = [];
      _ref = document.querySelectorAll(els);
      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
        el = _ref[_j];
        elements.push(el);
      }
    } else if (els.nodeType != null) {
      elements = [els];
    }
    if (!((elements != null) && elements.length)) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
    }
    return elements;
  };

  Dropzone.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) {
      return accepted();
    } else if (rejected != null) {
      return rejected();
    }
  };

  Dropzone.isValidFile = function(file, acceptedFiles) {
    var baseMimeType, mimeType, validType, _i, _len;
    if (!acceptedFiles) {
      return true;
    }
    acceptedFiles = acceptedFiles.split(",");
    mimeType = file.type;
    baseMimeType = mimeType.replace(/\/.*$/, "");
    for (_i = 0, _len = acceptedFiles.length; _i < _len; _i++) {
      validType = acceptedFiles[_i];
      validType = validType.trim();
      if (validType.charAt(0) === ".") {
        if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
          return true;
        }
      } else if (/\/\*$/.test(validType)) {
        if (baseMimeType === validType.replace(/\/.*$/, "")) {
          return true;
        }
      } else {
        if (mimeType === validType) {
          return true;
        }
      }
    }
    return false;
  };

  if (typeof jQuery !== "undefined" && jQuery !== null) {
    jQuery.fn.dropzone = function(options) {
      return this.each(function() {
        return new Dropzone(this, options);
      });
    };
  }

  if (typeof module !== "undefined" && module !== null) {
    module.exports = Dropzone;
  } else {
    window.Dropzone = Dropzone;
  }

  Dropzone.ADDED = "added";

  Dropzone.QUEUED = "queued";

  Dropzone.ACCEPTED = Dropzone.QUEUED;

  Dropzone.UPLOADING = "uploading";

  Dropzone.PROCESSING = Dropzone.UPLOADING;

  Dropzone.CANCELED = "canceled";

  Dropzone.ERROR = "error";

  Dropzone.SUCCESS = "success";


  /*
  
  Bugfix for iOS 6 and 7
  Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
  based on the work of https://github.com/stomita/ios-imagefile-megapixel
   */

  detectVerticalSquash = function(img) {
    var alpha, canvas, ctx, data, ey, ih, iw, py, ratio, sy;
    iw = img.naturalWidth;
    ih = img.naturalHeight;
    canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    data = ctx.getImageData(0, 0, 1, ih).data;
    sy = 0;
    ey = ih;
    py = ih;
    while (py > sy) {
      alpha = data[(py - 1) * 4 + 3];
      if (alpha === 0) {
        ey = py;
      } else {
        sy = py;
      }
      py = (ey + sy) >> 1;
    }
    ratio = py / ih;
    if (ratio === 0) {
      return 1;
    } else {
      return ratio;
    }
  };

  drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    var vertSquashRatio;
    vertSquashRatio = detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
  };


  /*
   * contentloaded.js
   *
   * Author: Diego Perini (diego.perini at gmail.com)
   * Summary: cross-browser wrapper for DOMContentLoaded
   * Updated: 20101020
   * License: MIT
   * Version: 1.2
   *
   * URL:
   * http://javascript.nwbox.com/ContentLoaded/
   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
   */

  contentLoaded = function(win, fn) {
    var add, doc, done, init, poll, pre, rem, root, top;
    done = false;
    top = true;
    doc = win.document;
    root = doc.documentElement;
    add = (doc.addEventListener ? "addEventListener" : "attachEvent");
    rem = (doc.addEventListener ? "removeEventListener" : "detachEvent");
    pre = (doc.addEventListener ? "" : "on");
    init = function(e) {
      if (e.type === "readystatechange" && doc.readyState !== "complete") {
        return;
      }
      (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
      if (!done && (done = true)) {
        return fn.call(win, e.type || e);
      }
    };
    poll = function() {
      var e;
      try {
        root.doScroll("left");
      } catch (_error) {
        e = _error;
        setTimeout(poll, 50);
        return;
      }
      return init("poll");
    };
    if (doc.readyState !== "complete") {
      if (doc.createEventObject && root.doScroll) {
        try {
          top = !win.frameElement;
        } catch (_error) {}
        if (top) {
          poll();
        }
      }
      doc[add](pre + "DOMContentLoaded", init, false);
      doc[add](pre + "readystatechange", init, false);
      return win[add](pre + "load", init, false);
    }
  };

  Dropzone._autoDiscoverFunction = function() {
    if (Dropzone.autoDiscover) {
      return Dropzone.discover();
    }
  };

  contentLoaded(window, Dropzone._autoDiscoverFunction);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js"), __webpack_require__("../../../node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "../../../node_modules/mousetrap/plugins/pause/mousetrap-pause.js":
/***/ (function(module, exports) {

/**
 * adds a pause and unpause method to Mousetrap
 * this allows you to enable or disable keyboard shortcuts
 * without having to reset Mousetrap and rebind everything
 */
/* global Mousetrap:true */
Mousetrap = (function(Mousetrap) {
    var self = Mousetrap,
        _originalStopCallback = self.stopCallback,
        enabled = true;

    self.stopCallback = function(e, element, combo) {
        if (!enabled) {
            return true;
        }

        return _originalStopCallback(e, element, combo);
    };

    self.pause = function() {
        enabled = false;
    };

    self.unpause = function() {
        enabled = true;
    };

    return self;
}) (Mousetrap);


/***/ }),

/***/ "../../../node_modules/pikaday/pikaday.js":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Pikaday
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/dbushell/Pikaday
 */

(function (root, factory)
{
    'use strict';

    var moment;
    if (true) {
        // CommonJS module
        // Load moment.js as an optional dependency
        try { moment = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"moment\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())); } catch (e) {}
        module.exports = factory(moment);
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (req)
        {
            // Load moment.js as an optional dependency
            var id = 'moment';
            try { moment = req(id); } catch (e) {}
            return factory(moment);
        });
    } else {
        root.Pikaday = factory(root.moment);
    }
}(this, function (moment)
{
    'use strict';

    /**
     * feature detection and helper functions
     */
    var hasMoment = typeof moment === 'function',

    hasEventListeners = !!window.addEventListener,

    document = window.document,

    sto = window.setTimeout,

    addEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.addEventListener(e, callback, !!capture);
        } else {
            el.attachEvent('on' + e, callback);
        }
    },

    removeEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.removeEventListener(e, callback, !!capture);
        } else {
            el.detachEvent('on' + e, callback);
        }
    },

    trim = function(str)
    {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
    },

    hasClass = function(el, cn)
    {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    },

    addClass = function(el, cn)
    {
        if (!hasClass(el, cn)) {
            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
        }
    },

    removeClass = function(el, cn)
    {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    },

    isArray = function(obj)
    {
        return (/Array/).test(Object.prototype.toString.call(obj));
    },

    isDate = function(obj)
    {
        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
    },

    isWeekend = function(date)
    {
        var day = date.getDay();
        return day === 0 || day === 6;
    },

    isLeapYear = function(year)
    {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    },

    getDaysInMonth = function(year, month)
    {
        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },

    setToStartOfDay = function(date)
    {
        if (isDate(date)) date.setHours(0,0,0,0);
    },

    compareDates = function(a,b)
    {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
    },

    extend = function(to, from, overwrite)
    {
        var prop, hasProp;
        for (prop in from) {
            hasProp = to[prop] !== undefined;
            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                if (isDate(from[prop])) {
                    if (overwrite) {
                        to[prop] = new Date(from[prop].getTime());
                    }
                }
                else if (isArray(from[prop])) {
                    if (overwrite) {
                        to[prop] = from[prop].slice(0);
                    }
                } else {
                    to[prop] = extend({}, from[prop], overwrite);
                }
            } else if (overwrite || !hasProp) {
                to[prop] = from[prop];
            }
        }
        return to;
    },

    fireEvent = function(el, eventName, data)
    {
        var ev;

        if (document.createEvent) {
            ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventName, true, false);
            ev = extend(ev, data);
            el.dispatchEvent(ev);
        } else if (document.createEventObject) {
            ev = document.createEventObject();
            ev = extend(ev, data);
            el.fireEvent('on' + eventName, ev);
        }
    },

    adjustCalendar = function(calendar) {
        if (calendar.month < 0) {
            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
            calendar.month += 12;
        }
        if (calendar.month > 11) {
            calendar.year += Math.floor(Math.abs(calendar.month)/12);
            calendar.month -= 12;
        }
        return calendar;
    },

    /**
     * defaults and localisation
     */
    defaults = {

        // bind the picker to a form field
        field: null,

        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
        bound: undefined,

        // position of the datepicker, relative to the field (default to bottom & left)
        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
        position: 'bottom left',

        // automatically fit in the viewport even if it means repositioning from the position option
        reposition: true,

        // the default output format for `.toString()` and `field` value
        format: 'YYYY-MM-DD',

        // the toString function which gets passed a current date object and format
        // and returns a string
        toString: null,

        // used to create date object from current input string
        parse: null,

        // the initial date to view when first opened
        defaultDate: null,

        // make the `defaultDate` the initial selected value
        setDefaultDate: false,

        // first day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,

        // the default flag for moment's strict date parsing
        formatStrict: false,

        // the minimum/earliest date that can be selected
        minDate: null,
        // the maximum/latest date that can be selected
        maxDate: null,

        // number of years either side, or array of upper/lower range
        yearRange: 10,

        // show week numbers at head of row
        showWeekNumber: false,

        // Week picker mode
        pickWholeWeek: false,

        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,

        startRange: null,
        endRange: null,

        isRTL: false,

        // Additional text to append to the year in the calendar title
        yearSuffix: '',

        // Render the month after year in the calendar title
        showMonthAfterYear: false,

        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,

        // Allows user to select days that fall in the next or previous month
        enableSelectionDaysInNextAndPreviousMonths: false,

        // how many months are visible
        numberOfMonths: 1,

        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
        // only used for the first display or when a selected date is not visible
        mainCalendar: 'left',

        // Specify a DOM element to render the calendar in
        container: undefined,

        // Blur field when date is selected
        blurFieldOnSelect : true,

        // internationalization
        i18n: {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
        },

        // Theme Classname
        theme: null,

        // events array
        events: [],

        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null
    },


    /**
     * templating functions to abstract HTML rendering
     */
    renderDayName = function(opts, day, abbr)
    {
        day += opts.firstDay;
        while (day >= 7) {
            day -= 7;
        }
        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
    },

    renderDay = function(opts)
    {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
            if (opts.showDaysInNextAndPreviousMonths) {
                arr.push('is-outside-current-month');

                if(!opts.enableSelectionDaysInNextAndPreviousMonths) {
                    arr.push('is-selection-disabled');
                }

            } else {
                return '<td class="is-empty"></td>';
            }
        }
        if (opts.isDisabled) {
            arr.push('is-disabled');
        }
        if (opts.isToday) {
            arr.push('is-today');
        }
        if (opts.isSelected) {
            arr.push('is-selected');
            ariaSelected = 'true';
        }
        if (opts.hasEvent) {
            arr.push('has-event');
        }
        if (opts.isInRange) {
            arr.push('is-inrange');
        }
        if (opts.isStartRange) {
            arr.push('is-startrange');
        }
        if (opts.isEndRange) {
            arr.push('is-endrange');
        }
        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' +
                 '<button class="pika-button pika-day" type="button" ' +
                    'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
                        opts.day +
                 '</button>' +
               '</td>';
    },

    renderWeek = function (d, m, y) {
        // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
        var onejan = new Date(y, 0, 1),
            weekNum = Math.ceil((((new Date(y, m, d) - onejan) / 86400000) + onejan.getDay()+1)/7);
        return '<td class="pika-week">' + weekNum + '</td>';
    },

    renderRow = function(days, isRTL, pickWholeWeek, isRowSelected)
    {
        return '<tr class="pika-row' + (pickWholeWeek ? ' pick-whole-week' : '') + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
    },

    renderBody = function(rows)
    {
        return '<tbody>' + rows.join('') + '</tbody>';
    },

    renderHead = function(opts)
    {
        var i, arr = [];
        if (opts.showWeekNumber) {
            arr.push('<th></th>');
        }
        for (i = 0; i < 7; i++) {
            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
    },

    renderTitle = function(instance, c, year, month, refYear, randId)
    {
        var i, j, arr,
            opts = instance._o,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">',
            monthHtml,
            yearHtml,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
                (i === month ? ' selected="selected"': '') +
                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? 'disabled="disabled"' : '') + '>' +
                opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';

        if (isArray(opts.yearRange)) {
            i = opts.yearRange[0];
            j = opts.yearRange[1] + 1;
        } else {
            i = year - opts.yearRange;
            j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
            if (i >= opts.minYear) {
                arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"': '') + '>' + (i) + '</option>');
            }
        }
        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';

        if (opts.showMonthAfterYear) {
            html += yearHtml + monthHtml;
        } else {
            html += monthHtml + yearHtml;
        }

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
            prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
            next = false;
        }

        if (c === 0) {
            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
        }
        if (c === (instance._o.numberOfMonths - 1) ) {
            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
        }

        return html += '</div>';
    },

    renderTable = function(opts, data, randId)
    {
        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
    },


    /**
     * Pikaday constructor
     */
    Pikaday = function(options)
    {
        var self = this,
            opts = self.config(options);

        self._onMouseDown = function(e)
        {
            if (!self._v) {
                return;
            }
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }

            if (!hasClass(target, 'is-disabled')) {
                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
                    if (opts.bound) {
                        sto(function() {
                            self.hide();
                            if (opts.blurFieldOnSelect && opts.field) {
                                opts.field.blur();
                            }
                        }, 100);
                    }
                }
                else if (hasClass(target, 'pika-prev')) {
                    self.prevMonth();
                }
                else if (hasClass(target, 'pika-next')) {
                    self.nextMonth();
                }
            }
            if (!hasClass(target, 'pika-select')) {
                // if this is touch event prevent mouse events emulation
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                    return false;
                }
            } else {
                self._c = true;
            }
        };

        self._onChange = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }
            if (hasClass(target, 'pika-select-month')) {
                self.gotoMonth(target.value);
            }
            else if (hasClass(target, 'pika-select-year')) {
                self.gotoYear(target.value);
            }
        };

        self._onKeyChange = function(e)
        {
            e = e || window.event;

            if (self.isVisible()) {

                switch(e.keyCode){
                    case 13:
                    case 27:
                        if (opts.field) {
                            opts.field.blur();
                        }
                        break;
                    case 37:
                        e.preventDefault();
                        self.adjustDate('subtract', 1);
                        break;
                    case 38:
                        self.adjustDate('subtract', 7);
                        break;
                    case 39:
                        self.adjustDate('add', 1);
                        break;
                    case 40:
                        self.adjustDate('add', 7);
                        break;
                }
            }
        };

        self._onInputChange = function(e)
        {
            var date;

            if (e.firedBy === self) {
                return;
            }
            if (opts.parse) {
                date = opts.parse(opts.field.value, opts.format);
            } else if (hasMoment) {
                date = moment(opts.field.value, opts.format, opts.formatStrict);
                date = (date && date.isValid()) ? date.toDate() : null;
            }
            else {
                date = new Date(Date.parse(opts.field.value));
            }
            if (isDate(date)) {
              self.setDate(date);
            }
            if (!self._v) {
                self.show();
            }
        };

        self._onInputFocus = function()
        {
            self.show();
        };

        self._onInputClick = function()
        {
            self.show();
        };

        self._onInputBlur = function()
        {
            // IE allows pika div to gain focus; catch blur the input field
            var pEl = document.activeElement;
            do {
                if (hasClass(pEl, 'pika-single')) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));

            if (!self._c) {
                self._b = sto(function() {
                    self.hide();
                }, 50);
            }
            self._c = false;
        };

        self._onClick = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement,
                pEl = target;
            if (!target) {
                return;
            }
            if (!hasEventListeners && hasClass(target, 'pika-select')) {
                if (!target.onchange) {
                    target.setAttribute('onchange', 'return;');
                    addEvent(target, 'change', self._onChange);
                }
            }
            do {
                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));
            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                self.hide();
            }
        };

        self.el = document.createElement('div');
        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');

        addEvent(self.el, 'mousedown', self._onMouseDown, true);
        addEvent(self.el, 'touchend', self._onMouseDown, true);
        addEvent(self.el, 'change', self._onChange);
        addEvent(document, 'keydown', self._onKeyChange);

        if (opts.field) {
            if (opts.container) {
                opts.container.appendChild(self.el);
            } else if (opts.bound) {
                document.body.appendChild(self.el);
            } else {
                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
            }
            addEvent(opts.field, 'change', self._onInputChange);

            if (!opts.defaultDate) {
                if (hasMoment && opts.field.value) {
                    opts.defaultDate = moment(opts.field.value, opts.format).toDate();
                } else {
                    opts.defaultDate = new Date(Date.parse(opts.field.value));
                }
                opts.setDefaultDate = true;
            }
        }

        var defDate = opts.defaultDate;

        if (isDate(defDate)) {
            if (opts.setDefaultDate) {
                self.setDate(defDate, true);
            } else {
                self.gotoDate(defDate);
            }
        } else {
            self.gotoDate(new Date());
        }

        if (opts.bound) {
            this.hide();
            self.el.className += ' is-bound';
            addEvent(opts.trigger, 'click', self._onInputClick);
            addEvent(opts.trigger, 'focus', self._onInputFocus);
            addEvent(opts.trigger, 'blur', self._onInputBlur);
        } else {
            this.show();
        }
    };


    /**
     * public Pikaday API
     */
    Pikaday.prototype = {


        /**
         * configure functionality
         */
        config: function(options)
        {
            if (!this._o) {
                this._o = extend({}, defaults, true);
            }

            var opts = extend(this._o, options, true);

            opts.isRTL = !!opts.isRTL;

            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;

            opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;

            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);

            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;

            opts.disableWeekends = !!opts.disableWeekends;

            opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;

            var nom = parseInt(opts.numberOfMonths, 10) || 1;
            opts.numberOfMonths = nom > 4 ? 4 : nom;

            if (!isDate(opts.minDate)) {
                opts.minDate = false;
            }
            if (!isDate(opts.maxDate)) {
                opts.maxDate = false;
            }
            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
                opts.maxDate = opts.minDate = false;
            }
            if (opts.minDate) {
                this.setMinDate(opts.minDate);
            }
            if (opts.maxDate) {
                this.setMaxDate(opts.maxDate);
            }

            if (isArray(opts.yearRange)) {
                var fallback = new Date().getFullYear() - 10;
                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
            } else {
                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                if (opts.yearRange > 100) {
                    opts.yearRange = 100;
                }
            }

            return opts;
        },

        /**
         * return a formatted string of the current selection (using Moment.js if available)
         */
        toString: function(format)
        {
            format = format || this._o.format;
            if (!isDate(this._d)) {
                return '';
            }
            if (this._o.toString) {
              return this._o.toString(this._d, format);
            }
            if (hasMoment) {
              return moment(this._d).format(format);
            }
            return this._d.toDateString();
        },

        /**
         * return a Moment.js object of the current selection (if available)
         */
        getMoment: function()
        {
            return hasMoment ? moment(this._d) : null;
        },

        /**
         * set the current selection from a Moment.js object (if available)
         */
        setMoment: function(date, preventOnSelect)
        {
            if (hasMoment && moment.isMoment(date)) {
                this.setDate(date.toDate(), preventOnSelect);
            }
        },

        /**
         * return a Date object of the current selection
         */
        getDate: function()
        {
            return isDate(this._d) ? new Date(this._d.getTime()) : null;
        },

        /**
         * set the current selection
         */
        setDate: function(date, preventOnSelect)
        {
            if (!date) {
                this._d = null;

                if (this._o.field) {
                    this._o.field.value = '';
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }

                return this.draw();
            }
            if (typeof date === 'string') {
                date = new Date(Date.parse(date));
            }
            if (!isDate(date)) {
                return;
            }

            var min = this._o.minDate,
                max = this._o.maxDate;

            if (isDate(min) && date < min) {
                date = min;
            } else if (isDate(max) && date > max) {
                date = max;
            }

            this._d = new Date(date.getTime());
            setToStartOfDay(this._d);
            this.gotoDate(this._d);

            if (this._o.field) {
                this._o.field.value = this.toString();
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                this._o.onSelect.call(this, this.getDate());
            }
        },

        /**
         * change view to a specific date
         */
        gotoDate: function(date)
        {
            var newCalendar = true;

            if (!isDate(date)) {
                return;
            }

            if (this.calendars) {
                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
                    visibleDate = date.getTime();
                // get the end of the month
                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
            }

            if (newCalendar) {
                this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear()
                }];
                if (this._o.mainCalendar === 'right') {
                    this.calendars[0].month += 1 - this._o.numberOfMonths;
                }
            }

            this.adjustCalendars();
        },

        adjustDate: function(sign, days) {

            var day = this.getDate() || new Date();
            var difference = parseInt(days)*24*60*60*1000;

            var newDay;

            if (sign === 'add') {
                newDay = new Date(day.valueOf() + difference);
            } else if (sign === 'subtract') {
                newDay = new Date(day.valueOf() - difference);
            }

            this.setDate(newDay);
        },

        adjustCalendars: function() {
            this.calendars[0] = adjustCalendar(this.calendars[0]);
            for (var c = 1; c < this._o.numberOfMonths; c++) {
                this.calendars[c] = adjustCalendar({
                    month: this.calendars[0].month + c,
                    year: this.calendars[0].year
                });
            }
            this.draw();
        },

        gotoToday: function()
        {
            this.gotoDate(new Date());
        },

        /**
         * change view to a specific month (zero-index, e.g. 0: January)
         */
        gotoMonth: function(month)
        {
            if (!isNaN(month)) {
                this.calendars[0].month = parseInt(month, 10);
                this.adjustCalendars();
            }
        },

        nextMonth: function()
        {
            this.calendars[0].month++;
            this.adjustCalendars();
        },

        prevMonth: function()
        {
            this.calendars[0].month--;
            this.adjustCalendars();
        },

        /**
         * change view to a specific full year (e.g. "2012")
         */
        gotoYear: function(year)
        {
            if (!isNaN(year)) {
                this.calendars[0].year = parseInt(year, 10);
                this.adjustCalendars();
            }
        },

        /**
         * change the minDate
         */
        setMinDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.minDate = value;
                this._o.minYear  = value.getFullYear();
                this._o.minMonth = value.getMonth();
            } else {
                this._o.minDate = defaults.minDate;
                this._o.minYear  = defaults.minYear;
                this._o.minMonth = defaults.minMonth;
                this._o.startRange = defaults.startRange;
            }

            this.draw();
        },

        /**
         * change the maxDate
         */
        setMaxDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.maxDate = value;
                this._o.maxYear = value.getFullYear();
                this._o.maxMonth = value.getMonth();
            } else {
                this._o.maxDate = defaults.maxDate;
                this._o.maxYear = defaults.maxYear;
                this._o.maxMonth = defaults.maxMonth;
                this._o.endRange = defaults.endRange;
            }

            this.draw();
        },

        setStartRange: function(value)
        {
            this._o.startRange = value;
        },

        setEndRange: function(value)
        {
            this._o.endRange = value;
        },

        /**
         * refresh the HTML
         */
        draw: function(force)
        {
            if (!this._v && !force) {
                return;
            }
            var opts = this._o,
                minYear = opts.minYear,
                maxYear = opts.maxYear,
                minMonth = opts.minMonth,
                maxMonth = opts.maxMonth,
                html = '',
                randId;

            if (this._y <= minYear) {
                this._y = minYear;
                if (!isNaN(minMonth) && this._m < minMonth) {
                    this._m = minMonth;
                }
            }
            if (this._y >= maxYear) {
                this._y = maxYear;
                if (!isNaN(maxMonth) && this._m > maxMonth) {
                    this._m = maxMonth;
                }
            }

            randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);

            for (var c = 0; c < opts.numberOfMonths; c++) {
                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
            }

            this.el.innerHTML = html;

            if (opts.bound) {
                if(opts.field.type !== 'hidden') {
                    sto(function() {
                        opts.trigger.focus();
                    }, 1);
                }
            }

            if (typeof this._o.onDraw === 'function') {
                this._o.onDraw(this);
            }

            if (opts.bound) {
                // let the screen reader user know to use arrow keys
                opts.field.setAttribute('aria-label', 'Use the arrow keys to pick a date');
            }
        },

        adjustPosition: function()
        {
            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect;

            if (this._o.container) return;

            this.el.style.position = 'absolute';

            field = this._o.trigger;
            pEl = field;
            width = this.el.offsetWidth;
            height = this.el.offsetHeight;
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;

            if (typeof field.getBoundingClientRect === 'function') {
                clientRect = field.getBoundingClientRect();
                left = clientRect.left + window.pageXOffset;
                top = clientRect.bottom + window.pageYOffset;
            } else {
                left = pEl.offsetLeft;
                top  = pEl.offsetTop + pEl.offsetHeight;
                while((pEl = pEl.offsetParent)) {
                    left += pEl.offsetLeft;
                    top  += pEl.offsetTop;
                }
            }

            // default position is bottom & left
            if ((this._o.reposition && left + width > viewportWidth) ||
                (
                    this._o.position.indexOf('right') > -1 &&
                    left - width + field.offsetWidth > 0
                )
            ) {
                left = left - width + field.offsetWidth;
            }
            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
                (
                    this._o.position.indexOf('top') > -1 &&
                    top - height - field.offsetHeight > 0
                )
            ) {
                top = top - height - field.offsetHeight;
            }

            this.el.style.left = left + 'px';
            this.el.style.top = top + 'px';
        },

        /**
         * render HTML for a particular month
         */
        render: function(year, month, randId)
        {
            var opts   = this._o,
                now    = new Date(),
                days   = getDaysInMonth(year, month),
                before = new Date(year, month, 1).getDay(),
                data   = [],
                row    = [];
            setToStartOfDay(now);
            if (opts.firstDay > 0) {
                before -= opts.firstDay;
                if (before < 0) {
                    before += 7;
                }
            }
            var previousMonth = month === 0 ? 11 : month - 1,
                nextMonth = month === 11 ? 0 : month + 1,
                yearOfPreviousMonth = month === 0 ? year - 1 : year,
                yearOfNextMonth = month === 11 ? year + 1 : year,
                daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
            var cells = days + before,
                after = cells;
            while(after > 7) {
                after -= 7;
            }
            cells += 7 - after;
            var isWeekSelected = false;
            for (var i = 0, r = 0; i < cells; i++)
            {
                var day = new Date(year, month, 1 + (i - before)),
                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
                    isToday = compareDates(day, now),
                    hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
                    isEmpty = i < before || i >= (days + before),
                    dayNumber = 1 + (i - before),
                    monthNumber = month,
                    yearNumber = year,
                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
                    isDisabled = (opts.minDate && day < opts.minDate) ||
                                 (opts.maxDate && day > opts.maxDate) ||
                                 (opts.disableWeekends && isWeekend(day)) ||
                                 (opts.disableDayFn && opts.disableDayFn(day));

                if (isEmpty) {
                    if (i < before) {
                        dayNumber = daysInPreviousMonth + dayNumber;
                        monthNumber = previousMonth;
                        yearNumber = yearOfPreviousMonth;
                    } else {
                        dayNumber = dayNumber - days;
                        monthNumber = nextMonth;
                        yearNumber = yearOfNextMonth;
                    }
                }

                var dayConfig = {
                        day: dayNumber,
                        month: monthNumber,
                        year: yearNumber,
                        hasEvent: hasEvent,
                        isSelected: isSelected,
                        isToday: isToday,
                        isDisabled: isDisabled,
                        isEmpty: isEmpty,
                        isStartRange: isStartRange,
                        isEndRange: isEndRange,
                        isInRange: isInRange,
                        showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths,
                        enableSelectionDaysInNextAndPreviousMonths: opts.enableSelectionDaysInNextAndPreviousMonths
                    };

                if (opts.pickWholeWeek && isSelected) {
                    isWeekSelected = true;
                }

                row.push(renderDay(dayConfig));

                if (++r === 7) {
                    if (opts.showWeekNumber) {
                        row.unshift(renderWeek(i - before, month, year));
                    }
                    data.push(renderRow(row, opts.isRTL, opts.pickWholeWeek, isWeekSelected));
                    row = [];
                    r = 0;
                    isWeekSelected = false;
                }
            }
            return renderTable(opts, data, randId);
        },

        isVisible: function()
        {
            return this._v;
        },

        show: function()
        {
            if (!this.isVisible()) {
                this._v = true;
                this.draw();
                removeClass(this.el, 'is-hidden');
                if (this._o.bound) {
                    addEvent(document, 'click', this._onClick);
                    this.adjustPosition();
                }
                if (typeof this._o.onOpen === 'function') {
                    this._o.onOpen.call(this);
                }
            }
        },

        hide: function()
        {
            var v = this._v;
            if (v !== false) {
                if (this._o.bound) {
                    removeEvent(document, 'click', this._onClick);
                }
                this.el.style.position = 'static'; // reset
                this.el.style.left = 'auto';
                this.el.style.top = 'auto';
                addClass(this.el, 'is-hidden');
                this._v = false;
                if (v !== undefined && typeof this._o.onClose === 'function') {
                    this._o.onClose.call(this);
                }
            }
        },

        /**
         * GAME OVER
         */
        destroy: function()
        {
            this.hide();
            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
            removeEvent(this.el, 'touchend', this._onMouseDown, true);
            removeEvent(this.el, 'change', this._onChange);
            removeEvent(document, 'keydown', this._onKeyChange);
            if (this._o.field) {
                removeEvent(this._o.field, 'change', this._onInputChange);
                if (this._o.bound) {
                    removeEvent(this._o.trigger, 'click', this._onInputClick);
                    removeEvent(this._o.trigger, 'focus', this._onInputFocus);
                    removeEvent(this._o.trigger, 'blur', this._onInputBlur);
                }
            }
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }
        }

    };

    return Pikaday;

}));


/***/ }),

/***/ "../../../node_modules/visibilityjs/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../../../node_modules/visibilityjs/lib/visibility.timers.js")


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.core.js":
/***/ (function(module, exports) {

;(function (global) {
    "use strict";

    var lastId = -1;

    // Visibility.js allow you to know, that your web page is in the background
    // tab and thus not visible to the user. This library is wrap under
    // Page Visibility API. It fix problems with different vendor prefixes and
    // add high-level useful functions.
    var self = {

        // Call callback only when page become to visible for user or
        // call it now if page is visible now or Page Visibility API
        // doesn’t supported.
        //
        // Return false if API isn’t supported, true if page is already visible
        // or listener ID (you can use it in `unbind` method) if page isn’t
        // visible now.
        //
        //   Visibility.onVisible(function () {
        //       startIntroAnimation();
        //   });
        onVisible: function (callback) {
            var support = self.isSupported();
            if ( !support || !self.hidden() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( !self.hidden() ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Call callback when visibility will be changed. First argument for
        // callback will be original event object, second will be visibility
        // state name.
        //
        // Return listener ID to unbind listener by `unbind` method.
        //
        // If Page Visibility API doesn’t supported method will be return false
        // and callback never will be called.
        //
        //   Visibility.change(function(e, state) {
        //       Statistics.visibilityChange(state);
        //   });
        //
        // It is just proxy to `visibilitychange` event, but use vendor prefix.
        change: function (callback) {
            if ( !self.isSupported() ) {
                return false;
            }
            lastId += 1;
            var number = lastId;
            self._callbacks[number] = callback;
            self._listen();
            return number;
        },

        // Remove `change` listener by it ID.
        //
        //   var id = Visibility.change(function(e, state) {
        //       firstChangeCallback();
        //       Visibility.unbind(id);
        //   });
        unbind: function (id) {
            delete self._callbacks[id];
        },

        // Call `callback` in any state, expect “prerender”. If current state
        // is “prerender” it will wait until state will be changed.
        // If Page Visibility API doesn’t supported, it will call `callback`
        // immediately.
        //
        // Return false if API isn’t supported, true if page is already after
        // prerendering or listener ID (you can use it in `unbind` method)
        // if page is prerended now.
        //
        //   Visibility.afterPrerendering(function () {
        //       Statistics.countVisitor();
        //   });
        afterPrerendering: function (callback) {
            var support   = self.isSupported();
            var prerender = 'prerender';

            if ( !support || prerender != self.state() ) {
                callback();
                return support;
            }

            var listener = self.change(function (e, state) {
                if ( prerender != state ) {
                    self.unbind(listener);
                    callback();
                }
            });
            return listener;
        },

        // Return true if page now isn’t visible to user.
        //
        //   if ( !Visibility.hidden() ) {
        //       VideoPlayer.play();
        //   }
        //
        // It is just proxy to `document.hidden`, but use vendor prefix.
        hidden: function () {
            return !!(self._doc.hidden || self._doc.webkitHidden);
        },

        // Return visibility state: 'visible', 'hidden' or 'prerender'.
        //
        //   if ( 'prerender' == Visibility.state() ) {
        //       Statistics.pageIsPrerendering();
        //   }
        //
        // Don’t use `Visibility.state()` to detect, is page visible, because
        // visibility states can extend in next API versions.
        // Use more simpler and general `Visibility.hidden()` for this cases.
        //
        // It is just proxy to `document.visibilityState`, but use
        // vendor prefix.
        state: function () {
            return self._doc.visibilityState       ||
                   self._doc.webkitVisibilityState ||
                   'visible';
        },

        // Return true if browser support Page Visibility API.
        //
        //   if ( Visibility.isSupported() ) {
        //       Statistics.startTrackingVisibility();
        //       Visibility.change(function(e, state)) {
        //           Statistics.trackVisibility(state);
        //       });
        //   }
        isSupported: function () {
            return !!(self._doc.visibilityState ||
                      self._doc.webkitVisibilityState);
        },

        // Link to document object to change it in tests.
        _doc: document || {},

        // Callbacks from `change` method, that wait visibility changes.
        _callbacks: { },

        // Listener for `visibilitychange` event.
        _change: function(event) {
            var state = self.state();

            for ( var i in self._callbacks ) {
                self._callbacks[i].call(self._doc, event, state);
            }
        },

        // Set listener for `visibilitychange` event.
        _listen: function () {
            if ( self._init ) {
                return;
            }

            var event = 'visibilitychange';
            if ( self._doc.webkitVisibilityState ) {
                event = 'webkit' + event;
            }

            var listener = function () {
                self._change.apply(self, arguments);
            };
            if ( self._doc.addEventListener ) {
                self._doc.addEventListener(event, listener);
            } else {
                self._doc.attachEvent(event, listener);
            }
            self._init = true;
        }

    };

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = self;
    } else {
        global.Visibility = self;
    }

})(this);


/***/ }),

/***/ "../../../node_modules/visibilityjs/lib/visibility.timers.js":
/***/ (function(module, exports, __webpack_require__) {

;(function (window) {
    "use strict";

    var lastTimer = -1;

    var install = function (Visibility) {

        // Run callback every `interval` milliseconds if page is visible and
        // every `hiddenInterval` milliseconds if page is hidden.
        //
        //   Visibility.every(60 * 1000, 5 * 60 * 1000, function () {
        //       checkNewMails();
        //   });
        //
        // You can skip `hiddenInterval` and callback will be called only if
        // page is visible.
        //
        //   Visibility.every(1000, function () {
        //       updateCountdown();
        //   });
        //
        // It is analog of `setInterval(callback, interval)` but use visibility
        // state.
        //
        // It return timer ID, that you can use in `Visibility.stop(id)` to stop
        // timer (`clearInterval` analog).
        // Warning: timer ID is different from interval ID from `setInterval`,
        // so don’t use it in `clearInterval`.
        //
        // On change state from hidden to visible timers will be execute.
        Visibility.every = function (interval, hiddenInterval, callback) {
            Visibility._time();

            if ( !callback ) {
                callback = hiddenInterval;
                hiddenInterval = null;
            }

            lastTimer += 1;
            var number = lastTimer;

            Visibility._timers[number] = {
                visible:  interval,
                hidden:   hiddenInterval,
                callback: callback
            };
            Visibility._run(number, false);

            if ( Visibility.isSupported() ) {
                Visibility._listen();
            }
            return number;
        };

        // Stop timer from `every` method by it ID (`every` method return it).
        //
        //   slideshow = Visibility.every(5 * 1000, function () {
        //       changeSlide();
        //   });
        //   $('.stopSlideshow').click(function () {
        //       Visibility.stop(slideshow);
        //   });
        Visibility.stop = function(id) {
            if ( !Visibility._timers[id] ) {
                return false;
            }
            Visibility._stop(id);
            delete Visibility._timers[id];
            return true;
        };

        // Callbacks and intervals added by `every` method.
        Visibility._timers = { };

        // Initialize variables on page loading.
        Visibility._time = function () {
            if ( Visibility._timed ) {
                return;
            }
            Visibility._timed     = true;
            Visibility._wasHidden = Visibility.hidden();

            Visibility.change(function () {
                Visibility._stopRun();
                Visibility._wasHidden = Visibility.hidden();
            });
        };

        // Try to run timer from every method by it’s ID. It will be use
        // `interval` or `hiddenInterval` depending on visibility state.
        // If page is hidden and `hiddenInterval` is null,
        // it will not run timer.
        //
        // Argument `runNow` say, that timers must be execute now too.
        Visibility._run = function (id, runNow) {
            var interval,
                timer = Visibility._timers[id];

            if ( Visibility.hidden() ) {
                if ( null === timer.hidden ) {
                    return;
                }
                interval = timer.hidden;
            } else {
                interval = timer.visible;
            }

            var runner = function () {
                timer.last = new Date();
                timer.callback.call(window);
            }

            if ( runNow ) {
                var now  = new Date();
                var last = now - timer.last ;

                if ( interval > last ) {
                    timer.delay = setTimeout(function () {
                        timer.id = setInterval(runner, interval);
                        runner();
                    }, interval - last);
                } else {
                    timer.id = setInterval(runner, interval);
                    runner();
                }

            } else {
              timer.id = setInterval(runner, interval);
            }
        };

        // Stop timer from `every` method by it’s ID.
        Visibility._stop = function (id) {
            var timer = Visibility._timers[id];
            clearInterval(timer.id);
            clearTimeout(timer.delay);
            delete timer.id;
            delete timer.delay;
        };

        // Listener for `visibilitychange` event.
        Visibility._stopRun = function (event) {
            var isHidden  = Visibility.hidden(),
                wasHidden = Visibility._wasHidden;

            if ( (isHidden && !wasHidden) || (!isHidden && wasHidden) ) {
                for ( var i in Visibility._timers ) {
                    Visibility._stop(i);
                    Visibility._run(i, !isHidden);
                }
            }
        };

        return Visibility;
    }

    if ( typeof(module) != 'undefined' && module.exports ) {
        module.exports = install(__webpack_require__("../../../node_modules/visibilityjs/lib/visibility.core.js"));
    } else {
        install(window.Visibility)
    }

})(window);


/***/ }),

/***/ "../../../node_modules/webpack/buildin/module.js":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "../../views/shared/icons/_icon_commit.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><path d=\"M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3.876-1.008a4.002 4.002 0 0 1-7.752 0A1.01 1.01 0 0 1 4 9H1a1 1 0 1 1 0-2h3c.042 0 .083.003.124.008a4.002 4.002 0 0 1 7.752 0A1.01 1.01 0 0 1 12 7h3a1 1 0 0 1 0 2h-3a1.01 1.01 0 0 1-.124-.008z\"/></svg>\n\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_success.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M6.278 7.697L5.045 6.464a.296.296 0 0 0-.42-.002l-.613.614a.298.298 0 0 0 .002.42l1.91 1.909a.5.5 0 0 0 .703.005l.265-.265L9.997 6.04a.291.291 0 0 0-.009-.408l-.614-.614a.29.29 0 0 0-.408-.009L6.278 7.697z\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_status_warning.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7z\"/><path d=\"M13 7A6 6 0 1 0 1 7a6 6 0 0 0 12 0z\" fill=\"#FFF\"/><path d=\"M6 3.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-4m0 6c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5h-1c-.3 0-.5-.2-.5-.5v-1\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_stopwatch.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" enable-background=\"new 0 0 12 14\"><path d=\"m11.5 2.4l-1.3-1.1-1 1.1 1.4 1.1.9-1.1\"/><path d=\"m6.8 2v-.5h.5v-1.5h-2.6v1.5h.5v.5c-2.9.4-5.2 2.9-5.2 6 0 3.3 2.7 6 6 6s6-2.7 6-6c0-3-2.3-5.6-5.2-6m-.8 10.5c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5 4.5 2 4.5 4.5-2 4.5-4.5 4.5\"/><path d=\"m6.2 8.9h-.5c-.1 0-.2-.1-.2-.2v-3.5c0-.1.1-.2.2-.2h.5c.1 0 .2.1.2.2v3.5c0 .1-.1.2-.2.2\"/></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_icon_timer.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\"><g fill=\"#8F8F8F\" fill-rule=\"evenodd\"><path d=\"M29.513 10.134A15.922 15.922 0 0 0 23 7.28V6h2.993C26.55 6 27 5.552 27 5V2a1 1 0 0 0-1.007-1H14.007C13.45 1 13 1.448 13 2v3a1 1 0 0 0 1.007 1H17v1.28C9.597 8.686 4 15.19 4 23c0 8.837 7.163 16 16 16s16-7.163 16-16c0-3.461-1.099-6.665-2.967-9.283l1.327-1.58a2.498 2.498 0 0 0-.303-3.53 2.499 2.499 0 0 0-3.528.315l-1.016 1.212zM20 34c6.075 0 11-4.925 11-11s-4.925-11-11-11S9 16.925 9 23s4.925 11 11 11z\"/><path d=\"M19 21h-4.002c-.552 0-.998.452-.998 1.01v1.98c0 .567.447 1.01.998 1.01h7.004c.274 0 .521-.111.701-.291a.979.979 0 0 0 .297-.704v-8.01c0-.54-.452-.995-1.01-.995h-1.98a.997.997 0 0 0-1.01.995V21z\"/></g></svg>\n"

/***/ }),

/***/ "../../views/shared/icons/_mr_widget_empty_state.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"256\" height=\"146\" viewBox=\"0 0 256 146\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><title>illustration</title><defs><rect id=\"a\" width=\"178.714\" height=\"115.389\" rx=\"10\"/><mask id=\"d\" x=\"0\" y=\"0\" width=\"178.714\" height=\"115.389\" fill=\"#fff\"><use xlink:href=\"#a\"/></mask><path d=\"M8.796 31.515c.395.047.8.072 1.207.072h23.065c5.536 0 10.003-4.475 10.003-9.994v-11.6C43.07 4.476 38.594 0 33.07 0H10.003C4.467 0 0 4.475 0 9.994v11.6c0 1.248.23 2.444.65 3.547H0v7.414c0 4.094 2.394 5.113 5.342 2.28l3.454-3.32z\" id=\"b\"/><mask id=\"e\" x=\"0\" y=\"0\" width=\"43.071\" height=\"36.437\" fill=\"#fff\"><use xlink:href=\"#b\"/></mask><path d=\"M8.796 31.515c.395.047.8.072 1.207.072h23.065c5.536 0 10.003-4.475 10.003-9.994v-11.6C43.07 4.476 38.594 0 33.07 0H10.003C4.467 0 0 4.475 0 9.994v11.6c0 1.248.23 2.444.65 3.547H0v7.414c0 4.094 2.394 5.113 5.342 2.28l3.454-3.32z\" id=\"c\"/><mask id=\"f\" x=\"0\" y=\"0\" width=\"43.071\" height=\"36.437\" fill=\"#fff\"><use xlink:href=\"#c\"/></mask></defs><g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(0 3.868)\" fill=\"#F9F9F9\"><rect x=\"19.286\" width=\"77.143\" height=\"14.182\" rx=\"7.091\"/><rect y=\"28.364\" width=\"84.857\" height=\"14.182\" rx=\"7.091\"/><rect x=\"133.714\" y=\"42.546\" width=\"122.143\" height=\"14.182\" rx=\"7.091\"/><rect x=\"82.929\" y=\"126.992\" width=\"101.571\" height=\"14.182\" rx=\"7.091\"/><rect x=\"42.429\" y=\"99.273\" width=\"101.571\" height=\"14.182\" rx=\"7.091\"/><rect x=\"19.929\" y=\"70.909\" width=\"225\" height=\"14.182\" rx=\"7.091\"/><path d=\"M98.37 14.182H13.488h13.81a7.098 7.098 0 0 1 7.094 7.09 7.09 7.09 0 0 1-7.094 7.092h-13.81 84.88-23.452a7.098 7.098 0 0 1-7.095-7.09 7.09 7.09 0 0 1 7.096-7.092h23.452zm162 42.545h-75.238 23.452a7.098 7.098 0 0 1 7.095 7.09 7.09 7.09 0 0 1-7.096 7.092h-23.452 75.237-23.453a7.098 7.098 0 0 1-7.095-7.09 7.09 7.09 0 0 1 7.095-7.093h23.452zM103.512 85.09H28.275h23.452a7.098 7.098 0 0 1 7.095 7.092 7.09 7.09 0 0 1-7.095 7.09H28.275h75.237H80.06a7.098 7.098 0 0 1-7.095-7.09 7.09 7.09 0 0 1 7.095-7.09h23.452zm48.215 28.365H76.49 90.3a7.098 7.098 0 0 1 7.093 7.09 7.09 7.09 0 0 1-7.094 7.092H76.49h75.237-33.096a7.098 7.098 0 0 1-7.094-7.09 7.09 7.09 0 0 1 7.095-7.092h33.097z\"/></g><g transform=\"translate(38.57 12.248)\"><use stroke=\"#EEE\" mask=\"url(#d)\" stroke-width=\"8\" fill=\"#FFF\" xlink:href=\"#a\"/><path fill=\"#EEE\" d=\"M2.57 18.694h174.215v2.58H2.57z\"/><g transform=\"translate(21.857 38.678)\"><rect fill=\"#B5A7DD\" y=\".645\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#EEE\" x=\"9.643\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"46.286\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"25.071\" y=\"14.182\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" x=\"34.071\" y=\"7.091\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" opacity=\".5\" x=\"30.857\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"14.182\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"18.643\" y=\"7.091\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" x=\"21.857\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"7.091\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#B5A7DD\" y=\"7.736\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#B5A7DD\" y=\"14.826\" width=\"3.857\" height=\"1.289\" rx=\".645\"/></g><g transform=\"translate(21.857 59.95)\"><rect fill=\"#B5A7DD\" y=\".645\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#FC6D26\" x=\"9.643\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"46.286\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" opacity=\".5\" x=\"25.071\" y=\"14.182\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"34.071\" y=\"7.091\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" x=\"30.857\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" x=\"9.643\" y=\"14.182\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"18.643\" y=\"7.091\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" opacity=\".5\" x=\"21.857\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"7.091\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#B5A7DD\" y=\"7.736\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#B5A7DD\" y=\"14.826\" width=\"3.857\" height=\"1.289\" rx=\".645\"/></g><g transform=\"translate(21.857 81.223)\"><rect fill=\"#B5A7DD\" y=\".645\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#EEE\" x=\"9.643\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"46.286\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"25.071\" y=\"14.182\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"34.071\" y=\"7.091\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" x=\"30.857\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"14.182\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"18.643\" y=\"7.091\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FC6D26\" opacity=\".5\" x=\"21.857\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"7.091\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#B5A7DD\" y=\"7.736\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#B5A7DD\" y=\"14.826\" width=\"3.857\" height=\"1.289\" rx=\".645\"/></g><g transform=\"translate(100.93 38.033)\"><rect fill=\"#FDE5D8\" y=\".645\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#EEE\" x=\"9.643\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"46.286\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"25.071\" y=\"14.182\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" x=\"34.071\" y=\"7.091\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"30.857\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" x=\"9.643\" y=\"14.182\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"18.643\" y=\"7.091\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" x=\"21.857\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"7.091\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FDE5D8\" y=\"7.736\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#FDE5D8\" y=\"14.826\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#FDE5D8\" y=\"21.917\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"21.273\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"37.286\" y=\"14.182\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"25.071\" y=\"35.455\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" x=\"18.643\" y=\"28.364\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" x=\"30.857\" y=\"21.273\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"35.455\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"21.857\" y=\"21.273\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"28.364\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"30.857\" y=\"28.364\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"39.857\" y=\"28.364\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"49.5\" y=\"14.182\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FDE5D8\" y=\"29.008\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#FDE5D8\" y=\"36.099\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#FDE5D8\" y=\"43.19\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#6B4FBB\" x=\"9.643\" y=\"42.546\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"25.071\" y=\"56.727\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"34.071\" y=\"49.636\" width=\"9.643\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"56.727\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#6B4FBB\" x=\"18.643\" y=\"49.636\" width=\"12.857\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"21.857\" y=\"42.546\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"46.286\" y=\"49.636\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#EEE\" x=\"9.643\" y=\"49.636\" width=\"6.429\" height=\"2.579\" rx=\"1.289\"/><rect fill=\"#FDE5D8\" y=\"50.281\" width=\"3.857\" height=\"1.289\" rx=\".645\"/><rect fill=\"#FDE5D8\" y=\"57.372\" width=\"3.857\" height=\"1.289\" rx=\".645\"/></g></g><g transform=\"translate(196.07)\"><use stroke=\"#FDE5D8\" mask=\"url(#e)\" stroke-width=\"8\" fill=\"#FFF\" xlink:href=\"#b\"/><rect fill=\"#FDB692\" x=\"9\" y=\"9.025\" width=\"18.643\" height=\"1.934\" rx=\".967\"/><rect fill=\"#FDB692\" x=\"9\" y=\"14.826\" width=\"25.071\" height=\"1.934\" rx=\".967\"/><rect fill=\"#FDB692\" x=\"9\" y=\"20.628\" width=\"18.643\" height=\"1.934\" rx=\".967\"/></g><g transform=\"translate(189 41.256)\"><ellipse stroke=\"#FC6D26\" stroke-width=\"3\" fill=\"#FFF7F4\" cx=\"10.286\" cy=\"9.669\" rx=\"9.643\" ry=\"9.669\"/><path d=\"M.023 9.002a8.352 8.352 0 0 0 7.94-4.308M9 .644c0-.21-.008-.416-.023-.62\" stroke=\"#FC6D26\" stroke-width=\"2\"/><path d=\"M5.045 2.008A10.266 10.266 0 0 0 13.5 6.446c2.112 0 4.076-.638 5.71-1.733\" stroke=\"#FC6D26\" stroke-width=\"2\"/><ellipse fill=\"#FC6D26\" cx=\"6.75\" cy=\"11.281\" rx=\".964\" ry=\".967\"/><ellipse fill=\"#FC6D26\" cx=\"13.821\" cy=\"11.281\" rx=\".964\" ry=\".967\"/></g><g transform=\"translate(46.93 96.05)\"><ellipse stroke=\"#6B4FBB\" stroke-width=\"3\" fill=\"#F4F1FA\" cx=\"9.643\" cy=\"10.314\" rx=\"9.643\" ry=\"9.669\"/><path d=\"M12.86 4.51h-.005L11.25 2.58 9.645 4.51H9.64L8.036 2.58 6.43 4.51h-.002L4.82 2.58 3.215 4.512h-1.75A9.646 9.646 0 0 1 9.642 0c3.447 0 6.47 1.8 8.176 4.508h-1.75l-1.605-1.93L12.86 4.51z\" fill=\"#6B4FBB\"/><ellipse fill=\"#6B4FBB\" cx=\"6.107\" cy=\"11.281\" rx=\".964\" ry=\".967\"/><ellipse fill=\"#6B4FBB\" cx=\"13.179\" cy=\"11.281\" rx=\".964\" ry=\".967\"/></g><g transform=\"matrix(-1 0 0 1 56.57 54.794)\"><use stroke=\"#E2DCF2\" mask=\"url(#f)\" stroke-width=\"8\" fill=\"#FFF\" xlink:href=\"#c\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"15.429\" y=\"9.025\" width=\"18.643\" height=\"1.934\" rx=\".967\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"21.857\" y=\"14.826\" width=\"12.214\" height=\"1.934\" rx=\".967\"/><rect fill=\"#6B4FBB\" opacity=\".5\" x=\"21.857\" y=\"20.628\" width=\"12.214\" height=\"1.934\" rx=\".967\"/></g></g></svg>\n"

/***/ }),

/***/ "../images/no_avatar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAAAAAAdJSU2AAACNElEQVR4AdXYBa7jMBCA4b3/JZahzIkjp2qt+BWUWnG5ln2XxaJJb2b5F2ukL4wvzK/rP7bUcbf92u6oftLSe1ldk8efsfaVeEjusZZeC6e1RllaCk/yG6ag1lZ4WwPX69uyD6tAe/g2ipAlNMRS37awDLaFrpcMWxXQOi0jnWCWjFkSZomYJWDWKmatYNZyEWkJsvQimoZYah5NgdaLxagCtF6GRy0DshZPkeYwS/KIJWGWYjwYUzDLxCwDtJ54OKglimBLqHWahii2g1pmHLLGBmwVoRjcKlmgOdw65H5qKuGWCVi5Qlhs6m1sENZi4q3AWNvca5UYy2RjT/SAsiZey6CsIvc0wVlV5lJ0ibPMyLUGCmlxQq0IM0hLdWyro7CWEc3sXsqaK4O2zLxOsmtpfW5Q1u68ZrVmepaaNXEewawtI9X5Xl3U3n1qND6+rfPzvqoIWz/fklNCSLY153YV53J/XUxGCJnKZ1lajsn3/Ffegf6Y5pV2LUsSNL2UHzxUfh3TlYpZqqTpXZm0KZk9zJcqaEmaWPHDw0pxe05K7bWOLHFLWXVetqpYmrjle4+1y0aBaF4UOQ1NU+lYezJClkjLUnSEjqhH6zjAW4OjtY39Ibq+sawUb6W2RQfoqG0VeKuwrRJvlba17faRdbe2pTtYq6Nty/S7yAbGsQjWIq41wVoT1+IdZNy1djUcVdu5lklQWC0xHkt1X31qNEE1Pr3qKv/9XiSNj6Aaifj3/69+AYujsR/MvkpZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./autosave.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-param-reassign, prefer-template, no-var, no-void, consistent-return */



var Autosave = function () {
  function Autosave(field, key) {
    var _this = this;

    _classCallCheck(this, Autosave);

    this.field = field;

    this.isLocalStorageAvailable = __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe();
    if (key.join != null) {
      key = key.join('/');
    }
    this.key = 'autosave/' + key;
    this.field.data('autosave', this);
    this.restore();
    this.field.on('input', function () {
      return _this.save();
    });
  }

  _createClass(Autosave, [{
    key: 'restore',
    value: function restore() {
      if (!this.isLocalStorageAvailable) return;
      if (!this.field.length) return;

      var text = window.localStorage.getItem(this.key);

      if ((text != null ? text.length : void 0) > 0) {
        this.field.val(text);
      }

      this.field.trigger('input');
      // v-model does not update with jQuery trigger
      // https://github.com/vuejs/vue/issues/2804#issuecomment-216968137
      var event = new Event('change', { bubbles: true, cancelable: false });
      var field = this.field.get(0);
      field.dispatchEvent(event);
    }
  }, {
    key: 'save',
    value: function save() {
      if (!this.field.length) return;

      var text = this.field.val();

      if (this.isLocalStorageAvailable && (text != null ? text.length : void 0) > 0) {
        return window.localStorage.setItem(this.key, text);
      }

      return this.reset();
    }
  }, {
    key: 'reset',
    value: function reset() {
      if (!this.isLocalStorageAvailable) return;

      return window.localStorage.removeItem(this.key);
    }
  }]);

  return Autosave;
}();

/* harmony default export */ __webpack_exports__["a"] = (Autosave);

/***/ }),

/***/ "./blob/blob_fork_suggestion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaults = {
  // Buttons that will show the `suggestionSections`
  // has `data-fork-path`, and `data-action`
  openButtons: [],
  // Update the href(from `openButton` -> `data-fork-path`)
  // whenever a `openButton` is clicked
  forkButtons: [],
  // Buttons to hide the `suggestionSections`
  cancelButtons: [],
  // Section to show/hide
  suggestionSections: [],
  // Pieces of text that need updating depending on the action, `edit`, `replace`, `delete`
  actionTextPieces: []
};

var BlobForkSuggestion = function () {
  function BlobForkSuggestion(options) {
    _classCallCheck(this, BlobForkSuggestion);

    this.elementMap = Object.assign({}, defaults, options);
    this.onOpenButtonClick = this.onOpenButtonClick.bind(this);
    this.onCancelButtonClick = this.onCancelButtonClick.bind(this);
  }

  _createClass(BlobForkSuggestion, [{
    key: 'init',
    value: function init() {
      this.bindEvents();

      return this;
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      $(this.elementMap.openButtons).on('click', this.onOpenButtonClick);
      $(this.elementMap.cancelButtons).on('click', this.onCancelButtonClick);
    }
  }, {
    key: 'showSuggestionSection',
    value: function showSuggestionSection(forkPath) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'edit';

      $(this.elementMap.suggestionSections).removeClass('hidden');
      $(this.elementMap.forkButtons).attr('href', forkPath);
      $(this.elementMap.actionTextPieces).text(action);
    }
  }, {
    key: 'hideSuggestionSection',
    value: function hideSuggestionSection() {
      $(this.elementMap.suggestionSections).addClass('hidden');
    }
  }, {
    key: 'onOpenButtonClick',
    value: function onOpenButtonClick(e) {
      var forkPath = $(e.currentTarget).attr('data-fork-path');
      var action = $(e.currentTarget).attr('data-action');
      this.showSuggestionSection(forkPath, action);
    }
  }, {
    key: 'onCancelButtonClick',
    value: function onCancelButtonClick() {
      this.hideSuggestionSection();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      $(this.elementMap.openButtons).off('click', this.onOpenButtonClick);
      $(this.elementMap.cancelButtons).off('click', this.onCancelButtonClick);
    }
  }]);

  return BlobForkSuggestion;
}();

/* harmony default export */ __webpack_exports__["a"] = (BlobForkSuggestion);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./commit/image_file.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-use-before-define, prefer-arrow-callback, no-else-return, consistent-return, prefer-template, quotes, one-var, one-var-declaration-per-line, no-unused-vars, no-return-assign, comma-dangle, quote-props, no-unused-expressions, no-sequences, object-shorthand, max-len */

// Width where images must fits in, for 2-up this gets divided by 2
var availWidth = 900;
var viewModes = ['two-up', 'swipe'];

var ImageFile = function () {
  function ImageFile(file) {
    _classCallCheck(this, ImageFile);

    this.views = {
      'two-up': function twoUp() {
        return $('.two-up.view .wrap', this.file).each(function (_this) {
          return function (index, wrap) {
            $('img', wrap).each(function () {
              var currentWidth;
              currentWidth = $(this).width();
              if (currentWidth > availWidth / 2) {
                return $(this).width(availWidth / 2);
              }
            });
            return _this.requestImageInfo($('img', wrap), function (width, height) {
              $('.image-info .meta-width', wrap).text(width + "px");
              $('.image-info .meta-height', wrap).text(height + "px");
              return $('.image-info', wrap).removeClass('hide');
            });
          };
        }(this));
      },
      'swipe': function swipe() {
        var maxHeight, maxWidth;
        maxWidth = 0;
        maxHeight = 0;
        return $('.swipe.view', this.file).each(function (_this) {
          return function (index, view) {
            var $swipeWrap, $swipeBar, $swipeFrame, wrapPadding, ref;
            ref = _this.prepareFrames(view), maxWidth = ref[0], maxHeight = ref[1];
            $swipeFrame = $('.swipe-frame', view);
            $swipeWrap = $('.swipe-wrap', view);
            $swipeBar = $('.swipe-bar', view);

            $swipeFrame.css({
              width: maxWidth + 16,
              height: maxHeight + 28
            });
            $swipeWrap.css({
              width: maxWidth + 1,
              height: maxHeight + 2
            });
            // Set swipeBar left position to match image frame
            $swipeBar.css({
              left: 1
            });

            wrapPadding = parseInt($swipeWrap.css('right').replace('px', ''), 10);

            _this.initDraggable($swipeBar, wrapPadding, function (e, left) {
              if (left > 0 && left < $swipeFrame.width() - wrapPadding * 2) {
                $swipeWrap.width(maxWidth + 1 - left);
                $swipeBar.css('left', left);
              }
            });
          };
        }(this));
      },
      'onion-skin': function onionSkin() {
        var dragTrackWidth, maxHeight, maxWidth;
        maxWidth = 0;
        maxHeight = 0;
        dragTrackWidth = $('.drag-track', this.file).width() - $('.dragger', this.file).width();
        return $('.onion-skin.view', this.file).each(function (_this) {
          return function (index, view) {
            var $frame,
                $track,
                $dragger,
                $frameAdded,
                framePadding,
                ref,
                dragging = false;
            ref = _this.prepareFrames(view), maxWidth = ref[0], maxHeight = ref[1];
            $frame = $('.onion-skin-frame', view);
            $frameAdded = $('.frame.added', view);
            $track = $('.drag-track', view);
            $dragger = $('.dragger', $track);

            $frame.css({
              width: maxWidth + 16,
              height: maxHeight + 28
            });
            $('.swipe-wrap', view).css({
              width: maxWidth + 1,
              height: maxHeight + 2
            });
            $dragger.css({
              left: dragTrackWidth
            });

            $frameAdded.css('opacity', 1);
            framePadding = parseInt($frameAdded.css('right').replace('px', ''), 10);

            _this.initDraggable($dragger, framePadding, function (e, left) {
              var opacity = left / dragTrackWidth;

              if (opacity >= 0 && opacity <= 1) {
                $dragger.css('left', left);
                $frameAdded.css('opacity', opacity);
              }
            });
          };
        }(this));
      }
    };

    this.file = file;
    this.requestImageInfo($('.two-up.view .frame.deleted img', this.file), function (_this) {
      return function (deletedWidth, deletedHeight) {
        return _this.requestImageInfo($('.two-up.view .frame.added img', _this.file), function (width, height) {
          _this.initViewModes();

          // Load two-up view after images are loaded
          // so that we can display the correct width and height information
          var $images = $('.two-up.view img', _this.file);

          $images.waitForImages(function () {
            _this.initView('two-up');
          });
        });
      };
    }(this));
  }

  _createClass(ImageFile, [{
    key: 'initViewModes',
    value: function initViewModes() {
      var viewMode = viewModes[0];
      $('.view-modes', this.file).removeClass('hide');
      $('.view-modes-menu', this.file).on('click', 'li', function (_this) {
        return function (event) {
          if (!$(event.currentTarget).hasClass('active')) {
            return _this.activateViewMode(event.currentTarget.className);
          }
        };
      }(this));
      return this.activateViewMode(viewMode);
    }
  }, {
    key: 'activateViewMode',
    value: function activateViewMode(viewMode) {
      $('.view-modes-menu li', this.file).removeClass('active').filter("." + viewMode).addClass('active');
      return $(".view:visible:not(." + viewMode + ")", this.file).fadeOut(200, function (_this) {
        return function () {
          $(".view." + viewMode, _this.file).fadeIn(200);
          return _this.initView(viewMode);
        };
      }(this));
    }
  }, {
    key: 'initView',
    value: function initView(viewMode) {
      return this.views[viewMode].call(this);
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'initDraggable',
    value: function initDraggable($el, padding, callback) {
      var dragging = false;
      var $body = $('body');
      var $offsetEl = $el.parent();

      $el.off('mousedown').on('mousedown', function () {
        dragging = true;
        $body.css('user-select', 'none');
      });

      $body.off('mouseup').off('mousemove').on('mouseup', function () {
        dragging = false;
        $body.css('user-select', '');
      }).on('mousemove', function (e) {
        var left;
        if (!dragging) return;

        left = e.pageX - ($offsetEl.offset().left + padding);

        callback(e, left);
      });
    }
  }, {
    key: 'prepareFrames',
    value: function prepareFrames(view) {
      var maxHeight, maxWidth;
      maxWidth = 0;
      maxHeight = 0;
      $('.frame', view).each(function (_this) {
        return function (index, frame) {
          var height, width;
          width = $(frame).width();
          height = $(frame).height();
          maxWidth = width > maxWidth ? width : maxWidth;
          return maxHeight = height > maxHeight ? height : maxHeight;
        };
      }(this)).css({
        width: maxWidth,
        height: maxHeight
      });
      return [maxWidth, maxHeight];
    }
    // eslint-disable-next-line

  }, {
    key: 'requestImageInfo',
    value: function requestImageInfo(img, callback) {
      var domImg = img.get(0);
      if (domImg) {
        if (domImg.complete) {
          return callback.call(this, domImg.naturalWidth, domImg.naturalHeight);
        } else {
          return img.on('load', function (_this) {
            return function () {
              return callback.call(_this, domImg.naturalWidth, domImg.naturalHeight);
            };
          }(this));
        }
      }
    }
  }]);

  return ImageFile;
}();

/* harmony default export */ __webpack_exports__["a"] = (ImageFile);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./commit/pipelines/pipelines_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: ./pipelines/services/pipelines_service.js
var pipelines_service = __webpack_require__("./pipelines/services/pipelines_service.js");

// EXTERNAL MODULE: ./pipelines/stores/pipelines_store.js
var pipelines_store = __webpack_require__("./pipelines/stores/pipelines_store.js");

// EXTERNAL MODULE: ./pipelines/mixins/pipelines.js + 27 modules
var pipelines = __webpack_require__("./pipelines/mixins/pipelines.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./commit/pipelines/pipelines_table.vue





/* harmony default export */ var pipelines_table = ({
  mixins: [pipelines["a" /* default */]],
  props: {
    endpoint: {
      type: String,
      required: true
    },
    helpPagePath: {
      type: String,
      required: true
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    },
    errorStateSvgPath: {
      type: String,
      required: true
    },
    viewType: {
      type: String,
      required: false,
      default: 'child'
    }
  },

  data: function data() {
    var store = new pipelines_store["a" /* default */]();

    return {
      store: store,
      state: store.state
    };
  },


  computed: {
    shouldRenderTable: function shouldRenderTable() {
      return !this.isLoading && this.state.pipelines.length > 0 && !this.hasError;
    },
    shouldRenderErrorState: function shouldRenderErrorState() {
      return this.hasError && !this.isLoading;
    }
  },
  created: function created() {
    this.service = new pipelines_service["a" /* default */](this.endpoint);
  },

  methods: {
    successCallback: function successCallback(resp) {
      var _this = this;

      return resp.json().then(function (response) {
        // depending of the endpoint the response can either bring a `pipelines` key or not.
        var pipelines = response.pipelines || response;
        _this.setCommonData(pipelines);

        var updatePipelinesEvent = new CustomEvent('update-pipelines-count', {
          detail: {
            pipelines: response
          }
        });

        // notifiy to update the count in tabs
        if (_this.$el.parentElement) {
          _this.$el.parentElement.dispatchEvent(updatePipelinesEvent);
        }
      });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34b04960","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./commit/pipelines/pipelines_table.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-list pipelines"},[(_vm.isLoading)?_c('loading-icon',{staticClass:"prepend-top-20",attrs:{"label":_vm.s__('Pipelines|Loading Pipelines'),"size":"3"}}):(_vm.shouldRenderErrorState)?_c('svg-blank-state',{attrs:{"svg-path":_vm.errorStateSvgPath,"message":_vm.s__("Pipelines|There was an error fetching the pipelines.\n    Try again in a few moments or contact your support team.")}}):(_vm.shouldRenderTable)?_c('div',{staticClass:"table-holder"},[_c('pipelines-table-component',{attrs:{"pipelines":_vm.state.pipelines,"update-graph-dropdown":_vm.updateGraphDropdown,"auto-devops-help-path":_vm.autoDevopsHelpPath,"view-type":_vm.viewType}})],1):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./commit/pipelines/pipelines_table.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  pipelines_table,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var pipelines_pipelines_table = (Component.exports);

// CONCATENATED MODULE: ./commit/pipelines/pipelines_bundle.js



/**
 * Used in:
 *  - Commit details View > Pipelines Tab > Pipelines Table.
 *  - Merge Request details View > Pipelines Tab > Pipelines Table.
 *  - New Merge Request View > Pipelines Tab > Pipelines Table.
 */

var CommitPipelinesTable = vue_esm["a" /* default */].extend(pipelines_pipelines_table);

// export for use in merge_request_tabs.js (TODO: remove this hack when we understand how to load
// vue.js in merge_request_tabs.js)
window.gl = window.gl || {};
window.gl.CommitPipelinesTable = CommitPipelinesTable;

/* harmony default export */ var pipelines_bundle = __webpack_exports__["a"] = (function () {
  var pipelineTableViewEl = document.querySelector('#commit-pipeline-table-view');

  if (pipelineTableViewEl) {
    // Update MR and Commits tabs
    pipelineTableViewEl.addEventListener('update-pipelines-count', function (event) {
      if (event.detail.pipelines && event.detail.pipelines.count && event.detail.pipelines.count.all) {
        var badge = document.querySelector('.js-pipelines-mr-count');

        badge.textContent = event.detail.pipelines.count.all;
      }
    });

    if (pipelineTableViewEl.dataset.disableInitialization === undefined) {
      var table = new CommitPipelinesTable({
        propsData: {
          endpoint: pipelineTableViewEl.dataset.endpoint,
          helpPagePath: pipelineTableViewEl.dataset.helpPagePath,
          emptyStateSvgPath: pipelineTableViewEl.dataset.emptyStateSvgPath,
          errorStateSvgPath: pipelineTableViewEl.dataset.errorStateSvgPath,
          autoDevopsHelpPath: pipelineTableViewEl.dataset.helpAutoDevopsPath
        }
      }).$mount();
      pipelineTableViewEl.appendChild(table.$el);
    }
  }
});

/***/ }),

/***/ "./create_label.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__ = __webpack_require__("./lib/utils/text_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, prefer-arrow-callback */



var CreateLabelDropdown = function () {
  function CreateLabelDropdown($el, namespacePath, projectPath) {
    _classCallCheck(this, CreateLabelDropdown);

    this.$el = $el;
    this.namespacePath = namespacePath;
    this.projectPath = projectPath;
    this.$dropdownBack = $('.dropdown-menu-back', this.$el.closest('.dropdown'));
    this.$cancelButton = $('.js-cancel-label-btn', this.$el);
    this.$newLabelField = $('#new_label_name', this.$el);
    this.$newColorField = $('#new_label_color', this.$el);
    this.$colorPreview = $('.js-dropdown-label-color-preview', this.$el);
    this.$newLabelError = $('.js-label-error', this.$el);
    this.$newLabelCreateButton = $('.js-new-label-btn', this.$el);
    this.$colorSuggestions = $('.suggest-colors-dropdown a', this.$el);

    this.$newLabelError.hide();
    this.$newLabelCreateButton.disable();

    this.cleanBinding();
    this.addBinding();
  }

  _createClass(CreateLabelDropdown, [{
    key: 'cleanBinding',
    value: function cleanBinding() {
      this.$colorSuggestions.off('click');
      this.$newLabelField.off('keyup change');
      this.$newColorField.off('keyup change');
      this.$dropdownBack.off('click');
      this.$cancelButton.off('click');
      this.$newLabelCreateButton.off('click');
    }
  }, {
    key: 'addBinding',
    value: function addBinding() {
      var self = this;

      this.$colorSuggestions.on('click', function (e) {
        var $this = $(this);
        self.addColorValue(e, $this);
      });

      this.$newLabelField.on('keyup change', this.enableLabelCreateButton.bind(this));
      this.$newColorField.on('keyup change', this.enableLabelCreateButton.bind(this));

      this.$dropdownBack.on('click', this.resetForm.bind(this));

      this.$cancelButton.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        self.resetForm();
        self.$dropdownBack.trigger('click');
      });

      this.$newLabelCreateButton.on('click', this.saveLabel.bind(this));
    }
  }, {
    key: 'addColorValue',
    value: function addColorValue(e, $this) {
      e.preventDefault();
      e.stopPropagation();

      this.$newColorField.val($this.data('color')).trigger('change');
      this.$colorPreview.css('background-color', $this.data('color')).parent().addClass('is-active');
    }
  }, {
    key: 'enableLabelCreateButton',
    value: function enableLabelCreateButton() {
      if (this.$newLabelField.val() !== '' && this.$newColorField.val() !== '') {
        this.$newLabelError.hide();
        this.$newLabelCreateButton.enable();
      } else {
        this.$newLabelCreateButton.disable();
      }
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      this.$newLabelField.val('').trigger('change');

      this.$newColorField.val('').trigger('change');

      this.$colorPreview.css('background-color', '').parent().removeClass('is-active');
    }
  }, {
    key: 'saveLabel',
    value: function saveLabel(e) {
      var _this = this;

      e.preventDefault();
      e.stopPropagation();

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].newLabel(this.namespacePath, this.projectPath, {
        title: this.$newLabelField.val(),
        color: this.$newColorField.val()
      }, function (label) {
        _this.$newLabelCreateButton.enable();

        if (label.message) {
          var errors = void 0;

          if (typeof label.message === 'string') {
            errors = label.message;
          } else {
            errors = Object.keys(label.message).map(function (key) {
              return Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_text_utility__["f" /* humanize */])(key) + ' ' + label.message[key].join(', ');
            }).join('<br/>');
          }

          _this.$newLabelError.html(errors).show();
        } else {
          _this.$dropdownBack.trigger('click');

          $(document).trigger('created.label', label);
        }
      });
    }
  }]);

  return CreateLabelDropdown;
}();

/* harmony default export */ __webpack_exports__["a"] = (CreateLabelDropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__files_comment_button__ = __webpack_require__("./files_comment_button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__single_file_diff__ = __webpack_require__("./single_file_diff.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__image_diff_helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var UNFOLD_COUNT = 20;
var isBound = false;

var Diff = function () {
  function Diff() {
    _classCallCheck(this, Diff);

    var $diffFile = $('.files .diff-file');

    $diffFile.each(function (index, file) {
      if (!$.data(file, 'singleFileDiff')) {
        $.data(file, 'singleFileDiff', new __WEBPACK_IMPORTED_MODULE_5__single_file_diff__["a" /* default */](file));
      }
    });

    var tab = document.getElementById('diffs');
    if (!tab || tab && tab.dataset && tab.dataset.isLocked !== '') __WEBPACK_IMPORTED_MODULE_4__files_comment_button__["a" /* default */].init($diffFile);

    var firstFile = $('.files').first().get(0);
    var canCreateNote = firstFile && firstFile.hasAttribute('data-can-create-note');
    $diffFile.each(function (index, file) {
      return __WEBPACK_IMPORTED_MODULE_6__image_diff_helpers_index__["a" /* default */].initImageDiff(file, canCreateNote);
    });

    if (!isBound) {
      $(document).on('click', '.js-unfold', this.handleClickUnfold.bind(this)).on('click', '.diff-line-num a', this.handleClickLineNum.bind(this)).on('mousedown', 'td.line_content.parallel', this.handleParallelLineDown.bind(this));
      isBound = true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_url_utility__["a" /* getLocationHash */])()) {
      this.highlightSelectedLine();
    }

    this.openAnchoredDiff();
  }

  _createClass(Diff, [{
    key: 'handleClickUnfold',
    value: function handleClickUnfold(e) {
      var $target = $(e.target);

      var _lineNumbers = this.lineNumbers($target.parent()),
          _lineNumbers2 = _slicedToArray(_lineNumbers, 2),
          oldLineNumber = _lineNumbers2[0],
          newLineNumber = _lineNumbers2[1];

      var offset = newLineNumber - oldLineNumber;
      var bottom = $target.hasClass('js-unfold-bottom');
      var since = void 0;
      var to = void 0;
      var unfold = true;

      if (bottom) {
        var lineNumber = newLineNumber + 1;
        since = lineNumber;
        to = lineNumber + UNFOLD_COUNT;
      } else {
        var _lineNumber = newLineNumber - 1;
        since = _lineNumber - UNFOLD_COUNT;
        to = _lineNumber;

        // make sure we aren't loading more than we need
        var prevNewLine = this.lineNumbers($target.parent().prev())[1];
        if (since <= prevNewLine + 1) {
          since = prevNewLine + 1;
          unfold = false;
        }
      }

      var file = $target.parents('.diff-file');
      var link = file.data('blobDiffPath');
      var view = file.data('view');

      var params = { since: since, to: to, bottom: bottom, offset: offset, unfold: unfold, view: view };
      __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].get(link, { params: params }).then(function (_ref) {
        var data = _ref.data;
        return $target.parent().replaceWith(data);
      }).catch(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('An error occurred while loading diff'));
      });
    }
  }, {
    key: 'openAnchoredDiff',
    value: function openAnchoredDiff(cb) {
      var _this = this;

      var locationHash = Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_url_utility__["a" /* getLocationHash */])();
      var anchoredDiff = locationHash && locationHash.split('_')[0];

      if (!anchoredDiff) return;

      var diffTitle = $('#' + anchoredDiff);
      var diffFile = diffTitle.closest('.diff-file');
      var nothingHereBlock = $('.nothing-here-block:visible', diffFile);
      if (nothingHereBlock.length) {
        var clickTarget = $('.js-file-title, .click-to-expand', diffFile);
        diffFile.data('singleFileDiff').toggleDiff(clickTarget, function () {
          _this.highlightSelectedLine();
          if (cb) cb();
        });
      } else if (cb) {
        cb();
      }
    }
  }, {
    key: 'handleClickLineNum',
    value: function handleClickLineNum(e) {
      var hash = $(e.currentTarget).attr('href');
      e.preventDefault();
      if (window.history.pushState) {
        window.history.pushState(null, null, hash);
      } else {
        window.location.hash = hash;
      }
      this.highlightSelectedLine();
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'handleParallelLineDown',
    value: function handleParallelLineDown(e) {
      var line = $(e.currentTarget);
      var table = line.closest('table');

      table.removeClass('left-side-selected right-side-selected');

      var lineClass = ['left-side', 'right-side'].filter(function (name) {
        return line.hasClass(name);
      })[0];
      if (lineClass) {
        table.addClass(lineClass + '-selected');
      }
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'diffViewType',
    value: function diffViewType() {
      return $('.inline-parallel-buttons a.active').data('viewType');
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'lineNumbers',
    value: function lineNumbers(line) {
      var children = line.find('.diff-line-num').toArray();
      if (children.length !== 2) {
        return [0, 0];
      }
      return children.map(function (elm) {
        return parseInt($(elm).data('linenumber'), 10) || 0;
      });
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'highlightSelectedLine',
    value: function highlightSelectedLine() {
      var hash = Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_url_utility__["a" /* getLocationHash */])();
      var $diffFiles = $('.diff-file');
      $diffFiles.find('.hll').removeClass('hll');

      if (hash) {
        $diffFiles.find('tr#' + hash + ':not(.match) td, td#' + hash + ', td[data-line-code="' + hash + '"]').addClass('hll');
      }
    }
  }]);

  return Diff;
}();

/* harmony default export */ __webpack_exports__["a"] = (Diff);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/comment_resolve_btn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable comma-dangle, object-shorthand, func-names, no-else-return, quotes, no-lonely-if, max-len */
/* global CommentsStore */



var CommentAndResolveBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    discussionId: String
  },
  data: function data() {
    return {
      textareaIsEmpty: true,
      discussion: {}
    };
  },

  computed: {
    showButton: function showButton() {
      if (this.discussion) {
        return this.discussion.isResolvable();
      } else {
        return false;
      }
    },
    isDiscussionResolved: function isDiscussionResolved() {
      return this.discussion.isResolved();
    },
    buttonText: function buttonText() {
      if (this.isDiscussionResolved) {
        if (this.textareaIsEmpty) {
          return "Unresolve discussion";
        } else {
          return "Comment & unresolve discussion";
        }
      } else {
        if (this.textareaIsEmpty) {
          return "Resolve discussion";
        } else {
          return "Comment & resolve discussion";
        }
      }
    }
  },
  created: function created() {
    if (this.discussionId) {
      this.discussion = CommentsStore.state[this.discussionId];
    }
  },

  mounted: function mounted() {
    var _this = this;

    if (!this.discussionId) return;

    var $textarea = $(".js-discussion-note-form[data-discussion-id=" + this.discussionId + "] .note-textarea");
    this.textareaIsEmpty = $textarea.val() === '';

    $textarea.on('input.comment-and-resolve-btn', function () {
      _this.textareaIsEmpty = $textarea.val() === '';
    });
  },
  destroyed: function destroyed() {
    if (!this.discussionId) return;

    $(".js-discussion-note-form[data-discussion-id=" + this.discussionId + "] .note-textarea").off('input.comment-and-resolve-btn');
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('comment-and-resolve-btn', CommentAndResolveBtn);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/diff_note_avatars.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg__ = __webpack_require__("./diff_notes/icons/collapse_icon.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notes__ = __webpack_require__("./notes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_user_avatar_user_avatar_image_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");
/* global CommentsStore */






var DiffNoteAvatars = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: ['discussionId'],
  data: function data() {
    return {
      isVisible: false,
      lineType: '',
      storeState: CommentsStore.state,
      shownAvatars: 3,
      collapseIcon: __WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg___default.a
    };
  },

  components: {
    userAvatarImage: __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_user_avatar_user_avatar_image_vue__["a" /* default */]
  },
  template: '\n    <div class="diff-comment-avatar-holders"\n      :class="discussionClassName"\n      v-show="notesCount !== 0">\n      <div v-if="!isVisible">\n        <!-- FIXME: Pass an alt attribute here for accessibility -->\n        <user-avatar-image\n          v-for="note in notesSubset"\n          :key="note.id"\n          class="diff-comment-avatar js-diff-comment-avatar"\n          @click.native="clickedAvatar($event)"\n          :img-src="note.authorAvatar"\n          :tooltip-text="getTooltipText(note)"\n          :data-line-type="lineType"\n          :size="19"\n          data-html="true"\n        />\n        <span v-if="notesCount > shownAvatars"\n          class="diff-comments-more-count has-tooltip js-diff-comment-avatar"\n          data-container="body"\n          data-placement="top"\n          ref="extraComments"\n          role="button"\n          :data-line-type="lineType"\n          :title="extraNotesTitle"\n          @click="clickedAvatar($event)">{{ moreText }}</span>\n      </div>\n      <button class="diff-notes-collapse js-diff-comment-avatar"\n        type="button"\n        aria-label="Show comments"\n        :data-line-type="lineType"\n        @click="clickedAvatar($event)"\n        v-if="isVisible"\n        v-html="collapseIcon">\n      </button>\n    </div>\n  ',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.addNoCommentClass();
      _this.setDiscussionVisible();

      _this.lineType = $(_this.$el).closest('.diff-line-num').hasClass('old_line') ? 'old' : 'new';
    });

    $(document).on('toggle.comments', function () {
      _this.$nextTick(function () {
        _this.setDiscussionVisible();
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.addNoCommentClass();
    $(document).off('toggle.comments');
  },

  watch: {
    storeState: {
      handler: function handler() {
        var _this2 = this;

        this.$nextTick(function () {
          $('.has-tooltip', _this2.$el).tooltip('fixTitle');

          // We need to add/remove a class to an element that is outside the Vue instance
          _this2.addNoCommentClass();
        });
      },

      deep: true
    }
  },
  computed: {
    discussionClassName: function discussionClassName() {
      return 'js-diff-avatars-' + this.discussionId;
    },
    notesSubset: function notesSubset() {
      var _this3 = this;

      var notes = [];

      if (this.discussion) {
        notes = Object.keys(this.discussion.notes).slice(0, this.shownAvatars).map(function (noteId) {
          return _this3.discussion.notes[noteId];
        });
      }

      return notes;
    },
    extraNotesTitle: function extraNotesTitle() {
      if (this.discussion) {
        var extra = this.discussion.notesCount() - this.shownAvatars;

        return extra + ' more comment' + (extra > 1 ? 's' : '');
      }

      return '';
    },
    discussion: function discussion() {
      return this.storeState[this.discussionId];
    },
    notesCount: function notesCount() {
      if (this.discussion) {
        return this.discussion.notesCount();
      }

      return 0;
    },
    moreText: function moreText() {
      var plusSign = this.notesCount < 100 ? '+' : '';

      return '' + plusSign + (this.notesCount - this.shownAvatars);
    }
  },
  methods: {
    clickedAvatar: function clickedAvatar(e) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__notes__["a" /* default */].instance.onAddDiffNote(e);

      // Toggle the active state of the toggle all button
      this.toggleDiscussionsToggleState();

      this.$nextTick(function () {
        _this4.setDiscussionVisible();

        $('.has-tooltip', _this4.$el).tooltip('fixTitle');
        $('.has-tooltip', _this4.$el).tooltip('hide');
      });
    },
    addNoCommentClass: function addNoCommentClass() {
      var notesCount = this.notesCount;

      $(this.$el).closest('.js-avatar-container').toggleClass('no-comment-btn', notesCount > 0).nextUntil('.js-avatar-container').toggleClass('no-comment-btn', notesCount > 0);
    },
    toggleDiscussionsToggleState: function toggleDiscussionsToggleState() {
      var $notesHolders = $(this.$el).closest('.code').find('.notes_holder');
      var $visibleNotesHolders = $notesHolders.filter(':visible');
      var $toggleDiffCommentsBtn = $(this.$el).closest('.diff-file').find('.js-toggle-diff-comments');

      $toggleDiffCommentsBtn.toggleClass('active', $notesHolders.length === $visibleNotesHolders.length);
    },
    setDiscussionVisible: function setDiscussionVisible() {
      this.isVisible = $('.diffs .notes[data-discussion-id="' + this.discussion.id + '"]').is(':visible');
    },
    getTooltipText: function getTooltipText(note) {
      return note.authorName + ': ' + note.noteTruncated;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('diff-note-avatars', DiffNoteAvatars);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/jump_to_discussion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion__ = __webpack_require__("./diff_notes/mixins/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mixins_discussion__);
/* eslint-disable comma-dangle, object-shorthand, func-names, no-else-return, guard-for-in, no-restricted-syntax, one-var, space-before-function-paren, no-lonely-if, no-continue, brace-style, max-len, quotes */
/* global DiscussionMixins */
/* global CommentsStore */





var JumpToDiscussion = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  mixins: [DiscussionMixins],
  props: {
    discussionId: String
  },
  data: function data() {
    return {
      discussions: CommentsStore.state,
      discussion: {}
    };
  },
  computed: {
    buttonText: function buttonText() {
      if (this.discussionId) {
        return 'Jump to next unresolved discussion';
      } else {
        return 'Jump to first unresolved discussion';
      }
    },
    allResolved: function allResolved() {
      return this.unresolvedDiscussionCount === 0;
    },
    showButton: function showButton() {
      if (this.discussionId) {
        if (this.unresolvedDiscussionCount > 1) {
          return true;
        } else {
          return this.discussionId !== this.lastResolvedId;
        }
      } else {
        return this.unresolvedDiscussionCount >= 1;
      }
    },
    lastResolvedId: function lastResolvedId() {
      var lastId = void 0;
      for (var discussionId in this.discussions) {
        var discussion = this.discussions[discussionId];

        if (!discussion.isResolved()) {
          lastId = discussion.id;
        }
      }
      return lastId;
    }
  },
  methods: {
    jumpToNextUnresolvedDiscussion: function jumpToNextUnresolvedDiscussion() {
      var discussionsSelector = void 0;
      var discussionIdsInScope = void 0;
      var firstUnresolvedDiscussionId = void 0;
      var nextUnresolvedDiscussionId = void 0;
      var activeTab = window.mrTabs.currentAction;
      var hasDiscussionsToJumpTo = true;
      var jumpToFirstDiscussion = !this.discussionId;

      var discussionIdsForElements = function discussionIdsForElements(elements) {
        return elements.map(function () {
          return $(this).attr('data-discussion-id');
        }).toArray();
      };

      var discussions = this.discussions;

      if (activeTab === 'diffs') {
        discussionsSelector = '.diffs .notes[data-discussion-id]';
        discussionIdsInScope = discussionIdsForElements($(discussionsSelector));

        var unresolvedDiscussionCount = 0;

        for (var i = 0; i < discussionIdsInScope.length; i += 1) {
          var discussionId = discussionIdsInScope[i];
          var discussion = discussions[discussionId];
          if (discussion && !discussion.isResolved()) {
            unresolvedDiscussionCount += 1;
          }
        }

        if (this.discussionId && !this.discussion.isResolved()) {
          // If this is the last unresolved discussion on the diffs tab,
          // there are no discussions to jump to.
          if (unresolvedDiscussionCount === 1) {
            hasDiscussionsToJumpTo = false;
          }
        } else {
          // If there are no unresolved discussions on the diffs tab at all,
          // there are no discussions to jump to.
          if (unresolvedDiscussionCount === 0) {
            hasDiscussionsToJumpTo = false;
          }
        }
      } else if (activeTab !== 'show') {
        // If we are on the commits or builds tabs,
        // there are no discussions to jump to.
        hasDiscussionsToJumpTo = false;
      }

      if (!hasDiscussionsToJumpTo) {
        // If there are no discussions to jump to on the current page,
        // switch to the notes tab and jump to the first disucssion there.
        window.mrTabs.activateTab('show');
        activeTab = 'show';
        jumpToFirstDiscussion = true;
      }

      if (activeTab === 'show') {
        discussionsSelector = '.discussion[data-discussion-id]';
        discussionIdsInScope = discussionIdsForElements($(discussionsSelector));
      }

      var currentDiscussionFound = false;
      for (var _i = 0; _i < discussionIdsInScope.length; _i += 1) {
        var _discussionId = discussionIdsInScope[_i];
        var _discussion = discussions[_discussionId];

        if (!_discussion) {
          // Discussions for comments on commits in this MR don't have a resolved status.
          continue;
        }

        if (!firstUnresolvedDiscussionId && !_discussion.isResolved()) {
          firstUnresolvedDiscussionId = _discussionId;

          if (jumpToFirstDiscussion) {
            break;
          }
        }

        if (!jumpToFirstDiscussion) {
          if (currentDiscussionFound) {
            if (!_discussion.isResolved()) {
              nextUnresolvedDiscussionId = _discussionId;
              break;
            } else {
              continue;
            }
          }

          if (_discussionId === this.discussionId) {
            currentDiscussionFound = true;
          }
        }
      }

      nextUnresolvedDiscussionId = nextUnresolvedDiscussionId || firstUnresolvedDiscussionId;

      if (!nextUnresolvedDiscussionId) {
        return;
      }

      var $target = $(discussionsSelector + '[data-discussion-id="' + nextUnresolvedDiscussionId + '"]');

      if (activeTab === 'show') {
        $target = $target.closest('.note-discussion');

        // If the next discussion is closed, toggle it open.
        if ($target.find('.js-toggle-content').is(':hidden')) {
          $target.find('.js-toggle-button i').trigger('click');
        }
      } else if (activeTab === 'diffs') {
        // Resolved discussions are hidden in the diffs tab by default.
        // If they are marked unresolved on the notes tab, they will still be hidden on the diffs tab.
        // When jumping between unresolved discussions on the diffs tab, we show them.
        $target.closest(".content").show();

        var $notesHolder = $target.closest("tr.notes_holder");

        // Image diff discussions does not use notes_holder
        // so we should keep original $target value in those cases
        if ($notesHolder.length > 0) {
          $target = $notesHolder;
        }

        $target.show();

        // If we are on the diffs tab, we don't scroll to the discussion itself, but to
        // 4 diff lines above it: the line the discussion was in response to + 3 context
        var prevEl = void 0;
        for (var _i2 = 0; _i2 < 4; _i2 += 1) {
          prevEl = $target.prev();

          // If the discussion doesn't have 4 lines above it, we'll have to do with fewer.
          if (!prevEl.hasClass("line_holder")) {
            break;
          }

          $target = prevEl;
        }
      }

      $.scrollTo($target, {
        offset: -150
      });
    }
  },
  created: function created() {
    this.discussion = this.discussions[this.discussionId];
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('jump-to-discussion', JumpToDiscussion);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/new_issue_for_discussion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* global CommentsStore */



var NewIssueForDiscussion = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    discussionId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      discussions: CommentsStore.state
    };
  },

  computed: {
    discussion: function discussion() {
      return this.discussions[this.discussionId];
    },
    showButton: function showButton() {
      if (this.discussion) return !this.discussion.isResolved();
      return false;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('new-issue-for-discussion-btn', NewIssueForDiscussion);

/***/ }),

/***/ "./diff_notes/components/resolve_btn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* eslint-disable comma-dangle, object-shorthand, func-names, quote-props, no-else-return, camelcase, max-len */
/* global CommentsStore */
/* global ResolveService */




var ResolveBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    noteId: Number,
    discussionId: String,
    resolved: Boolean,
    canResolve: Boolean,
    resolvedBy: String,
    authorName: String,
    authorAvatar: String,
    noteTruncated: String
  },
  data: function data() {
    return {
      discussions: CommentsStore.state,
      loading: false
    };
  },
  watch: {
    'discussions': {
      handler: 'updateTooltip',
      deep: true
    }
  },
  computed: {
    discussion: function discussion() {
      return this.discussions[this.discussionId];
    },
    note: function note() {
      return this.discussion ? this.discussion.getNote(this.noteId) : {};
    },
    buttonText: function buttonText() {
      if (this.isResolved) {
        return 'Resolved by ' + this.resolvedByName;
      } else if (this.canResolve) {
        return 'Mark as resolved';
      } else {
        return 'Unable to resolve';
      }
    },
    isResolved: function isResolved() {
      if (this.note) {
        return this.note.resolved;
      } else {
        return false;
      }
    },
    resolvedByName: function resolvedByName() {
      return this.note.resolved_by;
    }
  },
  methods: {
    updateTooltip: function updateTooltip() {
      var _this = this;

      this.$nextTick(function () {
        $(_this.$refs.button).tooltip('hide').tooltip('fixTitle');
      });
    },
    resolve: function resolve() {
      var _this2 = this;

      if (!this.canResolve) return;

      var promise = void 0;
      this.loading = true;

      if (this.isResolved) {
        promise = ResolveService.unresolve(this.noteId);
      } else {
        promise = ResolveService.resolve(this.noteId);
      }

      promise.then(function (resp) {
        return resp.json();
      }).then(function (data) {
        _this2.loading = false;

        var resolved_by = data ? data.resolved_by : null;

        CommentsStore.update(_this2.discussionId, _this2.noteId, !_this2.isResolved, resolved_by);
        _this2.discussion.updateHeadline(data);
        gl.mrWidget.checkStatus();
        document.dispatchEvent(new CustomEvent('refreshVueNotes'));

        _this2.updateTooltip();
      }).catch(function () {
        return new __WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */]('An error occurred when trying to resolve a comment. Please try again.');
      });
    }
  },
  mounted: function mounted() {
    $(this.$refs.button).tooltip({
      container: 'body'
    });
  },
  beforeDestroy: function beforeDestroy() {
    CommentsStore.delete(this.discussionId, this.noteId);
  },
  created: function created() {
    CommentsStore.create({
      discussionId: this.discussionId,
      noteId: this.noteId,
      canResolve: this.canResolve,
      resolved: this.resolved,
      resolvedBy: this.resolvedBy,
      authorName: this.authorName,
      authorAvatar: this.authorAvatar,
      noteTruncated: this.noteTruncated
    });
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('resolve-btn', ResolveBtn);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/resolve_count.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion__ = __webpack_require__("./diff_notes/mixins/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mixins_discussion__);
/* eslint-disable comma-dangle, object-shorthand, func-names, no-param-reassign */
/* global DiscussionMixins */
/* global CommentsStore */





window.ResolveCount = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  mixins: [DiscussionMixins],
  props: {
    loggedOut: Boolean
  },
  data: function data() {
    return {
      discussions: CommentsStore.state
    };
  },
  computed: {
    allResolved: function allResolved() {
      return this.resolvedDiscussionCount === this.discussionCount;
    },
    resolvedCountText: function resolvedCountText() {
      return this.discussionCount === 1 ? 'discussion' : 'discussions';
    }
  }
});

/***/ }),

/***/ "./diff_notes/components/resolve_discussion_btn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable object-shorthand, func-names, space-before-function-paren, comma-dangle, no-else-return, quotes, max-len */
/* global CommentsStore */
/* global ResolveService */



var ResolveDiscussionBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    discussionId: String,
    mergeRequestId: Number,
    canResolve: Boolean
  },
  data: function data() {
    return {
      discussion: {}
    };
  },
  computed: {
    showButton: function showButton() {
      if (this.discussion) {
        return this.discussion.isResolvable();
      } else {
        return false;
      }
    },
    isDiscussionResolved: function isDiscussionResolved() {
      if (this.discussion) {
        return this.discussion.isResolved();
      } else {
        return false;
      }
    },
    buttonText: function buttonText() {
      if (this.isDiscussionResolved) {
        return "Unresolve discussion";
      } else {
        return "Resolve discussion";
      }
    },
    loading: function loading() {
      if (this.discussion) {
        return this.discussion.loading;
      } else {
        return false;
      }
    }
  },
  methods: {
    resolve: function resolve() {
      ResolveService.toggleResolveForDiscussion(this.mergeRequestId, this.discussionId);
    }
  },
  created: function created() {
    CommentsStore.createDiscussion(this.discussionId, this.canResolve);

    this.discussion = CommentsStore.state[this.discussionId];
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('resolve-discussion-btn', ResolveDiscussionBtn);

/***/ }),

/***/ "./diff_notes/diff_notes_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_discussion__ = __webpack_require__("./diff_notes/models/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_note__ = __webpack_require__("./diff_notes/models/note.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__models_note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_comments__ = __webpack_require__("./diff_notes/stores/comments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_resolve__ = __webpack_require__("./diff_notes/services/resolve.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_discussion__ = __webpack_require__("./diff_notes/mixins/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_discussion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mixins_discussion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_comment_resolve_btn__ = __webpack_require__("./diff_notes/components/comment_resolve_btn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_jump_to_discussion__ = __webpack_require__("./diff_notes/components/jump_to_discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_resolve_btn__ = __webpack_require__("./diff_notes/components/resolve_btn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_resolve_count__ = __webpack_require__("./diff_notes/components/resolve_count.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_resolve_discussion_btn__ = __webpack_require__("./diff_notes/components/resolve_discussion_btn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_diff_note_avatars__ = __webpack_require__("./diff_notes/components/diff_note_avatars.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_new_issue_for_discussion__ = __webpack_require__("./diff_notes/components/new_issue_for_discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* eslint-disable func-names, comma-dangle, new-cap, no-new, max-len */
/* global ResolveCount */
















/* harmony default export */ __webpack_exports__["a"] = (function () {
  var projectPathHolder = document.querySelector('.merge-request') || document.querySelector('.commit-box');
  var projectPath = projectPathHolder.dataset.projectPath;
  var COMPONENT_SELECTOR = 'resolve-btn, resolve-discussion-btn, jump-to-discussion, comment-and-resolve-btn, new-issue-for-discussion-btn';

  window.gl = window.gl || {};
  window.gl.diffNoteApps = {};

  window.ResolveService = new gl.DiffNotesResolveServiceClass(projectPath);

  gl.diffNotesCompileComponents = function () {
    $('diff-note-avatars').each(function () {
      var tmp = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
        template: $(this).get(0).outerHTML
      });
      var tmpApp = new tmp().$mount();

      $(this).replaceWith(tmpApp.$el);
      $(tmpApp.$el).one('remove.vue', function () {
        tmpApp.$destroy();
        tmpApp.$el.remove();
      });
    });

    var $components = $(COMPONENT_SELECTOR).filter(function () {
      return $(this).closest('resolve-count').length !== 1;
    });

    if ($components) {
      $components.each(function () {
        var $this = $(this);
        var noteId = $this.attr(':note-id');
        var discussionId = $this.attr(':discussion-id');

        if ($this.is('comment-and-resolve-btn') && !discussionId) return;

        var tmp = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
          template: $this.get(0).outerHTML
        });
        var tmpApp = new tmp().$mount();

        if (noteId) {
          gl.diffNoteApps['note_' + noteId] = tmpApp;
        }

        $this.replaceWith(tmpApp.$el);
      });
    }
  };

  gl.diffNotesCompileComponents();

  if (!Object(__WEBPACK_IMPORTED_MODULE_13__lib_utils_common_utils__["n" /* hasVueMRDiscussionsCookie */])()) {
    new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
      el: '#resolve-count-app',
      components: {
        'resolve-count': ResolveCount
      }
    });
  }

  $(window).trigger('resize.nav');
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/icons/collapse_icon.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"11\" height=\"11\" viewBox=\"0 0 9 13\"><path d=\"M2.57568253,6.49866948 C2.50548852,6.57199715 2.44637866,6.59708255 2.39835118,6.57392645 C2.3503237,6.55077034 2.32631032,6.48902165 2.32631032,6.38867852 L2.32631032,-2.13272614 C2.32631032,-2.23306927 2.3503237,-2.29481796 2.39835118,-2.31797406 C2.44637866,-2.34113017 2.50548852,-2.31604477 2.57568253,-2.24271709 L6.51022184,1.86747129 C6.53977721,1.8983461 6.56379059,1.93500939 6.5822627,1.97746225 L6.5822627,2.27849013 C6.56379059,2.31708364 6.53977721,2.35374693 6.51022184,2.38848109 L2.57568253,6.49866948 Z\" transform=\"translate(4.454287, 2.127976) rotate(90.000000) translate(-4.454287, -2.127976) \"></path><path d=\"M3.74312342,2.09553332 C3.74312342,1.99519019 3.77821989,1.9083561 3.8484139,1.83502843 C3.91860791,1.76170075 4.00173115,1.72503747 4.09778611,1.72503747 L4.80711151,1.72503747 C4.90316647,1.72503747 4.98628971,1.76170075 5.05648372,1.83502843 C5.12667773,1.9083561 5.16177421,1.99519019 5.16177421,2.09553332 L5.16177421,10.2464421 C5.16177421,10.3467853 5.12667773,10.4336194 5.05648372,10.506947 C4.98628971,10.5802747 4.90316647,10.616938 4.80711151,10.616938 L4.09778611,10.616938 C4.00173115,10.616938 3.91860791,10.5802747 3.8484139,10.506947 C3.77821989,10.4336194 3.74312342,10.3467853 3.74312342,10.2464421 L3.74312342,2.09553332 Z\" transform=\"translate(4.452449, 6.170988) rotate(-90.000000) translate(-4.452449, -6.170988) \"></path><path d=\"M2.57568253,14.6236695 C2.50548852,14.6969971 2.44637866,14.7220826 2.39835118,14.6989264 C2.3503237,14.6757703 2.32631032,14.6140216 2.32631032,14.5136785 L2.32631032,5.99227386 C2.32631032,5.89193073 2.3503237,5.83018204 2.39835118,5.80702594 C2.44637866,5.78386983 2.50548852,5.80895523 2.57568253,5.88228291 L6.51022184,9.99247129 C6.53977721,10.0233461 6.56379059,10.0600094 6.5822627,10.1024622 L6.5822627,10.4034901 C6.56379059,10.4420836 6.53977721,10.4787469 6.51022184,10.5134811 L2.57568253,14.6236695 Z\" transform=\"translate(4.454287, 10.252976) scale(1, -1) rotate(90.000000) translate(-4.454287, -10.252976) \"></path></svg>\n"

/***/ }),

/***/ "./diff_notes/mixins/discussion.js":
/***/ (function(module, exports) {

/* eslint-disable object-shorthand, func-names, guard-for-in, no-restricted-syntax, comma-dangle, no-param-reassign, max-len */

window.DiscussionMixins = {
  computed: {
    discussionCount: function discussionCount() {
      return Object.keys(this.discussions).length;
    },
    resolvedDiscussionCount: function resolvedDiscussionCount() {
      var resolvedCount = 0;

      for (var discussionId in this.discussions) {
        var discussion = this.discussions[discussionId];

        if (discussion.isResolved()) {
          resolvedCount += 1;
        }
      }

      return resolvedCount;
    },
    unresolvedDiscussionCount: function unresolvedDiscussionCount() {
      var unresolvedCount = 0;

      for (var discussionId in this.discussions) {
        var discussion = this.discussions[discussionId];

        if (!discussion.isResolved()) {
          unresolvedCount += 1;
        }
      }

      return unresolvedCount;
    }
  }
};

/***/ }),

/***/ "./diff_notes/models/discussion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable space-before-function-paren, camelcase, guard-for-in, no-restricted-syntax, no-unused-vars, max-len */
/* global NoteModel */




var DiscussionModel = function () {
  function DiscussionModel(discussionId) {
    _classCallCheck(this, DiscussionModel);

    this.id = discussionId;
    this.notes = {};
    this.loading = false;
    this.canResolve = false;
  }

  _createClass(DiscussionModel, [{
    key: 'createNote',
    value: function createNote(noteObj) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.notes, noteObj.noteId, new NoteModel(this.id, noteObj));
    }
  }, {
    key: 'deleteNote',
    value: function deleteNote(noteId) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].delete(this.notes, noteId);
    }
  }, {
    key: 'getNote',
    value: function getNote(noteId) {
      return this.notes[noteId];
    }
  }, {
    key: 'notesCount',
    value: function notesCount() {
      return Object.keys(this.notes).length;
    }
  }, {
    key: 'isResolved',
    value: function isResolved() {
      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (!note.resolved) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: 'resolveAllNotes',
    value: function resolveAllNotes(resolved_by) {
      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (!note.resolved) {
          note.resolved = true;
          note.resolved_by = resolved_by;
        }
      }
    }
  }, {
    key: 'unResolveAllNotes',
    value: function unResolveAllNotes() {
      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (note.resolved) {
          note.resolved = false;
          note.resolved_by = null;
        }
      }
    }
  }, {
    key: 'updateHeadline',
    value: function updateHeadline(data) {
      var discussionSelector = '.discussion[data-discussion-id="' + this.id + '"]';
      var $discussionHeadline = $(discussionSelector + ' .js-discussion-headline');

      if (data.discussion_headline_html) {
        if ($discussionHeadline.length) {
          $discussionHeadline.replaceWith(data.discussion_headline_html);
        } else {
          $(discussionSelector + ' .discussion-header').append(data.discussion_headline_html);
        }

        Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_datetime_utility__["h" /* localTimeAgo */])($('.js-timeago', '' + discussionSelector));
      } else {
        $discussionHeadline.remove();
      }
    }
  }, {
    key: 'isResolvable',
    value: function isResolvable() {
      if (!this.canResolve) {
        return false;
      }

      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (note.canResolve) {
          return true;
        }
      }

      return false;
    }
  }]);

  return DiscussionModel;
}();

window.DiscussionModel = DiscussionModel;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/models/note.js":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable camelcase, no-unused-vars */

var NoteModel = function NoteModel(discussionId, noteObj) {
  _classCallCheck(this, NoteModel);

  this.discussionId = discussionId;
  this.id = noteObj.noteId;
  this.canResolve = noteObj.canResolve;
  this.resolved = noteObj.resolved;
  this.resolved_by = noteObj.resolvedBy;
  this.authorName = noteObj.authorName;
  this.authorAvatar = noteObj.authorAvatar;
  this.noteTruncated = noteObj.noteTruncated;
};

window.NoteModel = NoteModel;

/***/ }),

/***/ "./diff_notes/services/resolve.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_vue_resource_interceptor__ = __webpack_require__("./vue_shared/vue_resource_interceptor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global CommentsStore */





window.gl = window.gl || {};

var ResolveServiceClass = function () {
  function ResolveServiceClass(root) {
    _classCallCheck(this, ResolveServiceClass);

    this.noteResource = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(root + '/notes{/noteId}/resolve?html=true');
    this.discussionResource = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(root + '/merge_requests{/mergeRequestId}/discussions{/discussionId}/resolve?html=true');
  }

  _createClass(ResolveServiceClass, [{
    key: 'resolve',
    value: function resolve(noteId) {
      return this.noteResource.save({ noteId: noteId }, {});
    }
  }, {
    key: 'unresolve',
    value: function unresolve(noteId) {
      return this.noteResource.delete({ noteId: noteId }, {});
    }
  }, {
    key: 'toggleResolveForDiscussion',
    value: function toggleResolveForDiscussion(mergeRequestId, discussionId) {
      var discussion = CommentsStore.state[discussionId];
      var isResolved = discussion.isResolved();
      var promise = void 0;

      if (isResolved) {
        promise = this.unResolveAll(mergeRequestId, discussionId);
      } else {
        promise = this.resolveAll(mergeRequestId, discussionId);
      }

      promise.then(function (resp) {
        return resp.json();
      }).then(function (data) {
        discussion.loading = false;
        var resolvedBy = data ? data.resolved_by : null;

        if (isResolved) {
          discussion.unResolveAllNotes();
        } else {
          discussion.resolveAllNotes(resolvedBy);
        }

        if (gl.mrWidget) gl.mrWidget.checkStatus();
        discussion.updateHeadline(data);
        document.dispatchEvent(new CustomEvent('refreshVueNotes'));
      }).catch(function () {
        return new __WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */]('An error occurred when trying to resolve a discussion. Please try again.');
      });
    }
  }, {
    key: 'resolveAll',
    value: function resolveAll(mergeRequestId, discussionId) {
      var discussion = CommentsStore.state[discussionId];

      discussion.loading = true;

      return this.discussionResource.save({
        mergeRequestId: mergeRequestId,
        discussionId: discussionId
      }, {});
    }
  }, {
    key: 'unResolveAll',
    value: function unResolveAll(mergeRequestId, discussionId) {
      var discussion = CommentsStore.state[discussionId];

      discussion.loading = true;

      return this.discussionResource.delete({
        mergeRequestId: mergeRequestId,
        discussionId: discussionId
      }, {});
    }
  }]);

  return ResolveServiceClass;
}();

gl.DiffNotesResolveServiceClass = ResolveServiceClass;

/***/ }),

/***/ "./diff_notes/stores/comments.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable object-shorthand, func-names, camelcase, no-restricted-syntax, guard-for-in, comma-dangle, max-len, no-param-reassign */
/* global DiscussionModel */



window.CommentsStore = {
  state: {},
  get: function get(discussionId, noteId) {
    return this.state[discussionId].getNote(noteId);
  },
  createDiscussion: function createDiscussion(discussionId, canResolve) {
    var discussion = this.state[discussionId];
    if (!this.state[discussionId]) {
      discussion = new DiscussionModel(discussionId);
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.state, discussionId, discussion);
    }

    if (canResolve !== undefined) {
      discussion.canResolve = canResolve;
    }

    return discussion;
  },
  create: function create(noteObj) {
    var discussion = this.createDiscussion(noteObj.discussionId);

    discussion.createNote(noteObj);
  },
  update: function update(discussionId, noteId, resolved, resolved_by) {
    var discussion = this.state[discussionId];
    var note = discussion.getNote(noteId);
    note.resolved = resolved;
    note.resolved_by = resolved_by;
  },
  delete: function _delete(discussionId, noteId) {
    var discussion = this.state[discussionId];
    discussion.deleteNote(noteId);

    if (discussion.notesCount() === 0) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].delete(this.state, discussionId);
    }
  },
  unresolvedDiscussionIds: function unresolvedDiscussionIds() {
    var ids = [];

    for (var discussionId in this.state) {
      var discussion = this.state[discussionId];

      if (!discussion.isResolved()) {
        ids.push(discussion.id);
      }
    }

    return ids;
  }
};

/***/ }),

/***/ "./droplab/plugins/input_setter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */

var InputSetter = {
  init: function init(hook) {
    this.hook = hook;
    this.destroyed = false;
    this.config = hook.config.InputSetter || (this.hook.config.InputSetter = {});

    this.eventWrapper = {};

    this.addEvents();
  },
  addEvents: function addEvents() {
    this.eventWrapper.setInputs = this.setInputs.bind(this);
    this.hook.list.list.addEventListener('click.dl', this.eventWrapper.setInputs);
  },
  removeEvents: function removeEvents() {
    this.hook.list.list.removeEventListener('click.dl', this.eventWrapper.setInputs);
  },
  setInputs: function setInputs(e) {
    var _this = this;

    if (this.destroyed) return;

    var selectedItem = e.detail.selected;

    if (!Array.isArray(this.config)) this.config = [this.config];

    this.config.forEach(function (config) {
      return _this.setInput(config, selectedItem);
    });
  },
  setInput: function setInput(config, selectedItem) {
    var input = config.input || this.hook.trigger;
    var newValue = selectedItem.getAttribute(config.valueAttribute);
    var inputAttribute = config.inputAttribute;

    if (input.hasAttribute(inputAttribute)) return input.setAttribute(inputAttribute, newValue);
    if (input.tagName === 'INPUT') return input.value = newValue;
    return input.textContent = newValue;
  },
  destroy: function destroy() {
    this.destroyed = true;

    this.removeEvents();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (InputSetter);

/***/ }),

/***/ "./dropzone_input.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = dropzoneInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dropzone__ = __webpack_require__("../../../node_modules/dropzone/dist/dropzone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preview_markdown__ = __webpack_require__("./preview_markdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_csrf__ = __webpack_require__("./lib/utils/csrf.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");






__WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.autoDiscover = false;

function dropzoneInput(form) {
  var divHover = '<div class="div-dropzone-hover"></div>';
  var iconPaperclip = '<i class="fa fa-paperclip div-dropzone-icon"></i>';
  var $attachButton = form.find('.button-attach-file');
  var $attachingFileMessage = form.find('.attaching-file-message');
  var $cancelButton = form.find('.button-cancel-uploading-files');
  var $retryLink = form.find('.retry-uploading-link');
  var $uploadProgress = form.find('.uploading-progress');
  var $uploadingErrorContainer = form.find('.uploading-error-container');
  var $uploadingErrorMessage = form.find('.uploading-error-message');
  var $uploadingProgressContainer = form.find('.uploading-progress-container');
  var uploadsPath = window.uploads_path || null;
  var maxFileSize = gon.max_file_size || 10;
  var formTextarea = form.find('.js-gfm-input');
  var handlePaste = void 0;
  var pasteText = void 0;
  var addFileToForm = void 0;
  var updateAttachingMessage = void 0;
  var isImage = void 0;
  var getFilename = void 0;
  var uploadFile = void 0;

  formTextarea.wrap('<div class="div-dropzone"></div>');
  formTextarea.on('paste', function (event) {
    return handlePaste(event);
  });

  // Add dropzone area to the form.
  var $mdArea = formTextarea.closest('.md-area');
  form.setupMarkdownPreview();
  var $formDropzone = form.find('.div-dropzone');
  $formDropzone.parent().addClass('div-dropzone-wrapper');
  $formDropzone.append(divHover);
  $formDropzone.find('.div-dropzone-hover').append(iconPaperclip);

  if (!uploadsPath) {
    $formDropzone.addClass('js-invalid-dropzone');
    return;
  }

  var dropzone = $formDropzone.dropzone({
    url: uploadsPath,
    dictDefaultMessage: '',
    clickable: true,
    paramName: 'file',
    maxFilesize: maxFileSize,
    uploadMultiple: false,
    headers: __WEBPACK_IMPORTED_MODULE_3__lib_utils_csrf__["a" /* default */].headers,
    previewContainer: false,
    processing: function processing() {
      return $('.div-dropzone-alert').alert('close');
    },
    dragover: function dragover() {
      $mdArea.addClass('is-dropzone-hover');
      form.find('.div-dropzone-hover').css('opacity', 0.7);
    },
    dragleave: function dragleave() {
      $mdArea.removeClass('is-dropzone-hover');
      form.find('.div-dropzone-hover').css('opacity', 0);
    },
    drop: function drop() {
      $mdArea.removeClass('is-dropzone-hover');
      form.find('.div-dropzone-hover').css('opacity', 0);
      formTextarea.focus();
    },
    success: function success(header, response) {
      var processingFileCount = this.getQueuedFiles().length + this.getUploadingFiles().length;
      var shouldPad = processingFileCount >= 1;

      pasteText(response.link.markdown, shouldPad);
      // Show 'Attach a file' link only when all files have been uploaded.
      if (!processingFileCount) $attachButton.removeClass('hide');
      addFileToForm(response.link.url);
    },

    error: function error(file) {
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Attaching the file failed.';
      var xhr = arguments[2];

      // If 'error' event is fired by dropzone, the second parameter is error message.
      // If the 'errorMessage' parameter is empty, the default error message is set.
      // If the 'error' event is fired by backend (xhr) error response, the third parameter is
      // xhr object (xhr.responseText is error message).
      // On error we hide the 'Attach' and 'Cancel' buttons
      // and show an error.

      // If there's xhr error message, let's show it instead of dropzone's one.
      var message = xhr ? xhr.responseText : errorMessage;

      $uploadingErrorContainer.removeClass('hide');
      $uploadingErrorMessage.html(message);
      $attachButton.addClass('hide');
      $cancelButton.addClass('hide');
    },
    totaluploadprogress: function totaluploadprogress(totalUploadProgress) {
      updateAttachingMessage(this.files, $attachingFileMessage);
      $uploadProgress.text(Math.round(totalUploadProgress) + '%');
    },

    sending: function sending() {
      // DOM elements already exist.
      // Instead of dynamically generating them,
      // we just either hide or show them.
      $attachButton.addClass('hide');
      $uploadingErrorContainer.addClass('hide');
      $uploadingProgressContainer.removeClass('hide');
      $cancelButton.removeClass('hide');
    },
    removedfile: function removedfile() {
      $attachButton.removeClass('hide');
      $cancelButton.addClass('hide');
      $uploadingProgressContainer.addClass('hide');
      $uploadingErrorContainer.addClass('hide');
    },
    queuecomplete: function queuecomplete() {
      $('.dz-preview').remove();
      $('.markdown-area').trigger('input');

      $uploadingProgressContainer.addClass('hide');
      $cancelButton.addClass('hide');
    }
  });

  var child = $(dropzone[0]).children('textarea');

  // removeAllFiles(true) stops uploading files (if any)
  // and remove them from dropzone files queue.
  $cancelButton.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    __WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.forElement($formDropzone.get(0)).removeAllFiles(true);
  });

  // If 'error' event is fired, we store a failed files,
  // clear dropzone files queue, change status of failed files to undefined,
  // and add that files to the dropzone files queue again.
  // addFile() adds file to dropzone files queue and upload it.
  $retryLink.on('click', function (e) {
    var dropzoneInstance = __WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.forElement(e.target.closest('.js-main-target-form').querySelector('.div-dropzone'));
    var failedFiles = dropzoneInstance.files;

    e.preventDefault();

    // 'true' parameter of removeAllFiles() cancels
    // uploading of files that are being uploaded at the moment.
    dropzoneInstance.removeAllFiles(true);

    failedFiles.map(function (failedFile) {
      var file = failedFile;

      if (file.status === __WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.ERROR) {
        file.status = undefined;
        file.accepted = undefined;
      }

      return dropzoneInstance.addFile(file);
    });
  });
  // eslint-disable-next-line consistent-return
  handlePaste = function handlePaste(event) {
    var pasteEvent = event.originalEvent;
    if (pasteEvent.clipboardData && pasteEvent.clipboardData.items) {
      var image = isImage(pasteEvent);
      if (image) {
        event.preventDefault();
        var filename = getFilename(pasteEvent) || 'image.png';
        var text = '{{' + filename + '}}';
        pasteText(text);
        return uploadFile(image.getAsFile(), filename);
      }
    }
  };

  isImage = function isImage(data) {
    var i = 0;
    while (i < data.clipboardData.items.length) {
      var item = data.clipboardData.items[i];
      if (item.type.indexOf('image') !== -1) {
        return item;
      }
      i += 1;
    }
    return false;
  };

  pasteText = function pasteText(text, shouldPad) {
    var formattedText = text;
    if (shouldPad) {
      formattedText += '\n\n';
    }
    var textarea = child.get(0);
    var caretStart = textarea.selectionStart;
    var caretEnd = textarea.selectionEnd;
    var textEnd = $(child).val().length;
    var beforeSelection = $(child).val().substring(0, caretStart);
    var afterSelection = $(child).val().substring(caretEnd, textEnd);
    $(child).val(beforeSelection + formattedText + afterSelection);
    textarea.setSelectionRange(caretStart + formattedText.length, caretEnd + formattedText.length);
    textarea.style.height = textarea.scrollHeight + 'px';
    formTextarea.get(0).dispatchEvent(new Event('input'));
    return formTextarea.trigger('input');
  };

  addFileToForm = function addFileToForm(path) {
    $(form).append('<input type="hidden" name="files[]" value="' + __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.escape(path) + '">');
  };

  getFilename = function getFilename(e) {
    var value = void 0;
    if (window.clipboardData && window.clipboardData.getData) {
      value = window.clipboardData.getData('Text');
    } else if (e.clipboardData && e.clipboardData.getData) {
      value = e.clipboardData.getData('text/plain');
    }
    value = value.split('\r');
    return value[0];
  };

  var showSpinner = function showSpinner() {
    return $uploadingProgressContainer.removeClass('hide');
  };

  var closeSpinner = function closeSpinner() {
    return $uploadingProgressContainer.addClass('hide');
  };

  var showError = function showError(message) {
    $uploadingErrorContainer.removeClass('hide');
    $uploadingErrorMessage.html(message);
  };

  var closeAlertMessage = function closeAlertMessage() {
    return form.find('.div-dropzone-alert').alert('close');
  };

  var insertToTextArea = function insertToTextArea(filename, url) {
    var $child = $(child);
    $child.val(function (index, val) {
      return val.replace('{{' + filename + '}}', url);
    });

    $child.trigger('change');
  };

  uploadFile = function uploadFile(item, filename) {
    var formData = new FormData();
    formData.append('file', item, filename);

    showSpinner();
    closeAlertMessage();

    __WEBPACK_IMPORTED_MODULE_4__lib_utils_axios_utils__["a" /* default */].post(uploadsPath, formData).then(function (_ref) {
      var data = _ref.data;

      var md = data.link.markdown;

      insertToTextArea(filename, md);
      closeSpinner();
    }).catch(function (e) {
      showError(e.response.data.message);
      closeSpinner();
    });
  };

  updateAttachingMessage = function updateAttachingMessage(files, messageContainer) {
    var attachingMessage = void 0;
    var filesCount = files.filter(function (file) {
      return file.status === 'uploading' || file.status === 'queued';
    }).length;

    // Dinamycally change uploading files text depending on files number in
    // dropzone files queue.
    if (filesCount > 1) {
      attachingMessage = 'Attaching ' + filesCount + ' files -';
    } else {
      attachingMessage = 'Attaching a file -';
    }

    messageContainer.text(attachingMessage);
  };

  form.find('.markdown-selector').click(function onMarkdownClick(e) {
    e.preventDefault();
    $(this).closest('.gfm-form').find('.div-dropzone').click();
    formTextarea.focus();
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./due_date_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday__ = __webpack_require__("../../../node_modules/pikaday/pikaday.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pikaday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pikaday__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__ = __webpack_require__("./lib/utils/datefix.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global dateFormat */





var DueDateSelect = function () {
  function DueDateSelect() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        $dropdown = _ref.$dropdown,
        $loading = _ref.$loading;

    _classCallCheck(this, DueDateSelect);

    var $dropdownParent = $dropdown.closest('.dropdown');
    var $block = $dropdown.closest('.block');
    this.$loading = $loading;
    this.$dropdown = $dropdown;
    this.$dropdownParent = $dropdownParent;
    this.$datePicker = $dropdownParent.find('.js-due-date-calendar');
    this.$block = $block;
    this.$selectbox = $dropdown.closest('.selectbox');
    this.$value = $block.find('.value');
    this.$valueContent = $block.find('.value-content');
    this.$sidebarValue = $('.js-due-date-sidebar-value', $block);
    this.fieldName = $dropdown.data('fieldName');
    this.abilityName = $dropdown.data('abilityName');
    this.issueUpdateURL = $dropdown.data('issueUpdate');

    this.rawSelectedDate = null;
    this.displayedDate = null;
    this.datePayload = null;

    this.initGlDropdown();
    this.initRemoveDueDate();
    this.initDatePicker();
  }

  _createClass(DueDateSelect, [{
    key: 'initGlDropdown',
    value: function initGlDropdown() {
      var _this = this;

      this.$dropdown.glDropdown({
        opened: function opened() {
          var calendar = _this.$datePicker.data('pikaday');
          calendar.show();
        },
        hidden: function hidden() {
          _this.$selectbox.hide();
          _this.$value.css('display', '');
        }
      });
    }
  }, {
    key: 'initDatePicker',
    value: function initDatePicker() {
      var _this2 = this;

      var $dueDateInput = $('input[name=\'' + this.fieldName + '\']');
      var calendar = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a({
        field: $dueDateInput.get(0),
        theme: 'gitlab-theme',
        format: 'yyyy-mm-dd',
        parse: function parse(dateString) {
          return Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["a" /* parsePikadayDate */])(dateString);
        },
        toString: function toString(date) {
          return Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["b" /* pikadayToString */])(date);
        },
        onSelect: function onSelect(dateText) {
          $dueDateInput.val(calendar.toString(dateText));

          if (_this2.$dropdown.hasClass('js-issue-boards-due-date')) {
            gl.issueBoards.BoardsStore.detail.issue.dueDate = $dueDateInput.val();
            _this2.updateIssueBoardIssue();
          } else {
            _this2.saveDueDate(true);
          }
        }
      });

      calendar.setDate(Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["a" /* parsePikadayDate */])($dueDateInput.val()));
      this.$datePicker.append(calendar.el);
      this.$datePicker.data('pikaday', calendar);
    }
  }, {
    key: 'initRemoveDueDate',
    value: function initRemoveDueDate() {
      var _this3 = this;

      this.$block.on('click', '.js-remove-due-date', function (e) {
        var calendar = _this3.$datePicker.data('pikaday');
        e.preventDefault();

        calendar.setDate(null);

        if (_this3.$dropdown.hasClass('js-issue-boards-due-date')) {
          gl.issueBoards.BoardsStore.detail.issue.dueDate = '';
          _this3.updateIssueBoardIssue();
        } else {
          $('input[name=\'' + _this3.fieldName + '\']').val('');
          _this3.saveDueDate(false);
        }
      });
    }
  }, {
    key: 'saveDueDate',
    value: function saveDueDate(isDropdown) {
      this.parseSelectedDate();
      this.prepSelectedDate();
      this.submitSelectedDate(isDropdown);
    }
  }, {
    key: 'parseSelectedDate',
    value: function parseSelectedDate() {
      this.rawSelectedDate = $('input[name=\'' + this.fieldName + '\']').val();

      if (this.rawSelectedDate.length) {
        // Construct Date object manually to avoid buggy dateString support within Date constructor
        var dateArray = this.rawSelectedDate.split('-').map(function (v) {
          return parseInt(v, 10);
        });
        var dateObj = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
        this.displayedDate = dateFormat(dateObj, 'mmm d, yyyy');
      } else {
        this.displayedDate = 'No due date';
      }
    }
  }, {
    key: 'prepSelectedDate',
    value: function prepSelectedDate() {
      var datePayload = {};
      datePayload[this.abilityName] = {};
      datePayload[this.abilityName].due_date = this.rawSelectedDate;
      this.datePayload = datePayload;
    }
  }, {
    key: 'updateIssueBoardIssue',
    value: function updateIssueBoardIssue() {
      var _this4 = this;

      this.$loading.fadeIn();
      this.$dropdown.trigger('loading.gl.dropdown');
      this.$selectbox.hide();
      this.$value.css('display', '');
      var fadeOutLoader = function fadeOutLoader() {
        _this4.$loading.fadeOut();
      };

      gl.issueBoards.BoardsStore.detail.issue.update(this.$dropdown.attr('data-issue-update')).then(fadeOutLoader).catch(fadeOutLoader);
    }
  }, {
    key: 'submitSelectedDate',
    value: function submitSelectedDate(isDropdown) {
      var _this5 = this;

      var selectedDateValue = this.datePayload[this.abilityName].due_date;
      var displayedDateStyle = this.displayedDate !== 'No due date' ? 'bold' : 'no-value';

      this.$loading.removeClass('hidden').fadeIn();

      if (isDropdown) {
        this.$dropdown.trigger('loading.gl.dropdown');
        this.$selectbox.hide();
      }

      this.$value.css('display', '');
      this.$valueContent.html('<span class=\'' + displayedDateStyle + '\'>' + this.displayedDate + '</span>');
      this.$sidebarValue.html(this.displayedDate);

      $('.js-remove-due-date-holder').toggleClass('hidden', selectedDateValue.length);

      return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].put(this.issueUpdateURL, this.datePayload).then(function () {
        if (isDropdown) {
          _this5.$dropdown.trigger('loaded.gl.dropdown');
          _this5.$dropdown.dropdown('toggle');
        }
        return _this5.$loading.fadeOut();
      });
    }
  }]);

  return DueDateSelect;
}();

var DueDateSelectors = function () {
  function DueDateSelectors() {
    _classCallCheck(this, DueDateSelectors);

    this.initMilestoneDatePicker();
    this.initIssuableSelect();
  }
  // eslint-disable-next-line class-methods-use-this


  _createClass(DueDateSelectors, [{
    key: 'initMilestoneDatePicker',
    value: function initMilestoneDatePicker() {
      $('.datepicker').each(function initPikadayMilestone() {
        var $datePicker = $(this);
        var calendar = new __WEBPACK_IMPORTED_MODULE_0_pikaday___default.a({
          field: $datePicker.get(0),
          theme: 'gitlab-theme animate-picker',
          format: 'yyyy-mm-dd',
          container: $datePicker.parent().get(0),
          parse: function parse(dateString) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["a" /* parsePikadayDate */])(dateString);
          },
          toString: function toString(date) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["b" /* pikadayToString */])(date);
          },
          onSelect: function onSelect(dateText) {
            $datePicker.val(calendar.toString(dateText));
          }
        });

        calendar.setDate(Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_datefix__["a" /* parsePikadayDate */])($datePicker.val()));

        $datePicker.data('pikaday', calendar);
      });

      $('.js-clear-due-date,.js-clear-start-date').on('click', function (e) {
        e.preventDefault();
        var calendar = $(e.target).siblings('.datepicker').data('pikaday');
        calendar.setDate(null);
      });
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'initIssuableSelect',
    value: function initIssuableSelect() {
      var $loading = $('.js-issuable-update .due_date').find('.block-loading').hide();

      $('.js-due-date-select').each(function (i, dropdown) {
        var $dropdown = $(dropdown);
        // eslint-disable-next-line no-new
        new DueDateSelect({
          $dropdown: $dropdown,
          $loading: $loading
        });
      });
    }
  }]);

  return DueDateSelectors;
}();

/* harmony default export */ __webpack_exports__["a"] = (DueDateSelectors);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./files_comment_button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* Developer beware! Do not add logic to showButton or hideButton
 * that will force a reflow. Doing so will create a signficant performance
 * bottleneck for pages with large diffs. For a comprehensive list of what
 * causes reflows, visit https://gist.github.com/paulirish/5d52fb081b3570c81e3a
 */



var LINE_NUMBER_CLASS = 'diff-line-num';
var UNFOLDABLE_LINE_CLASS = 'js-unfold';
var NO_COMMENT_CLASS = 'no-comment-btn';
var EMPTY_CELL_CLASS = 'empty-cell';
var OLD_LINE_CLASS = 'old_line';
var LINE_COLUMN_CLASSES = '.' + LINE_NUMBER_CLASS + ', .line_content';
var DIFF_CONTAINER_SELECTOR = '.files';
var DIFF_EXPANDED_CLASS = 'diff-expanded';

/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init($diffFile) {
    var _this = this;

    /* Caching is used only when the following members are *true*.
     * This is because there are likely to be
     * differently configured versions of diffs in the same session.
     * However if these values are true, they
     * will be true in all cases */

    if (!this.userCanCreateNote) {
      // data-can-create-note is an empty string when true, otherwise undefined
      this.userCanCreateNote = $diffFile.closest(DIFF_CONTAINER_SELECTOR).data('canCreateNote') === '';
    }

    this.isParallelView = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('diff_view') === 'parallel';

    if (this.userCanCreateNote) {
      $diffFile.on('mouseover', LINE_COLUMN_CLASSES, function (e) {
        return _this.showButton(_this.isParallelView, e);
      }).on('mouseleave', LINE_COLUMN_CLASSES, function (e) {
        return _this.hideButton(_this.isParallelView, e);
      });
    }
  },
  showButton: function showButton(isParallelView, e) {
    var buttonParentElement = this.getButtonParent(e.currentTarget, isParallelView);

    if (!this.validateButtonParent(buttonParentElement)) return;

    buttonParentElement.classList.add('is-over');
    buttonParentElement.nextElementSibling.classList.add('is-over');
  },
  hideButton: function hideButton(isParallelView, e) {
    var buttonParentElement = this.getButtonParent(e.currentTarget, isParallelView);

    buttonParentElement.classList.remove('is-over');
    buttonParentElement.nextElementSibling.classList.remove('is-over');
  },
  getButtonParent: function getButtonParent(hoveredElement, isParallelView) {
    if (isParallelView) {
      if (!hoveredElement.classList.contains(LINE_NUMBER_CLASS)) {
        return hoveredElement.previousElementSibling;
      }
    } else if (!hoveredElement.classList.contains(OLD_LINE_CLASS)) {
      return hoveredElement.parentNode.querySelector('.' + OLD_LINE_CLASS);
    }
    return hoveredElement;
  },
  validateButtonParent: function validateButtonParent(buttonParentElement) {
    return !buttonParentElement.classList.contains(EMPTY_CELL_CLASS) && !buttonParentElement.classList.contains(UNFOLDABLE_LINE_CLASS) && !buttonParentElement.classList.contains(NO_COMMENT_CLASS) && !buttonParentElement.parentNode.classList.contains(DIFF_EXPANDED_CLASS);
  }
});

/***/ }),

/***/ "./gl_form.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize__ = __webpack_require__("../../../node_modules/autosize/dist/autosize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gfm_auto_complete__ = __webpack_require__("./gfm_auto_complete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dropzone_input__ = __webpack_require__("./dropzone_input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_text_markdown__ = __webpack_require__("./lib/utils/text_markdown.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var GLForm = function () {
  function GLForm(form) {
    var enableGFM = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, GLForm);

    this.form = form;
    this.textarea = this.form.find('textarea.js-gfm-input');
    this.enableGFM = enableGFM;
    // Before we start, we should clean up any previous data for this form
    this.destroy();
    // Setup the form
    this.setupForm();
    this.form.data('glForm', this);
  }

  _createClass(GLForm, [{
    key: 'destroy',
    value: function destroy() {
      // Clean form listeners
      this.clearEventListeners();
      if (this.autoComplete) {
        this.autoComplete.destroy();
      }
      this.form.data('glForm', null);
    }
  }, {
    key: 'setupForm',
    value: function setupForm() {
      var isNewForm = this.form.is(':not(.gfm-form)');
      this.form.removeClass('js-new-note-form');
      if (isNewForm) {
        this.form.find('.div-dropzone').remove();
        this.form.addClass('gfm-form');
        // remove notify commit author checkbox for non-commit notes
        gl.utils.disableButtonIfEmptyField(this.form.find('.js-note-text'), this.form.find('.js-comment-button, .js-note-new-discussion'));
        this.autoComplete = new __WEBPACK_IMPORTED_MODULE_1__gfm_auto_complete__["a" /* default */](gl.GfmAutoComplete && gl.GfmAutoComplete.dataSources);
        this.autoComplete.setup(this.form.find('.js-gfm-input'), {
          emojis: true,
          members: this.enableGFM,
          issues: this.enableGFM,
          milestones: this.enableGFM,
          mergeRequests: this.enableGFM,
          labels: this.enableGFM
        });
        Object(__WEBPACK_IMPORTED_MODULE_2__dropzone_input__["a" /* default */])(this.form);
        __WEBPACK_IMPORTED_MODULE_0_autosize___default()(this.textarea);
      }
      // form and textarea event listeners
      this.addEventListeners();
      __WEBPACK_IMPORTED_MODULE_3__lib_utils_text_markdown__["a" /* default */].init(this.form);
      // hide discard button
      this.form.find('.js-note-discard').hide();
      this.form.show();
      if (this.isAutosizeable) this.setupAutosize();
    }
  }, {
    key: 'setupAutosize',
    value: function setupAutosize() {
      var _this = this;

      this.textarea.off('autosize:resized').on('autosize:resized', this.setHeightData.bind(this));

      this.textarea.off('mouseup.autosize').on('mouseup.autosize', this.destroyAutosize.bind(this));

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_autosize___default()(_this.textarea);
        _this.textarea.css('resize', 'vertical');
      }, 0);
    }
  }, {
    key: 'setHeightData',
    value: function setHeightData() {
      this.textarea.data('height', this.textarea.outerHeight());
    }
  }, {
    key: 'destroyAutosize',
    value: function destroyAutosize() {
      var outerHeight = this.textarea.outerHeight();

      if (this.textarea.data('height') === outerHeight) return;

      __WEBPACK_IMPORTED_MODULE_0_autosize___default.a.destroy(this.textarea);

      this.textarea.data('height', outerHeight);
      this.textarea.outerHeight(outerHeight);
      this.textarea.css('max-height', window.outerHeight);
    }
  }, {
    key: 'clearEventListeners',
    value: function clearEventListeners() {
      this.textarea.off('focus');
      this.textarea.off('blur');
      __WEBPACK_IMPORTED_MODULE_3__lib_utils_text_markdown__["a" /* default */].removeListeners(this.form);
    }
  }, {
    key: 'addEventListeners',
    value: function addEventListeners() {
      this.textarea.on('focus', function focusTextArea() {
        $(this).closest('.md-area').addClass('is-focused');
      });
      this.textarea.on('blur', function blurTextArea() {
        $(this).closest('.md-area').removeClass('is-focused');
      });
    }
  }]);

  return GLForm;
}();

/* harmony default export */ __webpack_exports__["a"] = (GLForm);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./helpers/issuables_helper.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./droplab/drop_lab.js + 7 modules
var drop_lab = __webpack_require__("./droplab/drop_lab.js");

// EXTERNAL MODULE: ./droplab/plugins/input_setter.js
var input_setter = __webpack_require__("./droplab/plugins/input_setter.js");

// CONCATENATED MODULE: ./close_reopen_report_toggle.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




// Todo: Remove this when fixing issue in input_setter plugin
var InputSetter = Object.assign({}, input_setter["a" /* default */]);

var close_reopen_report_toggle_CloseReopenReportToggle = function () {
  function CloseReopenReportToggle() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CloseReopenReportToggle);

    this.dropdownTrigger = opts.dropdownTrigger;
    this.dropdownList = opts.dropdownList;
    this.button = opts.button;
  }

  _createClass(CloseReopenReportToggle, [{
    key: 'initDroplab',
    value: function initDroplab() {
      this.reopenItem = this.dropdownList.querySelector('.reopen-item');
      this.closeItem = this.dropdownList.querySelector('.close-item');

      this.droplab = new drop_lab["a" /* default */]();

      var config = this.setConfig();

      this.droplab.init(this.dropdownTrigger, this.dropdownList, [InputSetter], config);
    }
  }, {
    key: 'updateButton',
    value: function updateButton(isClosed) {
      this.toggleButtonType(isClosed);

      this.button.blur();
    }
  }, {
    key: 'toggleButtonType',
    value: function toggleButtonType(isClosed) {
      var _getButtonTypes = this.getButtonTypes(isClosed),
          _getButtonTypes2 = _slicedToArray(_getButtonTypes, 2),
          showItem = _getButtonTypes2[0],
          hideItem = _getButtonTypes2[1];

      showItem.classList.remove('hidden');
      showItem.classList.add('droplab-item-selected');

      hideItem.classList.add('hidden');
      hideItem.classList.remove('droplab-item-selected');

      showItem.click();
    }
  }, {
    key: 'getButtonTypes',
    value: function getButtonTypes(isClosed) {
      return isClosed ? [this.reopenItem, this.closeItem] : [this.closeItem, this.reopenItem];
    }
  }, {
    key: 'setDisable',
    value: function setDisable() {
      var shouldDisable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (shouldDisable) {
        this.button.setAttribute('disabled', 'true');
        this.dropdownTrigger.setAttribute('disabled', 'true');
      } else {
        this.button.removeAttribute('disabled');
        this.dropdownTrigger.removeAttribute('disabled');
      }
    }
  }, {
    key: 'setConfig',
    value: function setConfig() {
      var config = {
        InputSetter: [{
          input: this.button,
          valueAttribute: 'data-text',
          inputAttribute: 'data-value'
        }, {
          input: this.button,
          valueAttribute: 'data-text',
          inputAttribute: 'title'
        }, {
          input: this.button,
          valueAttribute: 'data-button-class',
          inputAttribute: 'class'
        }, {
          input: this.dropdownTrigger,
          valueAttribute: 'data-toggle-class',
          inputAttribute: 'class'
        }, {
          input: this.button,
          valueAttribute: 'data-url',
          inputAttribute: 'href'
        }, {
          input: this.button,
          valueAttribute: 'data-method',
          inputAttribute: 'data-method'
        }]
      };

      return config;
    }
  }]);

  return CloseReopenReportToggle;
}();

/* harmony default export */ var close_reopen_report_toggle = (close_reopen_report_toggle_CloseReopenReportToggle);
// CONCATENATED MODULE: ./helpers/issuables_helper.js


function initCloseReopenReport() {
  var container = document.querySelector('.js-issuable-close-dropdown');

  if (!container) return undefined;

  var dropdownTrigger = container.querySelector('.js-issuable-close-toggle');
  var dropdownList = container.querySelector('.js-issuable-close-menu');
  var button = container.querySelector('.js-issuable-close-button');

  var closeReopenReportToggle = new close_reopen_report_toggle({
    dropdownTrigger: dropdownTrigger,
    dropdownList: dropdownList,
    button: button
  });

  closeReopenReportToggle.initDroplab();

  return closeReopenReportToggle;
}

var IssuablesHelper = {
  initCloseReopenReport: initCloseReopenReport
};

/* harmony default export */ var issuables_helper = __webpack_exports__["a"] = (IssuablesHelper);

/***/ }),

/***/ "./how_to_merge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = (function () {
  var modal = $('#modal_merge_info');

  if (modal) {
    modal.modal({
      modal: true,
      show: false
    });

    $('.how_to_merge_link').on('click', modal.show);
    $('.modal-header .close').on('click', modal.hide);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./image_diff/helpers/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./image_diff/helpers/badge_helper.js
function createImageBadge(noteId, _ref) {
  var x = _ref.x,
      y = _ref.y;
  var classNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var buttonEl = document.createElement('button');
  var classList = classNames.concat(['js-image-badge']);
  classList.forEach(function (className) {
    return buttonEl.classList.add(className);
  });
  buttonEl.setAttribute('type', 'button');
  buttonEl.setAttribute('disabled', true);
  buttonEl.dataset.noteId = noteId;
  buttonEl.style.left = x + 'px';
  buttonEl.style.top = y + 'px';

  return buttonEl;
}

function addImageBadge(containerEl, _ref2) {
  var coordinate = _ref2.coordinate,
      badgeText = _ref2.badgeText,
      noteId = _ref2.noteId;

  var buttonEl = createImageBadge(noteId, coordinate, ['badge']);
  buttonEl.innerText = badgeText;

  containerEl.appendChild(buttonEl);
}

function addImageCommentBadge(containerEl, _ref3) {
  var coordinate = _ref3.coordinate,
      noteId = _ref3.noteId;

  var buttonEl = createImageBadge(noteId, coordinate, ['image-comment-badge']);
  buttonEl.innerHTML = gl.utils.spriteIcon('image-comment-dark');

  containerEl.appendChild(buttonEl);
}

function addAvatarBadge(el, event) {
  var _event$detail = event.detail,
      noteId = _event$detail.noteId,
      badgeNumber = _event$detail.badgeNumber;

  // Add badge to new comment

  var avatarBadgeEl = el.querySelector('#' + noteId + ' .badge');
  avatarBadgeEl.innerText = badgeNumber;
  avatarBadgeEl.classList.remove('hidden');
}
// CONCATENATED MODULE: ./image_diff/helpers/comment_indicator_helper.js
function addCommentIndicator(containerEl, _ref) {
  var x = _ref.x,
      y = _ref.y;

  var buttonEl = document.createElement('button');
  buttonEl.classList.add('btn-transparent');
  buttonEl.classList.add('comment-indicator');
  buttonEl.setAttribute('type', 'button');
  buttonEl.style.left = x + 'px';
  buttonEl.style.top = y + 'px';

  buttonEl.innerHTML = gl.utils.spriteIcon('image-comment-dark');

  containerEl.appendChild(buttonEl);
}

function removeCommentIndicator(imageFrameEl) {
  var commentIndicatorEl = imageFrameEl.querySelector('.comment-indicator');
  var imageEl = imageFrameEl.querySelector('img');
  var willRemove = !!commentIndicatorEl;
  var meta = {};

  if (willRemove) {
    meta = {
      x: parseInt(commentIndicatorEl.style.left, 10),
      y: parseInt(commentIndicatorEl.style.top, 10),
      image: {
        width: imageEl.width,
        height: imageEl.height
      }
    };

    commentIndicatorEl.remove();
  }

  return Object.assign({}, meta, {
    removed: willRemove
  });
}

function showCommentIndicator(imageFrameEl, coordinate) {
  var x = coordinate.x,
      y = coordinate.y;

  var commentIndicatorEl = imageFrameEl.querySelector('.comment-indicator');

  if (commentIndicatorEl) {
    commentIndicatorEl.style.left = x + 'px';
    commentIndicatorEl.style.top = y + 'px';
  } else {
    addCommentIndicator(imageFrameEl, coordinate);
  }
}

function commentIndicatorOnClick(event) {
  // Prevent from triggering onAddImageDiffNote in notes.js
  event.stopPropagation();

  var buttonEl = event.currentTarget;
  var diffViewerEl = buttonEl.closest('.diff-viewer');
  var textareaEl = diffViewerEl.querySelector('.note-container .note-textarea');
  textareaEl.focus();
}
// CONCATENATED MODULE: ./image_diff/helpers/dom_helper.js
function setPositionDataAttribute(el, options) {
  // Update position data attribute so that the
  // new comment form can use this data for ajax request
  var x = options.x,
      y = options.y,
      width = options.width,
      height = options.height;

  var position = el.dataset.position;
  var positionObject = Object.assign({}, JSON.parse(position), {
    x: x,
    y: y,
    width: width,
    height: height
  });

  el.setAttribute('data-position', JSON.stringify(positionObject));
}

function updateDiscussionAvatarBadgeNumber(discussionEl, newBadgeNumber) {
  var avatarBadgeEl = discussionEl.querySelector('.image-diff-avatar-link .badge');
  avatarBadgeEl.innerText = newBadgeNumber;
}

function updateDiscussionBadgeNumber(discussionEl, newBadgeNumber) {
  var discussionBadgeEl = discussionEl.querySelector('.badge');
  discussionBadgeEl.innerText = newBadgeNumber;
}

function toggleCollapsed(event) {
  var toggleButtonEl = event.currentTarget;
  var discussionNotesEl = toggleButtonEl.closest('.discussion-notes');
  var formEl = discussionNotesEl.querySelector('.discussion-form');
  var isCollapsed = discussionNotesEl.classList.contains('collapsed');

  if (isCollapsed) {
    discussionNotesEl.classList.remove('collapsed');
  } else {
    discussionNotesEl.classList.add('collapsed');
  }

  // Override the inline display style set in notes.js
  if (formEl && !isCollapsed) {
    formEl.style.display = 'none';
  } else if (formEl && isCollapsed) {
    formEl.style.display = 'block';
  }
}
// EXTERNAL MODULE: ./image_diff/image_badge.js
var image_badge = __webpack_require__("./image_diff/image_badge.js");

// EXTERNAL MODULE: ./image_diff/image_diff.js
var image_diff = __webpack_require__("./image_diff/image_diff.js");

// CONCATENATED MODULE: ./image_diff/view_types.js
var viewTypes = {
  TWO_UP: 'TWO_UP',
  SWIPE: 'SWIPE',
  ONION_SKIN: 'ONION_SKIN'
};

function isValidViewType(validate) {
  return !!Object.getOwnPropertyNames(viewTypes).find(function (viewType) {
    return viewType === validate;
  });
}
// CONCATENATED MODULE: ./image_diff/replaced_image_diff.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var replaced_image_diff_ReplacedImageDiff = function (_ImageDiff) {
  _inherits(ReplacedImageDiff, _ImageDiff);

  function ReplacedImageDiff() {
    _classCallCheck(this, ReplacedImageDiff);

    return _possibleConstructorReturn(this, (ReplacedImageDiff.__proto__ || Object.getPrototypeOf(ReplacedImageDiff)).apply(this, arguments));
  }

  _createClass(ReplacedImageDiff, [{
    key: 'init',
    value: function init() {
      var _imageFrameEls, _viewModesEls;

      var defaultViewType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : viewTypes.TWO_UP;

      this.imageFrameEls = (_imageFrameEls = {}, _defineProperty(_imageFrameEls, viewTypes.TWO_UP, this.el.querySelector('.two-up .js-image-frame')), _defineProperty(_imageFrameEls, viewTypes.SWIPE, this.el.querySelector('.swipe .js-image-frame')), _defineProperty(_imageFrameEls, viewTypes.ONION_SKIN, this.el.querySelector('.onion-skin .js-image-frame')), _imageFrameEls);

      var viewModesEl = this.el.querySelector('.view-modes-menu');
      this.viewModesEls = (_viewModesEls = {}, _defineProperty(_viewModesEls, viewTypes.TWO_UP, viewModesEl.querySelector('.two-up')), _defineProperty(_viewModesEls, viewTypes.SWIPE, viewModesEl.querySelector('.swipe')), _defineProperty(_viewModesEls, viewTypes.ONION_SKIN, viewModesEl.querySelector('.onion-skin')), _viewModesEls);

      this.currentView = defaultViewType;
      this.generateImageEls();
      this.bindEvents();
    }
  }, {
    key: 'generateImageEls',
    value: function generateImageEls() {
      var _this2 = this;

      this.imageEls = {};

      var viewTypeNames = Object.getOwnPropertyNames(viewTypes);
      viewTypeNames.forEach(function (viewType) {
        _this2.imageEls[viewType] = _this2.imageFrameEls[viewType].querySelector('img');
      });
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      _get(ReplacedImageDiff.prototype.__proto__ || Object.getPrototypeOf(ReplacedImageDiff.prototype), 'bindEvents', this).call(this);

      this.changeToViewTwoUp = this.changeView.bind(this, viewTypes.TWO_UP);
      this.changeToViewSwipe = this.changeView.bind(this, viewTypes.SWIPE);
      this.changeToViewOnionSkin = this.changeView.bind(this, viewTypes.ONION_SKIN);

      this.viewModesEls[viewTypes.TWO_UP].addEventListener('click', this.changeToViewTwoUp);
      this.viewModesEls[viewTypes.SWIPE].addEventListener('click', this.changeToViewSwipe);
      this.viewModesEls[viewTypes.ONION_SKIN].addEventListener('click', this.changeToViewOnionSkin);
    }
  }, {
    key: 'changeView',
    value: function changeView(newView) {
      if (!isValidViewType(newView)) {
        return;
      }

      var indicator = helpers.removeCommentIndicator(this.imageFrameEl);

      this.currentView = newView;

      // Clear existing badges on new view
      var existingBadges = this.imageFrameEl.querySelectorAll('.badge');
      [].concat(_toConsumableArray(existingBadges)).map(function (badge) {
        return badge.remove();
      });

      // Remove existing references to old view image badges
      this.imageBadges = [];

      // Image_file.js has a fade animation of 200ms for loading the view
      // Need to wait an additional 250ms for the images to be displayed
      // on window in order to re-normalize their dimensions
      setTimeout(this.renderNewView.bind(this, indicator), 250);
    }
  }, {
    key: 'renderNewView',
    value: function renderNewView(indicator) {
      // Generate badge coordinates on new view
      this.renderBadges();

      // Re-render indicator in new view
      if (indicator.removed) {
        var normalizedIndicator = helpers.resizeCoordinatesToImageElement(this.imageEl, {
          x: indicator.x,
          y: indicator.y,
          width: indicator.image.width,
          height: indicator.image.height
        });
        helpers.showCommentIndicator(this.imageFrameEl, normalizedIndicator);
      }
    }
  }, {
    key: 'imageEl',
    get: function get() {
      return this.imageEls[this.currentView];
    }
  }, {
    key: 'imageFrameEl',
    get: function get() {
      return this.imageFrameEls[this.currentView];
    }
  }]);

  return ReplacedImageDiff;
}(image_diff["a" /* default */]);

/* harmony default export */ var replaced_image_diff = (replaced_image_diff_ReplacedImageDiff);
// EXTERNAL MODULE: ./commit/image_file.js
var image_file = __webpack_require__("./commit/image_file.js");

// CONCATENATED MODULE: ./image_diff/helpers/utils_helper.js





function resizeCoordinatesToImageElement(imageEl, meta) {
  var x = meta.x,
      y = meta.y,
      width = meta.width,
      height = meta.height;


  var imageWidth = imageEl.width;
  var imageHeight = imageEl.height;

  var widthRatio = imageWidth / width;
  var heightRatio = imageHeight / height;

  return {
    x: Math.round(x * widthRatio),
    y: Math.round(y * heightRatio),
    width: imageWidth,
    height: imageHeight
  };
}

function generateBadgeFromDiscussionDOM(imageFrameEl, discussionEl) {
  var position = JSON.parse(discussionEl.dataset.position);
  var firstNoteEl = discussionEl.querySelector('.note');
  var badge = new image_badge["a" /* default */]({
    actual: position,
    imageEl: imageFrameEl.querySelector('img'),
    noteId: firstNoteEl.id,
    discussionId: discussionEl.dataset.discussionId
  });

  return badge;
}

function getTargetSelection(event) {
  var containerEl = event.currentTarget;
  var imageEl = containerEl.querySelector('img');

  var x = event.offsetX;
  var y = event.offsetY;

  var width = imageEl.width;
  var height = imageEl.height;

  var actualWidth = imageEl.naturalWidth;
  var actualHeight = imageEl.naturalHeight;

  var widthRatio = actualWidth / width;
  var heightRatio = actualHeight / height;

  // Browser will include the frame as a clickable target,
  // which would result in potential 1px out of bounds value
  // This bound the coordinates to inside the frame
  var normalizedX = Math.max(0, x) && Math.min(x, width);
  var normalizedY = Math.max(0, y) && Math.min(y, height);

  return {
    browser: {
      x: normalizedX,
      y: normalizedY,
      width: width,
      height: height
    },
    actual: {
      // Round x, y so that we don't need to deal with decimals
      x: Math.round(normalizedX * widthRatio),
      y: Math.round(normalizedY * heightRatio),
      width: actualWidth,
      height: actualHeight
    }
  };
}

function initImageDiff(fileEl, canCreateNote, renderCommentBadge) {
  var options = {
    canCreateNote: canCreateNote,
    renderCommentBadge: renderCommentBadge
  };
  var diff = void 0;

  // ImageFile needs to be invoked before initImageDiff so that badges
  // can mount to the correct location
  new image_file["a" /* default */](fileEl); // eslint-disable-line no-new

  if (fileEl.querySelector('.diff-file .js-single-image')) {
    diff = new image_diff["a" /* default */](fileEl, options);
    diff.init();
  } else if (fileEl.querySelector('.diff-file .js-replaced-image')) {
    diff = new replaced_image_diff(fileEl, options);
    diff.init();
  }

  return diff;
}
// CONCATENATED MODULE: ./image_diff/helpers/index.js





/* harmony default export */ var helpers = __webpack_exports__["a"] = ({
  addCommentIndicator: addCommentIndicator,
  removeCommentIndicator: removeCommentIndicator,
  showCommentIndicator: showCommentIndicator,
  commentIndicatorOnClick: commentIndicatorOnClick,

  addImageBadge: addImageBadge,
  addImageCommentBadge: addImageCommentBadge,
  addAvatarBadge: addAvatarBadge,

  setPositionDataAttribute: setPositionDataAttribute,
  updateDiscussionAvatarBadgeNumber: updateDiscussionAvatarBadgeNumber,
  updateDiscussionBadgeNumber: updateDiscussionBadgeNumber,
  toggleCollapsed: toggleCollapsed,

  resizeCoordinatesToImageElement: resizeCoordinatesToImageElement,
  generateBadgeFromDiscussionDOM: generateBadgeFromDiscussionDOM,
  getTargetSelection: getTargetSelection,
  initImageDiff: initImageDiff
});

/***/ }),

/***/ "./image_diff/image_badge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var defaultMeta = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};

var ImageBadge = function ImageBadge(options) {
  _classCallCheck(this, ImageBadge);

  var noteId = options.noteId,
      discussionId = options.discussionId;


  this.actual = options.actual || defaultMeta;
  this.browser = options.browser || defaultMeta;
  this.noteId = noteId;
  this.discussionId = discussionId;

  if (options.imageEl && !options.browser) {
    this.browser = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].resizeCoordinatesToImageElement(options.imageEl, this.actual);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ImageBadge);

/***/ }),

/***/ "./image_diff/image_diff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__image_badge__ = __webpack_require__("./image_diff/image_badge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_image_utility__ = __webpack_require__("./lib/utils/image_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var ImageDiff = function () {
  function ImageDiff(el, options) {
    _classCallCheck(this, ImageDiff);

    this.el = el;
    this.canCreateNote = !!(options && options.canCreateNote);
    this.renderCommentBadge = !!(options && options.renderCommentBadge);
    this.$noteContainer = $('.note-container', this.el);
    this.imageBadges = [];
  }

  _createClass(ImageDiff, [{
    key: 'init',
    value: function init() {
      this.imageFrameEl = this.el.querySelector('.diff-file .js-image-frame');
      this.imageEl = this.imageFrameEl.querySelector('img');

      this.bindEvents();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.imageClickedWrapper = this.imageClicked.bind(this);
      this.imageBlurredWrapper = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].removeCommentIndicator.bind(null, this.imageFrameEl);
      this.addBadgeWrapper = this.addBadge.bind(this);
      this.removeBadgeWrapper = this.removeBadge.bind(this);
      this.renderBadgesWrapper = this.renderBadges.bind(this);

      // Render badges
      if (Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_image_utility__["a" /* isImageLoaded */])(this.imageEl)) {
        this.renderBadges();
      } else {
        this.imageEl.addEventListener('load', this.renderBadgesWrapper);
      }

      // jquery makes the event delegation here much simpler
      this.$noteContainer.on('click', '.js-diff-notes-toggle', __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].toggleCollapsed);
      $(this.el).on('click', '.comment-indicator', __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].commentIndicatorOnClick);

      if (this.canCreateNote) {
        this.el.addEventListener('click.imageDiff', this.imageClickedWrapper);
        this.el.addEventListener('blur.imageDiff', this.imageBlurredWrapper);
        this.el.addEventListener('addBadge.imageDiff', this.addBadgeWrapper);
        this.el.addEventListener('removeBadge.imageDiff', this.removeBadgeWrapper);
      }
    }
  }, {
    key: 'imageClicked',
    value: function imageClicked(event) {
      var customEvent = event.detail;
      var selection = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].getTargetSelection(customEvent);
      var el = customEvent.currentTarget;

      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].setPositionDataAttribute(el, selection.actual);
      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].showCommentIndicator(this.imageFrameEl, selection.browser);
    }
  }, {
    key: 'renderBadges',
    value: function renderBadges() {
      var discussionsEls = this.el.querySelectorAll('.note-container .discussion-notes .notes');
      [].concat(_toConsumableArray(discussionsEls)).forEach(this.renderBadge.bind(this));
    }
  }, {
    key: 'renderBadge',
    value: function renderBadge(discussionEl, index) {
      var imageBadge = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].generateBadgeFromDiscussionDOM(this.imageFrameEl, discussionEl);

      this.imageBadges.push(imageBadge);

      var options = {
        coordinate: imageBadge.browser,
        noteId: imageBadge.noteId
      };

      if (this.renderCommentBadge) {
        __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addImageCommentBadge(this.imageFrameEl, options);
      } else {
        var numberBadgeOptions = Object.assign({}, options, {
          badgeText: index + 1
        });

        __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addImageBadge(this.imageFrameEl, numberBadgeOptions);
      }
    }
  }, {
    key: 'addBadge',
    value: function addBadge(event) {
      var _event$detail = event.detail,
          x = _event$detail.x,
          y = _event$detail.y,
          width = _event$detail.width,
          height = _event$detail.height,
          noteId = _event$detail.noteId,
          discussionId = _event$detail.discussionId;

      var badgeText = this.imageBadges.length + 1;
      var imageBadge = new __WEBPACK_IMPORTED_MODULE_1__image_badge__["a" /* default */]({
        actual: {
          x: x,
          y: y,
          width: width,
          height: height
        },
        imageEl: this.imageFrameEl.querySelector('img'),
        noteId: noteId,
        discussionId: discussionId
      });

      this.imageBadges.push(imageBadge);

      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addImageBadge(this.imageFrameEl, {
        coordinate: imageBadge.browser,
        badgeText: badgeText,
        noteId: noteId
      });

      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addAvatarBadge(this.el, {
        detail: {
          noteId: noteId,
          badgeNumber: badgeText
        }
      });

      var discussionEl = this.el.querySelector('#discussion_' + discussionId);
      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].updateDiscussionBadgeNumber(discussionEl, badgeText);
    }
  }, {
    key: 'removeBadge',
    value: function removeBadge(event) {
      var _this = this;

      var badgeNumber = event.detail.badgeNumber;

      var indexToRemove = badgeNumber - 1;
      var imageBadgeEls = this.imageFrameEl.querySelectorAll('.badge');

      if (this.imageBadges.length !== badgeNumber) {
        // Cascade badges count numbers for (avatar badges + image badges)
        this.imageBadges.forEach(function (badge, index) {
          if (index > indexToRemove) {
            var discussionId = badge.discussionId;

            var updatedBadgeNumber = index;
            var discussionEl = _this.el.querySelector('#discussion_' + discussionId);

            imageBadgeEls[index].innerText = updatedBadgeNumber;

            __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].updateDiscussionBadgeNumber(discussionEl, updatedBadgeNumber);
            __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].updateDiscussionAvatarBadgeNumber(discussionEl, updatedBadgeNumber);
          }
        });
      }

      this.imageBadges.splice(indexToRemove, 1);

      var imageBadgeEl = imageBadgeEls[indexToRemove];
      imageBadgeEl.remove();
    }
  }]);

  return ImageDiff;
}();

/* harmony default export */ __webpack_exports__["a"] = (ImageDiff);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./image_diff/init_discussion_tab.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* harmony default export */ __webpack_exports__["a"] = (function () {
  // Always pass can-create-note as false because a user
  // cannot place new badge markers on discussion tab
  var canCreateNote = false;
  var renderCommentBadge = true;

  var diffFileEls = document.querySelectorAll('.timeline-content .diff-file.js-image-file');
  [].concat(_toConsumableArray(diffFileEls)).forEach(function (diffFileEl) {
    return __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].initImageDiff(diffFileEl, canCreateNote, renderCommentBadge);
  });
});

/***/ }),

/***/ "./init_changes_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_sticky__ = __webpack_require__("./lib/utils/sticky.js");


/* harmony default export */ __webpack_exports__["a"] = (function (stickyTop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_sticky__["a" /* default */])(document.querySelector('.js-diff-files-changed'), stickyTop);

  $('.js-diff-stats-dropdown').glDropdown({
    filterable: true,
    remoteFilter: false
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./init_issuable_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__milestone_select__ = __webpack_require__("./milestone_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__labels_select__ = __webpack_require__("./labels_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__issuable_context__ = __webpack_require__("./issuable_context.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__right_sidebar__ = __webpack_require__("./right_sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__due_date_select__ = __webpack_require__("./due_date_select.js");
/* eslint-disable no-new */








/* harmony default export */ __webpack_exports__["a"] = (function () {
  var sidebarOptions = JSON.parse(document.querySelector('.js-sidebar-options').innerHTML);

  new __WEBPACK_IMPORTED_MODULE_0__milestone_select__["a" /* default */]({
    full_path: sidebarOptions.fullPath
  });
  new __WEBPACK_IMPORTED_MODULE_1__labels_select__["a" /* default */]();
  new __WEBPACK_IMPORTED_MODULE_2__issuable_context__["a" /* default */](sidebarOptions.currentUser);
  new __WEBPACK_IMPORTED_MODULE_4__due_date_select__["a" /* default */]();
  __WEBPACK_IMPORTED_MODULE_3__right_sidebar__["a" /* default */].initialize();
});

/***/ }),

/***/ "./init_notes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notes__ = __webpack_require__("./notes.js");


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var dataEl = document.querySelector('.js-notes-data');

  var _JSON$parse = JSON.parse(dataEl.innerHTML),
      notesUrl = _JSON$parse.notesUrl,
      notesIds = _JSON$parse.notesIds,
      now = _JSON$parse.now,
      diffView = _JSON$parse.diffView,
      autocomplete = _JSON$parse.autocomplete;

  // Create a singleton so that we don't need to assign
  // into the window object, we can just access the current isntance with Notes.instance


  __WEBPACK_IMPORTED_MODULE_0__notes__["a" /* default */].initialize(notesUrl, notesIds, now, diffView, autocomplete);
});

/***/ }),

/***/ "./issuable_bulk_update_actions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* eslint-disable comma-dangle, quotes, consistent-return, func-names, array-callback-return, space-before-function-paren, prefer-arrow-callback, max-len, no-unused-expressions, no-sequences, no-underscore-dangle, no-unused-vars, no-param-reassign */




/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        container = _ref.container,
        form = _ref.form,
        issues = _ref.issues,
        prefixId = _ref.prefixId;

    this.prefixId = prefixId || 'issue_';
    this.form = form || this.getElement('.bulk-update');
    this.$labelDropdown = this.form.find('.js-label-select');
    this.issues = issues || this.getElement('.issues-list .issue');
    this.willUpdateLabels = false;
    this.bindEvents();
  },
  bindEvents: function bindEvents() {
    return this.form.off('submit').on('submit', this.onFormSubmit.bind(this));
  },
  onFormSubmit: function onFormSubmit(e) {
    e.preventDefault();
    return this.submit();
  },
  submit: function submit() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */][this.form.attr('method')](this.form.attr('action'), this.getFormDataAsObject()).then(function () {
      return window.location.reload();
    }).catch(function () {
      return _this.onFormSubmitFailure();
    });
  },
  onFormSubmitFailure: function onFormSubmitFailure() {
    this.form.find('[type="submit"]').enable();
    return new __WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */]("Issue update failed");
  },
  getSelectedIssues: function getSelectedIssues() {
    return this.issues.has('.selected_issue:checked');
  },
  getLabelsFromSelection: function getLabelsFromSelection() {
    var labels = [];
    this.getSelectedIssues().map(function () {
      var labelsData = $(this).data('labels');
      if (labelsData) {
        return labelsData.map(function (labelId) {
          if (labels.indexOf(labelId) === -1) {
            return labels.push(labelId);
          }
        });
      }
    });
    return labels;
  },


  /**
   * Will return only labels that were marked previously and the user has unmarked
   * @return {Array} Label IDs
   */

  getUnmarkedIndeterminedLabels: function getUnmarkedIndeterminedLabels() {
    var result = [];
    var labelsToKeep = this.$labelDropdown.data('indeterminate');

    this.getLabelsFromSelection().forEach(function (id) {
      if (labelsToKeep.indexOf(id) === -1) {
        result.push(id);
      }
    });

    return result;
  },


  /**
   * Simple form serialization, it will return just what we need
   * Returns key/value pairs from form data
   */

  getFormDataAsObject: function getFormDataAsObject() {
    var formData = {
      update: {
        state_event: this.form.find('input[name="update[state_event]"]').val(),
        // For Merge Requests
        assignee_id: this.form.find('input[name="update[assignee_id]"]').val(),
        // For Issues
        assignee_ids: [this.form.find('input[name="update[assignee_ids][]"]').val()],
        milestone_id: this.form.find('input[name="update[milestone_id]"]').val(),
        issuable_ids: this.form.find('input[name="update[issuable_ids]"]').val(),
        subscription_event: this.form.find('input[name="update[subscription_event]"]').val(),
        add_label_ids: [],
        remove_label_ids: []
      }
    };
    if (this.willUpdateLabels) {
      formData.update.add_label_ids = this.$labelDropdown.data('marked');
      formData.update.remove_label_ids = this.$labelDropdown.data('unmarked');
    }
    return formData;
  },
  setOriginalDropdownData: function setOriginalDropdownData() {
    var $labelSelect = $('.bulk-update .js-label-select');
    $labelSelect.data('common', this.getOriginalCommonIds());
    $labelSelect.data('marked', this.getOriginalMarkedIds());
    $labelSelect.data('indeterminate', this.getOriginalIndeterminateIds());
  },


  // From issuable's initial bulk selection
  getOriginalCommonIds: function getOriginalCommonIds() {
    var _this2 = this;

    var labelIds = [];

    this.getElement('.selected_issue:checked').each(function (i, el) {
      labelIds.push(_this2.getElement('#' + _this2.prefixId + el.dataset.id).data('labels'));
    });
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds);
  },


  // From issuable's initial bulk selection
  getOriginalMarkedIds: function getOriginalMarkedIds() {
    var _this3 = this;

    var labelIds = [];
    this.getElement('.selected_issue:checked').each(function (i, el) {
      labelIds.push(_this3.getElement('#' + _this3.prefixId + el.dataset.id).data('labels'));
    });
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds);
  },


  // From issuable's initial bulk selection
  getOriginalIndeterminateIds: function getOriginalIndeterminateIds() {
    var _this4 = this;

    var uniqueIds = [];
    var labelIds = [];
    var issuableLabels = [];

    // Collect unique label IDs for all checked issues
    this.getElement('.selected_issue:checked').each(function (i, el) {
      issuableLabels = _this4.getElement('#' + _this4.prefixId + el.dataset.id).data('labels');
      issuableLabels.forEach(function (labelId) {
        // Store unique IDs
        if (uniqueIds.indexOf(labelId) === -1) {
          uniqueIds.push(labelId);
        }
      });
      // Store array of IDs per issuable
      labelIds.push(issuableLabels);
    });
    // Add uniqueIds to add it as argument for _.intersection
    labelIds.unshift(uniqueIds);
    // Return IDs that are present but not in all selected issueables
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.difference(uniqueIds, __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection.apply(this, labelIds));
  },
  getElement: function getElement(selector) {
    this.scopeEl = this.scopeEl || $('.content');
    return this.scopeEl.find(selector);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issuable_context.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints__ = __webpack_require__("./breakpoints.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_select__ = __webpack_require__("./users_select.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var IssuableContext = function IssuableContext(currentUser) {
  _classCallCheck(this, IssuableContext);

  this.userSelect = new __WEBPACK_IMPORTED_MODULE_2__users_select__["a" /* default */](currentUser);

  $('select.select2').select2({
    width: 'resolve',
    dropdownAutoWidth: true
  });

  $('.issuable-sidebar .inline-update').on('change', 'select', function onClickSelect() {
    return $(this).submit();
  });
  $('.issuable-sidebar .inline-update').on('change', '.js-assignee', function onClickAssignee() {
    return $(this).submit();
  });
  $(document).off('click', '.issuable-sidebar .dropdown-content a').on('click', '.issuable-sidebar .dropdown-content a', function (e) {
    return e.preventDefault();
  });

  $(document).off('click', '.edit-link').on('click', '.edit-link', function onClickEdit(e) {
    e.preventDefault();
    var $block = $(this).parents('.block');
    var $selectbox = $block.find('.selectbox');
    if ($selectbox.is(':visible')) {
      $selectbox.hide();
      $block.find('.value').show();
    } else {
      $selectbox.show();
      $block.find('.value').hide();
    }

    if ($selectbox.is(':visible')) {
      setTimeout(function () {
        return $block.find('.dropdown-menu-toggle').trigger('click');
      }, 0);
    }
  });

  window.addEventListener('beforeunload', function () {
    // collapsed_gutter cookie hides the sidebar
    var bpBreakpoint = __WEBPACK_IMPORTED_MODULE_1__breakpoints__["a" /* default */].getBreakpointSize();
    if (bpBreakpoint === 'xs' || bpBreakpoint === 'sm') {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('collapsed_gutter', true);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (IssuableContext);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./labels_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__ = __webpack_require__("./issuable_bulk_update_actions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filtered_search_dropdown_utils__ = __webpack_require__("./filtered_search/dropdown_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__create_label__ = __webpack_require__("./create_label.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flash__ = __webpack_require__("./flash.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-useless-return, func-names, space-before-function-paren, wrap-iife, no-var, no-underscore-dangle, prefer-arrow-callback, max-len, one-var, no-unused-vars, one-var-declaration-per-line, prefer-template, no-new, consistent-return, object-shorthand, comma-dangle, no-shadow, no-param-reassign, brace-style, vars-on-top, quotes, no-lonely-if, no-else-return, dot-notation, no-empty, no-return-assign, camelcase, prefer-spread */
/* global Issuable */
/* global ListLabel */








var LabelsSelect = function () {
  function LabelsSelect(els) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, LabelsSelect);

    var _this, $els;
    _this = this;

    $els = $(els);

    if (!els) {
      $els = $('.js-label-select');
    }

    $els.each(function (i, dropdown) {
      var $block, $colorPreview, $dropdown, $form, $loading, $selectbox, $sidebarCollapsedValue, $value, abilityName, defaultLabel, enableLabelCreateButton, issueURLSplit, issueUpdateURL, labelUrl, namespacePath, projectPath, saveLabelData, selectedLabel, showAny, showNo, $sidebarLabelTooltip, initialSelected, $toggleText, fieldName, useId, propertyName, showMenuAbove, $container, $dropdownContainer;
      $dropdown = $(dropdown);
      $dropdownContainer = $dropdown.closest('.labels-filter');
      $toggleText = $dropdown.find('.dropdown-toggle-text');
      namespacePath = $dropdown.data('namespacePath');
      projectPath = $dropdown.data('projectPath');
      labelUrl = $dropdown.data('labels');
      issueUpdateURL = $dropdown.data('issueUpdate');
      selectedLabel = $dropdown.data('selected');
      if (selectedLabel != null && !$dropdown.hasClass('js-multiselect')) {
        selectedLabel = selectedLabel.split(',');
      }
      showNo = $dropdown.data('showNo');
      showAny = $dropdown.data('showAny');
      showMenuAbove = $dropdown.data('showMenuAbove');
      defaultLabel = $dropdown.data('defaultLabel');
      abilityName = $dropdown.data('abilityName');
      $selectbox = $dropdown.closest('.selectbox');
      $block = $selectbox.closest('.block');
      $form = $dropdown.closest('form, .js-issuable-update');
      $sidebarCollapsedValue = $block.find('.sidebar-collapsed-icon span');
      $sidebarLabelTooltip = $block.find('.js-sidebar-labels-tooltip');
      $value = $block.find('.value');
      $loading = $block.find('.block-loading').fadeOut();
      fieldName = $dropdown.data('fieldName');
      useId = $dropdown.is('.js-issuable-form-dropdown, .js-filter-bulk-update, .js-label-sidebar-dropdown');
      propertyName = useId ? 'id' : 'title';
      initialSelected = $selectbox.find('input[name="' + $dropdown.data('fieldName') + '"]').map(function () {
        return this.value;
      }).get();
      var handleClick = options.handleClick;

      $sidebarLabelTooltip.tooltip();

      if ($dropdown.closest('.dropdown').find('.dropdown-new-label').length) {
        new __WEBPACK_IMPORTED_MODULE_5__create_label__["a" /* default */]($dropdown.closest('.dropdown').find('.dropdown-new-label'), namespacePath, projectPath);
      }

      saveLabelData = function saveLabelData() {
        var data, selected;
        selected = $dropdown.closest('.selectbox').find("input[name='" + fieldName + "']").map(function () {
          return this.value;
        }).get();

        if (__WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isEqual(initialSelected, selected)) return;
        initialSelected = selected;

        data = {};
        data[abilityName] = {};
        data[abilityName].label_ids = selected;
        if (!selected.length) {
          data[abilityName].label_ids = [''];
        }
        $loading.removeClass('hidden').fadeIn();
        $dropdown.trigger('loading.gl.dropdown');
        __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].put(issueUpdateURL, data).then(function (_ref) {
          var data = _ref.data;

          var labelCount, template, labelTooltipTitle, labelTitles;
          $loading.fadeOut();
          $dropdown.trigger('loaded.gl.dropdown');
          $selectbox.hide();
          data.issueUpdateURL = issueUpdateURL;
          labelCount = 0;
          if (data.labels.length && issueUpdateURL) {
            template = LabelsSelect.getLabelTemplate({
              labels: data.labels,
              issueUpdateURL: issueUpdateURL
            });
            labelCount = data.labels.length;
          } else {
            template = '<span class="no-value">None</span>';
          }
          $value.removeAttr('style').html(template);
          $sidebarCollapsedValue.text(labelCount);

          if (data.labels.length) {
            labelTitles = data.labels.map(function (label) {
              return label.title;
            });

            if (labelTitles.length > 5) {
              labelTitles = labelTitles.slice(0, 5);
              labelTitles.push('and ' + (data.labels.length - 5) + ' more');
            }

            labelTooltipTitle = labelTitles.join(', ');
          } else {
            labelTooltipTitle = '';
            $sidebarLabelTooltip.tooltip('destroy');
          }

          $sidebarLabelTooltip.attr('title', labelTooltipTitle).tooltip('fixTitle');

          $('.has-tooltip', $value).tooltip({
            container: 'body'
          });
        }).catch(function () {
          return Object(__WEBPACK_IMPORTED_MODULE_6__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('Error saving label update.'));
        });
      };
      $dropdown.glDropdown({
        showMenuAbove: showMenuAbove,
        data: function data(term, callback) {
          __WEBPACK_IMPORTED_MODULE_2__lib_utils_axios_utils__["a" /* default */].get(labelUrl).then(function (res) {
            var data = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.chain(res.data).groupBy(function (label) {
              return label.title;
            }).map(function (label) {
              var color;
              color = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.map(label, function (dup) {
                return dup.color;
              });
              return {
                id: label[0].id,
                title: label[0].title,
                color: color,
                duplicate: color.length > 1
              };
            }).value();
            if ($dropdown.hasClass('js-extra-options')) {
              var extraData = [];
              if (showNo) {
                extraData.unshift({
                  id: 0,
                  title: 'No Label'
                });
              }
              if (showAny) {
                extraData.unshift({
                  isAny: true,
                  title: 'Any Label'
                });
              }
              if (extraData.length) {
                extraData.push('divider');
                data = extraData.concat(data);
              }
            }

            callback(data);
            if (showMenuAbove) {
              $dropdown.data('glDropdown').positionMenuAbove();
            }
          }).catch(function () {
            return Object(__WEBPACK_IMPORTED_MODULE_6__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('Error fetching labels.'));
          });
        },
        renderRow: function renderRow(label, instance) {
          var $a, $li, color, colorEl, indeterminate, removesAll, selectedClass, spacing, i, marked, dropdownName, dropdownValue;
          $li = $('<li>');
          $a = $('<a href="#">');
          selectedClass = [];
          removesAll = label.id <= 0 || label.id == null;
          if ($dropdown.hasClass('js-filter-bulk-update')) {
            indeterminate = $dropdown.data('indeterminate') || [];
            marked = $dropdown.data('marked') || [];

            if (indeterminate.indexOf(label.id) !== -1) {
              selectedClass.push('is-indeterminate');
            }

            if (marked.indexOf(label.id) !== -1) {
              // Remove is-indeterminate class if the item will be marked as active
              i = selectedClass.indexOf('is-indeterminate');
              if (i !== -1) {
                selectedClass.splice(i, 1);
              }
              selectedClass.push('is-active');
            }
          } else {
            if (this.id(label)) {
              dropdownName = $dropdown.data('fieldName');
              dropdownValue = this.id(label).toString().replace(/'/g, '\\\'');

              if ($form.find("input[type='hidden'][name='" + dropdownName + "'][value='" + dropdownValue + "']").length) {
                selectedClass.push('is-active');
              }
            }

            if ($dropdown.hasClass('js-multiselect') && removesAll) {
              selectedClass.push('dropdown-clear-active');
            }
          }
          if (label.duplicate) {
            color = __WEBPACK_IMPORTED_MODULE_4__filtered_search_dropdown_utils__["a" /* default */].duplicateLabelColor(label.color);
          } else {
            if (label.color != null) {
              color = label.color[0];
            }
          }
          if (color) {
            colorEl = "<span class='dropdown-label-box' style='background: " + color + "'></span>";
          } else {
            colorEl = '';
          }
          // We need to identify which items are actually labels
          if (label.id) {
            selectedClass.push('label-item');
            $a.attr('data-label-id', label.id);
          }
          $a.addClass(selectedClass.join(' ')).html(colorEl + ' ' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(label.title));
          // Return generated html
          return $li.html($a).prop('outerHTML');
        },
        search: {
          fields: ['title']
        },
        selectable: true,
        filterable: true,
        selected: $dropdown.data('selected') || [],
        toggleLabel: function toggleLabel(selected, el) {
          var $dropdownParent = $dropdown.parent();
          var $dropdownInputField = $dropdownParent.find('.dropdown-input-field');
          var isSelected = el !== null ? el.hasClass('is-active') : false;
          var title = selected.title;
          var selectedLabels = this.selected;

          if ($dropdownInputField.length && $dropdownInputField.val().length) {
            $dropdownParent.find('.dropdown-input-clear').trigger('click');
          }

          if (selected.id === 0) {
            this.selected = [];
            return 'No Label';
          } else if (isSelected) {
            this.selected.push(title);
          } else {
            var index = this.selected.indexOf(title);
            this.selected.splice(index, 1);
          }

          if (selectedLabels.length === 1) {
            return selectedLabels;
          } else if (selectedLabels.length) {
            return selectedLabels[0] + " +" + (selectedLabels.length - 1) + " more";
          } else {
            return defaultLabel;
          }
        },
        fieldName: $dropdown.data('fieldName'),
        id: function id(label) {
          if (label.id <= 0) return label.title;

          if ($dropdown.hasClass('js-issuable-form-dropdown')) {
            return label.id;
          }

          if ($dropdown.hasClass("js-filter-submit") && label.isAny == null) {
            return label.title;
          } else {
            return label.id;
          }
        },
        hidden: function hidden() {
          var isIssueIndex, isMRIndex, page, selectedLabels;
          page = $('body').attr('data-page');
          isIssueIndex = page === 'projects:issues:index';
          isMRIndex = page === 'projects:merge_requests:index';
          $selectbox.hide();
          // display:block overrides the hide-collapse rule
          $value.removeAttr('style');

          if ($dropdown.hasClass('js-issuable-form-dropdown')) {
            return;
          }

          if ($('html').hasClass('issue-boards-page')) {
            return;
          }
          if ($dropdown.hasClass('js-multiselect')) {
            if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
              selectedLabels = $dropdown.closest('form').find("input:hidden[name='" + $dropdown.data('fieldName') + "']");
              Issuable.filterResults($dropdown.closest('form'));
            } else if ($dropdown.hasClass('js-filter-submit')) {
              $dropdown.closest('form').submit();
            } else {
              if (!$dropdown.hasClass('js-filter-bulk-update')) {
                saveLabelData();
              }
            }
          }
        },
        multiSelect: $dropdown.hasClass('js-multiselect'),
        vue: $dropdown.hasClass('js-issue-board-sidebar'),
        clicked: function clicked(clickEvent) {
          var $el = clickEvent.$el,
              e = clickEvent.e,
              isMarking = clickEvent.isMarking;

          var label = clickEvent.selectedObj;

          var isIssueIndex, isMRIndex, page, boardsModel;
          var fadeOutLoader = function fadeOutLoader() {
            $loading.fadeOut();
          };

          page = $('body').attr('data-page');
          isIssueIndex = page === 'projects:issues:index';
          isMRIndex = page === 'projects:merge_requests:index';

          if ($dropdown.parent().find('.is-active:not(.dropdown-clear-active)').length) {
            $dropdown.parent().find('.dropdown-clear-active').removeClass('is-active');
          }

          if ($dropdown.hasClass('js-issuable-form-dropdown')) {
            return;
          }

          if ($dropdown.hasClass('js-filter-bulk-update')) {
            _this.enableBulkLabelDropdown();
            _this.setDropdownData($dropdown, isMarking, label.id);
            return;
          }

          if ($dropdown.closest('.add-issues-modal').length) {
            boardsModel = gl.issueBoards.ModalStore.store.filter;
          }

          if (boardsModel) {
            if (label.isAny) {
              boardsModel['label_name'] = [];
            } else if ($el.hasClass('is-active')) {
              boardsModel['label_name'].push(label.title);
            }

            e.preventDefault();
            return;
          } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
            if (!$dropdown.hasClass('js-multiselect')) {
              selectedLabel = label.title;
              return Issuable.filterResults($dropdown.closest('form'));
            }
          } else if ($dropdown.hasClass('js-filter-submit')) {
            return $dropdown.closest('form').submit();
          } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
            if ($el.hasClass('is-active')) {
              gl.issueBoards.BoardsStore.detail.issue.labels.push(new ListLabel({
                id: label.id,
                title: label.title,
                color: label.color[0],
                textColor: '#fff'
              }));
            } else {
              var labels = gl.issueBoards.BoardsStore.detail.issue.labels;
              labels = labels.filter(function (selectedLabel) {
                return selectedLabel.id !== label.id;
              });
              gl.issueBoards.BoardsStore.detail.issue.labels = labels;
            }

            $loading.fadeIn();

            gl.issueBoards.BoardsStore.detail.issue.update($dropdown.attr('data-issue-update')).then(fadeOutLoader).catch(fadeOutLoader);
          } else if (handleClick) {
            e.preventDefault();
            handleClick(label);
          } else {
            if ($dropdown.hasClass('js-multiselect')) {} else {
              return saveLabelData();
            }
          }
        }
      });

      // Set dropdown data
      _this.setOriginalDropdownData($dropdownContainer, $dropdown);
    });
    this.bindEvents();
  }

  _createClass(LabelsSelect, [{
    key: 'bindEvents',
    value: function bindEvents() {
      return $('body').on('change', '.selected_issue', this.onSelectCheckboxIssue);
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'onSelectCheckboxIssue',
    value: function onSelectCheckboxIssue() {
      if ($('.selected_issue:checked').length) {
        return;
      }
      return $('.issues-bulk-update .labels-filter .dropdown-toggle-text').text('Label');
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'enableBulkLabelDropdown',
    value: function enableBulkLabelDropdown() {
      __WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__["a" /* default */].willUpdateLabels = true;
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'setDropdownData',
    value: function setDropdownData($dropdown, isMarking, value) {
      var i, markedIds, unmarkedIds, indeterminateIds;

      markedIds = $dropdown.data('marked') || [];
      unmarkedIds = $dropdown.data('unmarked') || [];
      indeterminateIds = $dropdown.data('indeterminate') || [];

      if (isMarking) {
        markedIds.push(value);

        i = indeterminateIds.indexOf(value);
        if (i > -1) {
          indeterminateIds.splice(i, 1);
        }

        i = unmarkedIds.indexOf(value);
        if (i > -1) {
          unmarkedIds.splice(i, 1);
        }
      } else {
        // If marked item (not common) is unmarked
        i = markedIds.indexOf(value);
        if (i > -1) {
          markedIds.splice(i, 1);
        }

        // If an indeterminate item is being unmarked
        if (__WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__["a" /* default */].getOriginalIndeterminateIds().indexOf(value) > -1) {
          unmarkedIds.push(value);
        }

        // If a marked item is being unmarked
        // (a marked item could also be a label that is present in all selection)
        if (__WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_actions__["a" /* default */].getOriginalCommonIds().indexOf(value) > -1) {
          unmarkedIds.push(value);
        }
      }

      $dropdown.data('marked', markedIds);
      $dropdown.data('unmarked', unmarkedIds);
      $dropdown.data('indeterminate', indeterminateIds);
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'setOriginalDropdownData',
    value: function setOriginalDropdownData($container, $dropdown) {
      var labels = [];
      $container.find('[name="label_name[]"]').map(function () {
        return labels.push(this.value);
      });
      $dropdown.data('marked', labels);
    }
  }], [{
    key: 'getLabelTemplate',
    value: function getLabelTemplate(tplData) {
      // We could use ES6 template string here
      // and properly indent markup for readability
      // but that also introduces unintended white-space
      // so best approach is to use traditional way of
      // concatenation
      // see: http://2ality.com/2016/05/template-literal-whitespace.html#joining-arrays
      var tpl = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template(['<% _.each(labels, function(label){ %>', '<a href="<%- issueUpdateURL.slice(0, issueUpdateURL.lastIndexOf("/")) %>?label_name[]=<%- encodeURIComponent(label.title) %>">', '<span class="label has-tooltip color-label" title="<%- label.description %>" style="background-color: <%- label.color %>; color: <%- label.text_color %>;">', '<%- label.title %>', '</span>', '</a>', '<% }); %>'].join(''));

      return tpl(tplData);
    }
  }]);

  return LabelsSelect;
}();

/* harmony default export */ __webpack_exports__["a"] = (LabelsSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./lib/utils/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BYTES_IN_KIB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIDDEN_CLASS; });
var BYTES_IN_KIB = 1024;
var HIDDEN_CLASS = 'hidden';

/***/ }),

/***/ "./lib/utils/datefix.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pad */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parsePikadayDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pikadayToString; });

var pad = function pad(val) {
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return ('0' + val).slice(-len);
};

/**
 * Formats dates in Pickaday
 * @param {String} dateString Date in yyyy-mm-dd format
 * @return {Date} UTC format
 */
var parsePikadayDate = function parsePikadayDate(dateString) {
  var parts = dateString.split('-');
  var year = parseInt(parts[0], 10);
  var month = parseInt(parts[1] - 1, 10);
  var day = parseInt(parts[2], 10);

  return new Date(year, month, day);
};

/**
 * Used `onSelect` method in pickaday
 * @param {Date} date UTC format
 * @return {String} Date formated in yyyy-mm-dd
 */
var pikadayToString = function pikadayToString(date) {
  var day = pad(date.getDate());
  var month = pad(date.getMonth() + 1);
  var year = date.getFullYear();

  return year + '-' + month + '-' + day;
};

/***/ }),

/***/ "./lib/utils/http_status.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * exports HTTP status codes
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  ABORTED: 0,
  NO_CONTENT: 204,
  OK: 200,
  MULTIPLE_CHOICES: 300,
  BAD_REQUEST: 400,
  NOT_FOUND: 404
});

/***/ }),

/***/ "./lib/utils/image_utility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isImageLoaded;
/* eslint-disable import/prefer-default-export */

function isImageLoaded(element) {
  return element.complete && element.naturalHeight !== 0;
}

/***/ }),

/***/ "./lib/utils/number_utils.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = formatRelevantDigits;
/* unused harmony export bytesToKiB */
/* harmony export (immutable) */ __webpack_exports__["a"] = bytesToMiB;
/* unused harmony export bytesToGiB */
/* harmony export (immutable) */ __webpack_exports__["c"] = numberToHumanSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("./lib/utils/constants.js");


/**
 * Function that allows a number with an X amount of decimals
 * to be formatted in the following fashion:
 * * For 1 digit to the left of the decimal point and X digits to the right of it
 * * * Show 3 digits to the right
 * * For 2 digits to the left of the decimal point and X digits to the right of it
 * * * Show 2 digits to the right
*/
function formatRelevantDigits(number) {
  var digitsLeft = '';
  var relevantDigits = 0;
  var formattedNumber = '';
  if (!isNaN(Number(number))) {
    digitsLeft = number.toString().split('.')[0];
    switch (digitsLeft.length) {
      case 1:
        relevantDigits = 3;
        break;
      case 2:
        relevantDigits = 2;
        break;
      case 3:
        relevantDigits = 1;
        break;
      default:
        relevantDigits = 4;
        break;
    }
    formattedNumber = Number(number).toFixed(relevantDigits);
  }
  return formattedNumber;
}

/**
 * Utility function that calculates KiB of the given bytes.
 *
 * @param  {Number} number bytes
 * @return {Number}        KiB
 */
function bytesToKiB(number) {
  return number / __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */];
}

/**
 * Utility function that calculates MiB of the given bytes.
 *
 * @param  {Number} number bytes
 * @return {Number}        MiB
 */
function bytesToMiB(number) {
  return number / (__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]);
}

/**
 * Utility function that calculates GiB of the given bytes.
 * @param {Number} number
 * @returns {Number}
 */
function bytesToGiB(number) {
  return number / (__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]);
}

/**
 * Port of rails number_to_human_size
 * Formats the bytes in number into a more understandable
 * representation (e.g., giving it 1500 yields 1.5 KB).
 *
 * @param {Number} size
 * @returns {String}
 */
function numberToHumanSize(size) {
  if (size < __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]) {
    return size + ' bytes';
  } else if (size < __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]) {
    return bytesToKiB(size).toFixed(2) + ' KiB';
  } else if (size < __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */] * __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */]) {
    return bytesToMiB(size).toFixed(2) + ' MiB';
  }
  return bytesToGiB(size).toFixed(2) + ' GiB';
}

/***/ }),

/***/ "./lib/utils/poll.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_status__ = __webpack_require__("./lib/utils/http_status.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




/**
 * Polling utility for handling realtime updates.
 * Requirements: Promise based HTTP client
 *
 * Service for promise based http client and method need to be provided as props
 *
 * @example
 * new Poll({
 *   resource: resource,
 *   method: 'name',
 *   data: {page: 1, scope: 'all'}, // optional
 *   successCallback: () => {},
 *   errorCallback: () => {},
 *   notificationCallback: () => {}, // optional
 * }).makeRequest();
 *
 * Usage in pipelines table with visibility lib:
 *
 * const poll = new Poll({
 *  resource: this.service,
 *  method: 'getPipelines',
 *  data: { page: pageNumber, scope },
 *  successCallback: this.successCallback,
 *  errorCallback: this.errorCallback,
 *  notificationCallback: this.updateLoading,
 * });
 *
 * if (!Visibility.hidden()) {
 *  poll.makeRequest();
 *  }
 *
 * Visibility.change(() => {
 *  if (!Visibility.hidden()) {
 *   poll.restart();
 *  } else {
 *   poll.stop();
 *  }
* });
 *
 * 1. Checks for response and headers before start polling
 * 2. Interval is provided by `Poll-Interval` header.
 * 3. If `Poll-Interval` is -1, we stop polling
 * 4. If HTTP response is 200, we poll.
 * 5. If HTTP response is different from 200, we stop polling.
 *
 */

var Poll = function () {
  function Poll() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Poll);

    this.options = options;
    this.options.data = options.data || {};
    this.options.notificationCallback = options.notificationCallback || function notificationCallback() {};

    this.intervalHeader = 'POLL-INTERVAL';
    this.timeoutID = null;
    this.canPoll = true;
  }

  _createClass(Poll, [{
    key: 'checkConditions',
    value: function checkConditions(response) {
      var _this = this;

      var headers = Object(__WEBPACK_IMPORTED_MODULE_1__common_utils__["x" /* normalizeHeaders */])(response.headers);
      var pollInterval = parseInt(headers[this.intervalHeader], 10);
      if (pollInterval > 0 && response.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].OK && this.canPoll) {
        this.timeoutID = setTimeout(function () {
          _this.makeRequest();
        }, pollInterval);
      }
      this.options.successCallback(response);
    }
  }, {
    key: 'makeRequest',
    value: function makeRequest() {
      var _this2 = this;

      var _options = this.options,
          resource = _options.resource,
          method = _options.method,
          data = _options.data,
          errorCallback = _options.errorCallback,
          notificationCallback = _options.notificationCallback;

      // It's called everytime a new request is made. Useful to update the status.

      notificationCallback(true);

      return resource[method](data).then(function (response) {
        _this2.checkConditions(response);
        notificationCallback(false);
      }).catch(function (error) {
        notificationCallback(false);
        if (error.status === __WEBPACK_IMPORTED_MODULE_0__http_status__["a" /* default */].ABORTED) {
          return;
        }
        errorCallback(error);
      });
    }

    /**
     * Stops the polling recursive chain
     * and guarantees if the timeout is already running it won't make another request by
     * cancelling the previously established timeout.
     */

  }, {
    key: 'stop',
    value: function stop() {
      this.canPoll = false;
      clearTimeout(this.timeoutID);
    }

    /**
     * Restarts polling after it has been stoped
     */

  }, {
    key: 'restart',
    value: function restart(options) {
      // update data
      if (options && options.data) {
        this.options.data = options.data;
      }

      this.canPoll = true;
      this.makeRequest();
    }
  }]);

  return Poll;
}();

/* harmony default export */ __webpack_exports__["a"] = (Poll);

/***/ }),

/***/ "./lib/utils/pretty_time.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSeconds;
/* harmony export (immutable) */ __webpack_exports__["c"] = stringifyTime;
/* harmony export (immutable) */ __webpack_exports__["a"] = abbreviateTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);


/*
 * TODO: Make these methods more configurable (e.g. stringifyTime condensed or
 * non-condensed, abbreviateTimelengths)
 * */

/*
 * Accepts seconds and returns a timeObject { weeks: #, days: #, hours: #, minutes: # }
 * Seconds can be negative or positive, zero or non-zero. Can be configured for any day
 * or week length.
*/

function parseSeconds(seconds) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$daysPerWeek = _ref.daysPerWeek,
      daysPerWeek = _ref$daysPerWeek === undefined ? 5 : _ref$daysPerWeek,
      _ref$hoursPerDay = _ref.hoursPerDay,
      hoursPerDay = _ref$hoursPerDay === undefined ? 8 : _ref$hoursPerDay;

  var DAYS_PER_WEEK = daysPerWeek;
  var HOURS_PER_DAY = hoursPerDay;
  var MINUTES_PER_HOUR = 60;
  var MINUTES_PER_WEEK = DAYS_PER_WEEK * HOURS_PER_DAY * MINUTES_PER_HOUR;
  var MINUTES_PER_DAY = HOURS_PER_DAY * MINUTES_PER_HOUR;

  var timePeriodConstraints = {
    weeks: MINUTES_PER_WEEK,
    days: MINUTES_PER_DAY,
    hours: MINUTES_PER_HOUR,
    minutes: 1
  };

  var unorderedMinutes = Math.abs(seconds / MINUTES_PER_HOUR);

  return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.mapObject(timePeriodConstraints, function (minutesPerPeriod) {
    var periodCount = Math.floor(unorderedMinutes / minutesPerPeriod);

    unorderedMinutes -= periodCount * minutesPerPeriod;

    return periodCount;
  });
}

/*
* Accepts a timeObject (see parseSeconds) and returns a condensed string representation of it
* (e.g. '1w 2d 3h 1m' or '1h 30m'). Zero value units are not included.
*/

function stringifyTime(timeObject) {
  var reducedTime = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.reduce(timeObject, function (memo, unitValue, unitName) {
    var isNonZero = !!unitValue;
    return isNonZero ? memo + ' ' + unitValue + unitName.charAt(0) : memo;
  }, '').trim();
  return reducedTime.length ? reducedTime : '0m';
}

/*
* Accepts a time string of any size (e.g. '1w 2d 3h 5m' or '1w 2d') and returns
*  the first non-zero unit/value pair.
*/

function abbreviateTime(timeStr) {
  return timeStr.split(' ').filter(function (unitStr) {
    return unitStr.charAt(0) !== '0';
  })[0];
}

/***/ }),

/***/ "./lib/utils/sticky.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createPlaceholder */
/* unused harmony export isSticky */
var createPlaceholder = function createPlaceholder() {
  var placeholder = document.createElement('div');
  placeholder.classList.add('sticky-placeholder');

  return placeholder;
};

var isSticky = function isSticky(el, scrollY, stickyTop, insertPlaceholder) {
  var top = Math.floor(el.offsetTop - scrollY);

  if (top <= stickyTop && !el.classList.contains('is-stuck')) {
    var placeholder = insertPlaceholder ? createPlaceholder() : null;
    var heightBefore = el.offsetHeight;

    el.classList.add('is-stuck');

    if (insertPlaceholder) {
      el.parentNode.insertBefore(placeholder, el.nextElementSibling);

      placeholder.style.height = heightBefore - el.offsetHeight + 'px';
    }
  } else if (top > stickyTop && el.classList.contains('is-stuck')) {
    el.classList.remove('is-stuck');

    if (insertPlaceholder && el.nextElementSibling && el.nextElementSibling.classList.contains('sticky-placeholder')) {
      el.nextElementSibling.remove();
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function (el, stickyTop) {
  var insertPlaceholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!el) return;

  if (typeof CSS === 'undefined' || !CSS.supports('(position: -webkit-sticky) or (position: sticky)')) return;

  document.addEventListener('scroll', function () {
    return isSticky(el, window.scrollY, stickyTop, insertPlaceholder);
  }, {
    passive: true
  });
});

/***/ }),

/***/ "./lib/utils/text_markdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable import/prefer-default-export, func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, quotes, one-var, one-var-declaration-per-line, operator-assignment, no-else-return, prefer-template, prefer-arrow-callback, no-empty, max-len, consistent-return, no-unused-vars, no-return-assign, max-len, vars-on-top */

var textUtils = {};

textUtils.selectedText = function (text, textarea) {
  return text.substring(textarea.selectionStart, textarea.selectionEnd);
};

textUtils.lineBefore = function (text, textarea) {
  var split;
  split = text.substring(0, textarea.selectionStart).trim().split('\n');
  return split[split.length - 1];
};

textUtils.lineAfter = function (text, textarea) {
  return text.substring(textarea.selectionEnd).trim().split('\n')[0];
};

textUtils.blockTagText = function (text, textArea, blockTag, selected) {
  var lineAfter, lineBefore;
  lineBefore = this.lineBefore(text, textArea);
  lineAfter = this.lineAfter(text, textArea);
  if (lineBefore === blockTag && lineAfter === blockTag) {
    // To remove the block tag we have to select the line before & after
    if (blockTag != null) {
      textArea.selectionStart = textArea.selectionStart - (blockTag.length + 1);
      textArea.selectionEnd = textArea.selectionEnd + (blockTag.length + 1);
    }
    return selected;
  } else {
    return blockTag + "\n" + selected + "\n" + blockTag;
  }
};

textUtils.insertText = function (textArea, text, tag, blockTag, selected, wrap) {
  var insertText, inserted, selectedSplit, startChar, removedLastNewLine, removedFirstNewLine, currentLineEmpty, lastNewLine;
  removedLastNewLine = false;
  removedFirstNewLine = false;
  currentLineEmpty = false;

  // Remove the first newline
  if (selected.indexOf('\n') === 0) {
    removedFirstNewLine = true;
    selected = selected.replace(/\n+/, '');
  }

  // Remove the last newline
  if (textArea.selectionEnd - textArea.selectionStart > selected.replace(/\n$/, '').length) {
    removedLastNewLine = true;
    selected = selected.replace(/\n$/, '');
  }

  selectedSplit = selected.split('\n');

  if (!wrap) {
    lastNewLine = textArea.value.substr(0, textArea.selectionStart).lastIndexOf('\n');

    // Check whether the current line is empty or consists only of spaces(=handle as empty)
    if (/^\s*$/.test(textArea.value.substring(lastNewLine, textArea.selectionStart))) {
      currentLineEmpty = true;
    }
  }

  startChar = !wrap && !currentLineEmpty && textArea.selectionStart > 0 ? '\n' : '';

  if (selectedSplit.length > 1 && (!wrap || blockTag != null && blockTag !== '')) {
    if (blockTag != null && blockTag !== '') {
      insertText = this.blockTagText(text, textArea, blockTag, selected);
    } else {
      insertText = selectedSplit.map(function (val) {
        if (val.indexOf(tag) === 0) {
          return "" + val.replace(tag, '');
        } else {
          return "" + tag + val;
        }
      }).join('\n');
    }
  } else {
    insertText = "" + startChar + tag + selected + (wrap ? tag : ' ');
  }

  if (removedFirstNewLine) {
    insertText = '\n' + insertText;
  }

  if (removedLastNewLine) {
    insertText += '\n';
  }

  if (document.queryCommandSupported('insertText')) {
    inserted = document.execCommand('insertText', false, insertText);
  }
  if (!inserted) {
    try {
      document.execCommand("ms-beginUndoUnit");
    } catch (error) {}
    textArea.value = this.replaceRange(text, textArea.selectionStart, textArea.selectionEnd, insertText);
    try {
      document.execCommand("ms-endUndoUnit");
    } catch (error) {}
  }
  return this.moveCursor(textArea, tag, wrap, removedLastNewLine);
};

textUtils.moveCursor = function (textArea, tag, wrapped, removedLastNewLine) {
  var pos;
  if (!textArea.setSelectionRange) {
    return;
  }
  if (textArea.selectionStart === textArea.selectionEnd) {
    if (wrapped) {
      pos = textArea.selectionStart - tag.length;
    } else {
      pos = textArea.selectionStart;
    }

    if (removedLastNewLine) {
      pos -= 1;
    }

    return textArea.setSelectionRange(pos, pos);
  }
};

textUtils.updateText = function (textArea, tag, blockTag, wrap) {
  var $textArea, selected, text;
  $textArea = $(textArea);
  textArea = $textArea.get(0);
  text = $textArea.val();
  selected = this.selectedText(text, textArea);
  $textArea.focus();
  return this.insertText(textArea, text, tag, blockTag, selected, wrap);
};

textUtils.init = function (form) {
  var self;
  self = this;
  return $('.js-md', form).off('click').on('click', function () {
    var $this;
    $this = $(this);
    return self.updateText($this.closest('.md-area').find('textarea'), $this.data('mdTag'), $this.data('mdBlock'), !$this.data('mdPrepend'));
  });
};

textUtils.removeListeners = function (form) {
  return $('.js-md', form).off('click');
};

textUtils.replaceRange = function (s, start, end, substitute) {
  return s.substring(0, start) + substitute + s.substring(end);
};

/* harmony default export */ __webpack_exports__["a"] = (textUtils);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./merge_request.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task_list__ = __webpack_require__("./task_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__merge_request_tabs__ = __webpack_require__("./merge_request_tabs.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_issuables_helper__ = __webpack_require__("./helpers/issuables_helper.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_text_utility__ = __webpack_require__("./lib/utils/text_utility.js");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, quotes, no-underscore-dangle, one-var, one-var-declaration-per-line, consistent-return, dot-notation, quote-props, comma-dangle, object-shorthand, max-len, prefer-arrow-callback */






function MergeRequest(opts) {
  // Initialize MergeRequest behavior
  //
  // Options:
  //   action - String, current controller action
  //
  this.opts = opts != null ? opts : {};
  this.submitNoteForm = this.submitNoteForm.bind(this);
  this.$el = $('.merge-request');
  this.$('.show-all-commits').on('click', function (_this) {
    return function () {
      return _this.showAllCommits();
    };
  }(this));

  this.initTabs();
  this.initMRBtnListeners();
  this.initCommitMessageListeners();
  this.closeReopenReportToggle = __WEBPACK_IMPORTED_MODULE_3__helpers_issuables_helper__["a" /* default */].initCloseReopenReport();

  if ($("a.btn-close").length) {
    this.taskList = new __WEBPACK_IMPORTED_MODULE_1__task_list__["a" /* default */]({
      dataType: 'merge_request',
      fieldName: 'description',
      selector: '.detail-page-description',
      onSuccess: function onSuccess(result) {
        document.querySelector('#task_status').innerText = result.task_status;
        document.querySelector('#task_status_short').innerText = result.task_status_short;
      }
    });
  }
}

// Local jQuery finder
MergeRequest.prototype.$ = function (selector) {
  return this.$el.find(selector);
};

MergeRequest.prototype.initTabs = function () {
  if (window.mrTabs) {
    window.mrTabs.unbindEvents();
  }
  window.mrTabs = new __WEBPACK_IMPORTED_MODULE_2__merge_request_tabs__["a" /* default */](this.opts);
};

MergeRequest.prototype.showAllCommits = function () {
  this.$('.first-commits').remove();
  return this.$('.all-commits').removeClass('hide');
};

MergeRequest.prototype.initMRBtnListeners = function () {
  var _this;
  _this = this;
  return $('a.btn-close, a.btn-reopen').on('click', function (e) {
    var $this, shouldSubmit;
    $this = $(this);
    shouldSubmit = $this.hasClass('btn-comment');
    if (shouldSubmit && $this.data('submitted')) {
      return;
    }

    if (this.closeReopenReportToggle) this.closeReopenReportToggle.setDisable();

    if (shouldSubmit) {
      if ($this.hasClass('btn-comment-and-close') || $this.hasClass('btn-comment-and-reopen')) {
        e.preventDefault();
        e.stopImmediatePropagation();

        _this.submitNoteForm($this.closest('form'), $this);
      }
    }
  });
};

MergeRequest.prototype.submitNoteForm = function (form, $button) {
  var noteText;
  noteText = form.find("textarea.js-note-text").val();
  if (noteText.trim().length > 0) {
    form.submit();
    $button.data('submitted', true);
    return $button.trigger('click');
  }
};

MergeRequest.prototype.initCommitMessageListeners = function () {
  $(document).on('click', 'a.js-with-description-link', function (e) {
    var textarea = $('textarea.js-commit-message');
    e.preventDefault();

    textarea.val(textarea.data('messageWithDescription'));
    $('.js-with-description-hint').hide();
    $('.js-without-description-hint').show();
  });

  $(document).on('click', 'a.js-without-description-link', function (e) {
    var textarea = $('textarea.js-commit-message');
    e.preventDefault();

    textarea.val(textarea.data('messageWithoutDescription'));
    $('.js-with-description-hint').show();
    $('.js-without-description-hint').hide();
  });
};

MergeRequest.setStatusBoxToMerged = function () {
  $('.detail-page-header .status-box').removeClass('status-box-open').addClass('status-box-mr-merged').find('span').text(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */])('Merged'));
};

MergeRequest.decreaseCounter = function () {
  var by = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  var $el = $('.js-merge-counter');
  var count = Math.max(parseInt($el.text().replace(/[^\d]/, ''), 10) - by, 0);

  $el.text(Object(__WEBPACK_IMPORTED_MODULE_4__lib_utils_text_utility__["a" /* addDelimiter */])(count));
};

MergeRequest.hideCloseButton = function () {
  var el = document.querySelector('.merge-request .js-issuable-actions');
  var closeDropdownItem = el.querySelector('li.close-item');
  if (closeDropdownItem) {
    closeDropdownItem.classList.add('hidden');
    // Selects the next dropdown item
    el.querySelector('li.report-item').click();
  } else {
    // No dropdown just hide the Close button
    el.querySelector('.btn-close').classList.add('hidden');
  }
  // Dropdown for mobile screen
  el.querySelector('li.js-close-item').classList.add('hidden');
};

/* harmony default export */ __webpack_exports__["a"] = (MergeRequest);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./merge_request_tabs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blob_blob_fork_suggestion__ = __webpack_require__("./blob/blob_fork_suggestion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__init_changes_dropdown__ = __webpack_require__("./init_changes_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__breakpoints__ = __webpack_require__("./breakpoints.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__image_diff_init_discussion_tab__ = __webpack_require__("./image_diff/init_discussion_tab.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__diff__ = __webpack_require__("./diff.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__syntax_highlight__ = __webpack_require__("./syntax_highlight.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__notes__ = __webpack_require__("./notes.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new, class-methods-use-this */















/* eslint-disable max-len */
// MergeRequestTabs
//
// Handles persisting and restoring the current tab selection and lazily-loading
// content on the MergeRequests#show page.
//
// ### Example Markup
//
//   <ul class="nav-links merge-request-tabs">
//     <li class="notes-tab active">
//       <a data-action="notes" data-target="#notes" data-toggle="tab" href="/foo/bar/merge_requests/1">
//         Discussion
//       </a>
//     </li>
//     <li class="commits-tab">
//       <a data-action="commits" data-target="#commits" data-toggle="tab" href="/foo/bar/merge_requests/1/commits">
//         Commits
//       </a>
//     </li>
//     <li class="diffs-tab">
//       <a data-action="diffs" data-target="#diffs" data-toggle="tab" href="/foo/bar/merge_requests/1/diffs">
//         Diffs
//       </a>
//     </li>
//   </ul>
//
//   <div class="tab-content">
//     <div class="notes tab-pane active" id="notes">
//       Notes Content
//     </div>
//     <div class="commits tab-pane" id="commits">
//       Commits Content
//     </div>
//     <div class="diffs tab-pane" id="diffs">
//       Diffs Content
//     </div>
//   </div>
//
//   <div class="mr-loading-status">
//     <div class="loading">
//       Loading Animation
//     </div>
//   </div>
//
/* eslint-enable max-len */

// Store the `location` object, allowing for easier stubbing in tests
var location = window.location;

var MergeRequestTabs = function () {
  function MergeRequestTabs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        action = _ref.action,
        setUrl = _ref.setUrl,
        stubLocation = _ref.stubLocation;

    _classCallCheck(this, MergeRequestTabs);

    var mergeRequestTabs = document.querySelector('.js-tabs-affix');
    var navbar = document.querySelector('.navbar-gitlab');
    var paddingTop = 16;

    this.diffsLoaded = false;
    this.pipelinesLoaded = false;
    this.commitsLoaded = false;
    this.fixedLayoutPref = null;

    this.setUrl = setUrl !== undefined ? setUrl : true;
    this.setCurrentAction = this.setCurrentAction.bind(this);
    this.tabShown = this.tabShown.bind(this);
    this.showTab = this.showTab.bind(this);
    this.stickyTop = navbar ? navbar.offsetHeight - paddingTop : 0;

    if (mergeRequestTabs) {
      this.stickyTop += mergeRequestTabs.offsetHeight;
    }

    if (stubLocation) {
      location = stubLocation;
    }

    this.bindEvents();
    this.activateTab(action);
    this.initAffix();
  }

  _createClass(MergeRequestTabs, [{
    key: 'bindEvents',
    value: function bindEvents() {
      $(document).on('shown.bs.tab', '.merge-request-tabs a[data-toggle="tab"]', this.tabShown).on('click', '.js-show-tab', this.showTab);

      $('.merge-request-tabs a[data-toggle="tab"]').on('click', this.clickTab);
    }

    // Used in tests

  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      $(document).off('shown.bs.tab', '.merge-request-tabs a[data-toggle="tab"]', this.tabShown).off('click', '.js-show-tab', this.showTab);

      $('.merge-request-tabs a[data-toggle="tab"]').off('click', this.clickTab);
    }
  }, {
    key: 'destroyPipelinesView',
    value: function destroyPipelinesView() {
      if (this.commitPipelinesTable) {
        this.commitPipelinesTable.$destroy();
        this.commitPipelinesTable = null;

        document.querySelector('#commit-pipeline-table-view').innerHTML = '';
      }
    }
  }, {
    key: 'showTab',
    value: function showTab(e) {
      e.preventDefault();
      this.activateTab($(e.target).data('action'));
    }
  }, {
    key: 'clickTab',
    value: function clickTab(e) {
      if (e.currentTarget && Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils_common_utils__["u" /* isMetaClick */])(e)) {
        var targetLink = e.currentTarget.getAttribute('href');
        e.stopImmediatePropagation();
        e.preventDefault();
        window.open(targetLink, '_blank');
      }
    }
  }, {
    key: 'tabShown',
    value: function tabShown(e) {
      var $target = $(e.target);
      var action = $target.data('action');

      if (action === 'commits') {
        this.loadCommits($target.attr('href'));
        this.expandView();
        this.resetViewContainer();
        this.destroyPipelinesView();
      } else if (this.isDiffAction(action)) {
        this.loadDiff($target.attr('href'));
        if (__WEBPACK_IMPORTED_MODULE_5__breakpoints__["a" /* default */].getBreakpointSize() !== 'lg') {
          this.shrinkView();
        }
        if (this.diffViewType() === 'parallel') {
          this.expandViewContainer();
        }
        this.destroyPipelinesView();
      } else if (action === 'pipelines') {
        this.resetViewContainer();
        this.mountPipelinesView();
      } else {
        if (__WEBPACK_IMPORTED_MODULE_5__breakpoints__["a" /* default */].getBreakpointSize() !== 'xs') {
          this.expandView();
        }
        this.resetViewContainer();
        this.destroyPipelinesView();

        Object(__WEBPACK_IMPORTED_MODULE_8__image_diff_init_discussion_tab__["a" /* default */])();
      }
      if (this.setUrl) {
        this.setCurrentAction(action);
      }
    }
  }, {
    key: 'scrollToElement',
    value: function scrollToElement(container) {
      if (location.hash) {
        var offset = 0 - ($('.navbar-gitlab').outerHeight() + $('.js-tabs-affix').outerHeight());
        var $el = $(container + ' ' + location.hash + ':not(.match)');
        if ($el.length) {
          $.scrollTo($el[0], { offset: offset });
        }
      }
    }

    // Activate a tab based on the current action

  }, {
    key: 'activateTab',
    value: function activateTab(action) {
      // important note: the .tab('show') method triggers 'shown.bs.tab' event itself
      $('.merge-request-tabs a[data-action=\'' + action + '\']').tab('show');
    }

    // Replaces the current Merge Request-specific action in the URL with a new one
    //
    // If the action is "notes", the URL is reset to the standard
    // `MergeRequests#show` route.
    //
    // Examples:
    //
    //   location.pathname # => "/namespace/project/merge_requests/1"
    //   setCurrentAction('diffs')
    //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
    //
    //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
    //   setCurrentAction('show')
    //   location.pathname # => "/namespace/project/merge_requests/1"
    //
    //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
    //   setCurrentAction('commits')
    //   location.pathname # => "/namespace/project/merge_requests/1/commits"
    //
    // Returns the new URL String

  }, {
    key: 'setCurrentAction',
    value: function setCurrentAction(action) {
      this.currentAction = action;

      // Remove a trailing '/commits' '/diffs' '/pipelines'
      var newState = location.pathname.replace(/\/(commits|diffs|pipelines)(\.html)?\/?$/, '');

      // Append the new action if we're on a tab other than 'notes'
      if (this.currentAction !== 'show' && this.currentAction !== 'new') {
        newState += '/' + this.currentAction;
      }

      // Ensure parameters and hash come along for the ride
      newState += location.search + location.hash;

      // TODO: Consider refactoring in light of turbolinks removal.

      // Replace the current history state with the new one without breaking
      // Turbolinks' history.
      //
      // See https://github.com/rails/turbolinks/issues/363
      window.history.replaceState({
        url: newState
      }, document.title, newState);

      return newState;
    }
  }, {
    key: 'getCurrentAction',
    value: function getCurrentAction() {
      return this.currentAction;
    }
  }, {
    key: 'loadCommits',
    value: function loadCommits(source) {
      var _this = this;

      if (this.commitsLoaded) {
        return;
      }

      this.toggleLoading(true);

      __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(source + '.json').then(function (_ref2) {
        var data = _ref2.data;

        document.querySelector('div#commits').innerHTML = data.html;
        Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils_datetime_utility__["h" /* localTimeAgo */])($('.js-timeago', 'div#commits'));
        _this.commitsLoaded = true;
        _this.scrollToElement('#commits');

        _this.toggleLoading(false);
      }).catch(function () {
        _this.toggleLoading(false);
        Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])('An error occurred while fetching this tab.');
      });
    }
  }, {
    key: 'mountPipelinesView',
    value: function mountPipelinesView() {
      var pipelineTableViewEl = document.querySelector('#commit-pipeline-table-view');
      var CommitPipelinesTable = gl.CommitPipelinesTable;
      this.commitPipelinesTable = new CommitPipelinesTable({
        propsData: {
          endpoint: pipelineTableViewEl.dataset.endpoint,
          helpPagePath: pipelineTableViewEl.dataset.helpPagePath,
          emptyStateSvgPath: pipelineTableViewEl.dataset.emptyStateSvgPath,
          errorStateSvgPath: pipelineTableViewEl.dataset.errorStateSvgPath,
          autoDevopsHelpPath: pipelineTableViewEl.dataset.helpAutoDevopsPath
        }
      }).$mount();

      // $mount(el) replaces the el with the new rendered component. We need it in order to mount
      // it everytime this tab is clicked - https://vuejs.org/v2/api/#vm-mount
      pipelineTableViewEl.appendChild(this.commitPipelinesTable.$el);
    }
  }, {
    key: 'loadDiff',
    value: function loadDiff(source) {
      var _this2 = this;

      if (this.diffsLoaded) {
        document.dispatchEvent(new CustomEvent('scroll'));
        return;
      }

      // We extract pathname for the current Changes tab anchor href
      // some pages like MergeRequestsController#new has query parameters on that anchor
      var urlPathname = Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils_common_utils__["B" /* parseUrlPathname */])(source);

      this.toggleLoading(true);

      __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(urlPathname + '.json' + location.search).then(function (_ref3) {
        var data = _ref3.data;

        var $container = $('#diffs');
        $container.html(data.html);

        Object(__WEBPACK_IMPORTED_MODULE_4__init_changes_dropdown__["a" /* default */])(_this2.stickyTop);

        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }

        Object(__WEBPACK_IMPORTED_MODULE_10__lib_utils_datetime_utility__["h" /* localTimeAgo */])($('.js-timeago', 'div#diffs'));
        Object(__WEBPACK_IMPORTED_MODULE_11__syntax_highlight__["a" /* default */])($('#diffs .js-syntax-highlight'));

        if (_this2.diffViewType() === 'parallel' && _this2.isDiffAction(_this2.currentAction)) {
          _this2.expandViewContainer();
        }
        _this2.diffsLoaded = true;

        new __WEBPACK_IMPORTED_MODULE_9__diff__["a" /* default */]();
        _this2.scrollToElement('#diffs');

        $('.diff-file').each(function (i, el) {
          new __WEBPACK_IMPORTED_MODULE_3__blob_blob_fork_suggestion__["a" /* default */]({
            openButtons: $(el).find('.js-edit-blob-link-fork-toggler'),
            forkButtons: $(el).find('.js-fork-suggestion-button'),
            cancelButtons: $(el).find('.js-cancel-fork-suggestion-button'),
            suggestionSections: $(el).find('.js-file-fork-suggestion-section'),
            actionTextPieces: $(el).find('.js-file-fork-suggestion-section-action')
          }).init();
        });

        // Scroll any linked note into view
        // Similar to `toggler_behavior` in the discussion tab
        var hash = Object(__WEBPACK_IMPORTED_MODULE_7__lib_utils_url_utility__["a" /* getLocationHash */])();
        var anchor = hash && $container.find('.note[id="' + hash + '"]');
        if (anchor && anchor.length > 0) {
          var notesContent = anchor.closest('.notes_content');
          var lineType = notesContent.hasClass('new') ? 'new' : 'old';
          __WEBPACK_IMPORTED_MODULE_12__notes__["a" /* default */].instance.toggleDiffNote({
            target: anchor,
            lineType: lineType,
            forceShow: true
          });
          anchor[0].scrollIntoView();
          Object(__WEBPACK_IMPORTED_MODULE_6__lib_utils_common_utils__["m" /* handleLocationHash */])();
          // We have multiple elements on the page with `#note_xxx`
          // (discussion and diff tabs) and `:target` only applies to the first
          anchor.addClass('target');
        }

        _this2.toggleLoading(false);
      }).catch(function () {
        _this2.toggleLoading(false);
        Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])('An error occurred while fetching this tab.');
      });
    }

    // Show or hide the loading spinner
    //
    // status - Boolean, true to show, false to hide

  }, {
    key: 'toggleLoading',
    value: function toggleLoading(status) {
      $('.mr-loading-status .loading').toggle(status);
    }
  }, {
    key: 'diffViewType',
    value: function diffViewType() {
      return $('.inline-parallel-buttons a.active').data('viewType');
    }
  }, {
    key: 'isDiffAction',
    value: function isDiffAction(action) {
      return action === 'diffs' || action === 'new/diffs';
    }
  }, {
    key: 'expandViewContainer',
    value: function expandViewContainer() {
      var $wrapper = $('.content-wrapper .container-fluid').not('.breadcrumbs');
      if (this.fixedLayoutPref === null) {
        this.fixedLayoutPref = $wrapper.hasClass('container-limited');
      }
      $wrapper.removeClass('container-limited');
    }
  }, {
    key: 'resetViewContainer',
    value: function resetViewContainer() {
      if (this.fixedLayoutPref !== null) {
        $('.content-wrapper .container-fluid').toggleClass('container-limited', this.fixedLayoutPref);
      }
    }
  }, {
    key: 'shrinkView',
    value: function shrinkView() {
      var $gutterIcon = $('.js-sidebar-toggle i:visible');

      // Wait until listeners are set
      setTimeout(function () {
        // Only when sidebar is expanded
        if ($gutterIcon.is('.fa-angle-double-right')) {
          $gutterIcon.closest('a').trigger('click', [true]);
        }
      }, 0);
    }

    // Expand the issuable sidebar unless the user explicitly collapsed it

  }, {
    key: 'expandView',
    value: function expandView() {
      if (__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('collapsed_gutter') === 'true') {
        return;
      }
      var $gutterIcon = $('.js-sidebar-toggle i:visible');

      // Wait until listeners are set
      setTimeout(function () {
        // Only when sidebar is collapsed
        if ($gutterIcon.is('.fa-angle-double-left')) {
          $gutterIcon.closest('a').trigger('click', [true]);
        }
      }, 0);
    }
  }, {
    key: 'initAffix',
    value: function initAffix() {
      var $tabs = $('.js-tabs-affix');
      var $fixedNav = $('.navbar-gitlab');

      // Screen space on small screens is usually very sparse
      // So we dont affix the tabs on these
      if (__WEBPACK_IMPORTED_MODULE_5__breakpoints__["a" /* default */].getBreakpointSize() === 'xs' || !$tabs.length) return;

      /**
        If the browser does not support position sticky, it returns the position as static.
        If the browser does support sticky, then we allow the browser to handle it, if not
        then we default back to Bootstraps affix
      **/
      if ($tabs.css('position') !== 'static') return;

      var $diffTabs = $('#diff-notes-app');

      $tabs.off('affix.bs.affix affix-top.bs.affix').affix({
        offset: {
          top: function top() {
            return $diffTabs.offset().top - $tabs.height() - $fixedNav.height();
          }
        }
      }).on('affix.bs.affix', function () {
        return $diffTabs.css({ marginTop: $tabs.height() });
      }).on('affix-top.bs.affix', function () {
        return $diffTabs.css({ marginTop: '' });
      });

      // Fix bug when reloading the page already scrolling
      if ($tabs.hasClass('affix')) {
        $tabs.trigger('affix.bs.affix');
      }
    }
  }]);

  return MergeRequestTabs;
}();

/* harmony default export */ __webpack_exports__["a"] = (MergeRequestTabs);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./notes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("../../../node_modules/autosize/dist/autosize.js");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/vendor/assets/javascripts/jquery.caret.js
var jquery_caret = __webpack_require__("../../../vendor/assets/javascripts/jquery.caret.js");
var jquery_caret_default = /*#__PURE__*/__webpack_require__.n(jquery_caret);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/vendor/assets/javascripts/jquery.atwho.js
var jquery_atwho = __webpack_require__("../../../vendor/assets/javascripts/jquery.atwho.js");
var jquery_atwho_default = /*#__PURE__*/__webpack_require__.n(jquery_atwho);

// EXTERNAL MODULE: ./lib/utils/ajax_cache.js
var ajax_cache = __webpack_require__("./lib/utils/ajax_cache.js");

// EXTERNAL MODULE: ./lib/utils/axios_utils.js
var axios_utils = __webpack_require__("./lib/utils/axios_utils.js");

// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./droplab/drop_lab.js + 7 modules
var drop_lab = __webpack_require__("./droplab/drop_lab.js");

// EXTERNAL MODULE: ./droplab/plugins/input_setter.js
var input_setter = __webpack_require__("./droplab/plugins/input_setter.js");

// CONCATENATED MODULE: ./comment_type_toggle.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




// Todo: Remove this when fixing issue in input_setter plugin
var InputSetter = Object.assign({}, input_setter["a" /* default */]);

var comment_type_toggle_CommentTypeToggle = function () {
  function CommentTypeToggle() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CommentTypeToggle);

    this.dropdownTrigger = opts.dropdownTrigger;
    this.dropdownList = opts.dropdownList;
    this.noteTypeInput = opts.noteTypeInput;
    this.submitButton = opts.submitButton;
    this.closeButton = opts.closeButton;
    this.reopenButton = opts.reopenButton;
  }

  _createClass(CommentTypeToggle, [{
    key: 'initDroplab',
    value: function initDroplab() {
      this.droplab = new drop_lab["a" /* default */]();

      var config = this.setConfig();

      this.droplab.init(this.dropdownTrigger, this.dropdownList, [InputSetter], config);
    }
  }, {
    key: 'setConfig',
    value: function setConfig() {
      var config = {
        InputSetter: [{
          input: this.noteTypeInput,
          valueAttribute: 'data-value'
        }, {
          input: this.submitButton,
          valueAttribute: 'data-submit-text'
        }]
      };

      if (this.closeButton) {
        config.InputSetter.push({
          input: this.closeButton,
          valueAttribute: 'data-close-text'
        }, {
          input: this.closeButton,
          valueAttribute: 'data-close-text',
          inputAttribute: 'data-alternative-text'
        });
      }

      if (this.reopenButton) {
        config.InputSetter.push({
          input: this.reopenButton,
          valueAttribute: 'data-reopen-text'
        }, {
          input: this.reopenButton,
          valueAttribute: 'data-reopen-text',
          inputAttribute: 'data-alternative-text'
        });
      }

      return config;
    }
  }]);

  return CommentTypeToggle;
}();

/* harmony default export */ var comment_type_toggle = (comment_type_toggle_CommentTypeToggle);
// EXTERNAL MODULE: ./gl_form.js
var gl_form = __webpack_require__("./gl_form.js");

// EXTERNAL MODULE: ./awards_handler.js
var awards_handler = __webpack_require__("./awards_handler.js");

// EXTERNAL MODULE: ./autosave.js
var autosave = __webpack_require__("./autosave.js");

// EXTERNAL MODULE: ./task_list.js
var task_list = __webpack_require__("./task_list.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// EXTERNAL MODULE: ./image_diff/helpers/index.js + 6 modules
var helpers = __webpack_require__("./image_diff/helpers/index.js");

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// CONCATENATED MODULE: ./notes.js
var notes__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function notes__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-restricted-properties, func-names, space-before-function-paren,
no-var, prefer-rest-params, wrap-iife, no-use-before-define, camelcase,
no-unused-expressions, quotes, max-len, one-var, one-var-declaration-per-line,
default-case, prefer-template, consistent-return, no-alert, no-return-assign,
no-param-reassign, prefer-arrow-callback, no-else-return, comma-dangle, no-new,
brace-style, no-lonely-if, vars-on-top, no-unused-vars, no-sequences, no-shadow,
newline-per-chained-call, no-useless-escape, class-methods-use-this */

/* global ResolveService */
/* global mrRefreshWidgetUrl */





 // required by jquery.atwho














window.autosize = autosize_default.a;

function normalizeNewlines(str) {
  return str.replace(/\r\n/g, '\n');
}

var MAX_VISIBLE_COMMIT_LIST_COUNT = 3;
var REGEX_QUICK_ACTIONS = /^\/\w+.*$/gm;

var notes_Notes = function () {
  notes__createClass(Notes, null, [{
    key: 'initialize',
    value: function initialize(notes_url, note_ids, last_fetched_at, view) {
      var enableGFM = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

      if (!this.instance) {
        this.instance = new Notes(notes_url, note_ids, last_fetched_at, view, enableGFM);
      }
    }
  }, {
    key: 'getInstance',
    value: function getInstance() {
      return this.instance;
    }
  }]);

  function Notes(notes_url, note_ids, last_fetched_at, view) {
    var enableGFM = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    notes__classCallCheck(this, Notes);

    this.updateTargetButtons = this.updateTargetButtons.bind(this);
    this.updateComment = this.updateComment.bind(this);
    this.visibilityChange = this.visibilityChange.bind(this);
    this.cancelDiscussionForm = this.cancelDiscussionForm.bind(this);
    this.onAddDiffNote = this.onAddDiffNote.bind(this);
    this.onAddImageDiffNote = this.onAddImageDiffNote.bind(this);
    this.setupDiscussionNoteForm = this.setupDiscussionNoteForm.bind(this);
    this.onReplyToDiscussionNote = this.onReplyToDiscussionNote.bind(this);
    this.removeNote = this.removeNote.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.updateNote = this.updateNote.bind(this);
    this.addDiscussionNote = this.addDiscussionNote.bind(this);
    this.addNoteError = this.addNoteError.bind(this);
    this.addNote = this.addNote.bind(this);
    this.resetMainTargetForm = this.resetMainTargetForm.bind(this);
    this.refresh = this.refresh.bind(this);
    this.keydownNoteText = this.keydownNoteText.bind(this);
    this.toggleCommitList = this.toggleCommitList.bind(this);
    this.postComment = this.postComment.bind(this);
    this.clearFlashWrapper = this.clearFlash.bind(this);
    this.onHashChange = this.onHashChange.bind(this);

    this.notes_url = notes_url;
    this.note_ids = note_ids;
    this.enableGFM = enableGFM;
    // Used to keep track of updated notes while people are editing things
    this.updatedNotesTrackingMap = {};
    this.last_fetched_at = last_fetched_at;
    this.noteable_url = document.URL;
    this.notesCountBadge || (this.notesCountBadge = jquery_default()('.issuable-details').find('.notes-tab .badge'));
    this.basePollingInterval = 15000;
    this.maxPollingSteps = 4;

    this.$wrapperEl = Object(common_utils["n" /* hasVueMRDiscussionsCookie */])() ? jquery_default()(document).find('.diffs') : jquery_default()(document);
    this.cleanBinding();
    this.addBinding();
    this.setPollingInterval();
    this.setupMainTargetNoteForm();
    this.taskList = new task_list["a" /* default */]({
      dataType: 'note',
      fieldName: 'note',
      selector: '.notes'
    });
    this.collapseLongCommitList();
    this.setViewType(view);

    // We are in the Merge Requests page so we need another edit form for Changes tab
    if (Object(common_utils["h" /* getPagePath */])(1) === 'merge_requests') {
      jquery_default()('.note-edit-form').clone().addClass('mr-note-edit-form').insertAfter('.note-edit-form');
    }
  }

  notes__createClass(Notes, [{
    key: 'setViewType',
    value: function setViewType(view) {
      this.view = js_cookie_default.a.get('diff_view') || view;
    }
  }, {
    key: 'addBinding',
    value: function addBinding() {
      // Edit note link
      this.$wrapperEl.on('click', '.js-note-edit', this.showEditForm.bind(this));
      this.$wrapperEl.on('click', '.note-edit-cancel', this.cancelEdit);
      // Reopen and close actions for Issue/MR combined with note form submit
      this.$wrapperEl.on('click', '.js-comment-submit-button', this.postComment);
      this.$wrapperEl.on('click', '.js-comment-save-button', this.updateComment);
      this.$wrapperEl.on('keyup input', '.js-note-text', this.updateTargetButtons);
      // resolve a discussion
      this.$wrapperEl.on('click', '.js-comment-resolve-button', this.postComment);
      // remove a note (in general)
      this.$wrapperEl.on('click', '.js-note-delete', this.removeNote);
      // delete note attachment
      this.$wrapperEl.on('click', '.js-note-attachment-delete', this.removeAttachment);
      // reset main target form when clicking discard
      this.$wrapperEl.on('click', '.js-note-discard', this.resetMainTargetForm);
      // update the file name when an attachment is selected
      this.$wrapperEl.on('change', '.js-note-attachment-input', this.updateFormAttachment);
      // reply to diff/discussion notes
      this.$wrapperEl.on('click', '.js-discussion-reply-button', this.onReplyToDiscussionNote);
      // add diff note
      this.$wrapperEl.on('click', '.js-add-diff-note-button', this.onAddDiffNote);
      // add diff note for images
      this.$wrapperEl.on('click', '.js-add-image-diff-note-button', this.onAddImageDiffNote);
      // hide diff note form
      this.$wrapperEl.on('click', '.js-close-discussion-note-form', this.cancelDiscussionForm);
      // toggle commit list
      this.$wrapperEl.on('click', '.system-note-commit-list-toggler', this.toggleCommitList);
      // fetch notes when tab becomes visible
      this.$wrapperEl.on('visibilitychange', this.visibilityChange);
      // when issue status changes, we need to refresh data
      this.$wrapperEl.on('issuable:change', this.refresh);
      // ajax:events that happen on Form when actions like Reopen, Close are performed on Issues and MRs.
      this.$wrapperEl.on('ajax:success', '.js-main-target-form', this.addNote);
      this.$wrapperEl.on('ajax:success', '.js-discussion-note-form', this.addDiscussionNote);
      this.$wrapperEl.on('ajax:success', '.js-main-target-form', this.resetMainTargetForm);
      this.$wrapperEl.on('ajax:complete', '.js-main-target-form', this.reenableTargetFormSubmitButton);
      // when a key is clicked on the notes
      this.$wrapperEl.on('keydown', '.js-note-text', this.keydownNoteText);
      // When the URL fragment/hash has changed, `#note_xxx`
      jquery_default()(window).on('hashchange', this.onHashChange);
      this.boundGetContent = this.getContent.bind(this);
      document.addEventListener('refreshLegacyNotes', this.boundGetContent);
    }
  }, {
    key: 'cleanBinding',
    value: function cleanBinding() {
      this.$wrapperEl.off('click', '.js-note-edit');
      this.$wrapperEl.off('click', '.note-edit-cancel');
      this.$wrapperEl.off('click', '.js-note-delete');
      this.$wrapperEl.off('click', '.js-note-attachment-delete');
      this.$wrapperEl.off('click', '.js-discussion-reply-button');
      this.$wrapperEl.off('click', '.js-add-diff-note-button');
      this.$wrapperEl.off('click', '.js-add-image-diff-note-button');
      this.$wrapperEl.off('visibilitychange');
      this.$wrapperEl.off('keyup input', '.js-note-text');
      this.$wrapperEl.off('click', '.js-note-target-reopen');
      this.$wrapperEl.off('click', '.js-note-target-close');
      this.$wrapperEl.off('click', '.js-note-discard');
      this.$wrapperEl.off('keydown', '.js-note-text');
      this.$wrapperEl.off('click', '.js-comment-resolve-button');
      this.$wrapperEl.off('click', '.system-note-commit-list-toggler');
      this.$wrapperEl.off('ajax:success', '.js-main-target-form');
      this.$wrapperEl.off('ajax:success', '.js-discussion-note-form');
      this.$wrapperEl.off('ajax:complete', '.js-main-target-form');
      document.removeEventListener('refreshLegacyNotes', this.boundGetContent);
      jquery_default()(window).off('hashchange', this.onHashChange);
    }
  }, {
    key: 'keydownNoteText',
    value: function keydownNoteText(e) {
      var $textarea, discussionNoteForm, editNote, myLastNote, myLastNoteEditBtn, newText, originalText;
      if (Object(common_utils["v" /* isMetaKey */])(e)) {
        return;
      }

      $textarea = jquery_default()(e.target);
      // Edit previous note when UP arrow is hit
      switch (e.which) {
        case 38:
          if ($textarea.val() !== '') {
            return;
          }
          myLastNote = jquery_default()('li.note[data-author-id=\'' + gon.current_user_id + '\'][data-editable]:last', $textarea.closest('.note, .notes_holder, #notes'));
          if (myLastNote.length) {
            myLastNoteEditBtn = myLastNote.find('.js-note-edit');
            return myLastNoteEditBtn.trigger('click', [true, myLastNote]);
          }
          break;
        // Cancel creating diff note or editing any note when ESCAPE is hit
        case 27:
          discussionNoteForm = $textarea.closest('.js-discussion-note-form');
          if (discussionNoteForm.length) {
            if ($textarea.val() !== '') {
              if (!confirm('Are you sure you want to cancel creating this comment?')) {
                return;
              }
            }
            this.removeDiscussionNoteForm(discussionNoteForm);
            return;
          }
          editNote = $textarea.closest('.note');
          if (editNote.length) {
            originalText = $textarea.closest('form').data('originalNote');
            newText = $textarea.val();
            if (originalText !== newText) {
              if (!confirm('Are you sure you want to cancel editing this comment?')) {
                return;
              }
            }
            return this.removeNoteEditForm(editNote);
          }
      }
    }
  }, {
    key: 'initRefresh',
    value: function initRefresh() {
      if (Notes.interval) {
        clearInterval(Notes.interval);
      }
      return Notes.interval = setInterval(function (_this) {
        return function () {
          return _this.refresh();
        };
      }(this), this.pollingInterval);
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      if (!document.hidden) {
        return this.getContent();
      }
    }
  }, {
    key: 'getContent',
    value: function getContent() {
      var _this2 = this;

      if (this.refreshing) {
        return;
      }

      this.refreshing = true;

      axios_utils["a" /* default */].get(this.notes_url + '?html=true', {
        headers: {
          'X-Last-Fetched-At': this.last_fetched_at
        }
      }).then(function (_ref) {
        var data = _ref.data;

        var notes = data.notes;
        _this2.last_fetched_at = data.last_fetched_at;
        _this2.setPollingInterval(data.notes.length);
        jquery_default.a.each(notes, function (i, note) {
          return _this2.renderNote(note);
        });

        _this2.refreshing = false;
      }).catch(function () {
        _this2.refreshing = false;
      });
    }

    /**
     * Increase @pollingInterval up to 120 seconds on every function call,
     * if `shouldReset` has a truthy value, 'null' or 'undefined' the variable
     * will reset to @basePollingInterval.
     *
     * Note: this function is used to gradually increase the polling interval
     * if there aren't new notes coming from the server
     */

  }, {
    key: 'setPollingInterval',
    value: function setPollingInterval(shouldReset) {
      var nthInterval;
      if (shouldReset == null) {
        shouldReset = true;
      }
      nthInterval = this.basePollingInterval * Math.pow(2, this.maxPollingSteps - 1);
      if (shouldReset) {
        this.pollingInterval = this.basePollingInterval;
      } else if (this.pollingInterval < nthInterval) {
        this.pollingInterval *= 2;
      }
      return this.initRefresh();
    }
  }, {
    key: 'handleQuickActions',
    value: function handleQuickActions(noteEntity) {
      var votesBlock;
      if (noteEntity.commands_changes) {
        if ('merge' in noteEntity.commands_changes) {
          Notes.checkMergeRequestStatus();
        }

        if ('emoji_award' in noteEntity.commands_changes) {
          votesBlock = jquery_default()('.js-awards-block').eq(0);

          Object(awards_handler["a" /* default */])().then(function (awardsHandler) {
            awardsHandler.addAwardToEmojiBar(votesBlock, noteEntity.commands_changes.emoji_award);
            awardsHandler.scrollToAwards();
          }).catch(function () {
            // ignore
          });
        }
      }
    }
  }, {
    key: 'setupNewNote',
    value: function setupNewNote($note) {
      // Update datetime format on the recent note
      Object(datetime_utility["h" /* localTimeAgo */])($note.find('.js-timeago'), false);

      this.collapseLongCommitList();
      this.taskList.init();

      // This stops the note highlight, #note_xxx`, from being removed after real time update
      // The `:target` selector does not re-evaluate after we replace element in the DOM
      Notes.updateNoteTargetSelector($note);
      this.$noteToCleanHighlight = $note;
    }
  }, {
    key: 'onHashChange',
    value: function onHashChange() {
      if (this.$noteToCleanHighlight) {
        Notes.updateNoteTargetSelector(this.$noteToCleanHighlight);
      }

      this.$noteToCleanHighlight = null;
    }
  }, {
    key: 'renderNote',


    /**
     * Render note in main comments area.
     *
     * Note: for rendering inline notes use renderDiscussionNote
     */
    value: function renderNote(noteEntity, $form) {
      var $notesList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : jquery_default()('.main-notes-list');

      if (noteEntity.discussion_html) {
        return this.renderDiscussionNote(noteEntity, $form);
      }

      if (!noteEntity.valid) {
        if (noteEntity.errors && noteEntity.errors.commands_only) {
          if (noteEntity.commands_changes && Object.keys(noteEntity.commands_changes).length > 0) {
            $notesList.find('.system-note.being-posted').remove();
          }
          this.addFlash(noteEntity.errors.commands_only, 'notice', this.parentTimeline.get(0));
          this.refresh();
        }
        return;
      }

      var $note = $notesList.find('#note_' + noteEntity.id);
      if (Notes.isNewNote(noteEntity, this.note_ids)) {
        if (Object(common_utils["n" /* hasVueMRDiscussionsCookie */])()) {
          return;
        }

        this.note_ids.push(noteEntity.id);

        if ($notesList.length) {
          $notesList.find('.system-note.being-posted').remove();
        }
        var $newNote = Notes.animateAppendNote(noteEntity.html, $notesList);

        this.setupNewNote($newNote);
        this.refresh();
        return this.updateNotesCount(1);
      }
      // The server can send the same update multiple times so we need to make sure to only update once per actual update.
      else if (Notes.isUpdatedNote(noteEntity, $note)) {
          var isEditing = $note.hasClass('is-editing');
          var initialContent = normalizeNewlines($note.find('.original-note-content').text().trim());
          var $textarea = $note.find('.js-note-text');
          var currentContent = $textarea.val();
          // There can be CRLF vs LF mismatches if we don't sanitize and compare the same way
          var sanitizedNoteNote = normalizeNewlines(noteEntity.note);
          var isTextareaUntouched = currentContent === initialContent || currentContent === sanitizedNoteNote;

          if (isEditing && isTextareaUntouched) {
            $textarea.val(noteEntity.note);
            this.updatedNotesTrackingMap[noteEntity.id] = noteEntity;
          } else if (isEditing && !isTextareaUntouched) {
            this.putConflictEditWarningInPlace(noteEntity, $note);
            this.updatedNotesTrackingMap[noteEntity.id] = noteEntity;
          } else {
            var $updatedNote = Notes.animateUpdateNote(noteEntity.html, $note);
            this.setupNewNote($updatedNote);
          }
        }

      Notes.refreshVueNotes();
    }
  }, {
    key: 'isParallelView',
    value: function isParallelView() {
      return js_cookie_default.a.get('diff_view') === 'parallel';
    }

    /**
     * Render note in discussion area. To render inline notes use renderDiscussionNote.
     */

  }, {
    key: 'renderDiscussionNote',
    value: function renderDiscussionNote(noteEntity, $form) {
      var discussionContainer, form, row, lineType, diffAvatarContainer;

      if (!Notes.isNewNote(noteEntity, this.note_ids)) {
        return;
      }
      this.note_ids.push(noteEntity.id);

      form = $form || jquery_default()('.js-discussion-note-form[data-discussion-id="' + noteEntity.discussion_id + '"]');
      row = form.length || !noteEntity.discussion_line_code ? form.closest('tr') : jquery_default()('#' + noteEntity.discussion_line_code);

      if (noteEntity.on_image) {
        row = form;
      }

      lineType = this.isParallelView() ? form.find('#line_type').val() : 'old';
      diffAvatarContainer = row.prevAll('.line_holder').first().find('.js-avatar-container.' + lineType + '_line');
      // is this the first note of discussion?
      discussionContainer = jquery_default()('.notes[data-discussion-id="' + noteEntity.discussion_id + '"]');
      if (!discussionContainer.length) {
        discussionContainer = form.closest('.discussion').find('.notes');
      }
      if (discussionContainer.length === 0) {
        if (noteEntity.diff_discussion_html) {
          var $discussion = jquery_default()(noteEntity.diff_discussion_html).renderGFM();

          if (!this.isParallelView() || row.hasClass('js-temp-notes-holder') || noteEntity.on_image) {
            // insert the note and the reply button after the temp row
            row.after($discussion);
          } else {
            // Merge new discussion HTML in
            var $notes = $discussion.find('.notes[data-discussion-id="' + noteEntity.discussion_id + '"]');
            var contentContainerClass = '.' + $notes.closest('.notes_content').attr('class').split(' ').join('.');

            row.find(contentContainerClass + ' .content').append($notes.closest('.content').children());
          }
        }
        // Init discussion on 'Discussion' page if it is merge request page
        var page = jquery_default()('body').attr('data-page');
        if (page && page.indexOf('projects:merge_request') !== -1 || !noteEntity.diff_discussion_html) {
          if (!Object(common_utils["n" /* hasVueMRDiscussionsCookie */])()) {
            Notes.animateAppendNote(noteEntity.discussion_html, jquery_default()('.main-notes-list'));
          }
        }
      } else {
        // append new note to all matching discussions
        Notes.animateAppendNote(noteEntity.html, discussionContainer);
      }

      if (typeof gl.diffNotesCompileComponents !== 'undefined' && noteEntity.discussion_resolvable) {
        gl.diffNotesCompileComponents();

        this.renderDiscussionAvatar(diffAvatarContainer, noteEntity);
      }

      Object(datetime_utility["h" /* localTimeAgo */])(jquery_default()('.js-timeago'), false);
      Notes.checkMergeRequestStatus();
      return this.updateNotesCount(1);
    }
  }, {
    key: 'getLineHolder',
    value: function getLineHolder(changesDiscussionContainer) {
      return jquery_default()(changesDiscussionContainer).closest('.notes_holder').prevAll('.line_holder').first().get(0);
    }
  }, {
    key: 'renderDiscussionAvatar',
    value: function renderDiscussionAvatar(diffAvatarContainer, noteEntity) {
      var avatarHolder = diffAvatarContainer.find('.diff-comment-avatar-holders');

      if (!avatarHolder.length) {
        avatarHolder = document.createElement('diff-note-avatars');
        avatarHolder.setAttribute('discussion-id', noteEntity.discussion_id);

        diffAvatarContainer.append(avatarHolder);

        gl.diffNotesCompileComponents();
      }
    }

    /**
     * Called in response the main target form has been successfully submitted.
     *
     * Removes any errors.
     * Resets text and preview.
     * Resets buttons.
     */

  }, {
    key: 'resetMainTargetForm',
    value: function resetMainTargetForm(e) {
      var form;
      form = jquery_default()('.js-main-target-form');
      // remove validation errors
      form.find('.js-errors').remove();
      // reset text and preview
      form.find('.js-md-write-button').click();
      form.find('.js-note-text').val('').trigger('input');
      form.find('.js-note-text').data('autosave').reset();

      var event = document.createEvent('Event');
      event.initEvent('autosize:update', true, false);
      form.find('.js-autosize')[0].dispatchEvent(event);

      this.updateTargetButtons(e);
    }
  }, {
    key: 'reenableTargetFormSubmitButton',
    value: function reenableTargetFormSubmitButton() {
      var form;
      form = jquery_default()('.js-main-target-form');
      return form.find('.js-note-text').trigger('input');
    }

    /**
     * Shows the main form and does some setup on it.
     *
     * Sets some hidden fields in the form.
     */

  }, {
    key: 'setupMainTargetNoteForm',
    value: function setupMainTargetNoteForm() {
      var form;
      // find the form
      form = jquery_default()('.js-new-note-form');
      // Set a global clone of the form for later cloning
      this.formClone = form.clone();
      // show the form
      this.setupNoteForm(form);
      // fix classes
      form.removeClass('js-new-note-form');
      form.addClass('js-main-target-form');
      form.find('#note_line_code').remove();
      form.find('#note_position').remove();
      form.find('#note_type').val('');
      form.find('#note_project_id').remove();
      form.find('#in_reply_to_discussion_id').remove();
      form.find('.js-comment-resolve-button').closest('comment-and-resolve-btn').remove();
      this.parentTimeline = form.parents('.timeline');

      if (form.length) {
        Notes.initCommentTypeToggle(form.get(0));
      }
    }

    /**
     * General note form setup.
     *
     * deactivates the submit button when text is empty
     * hides the preview button when text is empty
     * setup GFM auto complete
     * show the form
     */

  }, {
    key: 'setupNoteForm',
    value: function setupNoteForm(form) {
      var textarea, key;
      this.glForm = new gl_form["a" /* default */](form, this.enableGFM);
      textarea = form.find('.js-note-text');
      key = ['Note', form.find('#note_noteable_type').val(), form.find('#note_noteable_id').val(), form.find('#note_commit_id').val(), form.find('#note_type').val(), form.find('#note_project_id').val(), form.find('#in_reply_to_discussion_id').val(),

      // LegacyDiffNote
      form.find('#note_line_code').val(),

      // DiffNote
      form.find('#note_position').val()];
      return new autosave["a" /* default */](textarea, key);
    }

    /**
     * Called in response to the new note form being submitted
     *
     * Adds new note to list.
     */

  }, {
    key: 'addNote',
    value: function addNote($form, note) {
      return this.renderNote(note);
    }
  }, {
    key: 'addNoteError',
    value: function addNoteError($form) {
      var formParentTimeline = void 0;
      if ($form.hasClass('js-main-target-form')) {
        formParentTimeline = $form.parents('.timeline');
      } else if ($form.hasClass('js-discussion-note-form')) {
        formParentTimeline = $form.closest('.discussion-notes').find('.notes');
      }
      return this.addFlash('Your comment could not be submitted! Please check your network connection and try again.', 'alert', formParentTimeline.get(0));
    }
  }, {
    key: 'updateNoteError',
    value: function updateNoteError($parentTimeline) {
      new flash["a" /* default */]('Your comment could not be updated! Please check your network connection and try again.');
    }

    /**
     * Called in response to the new note form being submitted
     *
     * Adds new note to list.
     */

  }, {
    key: 'addDiscussionNote',
    value: function addDiscussionNote($form, note, isNewDiffComment) {
      if ($form.attr('data-resolve-all') != null) {
        var projectPath = $form.data('projectPath');
        var discussionId = $form.data('discussionId');
        var mergeRequestId = $form.data('noteableIid');

        if (ResolveService != null) {
          ResolveService.toggleResolveForDiscussion(mergeRequestId, discussionId);
        }
      }

      this.renderNote(note, $form);
      // cleanup after successfully creating a diff/discussion note
      if (isNewDiffComment) {
        this.removeDiscussionNoteForm($form);
      }
    }

    /**
     * Called in response to the edit note form being submitted
     *
     * Updates the current note field.
     */

  }, {
    key: 'updateNote',
    value: function updateNote(noteEntity, $targetNote) {
      var $noteEntityEl, $note_li;
      // Convert returned HTML to a jQuery object so we can modify it further
      $noteEntityEl = jquery_default()(noteEntity.html);
      this.revertNoteEditForm($targetNote);
      $noteEntityEl.renderGFM();
      // Find the note's `li` element by ID and replace it with the updated HTML
      $note_li = jquery_default()('.note-row-' + noteEntity.id);

      $note_li.replaceWith($noteEntityEl);
      this.setupNewNote($noteEntityEl);

      if (typeof gl.diffNotesCompileComponents !== 'undefined') {
        gl.diffNotesCompileComponents();
      }
    }
  }, {
    key: 'checkContentToAllowEditing',
    value: function checkContentToAllowEditing($el) {
      var initialContent = $el.find('.original-note-content').text().trim();
      var currentContent = $el.find('.js-note-text').val();
      var isAllowed = true;

      if (currentContent === initialContent) {
        this.removeNoteEditForm($el);
      } else {
        var $buttons = $el.find('.note-form-actions');
        var isWidgetVisible = Object(common_utils["t" /* isInViewport */])($el.get(0));

        if (!isWidgetVisible) {
          Object(common_utils["D" /* scrollToElement */])($el);
        }

        $el.find('.js-finish-edit-warning').show();
        isAllowed = false;
      }

      return isAllowed;
    }

    /**
     * Called in response to clicking the edit note link
     *
     * Replaces the note text with the note edit form
     * Adds a data attribute to the form with the original content of the note for cancellations
     */

  }, {
    key: 'showEditForm',
    value: function showEditForm(e, scrollTo, myLastNote) {
      e.preventDefault();

      var $target = jquery_default()(e.target);
      var $editForm = jquery_default()(this.getEditFormSelector($target));
      var $note = $target.closest('.note');
      var $currentlyEditing = jquery_default()('.note.is-editing:visible');

      if ($currentlyEditing.length) {
        var isEditAllowed = this.checkContentToAllowEditing($currentlyEditing);

        if (!isEditAllowed) {
          return;
        }
      }

      $note.find('.js-note-attachment-delete').show();
      $editForm.addClass('current-note-edit-form');
      $note.addClass('is-editing');
      this.putEditFormInPlace($target);
    }

    /**
     * Called in response to clicking the edit note link
     *
     * Hides edit form and restores the original note text to the editor textarea.
     */

  }, {
    key: 'cancelEdit',
    value: function cancelEdit(e) {
      e.preventDefault();
      var $target = jquery_default()(e.target);
      var $note = $target.closest('.note');
      var noteId = $note.attr('data-note-id');

      this.revertNoteEditForm($target);

      if (this.updatedNotesTrackingMap[noteId]) {
        var $newNote = jquery_default()(this.updatedNotesTrackingMap[noteId].html);
        $note.replaceWith($newNote);
        this.setupNewNote($newNote);
        // Now that we have taken care of the update, clear it out
        delete this.updatedNotesTrackingMap[noteId];
      } else {
        $note.find('.js-finish-edit-warning').hide();
        this.removeNoteEditForm($note);
      }
    }
  }, {
    key: 'revertNoteEditForm',
    value: function revertNoteEditForm($target) {
      $target = $target || jquery_default()('.note.is-editing:visible');
      var selector = this.getEditFormSelector($target);
      var $editForm = jquery_default()(selector);

      $editForm.insertBefore('.diffs');
      $editForm.find('.js-comment-save-button').enable();
      $editForm.find('.js-finish-edit-warning').hide();
    }
  }, {
    key: 'getEditFormSelector',
    value: function getEditFormSelector($el) {
      var selector = '.note-edit-form:not(.mr-note-edit-form)';

      if ($el.parents('#diffs').length) {
        selector = '.note-edit-form.mr-note-edit-form';
      }

      return selector;
    }
  }, {
    key: 'removeNoteEditForm',
    value: function removeNoteEditForm($note) {
      var form = $note.find('.diffs .current-note-edit-form');

      $note.removeClass('is-editing');
      form.removeClass('current-note-edit-form');
      form.find('.js-finish-edit-warning').hide();
      // Replace markdown textarea text with original note text.
      return form.find('.js-note-text').val(form.find('form.edit-note').data('originalNote'));
    }

    /**
     * Called in response to deleting a note of any kind.
     *
     * Removes the actual note from view.
     * Removes the whole discussion if the last note is being removed.
     */

  }, {
    key: 'removeNote',
    value: function removeNote(e) {
      var noteElId, noteId, dataNoteId, $note, lineHolder;
      $note = jquery_default()(e.currentTarget).closest('.note');
      noteElId = $note.attr('id');
      noteId = $note.attr('data-note-id');
      lineHolder = jquery_default()(e.currentTarget).closest('.notes[data-discussion-id]').closest('.notes_holder').prev('.line_holder');
      jquery_default()('.note[id="' + noteElId + '"]').each(function (_this) {
        // A same note appears in the "Discussion" and in the "Changes" tab, we have
        // to remove all. Using $('.note[id='noteId']') ensure we get all the notes,
        // where $('#noteId') would return only one.
        return function (i, el) {
          var $note, $notes;
          $note = jquery_default()(el);
          $notes = $note.closest('.discussion-notes');
          var discussionId = jquery_default()('.notes', $notes).data('discussionId');

          if (typeof gl.diffNotesCompileComponents !== 'undefined') {
            if (gl.diffNoteApps[noteElId]) {
              gl.diffNoteApps[noteElId].$destroy();
            }
          }

          $note.remove();

          // check if this is the last note for this line
          if ($notes.find('.note').length === 0) {
            var notesTr = $notes.closest('tr');

            // "Discussions" tab
            $notes.closest('.timeline-entry').remove();

            jquery_default()('.js-diff-avatars-' + discussionId).trigger('remove.vue');

            // The notes tr can contain multiple lists of notes, like on the parallel diff
            // notesTr does not exist for image diffs
            if (notesTr.find('.discussion-notes').length > 1 || notesTr.length === 0) {
              var $diffFile = $notes.closest('.diff-file');
              if ($diffFile.length > 0) {
                var removeBadgeEvent = new CustomEvent('removeBadge.imageDiff', {
                  detail: {
                    // badgeNumber's start with 1 and index starts with 0
                    badgeNumber: $notes.index() + 1
                  }
                });

                $diffFile[0].dispatchEvent(removeBadgeEvent);
              }

              $notes.remove();
            } else if (notesTr.length > 0) {
              notesTr.remove();
            }
          }
        };
      }(this));

      Notes.refreshVueNotes();
      Notes.checkMergeRequestStatus();
      return this.updateNotesCount(-1);
    }

    /**
     * Called in response to clicking the delete attachment link
     *
     * Removes the attachment wrapper view, including image tag if it exists
     * Resets the note editing form
     */

  }, {
    key: 'removeAttachment',
    value: function removeAttachment() {
      var $note = jquery_default()(this).closest('.note');
      $note.find('.note-attachment').remove();
      $note.find('.note-body > .note-text').show();
      $note.find('.note-header').show();
      return $note.find('.current-note-edit-form').remove();
    }

    /**
     * Called when clicking on the "reply" button for a diff line.
     *
     * Shows the note form below the notes.
     */

  }, {
    key: 'onReplyToDiscussionNote',
    value: function onReplyToDiscussionNote(e) {
      this.replyToDiscussionNote(e.target);
    }
  }, {
    key: 'replyToDiscussionNote',
    value: function replyToDiscussionNote(target) {
      var form, replyLink;
      form = this.cleanForm(this.formClone.clone());
      replyLink = jquery_default()(target).closest('.js-discussion-reply-button');
      // insert the form after the button
      replyLink.closest('.discussion-reply-holder').hide().after(form);
      // show the form
      return this.setupDiscussionNoteForm(replyLink, form);
    }

    /**
     * Shows the diff or discussion form and does some setup on it.
     *
     * Sets some hidden fields in the form.
     *
     * Note: dataHolder must have the "discussionId" and "lineCode" data attributes set.
     */

  }, {
    key: 'setupDiscussionNoteForm',
    value: function setupDiscussionNoteForm(dataHolder, form) {
      // setup note target
      var diffFileData = dataHolder.closest('.text-file');

      if (diffFileData.length === 0) {
        diffFileData = dataHolder.closest('.image');
      }

      var discussionID = dataHolder.data('discussionId');

      if (discussionID) {
        form.attr('data-discussion-id', discussionID);
        form.find('#in_reply_to_discussion_id').val(discussionID);
      }

      form.find('#note_project_id').val(dataHolder.data('discussionProjectId'));

      form.attr('data-line-code', dataHolder.data('lineCode'));
      form.find('#line_type').val(dataHolder.data('lineType'));

      form.find('#note_noteable_type').val(diffFileData.data('noteableType'));
      form.find('#note_noteable_id').val(diffFileData.data('noteableId'));
      form.find('#note_commit_id').val(diffFileData.data('commitId'));

      form.find('#note_type').val(dataHolder.data('noteType'));

      // LegacyDiffNote
      form.find('#note_line_code').val(dataHolder.data('lineCode'));

      // DiffNote
      form.find('#note_position').val(dataHolder.attr('data-position'));

      form.find('.js-note-discard').show().removeClass('js-note-discard').addClass('js-close-discussion-note-form').text(form.find('.js-close-discussion-note-form').data('cancelText'));
      form.find('.js-note-target-close').remove();
      form.find('.js-note-new-discussion').remove();
      this.setupNoteForm(form);

      form.removeClass('js-main-target-form').addClass('discussion-form js-discussion-note-form');

      if (typeof gl.diffNotesCompileComponents !== 'undefined') {
        var $commentBtn = form.find('comment-and-resolve-btn');
        $commentBtn.attr(':discussion-id', '\'' + discussionID + '\'');

        gl.diffNotesCompileComponents();
      }

      form.find('.js-note-text').focus();
      form.find('.js-comment-resolve-button').attr('data-discussion-id', discussionID);
    }

    /**
     * Called when clicking on the "add a comment" button on the side of a diff line.
     *
     * Inserts a temporary row for the form below the line.
     * Sets up the form and shows it.
     */

  }, {
    key: 'onAddDiffNote',
    value: function onAddDiffNote(e) {
      e.preventDefault();
      var link = e.currentTarget || e.target;
      var $link = jquery_default()(link);
      var showReplyInput = !$link.hasClass('js-diff-comment-avatar');
      this.toggleDiffNote({
        target: $link,
        lineType: link.dataset.lineType,
        showReplyInput: showReplyInput
      });
    }
  }, {
    key: 'onAddImageDiffNote',
    value: function onAddImageDiffNote(e) {
      var $link = jquery_default()(e.currentTarget || e.target);
      var $diffFile = $link.closest('.diff-file');

      var clickEvent = new CustomEvent('click.imageDiff', {
        detail: e
      });

      $diffFile[0].dispatchEvent(clickEvent);

      // Setup comment form
      var newForm = void 0;
      var $noteContainer = $link.closest('.diff-viewer').find('.note-container');
      var $form = $noteContainer.find('> .discussion-form');

      if ($form.length === 0) {
        newForm = this.cleanForm(this.formClone.clone());
        newForm.appendTo($noteContainer);
      } else {
        newForm = $form;
      }

      this.setupDiscussionNoteForm($link, newForm);
    }
  }, {
    key: 'toggleDiffNote',
    value: function toggleDiffNote(_ref2) {
      var target = _ref2.target,
          lineType = _ref2.lineType,
          forceShow = _ref2.forceShow,
          _ref2$showReplyInput = _ref2.showReplyInput,
          showReplyInput = _ref2$showReplyInput === undefined ? false : _ref2$showReplyInput;

      var $link, addForm, hasNotes, newForm, noteForm, replyButton, row, rowCssToAdd, targetContent, isDiffCommentAvatar;
      $link = jquery_default()(target);
      row = $link.closest('tr');
      var nextRow = row.next();
      var targetRow = row;
      if (nextRow.is('.notes_holder')) {
        targetRow = nextRow;
      }

      hasNotes = nextRow.is('.notes_holder');
      addForm = false;
      var lineTypeSelector = '';
      rowCssToAdd = '<tr class="notes_holder js-temp-notes-holder"><td class="notes_line" colspan="2"></td><td class="notes_content"><div class="content"></div></td></tr>';
      // In parallel view, look inside the correct left/right pane
      if (this.isParallelView()) {
        lineTypeSelector = '.' + lineType;
        rowCssToAdd = '<tr class="notes_holder js-temp-notes-holder"><td class="notes_line old"></td><td class="notes_content parallel old"><div class="content"></div></td><td class="notes_line new"></td><td class="notes_content parallel new"><div class="content"></div></td></tr>';
      }
      var notesContentSelector = '.notes_content' + lineTypeSelector + ' .content';
      var notesContent = targetRow.find(notesContentSelector);

      if (hasNotes && showReplyInput) {
        targetRow.show();
        notesContent = targetRow.find(notesContentSelector);
        if (notesContent.length) {
          notesContent.show();
          replyButton = notesContent.find('.js-discussion-reply-button:visible');
          if (replyButton.length) {
            this.replyToDiscussionNote(replyButton[0]);
          } else {
            // In parallel view, the form may not be present in one of the panes
            noteForm = notesContent.find('.js-discussion-note-form');
            if (noteForm.length === 0) {
              addForm = true;
            }
          }
        }
      } else if (showReplyInput) {
        // add a notes row and insert the form
        row.after(rowCssToAdd);
        targetRow = row.next();
        notesContent = targetRow.find(notesContentSelector);
        addForm = true;
      } else {
        var isCurrentlyShown = targetRow.find('.content:not(:empty)').is(':visible');
        var isForced = forceShow === true || forceShow === false;
        var showNow = forceShow === true || !isCurrentlyShown && !isForced;

        targetRow.toggle(showNow);
        notesContent.toggle(showNow);
      }

      if (addForm) {
        newForm = this.cleanForm(this.formClone.clone());
        newForm.appendTo(notesContent);
        // show the form
        return this.setupDiscussionNoteForm($link, newForm);
      }
    }

    /**
     * Called in response to "cancel" on a diff note form.
     *
     * Shows the reply button again.
     * Removes the form and if necessary it's temporary row.
     */

  }, {
    key: 'removeDiscussionNoteForm',
    value: function removeDiscussionNoteForm(form) {
      var glForm, row;
      row = form.closest('tr');
      glForm = form.data('glForm');
      glForm.destroy();
      form.find('.js-note-text').data('autosave').reset();
      // show the reply button (will only work for replies)
      form.prev('.discussion-reply-holder').show();
      if (row.is('.js-temp-notes-holder')) {
        // remove temporary row for diff lines
        return row.remove();
      } else {
        // only remove the form
        return form.remove();
      }
    }
  }, {
    key: 'cancelDiscussionForm',
    value: function cancelDiscussionForm(e) {
      e.preventDefault();
      var $form = jquery_default()(e.target).closest('.js-discussion-note-form');
      var $discussionNote = jquery_default()(e.target).closest('.discussion-notes');

      if ($discussionNote.length === 0) {
        // Only send blur event when the discussion form
        // is not part of a discussion note
        var $diffFile = $form.closest('.diff-file');

        if ($diffFile.length > 0) {
          var blurEvent = new CustomEvent('blur.imageDiff', {
            detail: e
          });

          $diffFile[0].dispatchEvent(blurEvent);
        }
      }

      return this.removeDiscussionNoteForm($form);
    }

    /**
     * Called after an attachment file has been selected.
     *
     * Updates the file name for the selected attachment.
     */

  }, {
    key: 'updateFormAttachment',
    value: function updateFormAttachment() {
      var filename, form;
      form = jquery_default()(this).closest('form');
      // get only the basename
      filename = jquery_default()(this).val().replace(/^.*[\\\/]/, '');
      return form.find('.js-attachment-filename').text(filename);
    }

    /**
     * Called when the tab visibility changes
     */

  }, {
    key: 'visibilityChange',
    value: function visibilityChange() {
      return this.refresh();
    }
  }, {
    key: 'updateTargetButtons',
    value: function updateTargetButtons(e) {
      var closebtn, closetext, discardbtn, form, reopenbtn, reopentext, textarea;
      textarea = jquery_default()(e.target);
      form = textarea.parents('form');
      reopenbtn = form.find('.js-note-target-reopen');
      closebtn = form.find('.js-note-target-close');
      discardbtn = form.find('.js-note-discard');

      if (textarea.val().trim().length > 0) {
        reopentext = reopenbtn.attr('data-alternative-text');
        closetext = closebtn.attr('data-alternative-text');
        if (reopenbtn.text() !== reopentext) {
          reopenbtn.text(reopentext);
        }
        if (closebtn.text() !== closetext) {
          closebtn.text(closetext);
        }
        if (reopenbtn.is(':not(.btn-comment-and-reopen)')) {
          reopenbtn.addClass('btn-comment-and-reopen');
        }
        if (closebtn.is(':not(.btn-comment-and-close)')) {
          closebtn.addClass('btn-comment-and-close');
        }
        if (discardbtn.is(':hidden')) {
          return discardbtn.show();
        }
      } else {
        reopentext = reopenbtn.data('originalText');
        closetext = closebtn.data('originalText');
        if (reopenbtn.text() !== reopentext) {
          reopenbtn.text(reopentext);
        }
        if (closebtn.text() !== closetext) {
          closebtn.text(closetext);
        }
        if (reopenbtn.is('.btn-comment-and-reopen')) {
          reopenbtn.removeClass('btn-comment-and-reopen');
        }
        if (closebtn.is('.btn-comment-and-close')) {
          closebtn.removeClass('btn-comment-and-close');
        }
        if (discardbtn.is(':visible')) {
          return discardbtn.hide();
        }
      }
    }
  }, {
    key: 'putEditFormInPlace',
    value: function putEditFormInPlace($el) {
      var $editForm = jquery_default()(this.getEditFormSelector($el));
      var $note = $el.closest('.note');

      $editForm.insertAfter($note.find('.note-text'));

      var $originalContentEl = $note.find('.original-note-content');
      var originalContent = $originalContentEl.text().trim();
      var postUrl = $originalContentEl.data('postUrl');
      var targetId = $originalContentEl.data('targetId');
      var targetType = $originalContentEl.data('targetType');

      this.glForm = new gl_form["a" /* default */]($editForm.find('form'), this.enableGFM);

      $editForm.find('form').attr('action', postUrl + '?html=true').attr('data-remote', 'true');
      $editForm.find('.js-form-target-id').val(targetId);
      $editForm.find('.js-form-target-type').val(targetType);
      $editForm.find('.js-note-text').focus().val(originalContent);
      $editForm.find('.js-md-write-button').trigger('click');
      $editForm.find('.referenced-users').hide();
    }
  }, {
    key: 'putConflictEditWarningInPlace',
    value: function putConflictEditWarningInPlace(noteEntity, $note) {
      if ($note.find('.js-conflict-edit-warning').length === 0) {
        var $alert = jquery_default()('<div class="js-conflict-edit-warning alert alert-danger">\n        This comment has changed since you started editing, please review the\n        <a href="#note_' + noteEntity.id + '" target="_blank" rel="noopener noreferrer">\n          updated comment\n        </a>\n        to ensure information is not lost\n      </div>');
        $alert.insertAfter($note.find('.note-text'));
      }
    }
  }, {
    key: 'updateNotesCount',
    value: function updateNotesCount(updateCount) {
      return this.notesCountBadge.text(parseInt(this.notesCountBadge.text(), 10) + updateCount);
    }
  }, {
    key: 'toggleCommitList',
    value: function toggleCommitList(e) {
      var $element = jquery_default()(e.currentTarget);
      var $closestSystemCommitList = $element.siblings('.system-note-commit-list');

      $element.find('.fa').toggleClass('fa-angle-down').toggleClass('fa-angle-up');
      $closestSystemCommitList.toggleClass('hide-shade');
    }

    /**
     * Scans system notes with `ul` elements in system note body
     * then collapse long commit list pushed by user to make it less
     * intrusive.
     */

  }, {
    key: 'collapseLongCommitList',
    value: function collapseLongCommitList() {
      var systemNotes = jquery_default()('#notes-list').find('li.system-note').has('ul');

      jquery_default.a.each(systemNotes, function (index, systemNote) {
        var $systemNote = jquery_default()(systemNote);
        var headerMessage = $systemNote.find('.note-text').find('p:first').text().replace(':', '');

        $systemNote.find('.note-header .system-note-message').html(headerMessage);

        if ($systemNote.find('li').length > MAX_VISIBLE_COMMIT_LIST_COUNT) {
          $systemNote.find('.note-text').addClass('system-note-commit-list');
          $systemNote.find('.system-note-commit-list-toggler').show();
        } else {
          $systemNote.find('.note-text').addClass('system-note-commit-list hide-shade');
        }
      });
    }
  }, {
    key: 'addFlash',
    value: function addFlash() {
      for (var _len = arguments.length, flashParams = Array(_len), _key = 0; _key < _len; _key++) {
        flashParams[_key] = arguments[_key];
      }

      this.flashContainer = new (Function.prototype.bind.apply(flash["a" /* default */], [null].concat(flashParams)))();
    }
  }, {
    key: 'clearFlash',
    value: function clearFlash() {
      if (this.flashContainer) {
        this.flashContainer.style.display = 'none';
        this.flashContainer = null;
      }
    }
  }, {
    key: 'cleanForm',
    value: function cleanForm($form) {
      // Remove JS classes that are not needed here
      $form.find('.js-comment-type-dropdown').removeClass('btn-group');

      // Remove dropdown
      $form.find('.dropdown-menu').remove();

      return $form;
    }

    /**
     * Check if note does not exists on page
     */

  }, {
    key: 'getFormData',


    /**
     * Get data from Form attributes to use for saving/submitting comment.
     */
    value: function getFormData($form) {
      var content = $form.find('.js-note-text').val();
      return {
        formData: $form.serialize(),
        formContent: underscore_default.a.escape(content),
        formAction: $form.attr('action'),
        formContentOriginal: content
      };
    }

    /**
     * Identify if comment has any quick actions
     */

  }, {
    key: 'hasQuickActions',
    value: function hasQuickActions(formContent) {
      return REGEX_QUICK_ACTIONS.test(formContent);
    }

    /**
     * Remove quick actions and leave comment with pure message
     */

  }, {
    key: 'stripQuickActions',
    value: function stripQuickActions(formContent) {
      return formContent.replace(REGEX_QUICK_ACTIONS, '').trim();
    }

    /**
     * Gets appropriate description from quick actions found in provided `formContent`
     */

  }, {
    key: 'getQuickActionDescription',
    value: function getQuickActionDescription(formContent) {
      var availableQuickActions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var tempFormContent = void 0;

      // Identify executed quick actions from `formContent`
      var executedCommands = availableQuickActions.filter(function (command, index) {
        var commandRegex = new RegExp('/' + command.name);
        return commandRegex.test(formContent);
      });

      if (executedCommands && executedCommands.length) {
        if (executedCommands.length > 1) {
          tempFormContent = 'Applying multiple commands';
        } else {
          var commandDescription = executedCommands[0].description.toLowerCase();
          tempFormContent = 'Applying command to ' + commandDescription;
        }
      } else {
        tempFormContent = 'Applying command';
      }

      return tempFormContent;
    }

    /**
     * Create placeholder note DOM element populated with comment body
     * that we will show while comment is being posted.
     * Once comment is _actually_ posted on server, we will have final element
     * in response that we will show in place of this temporary element.
     */

  }, {
    key: 'createPlaceholderNote',
    value: function createPlaceholderNote(_ref3) {
      var formContent = _ref3.formContent,
          uniqueId = _ref3.uniqueId,
          isDiscussionNote = _ref3.isDiscussionNote,
          currentUsername = _ref3.currentUsername,
          currentUserFullname = _ref3.currentUserFullname,
          currentUserAvatar = _ref3.currentUserAvatar;

      var discussionClass = isDiscussionNote ? 'discussion' : '';
      var $tempNote = jquery_default()('<li id="' + uniqueId + '" class="note being-posted fade-in-half timeline-entry">\n         <div class="timeline-entry-inner">\n            <div class="timeline-icon">\n               <a href="/' + underscore_default.a.escape(currentUsername) + '">\n                 <img class="avatar s40" src="' + currentUserAvatar + '" />\n               </a>\n            </div>\n            <div class="timeline-content ' + discussionClass + '">\n               <div class="note-header">\n                  <div class="note-header-info">\n                     <a href="/' + underscore_default.a.escape(currentUsername) + '">\n                       <span class="hidden-xs">' + underscore_default.a.escape(currentUsername) + '</span>\n                       <span class="note-headline-light">' + underscore_default.a.escape(currentUsername) + '</span>\n                     </a>\n                  </div>\n               </div>\n               <div class="note-body">\n                 <div class="note-text">\n                   <p>' + formContent + '</p>\n                 </div>\n               </div>\n            </div>\n         </div>\n      </li>');

      $tempNote.find('.hidden-xs').text(underscore_default.a.escape(currentUserFullname));
      $tempNote.find('.note-headline-light').text('@' + underscore_default.a.escape(currentUsername));

      return $tempNote;
    }

    /**
     * Create Placeholder System Note DOM element populated with quick action description
     */

  }, {
    key: 'createPlaceholderSystemNote',
    value: function createPlaceholderSystemNote(_ref4) {
      var formContent = _ref4.formContent,
          uniqueId = _ref4.uniqueId;

      var $tempNote = jquery_default()('<li id="' + uniqueId + '" class="note system-note timeline-entry being-posted fade-in-half">\n         <div class="timeline-entry-inner">\n           <div class="timeline-content">\n             <i>' + formContent + '</i>\n           </div>\n         </div>\n       </li>');

      return $tempNote;
    }

    /**
     * This method does following tasks step-by-step whenever a new comment
     * is submitted by user (both main thread comments as well as discussion comments).
     *
     * 1) Get Form metadata
     * 2) Identify comment type; a) Main thread b) Discussion thread c) Discussion resolve
     * 3) Build temporary placeholder element (using `createPlaceholderNote`)
     * 4) Show placeholder note on UI
     * 5) Perform network request to submit the note using `axios.post`
     *    a) If request is successfully completed
     *        1. Remove placeholder element
     *        2. Show submitted Note element
     *        3. Perform post-submit errands
     *           a. Mark discussion as resolved if comment submission was for resolve.
     *           b. Reset comment form to original state.
     *    b) If request failed
     *        1. Remove placeholder element
     *        2. Show error Flash message about failure
     */

  }, {
    key: 'postComment',
    value: function postComment(e) {
      var _this3 = this;

      e.preventDefault();

      // Get Form metadata
      var $submitBtn = jquery_default()(e.target);
      var $form = $submitBtn.parents('form');
      var $closeBtn = $form.find('.js-note-target-close');
      var isDiscussionNote = $submitBtn.parent().find('li.droplab-item-selected').attr('id') === 'discussion';
      var isMainForm = $form.hasClass('js-main-target-form');
      var isDiscussionForm = $form.hasClass('js-discussion-note-form');
      var isDiscussionResolve = $submitBtn.hasClass('js-comment-resolve-button');

      var _getFormData = this.getFormData($form),
          formData = _getFormData.formData,
          formContent = _getFormData.formContent,
          formAction = _getFormData.formAction,
          formContentOriginal = _getFormData.formContentOriginal;

      var noteUniqueId = void 0;
      var systemNoteUniqueId = void 0;
      var hasQuickActions = false;
      var $notesContainer = void 0;
      var tempFormContent = void 0;

      // Get reference to notes container based on type of comment
      if (isDiscussionForm) {
        $notesContainer = $form.parent('.discussion-notes').find('.notes');
      } else if (isMainForm) {
        $notesContainer = jquery_default()('ul.main-notes-list');
      }

      // If comment is to resolve discussion, disable submit buttons while
      // comment posting is finished.
      if (isDiscussionResolve) {
        $submitBtn.disable();
        $form.find('.js-comment-submit-button').disable();
      }

      tempFormContent = formContent;
      if (this.hasQuickActions(formContent)) {
        tempFormContent = this.stripQuickActions(formContent);
        hasQuickActions = true;
      }

      // Show placeholder note
      if (tempFormContent) {
        noteUniqueId = underscore_default.a.uniqueId('tempNote_');
        $notesContainer.append(this.createPlaceholderNote({
          formContent: tempFormContent,
          uniqueId: noteUniqueId,
          isDiscussionNote: isDiscussionNote,
          currentUsername: gon.current_username,
          currentUserFullname: gon.current_user_fullname,
          currentUserAvatar: gon.current_user_avatar_url
        }));
      }

      // Show placeholder system note
      if (hasQuickActions) {
        systemNoteUniqueId = underscore_default.a.uniqueId('tempSystemNote_');
        $notesContainer.append(this.createPlaceholderSystemNote({
          formContent: this.getQuickActionDescription(formContent, ajax_cache["a" /* default */].get(gl.GfmAutoComplete.dataSources.commands)),
          uniqueId: systemNoteUniqueId
        }));
      }

      // Clear the form textarea
      if ($notesContainer.length) {
        if (isMainForm) {
          this.resetMainTargetForm(e);
        } else if (isDiscussionForm) {
          this.removeDiscussionNoteForm($form);
        }
      }

      /* eslint-disable promise/catch-or-return */
      // Make request to submit comment on server
      axios_utils["a" /* default */].post(formAction + '?html=true', formData).then(function (res) {
        var note = res.data;

        // Submission successful! remove placeholder
        $notesContainer.find('#' + noteUniqueId).remove();

        var $diffFile = $form.closest('.diff-file');
        if ($diffFile.length > 0) {
          var blurEvent = new CustomEvent('blur.imageDiff', {
            detail: e
          });

          $diffFile[0].dispatchEvent(blurEvent);
        }

        // Reset cached commands list when command is applied
        if (hasQuickActions) {
          $form.find('textarea.js-note-text').trigger('clear-commands-cache.atwho');
        }

        // Clear previous form errors
        _this3.clearFlashWrapper();

        // Check if this was discussion comment
        if (isDiscussionForm) {
          // Remove flash-container
          $notesContainer.find('.flash-container').remove();

          // If comment intends to resolve discussion, do the same.
          if (isDiscussionResolve) {
            $form.attr('data-discussion-id', $submitBtn.data('discussionId')).attr('data-resolve-all', 'true').attr('data-project-path', $submitBtn.data('projectPath'));
          }

          // Show final note element on UI
          var isNewDiffComment = $notesContainer.length === 0;
          _this3.addDiscussionNote($form, note, isNewDiffComment);

          if (isNewDiffComment) {
            // Add image badge, avatar badge and toggle discussion badge for new image diffs
            var notePosition = $form.find('#note_position').val();
            if ($diffFile.length > 0 && notePosition.length > 0) {
              var _JSON$parse = JSON.parse(notePosition),
                  x = _JSON$parse.x,
                  y = _JSON$parse.y,
                  width = _JSON$parse.width,
                  height = _JSON$parse.height;

              var addBadgeEvent = new CustomEvent('addBadge.imageDiff', {
                detail: {
                  x: x,
                  y: y,
                  width: width,
                  height: height,
                  noteId: 'note_' + note.id,
                  discussionId: note.discussion_id
                }
              });

              $diffFile[0].dispatchEvent(addBadgeEvent);
            }
          }

          // append flash-container to the Notes list
          if ($notesContainer.length) {
            $notesContainer.append('<div class="flash-container" style="display: none;"></div>');
          }

          Notes.refreshVueNotes();
        } else if (isMainForm) {
          // Check if this was main thread comment
          // Show final note element on UI and perform form and action buttons cleanup
          _this3.addNote($form, note);
          _this3.reenableTargetFormSubmitButton(e);
        }

        if (note.commands_changes) {
          _this3.handleQuickActions(note);
        }

        $form.trigger('ajax:success', [note]);
      }).catch(function () {
        // Submission failed, remove placeholder note and show Flash error message
        $notesContainer.find('#' + noteUniqueId).remove();

        var blurEvent = new CustomEvent('blur.imageDiff', {
          detail: e
        });

        var closestDiffFile = $form.closest('.diff-file');

        if (closestDiffFile.length) {
          closestDiffFile[0].dispatchEvent(blurEvent);
        }

        if (hasQuickActions) {
          $notesContainer.find('#' + systemNoteUniqueId).remove();
        }

        // Show form again on UI on failure
        if (isDiscussionForm && $notesContainer.length) {
          var replyButton = $notesContainer.parent().find('.js-discussion-reply-button');
          _this3.replyToDiscussionNote(replyButton[0]);
          $form = $notesContainer.parent().find('form');
        }

        $form.find('.js-note-text').val(formContentOriginal);
        _this3.reenableTargetFormSubmitButton(e);
        _this3.addNoteError($form);
      });

      return $closeBtn.text($closeBtn.data('originalText'));
    }

    /**
     * This method does following tasks step-by-step whenever an existing comment
     * is updated by user (both main thread comments as well as discussion comments).
     *
     * 1) Get Form metadata
     * 2) Update note element with new content
     * 3) Perform network request to submit the updated note using `axios.post`
     *    a) If request is successfully completed
     *        1. Show submitted Note element
     *    b) If request failed
     *        1. Revert Note element to original content
     *        2. Show error Flash message about failure
     */

  }, {
    key: 'updateComment',
    value: function updateComment(e) {
      var _this4 = this;

      e.preventDefault();

      // Get Form metadata
      var $submitBtn = jquery_default()(e.target);
      var $form = $submitBtn.parents('form');
      var $closeBtn = $form.find('.js-note-target-close');
      var $editingNote = $form.parents('.note.is-editing');
      var $noteBody = $editingNote.find('.js-task-list-container');
      var $noteBodyText = $noteBody.find('.note-text');

      var _getFormData2 = this.getFormData($form),
          formData = _getFormData2.formData,
          formContent = _getFormData2.formContent,
          formAction = _getFormData2.formAction;

      var $diffFile = $form.closest('.diff-file');
      var $notesContainer = $form.closest('.notes');

      // Cache original comment content
      var cachedNoteBodyText = $noteBodyText.html();

      // Show updated comment content temporarily
      $noteBodyText.html(formContent);
      $editingNote.removeClass('is-editing fade-in-full').addClass('being-posted fade-in-half');
      $editingNote.find('.note-headline-meta a').html('<i class="fa fa-spinner fa-spin" aria-label="Comment is being updated" aria-hidden="true"></i>');

      /* eslint-disable promise/catch-or-return */
      // Make request to update comment on server
      axios_utils["a" /* default */].post(formAction + '?html=true', formData).then(function (_ref5) {
        var data = _ref5.data;

        // Submission successful! render final note element
        _this4.updateNote(data, $editingNote);
      }).catch(function () {
        // Submission failed, revert back to original note
        $noteBodyText.html(underscore_default.a.escape(cachedNoteBodyText));
        $editingNote.removeClass('being-posted fade-in');
        $editingNote.find('.fa.fa-spinner').remove();

        // Show Flash message about failure
        _this4.updateNoteError();
      });

      return $closeBtn.text($closeBtn.data('originalText'));
    }
  }], [{
    key: 'initCommentTypeToggle',
    value: function initCommentTypeToggle(form) {
      var dropdownTrigger = form.querySelector('.js-comment-type-dropdown .dropdown-toggle');
      var dropdownList = form.querySelector('.js-comment-type-dropdown .dropdown-menu');
      var noteTypeInput = form.querySelector('#note_type');
      var submitButton = form.querySelector('.js-comment-type-dropdown .js-comment-submit-button');
      var closeButton = form.querySelector('.js-note-target-close');
      var reopenButton = form.querySelector('.js-note-target-reopen');

      var commentTypeToggle = new comment_type_toggle({
        dropdownTrigger: dropdownTrigger,
        dropdownList: dropdownList,
        noteTypeInput: noteTypeInput,
        submitButton: submitButton,
        closeButton: closeButton,
        reopenButton: reopenButton
      });

      commentTypeToggle.initDroplab();
    }
  }, {
    key: 'updateNoteTargetSelector',
    value: function updateNoteTargetSelector($note) {
      var hash = Object(url_utility["a" /* getLocationHash */])();
      // Needs to be an explicit true/false for the jQuery `toggleClass(force)`
      var addTargetClass = Boolean(hash && $note.filter('#' + hash).length > 0);
      $note.toggleClass('target', addTargetClass);
    }
  }, {
    key: 'isNewNote',
    value: function isNewNote(noteEntity, noteIds) {
      return jquery_default.a.inArray(noteEntity.id, noteIds) === -1;
    }

    /**
     * Check if $note already contains the `noteEntity` content
     */

  }, {
    key: 'isUpdatedNote',
    value: function isUpdatedNote(noteEntity, $note) {
      // There can be CRLF vs LF mismatches if we don't sanitize and compare the same way
      var sanitizedNoteEntityText = normalizeNewlines(noteEntity.note.trim());
      var currentNoteText = normalizeNewlines($note.find('.original-note-content').first().text().trim());
      return sanitizedNoteEntityText !== currentNoteText;
    }
  }, {
    key: 'checkMergeRequestStatus',
    value: function checkMergeRequestStatus() {
      if (Object(common_utils["h" /* getPagePath */])(1) === 'merge_requests' && gl.mrWidget) {
        gl.mrWidget.checkStatus();
      }
    }
  }, {
    key: 'animateAppendNote',
    value: function animateAppendNote(noteHtml, $notesList) {
      var $note = jquery_default()(noteHtml);

      $note.addClass('fade-in-full').renderGFM();
      $notesList.append($note);
      return $note;
    }
  }, {
    key: 'animateUpdateNote',
    value: function animateUpdateNote(noteHtml, $note) {
      var $updatedNote = jquery_default()(noteHtml);

      $updatedNote.addClass('fade-in').renderGFM();
      $note.replaceWith($updatedNote);
      return $updatedNote;
    }
  }, {
    key: 'refreshVueNotes',
    value: function refreshVueNotes() {
      document.dispatchEvent(new CustomEvent('refreshVueNotes'));
    }
  }]);

  return Notes;
}();

/* harmony default export */ var notes_0 = __webpack_exports__["a"] = (notes_Notes);


window.Notes = notes_Notes;

/***/ }),

/***/ "./pages/projects/project.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__project_select__ = __webpack_require__("./project_select.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, no-var, consistent-return, no-new, prefer-arrow-callback, no-return-assign, one-var, one-var-declaration-per-line, object-shorthand, no-else-return, newline-per-chained-call, no-shadow, vars-on-top, prefer-template, max-len */








var Project = function () {
  function Project() {
    _classCallCheck(this, Project);

    var $cloneOptions = $('ul.clone-options-dropdown');
    var $projectCloneField = $('#project_clone');
    var $cloneBtnText = $('a.clone-dropdown-btn span');

    var selectedCloneOption = $cloneBtnText.text().trim();
    if (selectedCloneOption.length > 0) {
      $('a:contains(\'' + selectedCloneOption + '\')', $cloneOptions).addClass('is-active');
    }

    $('a', $cloneOptions).on('click', function (e) {
      var $this = $(e.currentTarget);
      var url = $this.attr('href');
      var activeText = $this.find('.dropdown-menu-inner-title').text();

      e.preventDefault();

      $('.is-active', $cloneOptions).not($this).removeClass('is-active');
      $this.toggleClass('is-active');
      $projectCloneField.val(url);
      $cloneBtnText.text(activeText);

      $('#modal-geo-info').data({
        cloneUrlSecondary: $this.attr('href'),
        cloneUrlPrimary: $this.data('primaryUrl') || ''
      });

      return $('.clone').text(url);
    });
    // Ref switcher
    Project.initRefSwitcher();
    $('.project-refs-select').on('change', function () {
      return $(this).parents('form').submit();
    });
    $('.hide-no-ssh-message').on('click', function (e) {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_no_ssh_message', 'false');
      $(this).parents('.no-ssh-key-message').remove();
      return e.preventDefault();
    });
    $('.hide-no-password-message').on('click', function (e) {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_no_password_message', 'false');
      $(this).parents('.no-password-message').remove();
      return e.preventDefault();
    });
    $('.hide-shared-runner-limit-message').on('click', function (e) {
      var $alert = $(this).parents('.shared-runner-quota-message');
      var scope = $alert.data('scope');
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_shared_runner_quota_message', 'false', { path: scope });
      $alert.remove();
      e.preventDefault();
    });
    Project.projectSelectDropdown();
  }

  _createClass(Project, null, [{
    key: 'projectSelectDropdown',
    value: function projectSelectDropdown() {
      Object(__WEBPACK_IMPORTED_MODULE_5__project_select__["a" /* default */])();
      $('.project-item-select').on('click', function (e) {
        return Project.changeProject($(e.currentTarget).val());
      });
    }
  }, {
    key: 'changeProject',
    value: function changeProject(url) {
      return window.location = url;
    }
  }, {
    key: 'initRefSwitcher',
    value: function initRefSwitcher() {
      var refListItem = document.createElement('li');
      var refLink = document.createElement('a');

      refLink.href = '#';

      return $('.js-project-refs-dropdown').each(function () {
        var $dropdown, selected;
        $dropdown = $(this);
        selected = $dropdown.data('selected');
        return $dropdown.glDropdown({
          data: function data(term, callback) {
            __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__["a" /* default */].get($dropdown.data('refsUrl'), {
              params: {
                ref: $dropdown.data('ref'),
                search: term
              }
            }).then(function (_ref) {
              var data = _ref.data;
              return callback(data);
            }).catch(function () {
              return Object(__WEBPACK_IMPORTED_MODULE_4__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__locale__["a" /* __ */])('An error occurred while getting projects'));
            });
          },

          selectable: true,
          filterable: true,
          filterRemote: true,
          filterByText: true,
          inputFieldName: $dropdown.data('inputFieldName'),
          fieldName: $dropdown.data('fieldName'),
          renderRow: function renderRow(ref) {
            var li = refListItem.cloneNode(false);

            if (ref.header != null) {
              li.className = 'dropdown-header';
              li.textContent = ref.header;
            } else {
              var link = refLink.cloneNode(false);

              if (ref === selected) {
                link.className = 'is-active';
              }

              link.textContent = ref;
              link.dataset.ref = ref;

              li.appendChild(link);
            }

            return li;
          },
          id: function id(obj, $el) {
            return $el.attr('data-ref');
          },
          toggleLabel: function toggleLabel(obj, $el) {
            return $el.text().trim();
          },
          clicked: function clicked(options) {
            var e = options.e;

            e.preventDefault();
            if ($('input[name="ref"]').length) {
              var $form = $dropdown.closest('form');

              var $visit = $dropdown.data('visit');
              var shouldVisit = $visit ? true : $visit;
              var action = $form.attr('action');
              var divider = action.indexOf('?') === -1 ? '?' : '&';
              if (shouldVisit) {
                Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_url_utility__["g" /* visitUrl */])('' + action + divider + $form.serialize());
              }
            }
          }
        });
      });
    }
  }]);

  return Project;
}();

/* harmony default export */ __webpack_exports__["a"] = (Project);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pipelines/components/stage.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue
var stage = __webpack_require__("../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/stage.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65860e01","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/stage.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"mini-pipeline-graph-dropdown-toggle js-builds-dropdown-button",class:_vm.triggerButtonClass,attrs:{"title":_vm.stage.title,"data-placement":"top","data-toggle":"dropdown","type":"button","id":"stageDropdown","aria-haspopup":"true","aria-expanded":"false"},on:{"click":_vm.onClickStage}},[_c('span',{attrs:{"aria-hidden":"true","aria-label":_vm.stage.title}},[_c('icon',{attrs:{"name":_vm.borderlessIcon}})],1),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu mini-pipeline-graph-dropdown-menu js-builds-dropdown-container",attrs:{"aria-labelledby":"stageDropdown"}},[_c('li',{staticClass:"js-builds-dropdown-list scrollable-menu",class:_vm.dropdownClass},[(_vm.isLoading)?_c('loading-icon'):_c('ul',{domProps:{"innerHTML":_vm._s(_vm.dropdownContent)}})],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./pipelines/components/stage.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  stage["a" /* default */],
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_stage = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./pipelines/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ "./pipelines/mixins/pipelines.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/visibilityjs/index.js
var visibilityjs = __webpack_require__("../../../node_modules/visibilityjs/index.js");
var visibilityjs_default = /*#__PURE__*/__webpack_require__.n(visibilityjs);

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./lib/utils/poll.js
var poll = __webpack_require__("./lib/utils/poll.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/empty_state.vue

/* harmony default export */ var empty_state = ({
  name: 'PipelinesEmptyState',
  props: {
    helpPagePath: {
      type: String,
      required: true
    },
    emptyStateSvgPath: {
      type: String,
      required: true
    },
    canSetCi: {
      type: Boolean,
      required: true
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a3569de","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/empty_state.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row empty-state js-empty-state"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"svg-content svg-250"},[_c('img',{attrs:{"src":_vm.emptyStateSvgPath}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"text-content"},[(_vm.canSetCi)?[_c('h4',{staticClass:"text-center"},[_vm._v("\n          "+_vm._s(_vm.s__('Pipelines|Build with confidence'))+"\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          "+_vm._s(_vm.s__("Pipelines|Continous Integration can help\n              catch bugs by running your tests automatically,\n              while Continuous Deployment can help you deliver\n              code to your product environment."))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('a',{staticClass:"btn btn-primary js-get-started-pipelines",attrs:{"href":_vm.helpPagePath}},[_vm._v("\n            "+_vm._s(_vm.s__('Pipelines|Get started with Pipelines'))+"\n          ")])])]:_c('p',{staticClass:"text-center"},[_vm._v("\n        "+_vm._s(_vm.s__('Pipelines|This project is not currently set up to run pipelines.'))+"\n      ")])],2)])])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./pipelines/components/empty_state.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  empty_state,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_empty_state = (Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/blank_state.vue

/* harmony default export */ var blank_state = ({
  name: 'PipelinesSvgState',
  props: {
    svgPath: {
      type: String,
      required: true
    },

    message: {
      type: String,
      required: true
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-190f43c7","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/blank_state.vue
var blank_state_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row empty-state"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"svg-content"},[_c('img',{attrs:{"src":_vm.svgPath}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 text-center"},[_c('div',{staticClass:"text-content"},[_c('h4',[_vm._v(_vm._s(_vm.message))])])])])}
var blank_state_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/blank_state.vue
/* script */


/* template */

/* template functional */
var blank_state___vue_template_functional__ = false
/* styles */
var blank_state___vue_styles__ = null
/* scopeId */
var blank_state___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var blank_state___vue_module_identifier__ = null

var blank_state_Component = Object(component_normalizer["a" /* default */])(
  blank_state,
  blank_state_render,
  blank_state_staticRenderFns,
  blank_state___vue_template_functional__,
  blank_state___vue_styles__,
  blank_state___vue_scopeId__,
  blank_state___vue_module_identifier__
)

/* harmony default export */ var components_blank_state = (blank_state_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/modal.vue + 2 modules
var modal = __webpack_require__("./vue_shared/components/modal.vue");

// EXTERNAL MODULE: ./pipelines/event_hub.js
var event_hub = __webpack_require__("./pipelines/event_hub.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/async_button.vue

/* eslint-disable no-alert */






/* harmony default export */ var async_button = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    loadingIcon: loading_icon["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    endpoint: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    cssClass: {
      type: String,
      required: true
    },
    pipelineId: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: false
    };
  },

  computed: {
    buttonClass: function buttonClass() {
      return 'btn ' + this.cssClass;
    }
  },
  created: function created() {
    // We're using eventHub to listen to the modal here instead of
    // using props because it would would make the parent components
    // much more complex to keep track of the loading state of each button
    event_hub["a" /* default */].$on('postAction', this.setLoading);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('postAction', this.setLoading);
  },

  methods: {
    onClick: function onClick() {
      event_hub["a" /* default */].$emit('openConfirmationModal', {
        pipelineId: this.pipelineId,
        endpoint: this.endpoint,
        type: this.type
      });
    },
    setLoading: function setLoading(endpoint) {
      if (endpoint === this.endpoint) {
        this.isLoading = true;
      }
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08a875a2","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/async_button.vue
var async_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.buttonClass,attrs:{"type":"button","title":_vm.title,"aria-label":_vm.title,"data-container":"body","data-placement":"top","disabled":_vm.isLoading},on:{"click":_vm.onClick}},[_c('icon',{attrs:{"name":_vm.icon}}),_vm._v(" "),(_vm.isLoading)?_c('loading-icon'):_vm._e()],1)}
var async_button_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/async_button.vue
/* script */


/* template */

/* template functional */
var async_button___vue_template_functional__ = false
/* styles */
var async_button___vue_styles__ = null
/* scopeId */
var async_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var async_button___vue_module_identifier__ = null

var async_button_Component = Object(component_normalizer["a" /* default */])(
  async_button,
  async_button_render,
  async_button_staticRenderFns,
  async_button___vue_template_functional__,
  async_button___vue_styles__,
  async_button___vue_scopeId__,
  async_button___vue_module_identifier__
)

/* harmony default export */ var components_async_button = (async_button_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_actions.vue






/* harmony default export */ var pipelines_actions = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    loadingIcon: loading_icon["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    actions: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      isLoading: false
    };
  },

  methods: {
    onClickAction: function onClickAction(endpoint) {
      this.isLoading = true;

      event_hub["a" /* default */].$emit('postAction', endpoint);
    },
    isActionDisabled: function isActionDisabled(action) {
      if (action.playable === undefined) {
        return false;
      }

      return !action.playable;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4131da4d","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_actions.vue
var pipelines_actions_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group"},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"dropdown-new btn btn-default js-pipeline-dropdown-manual-actions",attrs:{"type":"button","title":"Manual job","data-toggle":"dropdown","data-placement":"top","aria-label":"Manual job","disabled":_vm.isLoading}},[_c('icon',{staticClass:"icon-play",attrs:{"name":"play"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.isLoading)?_c('loading-icon'):_vm._e()],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-align-right"},_vm._l((_vm.actions),function(action,i){return _c('li',{key:i},[_c('button',{staticClass:"js-pipeline-action-link no-btn btn",class:{ disabled: _vm.isActionDisabled(action) },attrs:{"type":"button","disabled":_vm.isActionDisabled(action)},on:{"click":function($event){_vm.onClickAction(action.path)}}},[_vm._v("\n        "+_vm._s(action.name)+"\n      ")])])}))])}
var pipelines_actions_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/pipelines_actions.vue
/* script */


/* template */

/* template functional */
var pipelines_actions___vue_template_functional__ = false
/* styles */
var pipelines_actions___vue_styles__ = null
/* scopeId */
var pipelines_actions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_actions___vue_module_identifier__ = null

var pipelines_actions_Component = Object(component_normalizer["a" /* default */])(
  pipelines_actions,
  pipelines_actions_render,
  pipelines_actions_staticRenderFns,
  pipelines_actions___vue_template_functional__,
  pipelines_actions___vue_styles__,
  pipelines_actions___vue_scopeId__,
  pipelines_actions___vue_module_identifier__
)

/* harmony default export */ var components_pipelines_actions = (pipelines_actions_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_artifacts.vue




/* harmony default export */ var pipelines_artifacts = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    icon: icon["a" /* default */]
  },
  props: {
    artifacts: {
      type: Array,
      required: true
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8577a5a6","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_artifacts.vue
var pipelines_artifacts_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[_c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"dropdown-toggle btn btn-default build-artifacts js-pipeline-dropdown-download",attrs:{"title":"Artifacts","data-placement":"top","data-toggle":"dropdown","aria-label":"Artifacts"}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" "),_c('i',{staticClass:"fa fa-caret-down",attrs:{"aria-hidden":"true"}})],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-align-right"},_vm._l((_vm.artifacts),function(artifact,i){return _c('li',{key:i},[_c('a',{attrs:{"rel":"nofollow","download":"","href":artifact.path}},[_vm._v("\n        Download "+_vm._s(artifact.name)+" artifacts\n      ")])])}))])}
var pipelines_artifacts_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/pipelines_artifacts.vue
/* script */


/* template */

/* template functional */
var pipelines_artifacts___vue_template_functional__ = false
/* styles */
var pipelines_artifacts___vue_styles__ = null
/* scopeId */
var pipelines_artifacts___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_artifacts___vue_module_identifier__ = null

var pipelines_artifacts_Component = Object(component_normalizer["a" /* default */])(
  pipelines_artifacts,
  pipelines_artifacts_render,
  pipelines_artifacts_staticRenderFns,
  pipelines_artifacts___vue_template_functional__,
  pipelines_artifacts___vue_styles__,
  pipelines_artifacts___vue_scopeId__,
  pipelines_artifacts___vue_module_identifier__
)

/* harmony default export */ var components_pipelines_artifacts = (pipelines_artifacts_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/ci_badge_link.vue + 2 modules
var ci_badge_link = __webpack_require__("./vue_shared/components/ci_badge_link.vue");

// EXTERNAL MODULE: ./pipelines/components/stage.vue + 1 modules
var stage = __webpack_require__("./pipelines/components/stage.vue");

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue + 2 modules
var user_avatar_link = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");

// EXTERNAL MODULE: ./vue_shared/directives/popover.js
var popover = __webpack_require__("./vue_shared/directives/popover.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipeline_url.vue





/* harmony default export */ var pipeline_url = ({
  components: {
    userAvatarLink: user_avatar_link["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */],
    popover: popover["a" /* default */]
  },
  props: {
    pipeline: {
      type: Object,
      required: true
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    }
  },
  computed: {
    user: function user() {
      return this.pipeline.user;
    },
    popoverOptions: function popoverOptions() {
      return {
        html: true,
        trigger: 'focus',
        placement: 'top',
        title: '<div class="autodevops-title">\n          This pipeline makes use of a predefined CI/CD configuration enabled by <b>Auto DevOps.</b>\n        </div>',
        content: '<a\n          class="autodevops-link"\n          href="' + this.autoDevopsHelpPath + '"\n          target="_blank"\n          rel="noopener noreferrer nofollow">\n          Learn more about Auto DevOps\n        </a>'
      };
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cea8c848","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipeline_url.vue
var pipeline_url_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-section section-15 hidden-xs hidden-sm pipeline-tags"},[_c('a',{staticClass:"js-pipeline-url-link",attrs:{"href":_vm.pipeline.path}},[_c('span',{staticClass:"pipeline-id"},[_vm._v("#"+_vm._s(_vm.pipeline.id))])]),_vm._v(" "),_c('span',[_vm._v("by")]),_vm._v(" "),(_vm.user)?_c('user-avatar-link',{staticClass:"js-pipeline-url-user",attrs:{"link-href":_vm.pipeline.user.path,"img-src":_vm.pipeline.user.avatar_url,"tooltip-text":_vm.pipeline.user.name}}):_vm._e(),_vm._v(" "),(!_vm.user)?_c('span',{staticClass:"js-pipeline-url-api api"},[_vm._v("\n    API\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"label-container"},[(_vm.pipeline.flags.latest)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-pipeline-url-latest label label-success",attrs:{"title":"Latest pipeline for this branch"}},[_vm._v("\n      latest\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.yaml_errors)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-pipeline-url-yaml label label-danger",attrs:{"title":_vm.pipeline.yaml_errors}},[_vm._v("\n      yaml invalid\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.failure_reason)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"js-pipeline-url-failure label label-danger",attrs:{"title":_vm.pipeline.failure_reason}},[_vm._v("\n      error\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.auto_devops)?_c('a',{directives:[{name:"popover",rawName:"v-popover",value:(_vm.popoverOptions),expression:"popoverOptions"}],staticClass:"js-pipeline-url-autodevops label label-info autodevops-badge",attrs:{"tabindex":"0","role":"button"}},[_vm._v("\n      Auto DevOps\n    ")]):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.stuck)?_c('span',{staticClass:"js-pipeline-url-stuck label label-warning"},[_vm._v("\n      stuck\n    ")]):_vm._e()])],1)}
var pipeline_url_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/pipeline_url.vue
/* script */


/* template */

/* template functional */
var pipeline_url___vue_template_functional__ = false
/* styles */
var pipeline_url___vue_styles__ = null
/* scopeId */
var pipeline_url___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipeline_url___vue_module_identifier__ = null

var pipeline_url_Component = Object(component_normalizer["a" /* default */])(
  pipeline_url,
  pipeline_url_render,
  pipeline_url_staticRenderFns,
  pipeline_url___vue_template_functional__,
  pipeline_url___vue_styles__,
  pipeline_url___vue_scopeId__,
  pipeline_url___vue_module_identifier__
)

/* harmony default export */ var components_pipeline_url = (pipeline_url_Component.exports);

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/app/views/shared/icons/_icon_timer.svg
var _icon_timer = __webpack_require__("../../views/shared/icons/_icon_timer.svg");
var _icon_timer_default = /*#__PURE__*/__webpack_require__.n(_icon_timer);

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// EXTERNAL MODULE: ./vue_shared/mixins/timeago.js
var timeago = __webpack_require__("./vue_shared/mixins/timeago.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/time_ago.vue






/* harmony default export */ var time_ago = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  mixins: [timeago["a" /* default */]],
  props: {
    finishedTime: {
      type: String,
      required: true
    },
    duration: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      iconTimerSvg: _icon_timer_default.a
    };
  },

  computed: {
    hasDuration: function hasDuration() {
      return this.duration > 0;
    },
    hasFinishedTime: function hasFinishedTime() {
      return this.finishedTime !== '';
    },
    durationFormated: function durationFormated() {
      var date = new Date(this.duration * 1000);

      var hh = date.getUTCHours();
      var mm = date.getUTCMinutes();
      var ss = date.getSeconds();

      // left pad
      if (hh < 10) {
        hh = '0' + hh;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      if (ss < 10) {
        ss = '0' + ss;
      }

      return hh + ':' + mm + ':' + ss;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ecc1dd0","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/time_ago.vue
var time_ago_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-section section-15 pipelines-time-ago"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n    Duration\n  ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[(_vm.hasDuration)?_c('p',{staticClass:"duration"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.iconTimerSvg)}}),_vm._v("\n      "+_vm._s(_vm.durationFormated)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.hasFinishedTime)?_c('p',{staticClass:"finished-at hidden-xs hidden-sm"},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('time',{directives:[{name:"tooltip",rawName:"v-tooltip"}],attrs:{"data-placement":"top","data-container":"body","title":_vm.tooltipTitle(_vm.finishedTime)}},[_vm._v("\n        "+_vm._s(_vm.timeFormated(_vm.finishedTime))+"\n      ")])]):_vm._e()])])}
var time_ago_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/time_ago.vue
/* script */


/* template */

/* template functional */
var time_ago___vue_template_functional__ = false
/* styles */
var time_ago___vue_styles__ = null
/* scopeId */
var time_ago___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var time_ago___vue_module_identifier__ = null

var time_ago_Component = Object(component_normalizer["a" /* default */])(
  time_ago,
  time_ago_render,
  time_ago_staticRenderFns,
  time_ago___vue_template_functional__,
  time_ago___vue_styles__,
  time_ago___vue_scopeId__,
  time_ago___vue_module_identifier__
)

/* harmony default export */ var components_time_ago = (time_ago_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/commit.vue + 2 modules
var commit = __webpack_require__("./vue_shared/components/commit.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_table_row.vue

/* eslint-disable no-param-reassign */









/**
 * Pipeline table row.
 *
 * Given the received object renders a table row in the pipelines' table.
 */
/* harmony default export */ var pipelines_table_row = ({
  components: {
    asyncButtonComponent: components_async_button,
    pipelinesActionsComponent: components_pipelines_actions,
    pipelinesArtifactsComponent: components_pipelines_artifacts,
    commitComponent: commit["a" /* default */],
    pipelineStage: stage["a" /* default */],
    pipelineUrl: components_pipeline_url,
    ciBadge: ci_badge_link["a" /* default */],
    pipelinesTimeago: components_time_ago
  },
  props: {
    pipeline: {
      type: Object,
      required: true
    },
    updateGraphDropdown: {
      type: Boolean,
      required: false,
      default: false
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    },
    viewType: {
      type: String,
      required: true
    }
  },
  computed: {
    /**
     * If provided, returns the commit tag.
     * Needed to render the commit component column.
     *
     * This field needs a lot of verification, because of different possible cases:
     *
     * 1. person who is an author of a commit might be a GitLab user
     * 2. if person who is an author of a commit is a GitLab user he/she can have a GitLab avatar
     * 3. If GitLab user does not have avatar he/she might have a Gravatar
     * 4. If committer is not a GitLab User he/she can have a Gravatar
     * 5. We do not have consistent API object in this case
     * 6. We should improve API and the code
     *
     * @returns {Object|Undefined}
     */
    commitAuthor: function commitAuthor() {
      var commitAuthorInformation = void 0;

      if (!this.pipeline || !this.pipeline.commit) {
        return null;
      }

      // 1. person who is an author of a commit might be a GitLab user
      if (this.pipeline.commit.author) {
        // 2. if person who is an author of a commit is a GitLab user
        // he/she can have a GitLab avatar
        if (this.pipeline.commit.author.avatar_url) {
          commitAuthorInformation = this.pipeline.commit.author;

          // 3. If GitLab user does not have avatar he/she might have a Gravatar
        } else if (this.pipeline.commit.author_gravatar_url) {
          commitAuthorInformation = Object.assign({}, this.pipeline.commit.author, {
            avatar_url: this.pipeline.commit.author_gravatar_url
          });
        }
        // 4. If committer is not a GitLab User he/she can have a Gravatar
      } else {
        commitAuthorInformation = {
          avatar_url: this.pipeline.commit.author_gravatar_url,
          path: 'mailto:' + this.pipeline.commit.author_email,
          username: this.pipeline.commit.author_name
        };
      }

      return commitAuthorInformation;
    },


    /**
     * If provided, returns the commit tag.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitTag: function commitTag() {
      if (this.pipeline.ref && this.pipeline.ref.tag) {
        return this.pipeline.ref.tag;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit ref.
     * Needed to render the commit component column.
     *
     * Matches `path` prop sent in the API to `ref_url` prop needed
     * in the commit component.
     *
     * @returns {Object|Undefined}
     */
    commitRef: function commitRef() {
      var _this = this;

      if (this.pipeline.ref) {
        return Object.keys(this.pipeline.ref).reduce(function (accumulator, prop) {
          if (prop === 'path') {
            accumulator.ref_url = _this.pipeline.ref[prop];
          } else {
            accumulator[prop] = _this.pipeline.ref[prop];
          }
          return accumulator;
        }, {});
      }

      return undefined;
    },


    /**
     * If provided, returns the commit url.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitUrl: function commitUrl() {
      if (this.pipeline.commit && this.pipeline.commit.commit_path) {
        return this.pipeline.commit.commit_path;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit short sha.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitShortSha: function commitShortSha() {
      if (this.pipeline.commit && this.pipeline.commit.short_id) {
        return this.pipeline.commit.short_id;
      }
      return undefined;
    },


    /**
     * If provided, returns the commit title.
     * Needed to render the commit component column.
     *
     * @returns {String|Undefined}
     */
    commitTitle: function commitTitle() {
      if (this.pipeline.commit && this.pipeline.commit.title) {
        return this.pipeline.commit.title;
      }
      return undefined;
    },


    /**
     * Timeago components expects a number
     *
     * @return {type}  description
     */
    pipelineDuration: function pipelineDuration() {
      if (this.pipeline.details && this.pipeline.details.duration) {
        return this.pipeline.details.duration;
      }

      return 0;
    },


    /**
     * Timeago component expects a String.
     *
     * @return {String}
     */
    pipelineFinishedAt: function pipelineFinishedAt() {
      if (this.pipeline.details && this.pipeline.details.finished_at) {
        return this.pipeline.details.finished_at;
      }

      return '';
    },
    pipelineStatus: function pipelineStatus() {
      if (this.pipeline.details && this.pipeline.details.status) {
        return this.pipeline.details.status;
      }
      return {};
    },
    displayPipelineActions: function displayPipelineActions() {
      return this.pipeline.flags.retryable || this.pipeline.flags.cancelable || this.pipeline.details.manual_actions.length || this.pipeline.details.artifacts.length;
    },
    isChildView: function isChildView() {
      return this.viewType === 'child';
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c853a7e","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table_row.vue
var pipelines_table_row_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commit gl-responsive-table-row"},[_c('div',{staticClass:"table-section section-10 commit-link"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n      Status\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[_c('ci-badge',{attrs:{"status":_vm.pipelineStatus,"show-text":!_vm.isChildView}})],1)]),_vm._v(" "),_c('pipeline-url',{attrs:{"pipeline":_vm.pipeline,"auto-devops-help-path":_vm.autoDevopsHelpPath}}),_vm._v(" "),_c('div',{staticClass:"table-section section-20"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n      Commit\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[_c('commit-component',{attrs:{"tag":_vm.commitTag,"commit-ref":_vm.commitRef,"commit-url":_vm.commitUrl,"short-sha":_vm.commitShortSha,"title":_vm.commitTitle,"author":_vm.commitAuthor,"show-branch":!_vm.isChildView}})],1)]),_vm._v(" "),_c('div',{staticClass:"table-section section-wrap section-20 stage-cell"},[_c('div',{staticClass:"table-mobile-header",attrs:{"role":"rowheader"}},[_vm._v("\n      Stages\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-mobile-content"},[(_vm.pipeline.details.stages.length > 0)?_vm._l((_vm.pipeline.details.stages),function(stage,index){return _c('div',{key:index,staticClass:"stage-container dropdown js-mini-pipeline-graph"},[_c('pipeline-stage',{attrs:{"stage":stage,"update-dropdown":_vm.updateGraphDropdown}})],1)}):_vm._e()],2)]),_vm._v(" "),_c('pipelines-timeago',{attrs:{"duration":_vm.pipelineDuration,"finished-time":_vm.pipelineFinishedAt}}),_vm._v(" "),(_vm.displayPipelineActions)?_c('div',{staticClass:"table-section section-20 table-button-footer pipeline-actions"},[_c('div',{staticClass:"btn-group table-action-buttons"},[(_vm.pipeline.details.manual_actions.length)?_c('pipelines-actions-component',{attrs:{"actions":_vm.pipeline.details.manual_actions}}):_vm._e(),_vm._v(" "),(_vm.pipeline.details.artifacts.length)?_c('pipelines-artifacts-component',{staticClass:"hidden-xs hidden-sm",attrs:{"artifacts":_vm.pipeline.details.artifacts}}):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.retryable)?_c('async-button-component',{attrs:{"endpoint":_vm.pipeline.retry_path,"css-class":"js-pipelines-retry-button btn-default btn-retry","title":"Retry","icon":"repeat","pipeline-id":_vm.pipeline.id,"data-toggle":"modal","data-target":"#confirmation-modal","type":"retry"}}):_vm._e(),_vm._v(" "),(_vm.pipeline.flags.cancelable)?_c('async-button-component',{attrs:{"endpoint":_vm.pipeline.cancel_path,"css-class":"js-pipelines-cancel-button btn-remove","title":"Stop","icon":"close","pipeline-id":_vm.pipeline.id,"data-toggle":"modal","data-target":"#confirmation-modal","type":"stop"}}):_vm._e()],1)]):_vm._e()],1)}
var pipelines_table_row_staticRenderFns = []

// CONCATENATED MODULE: ./pipelines/components/pipelines_table_row.vue
/* script */


/* template */

/* template functional */
var pipelines_table_row___vue_template_functional__ = false
/* styles */
var pipelines_table_row___vue_styles__ = null
/* scopeId */
var pipelines_table_row___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_table_row___vue_module_identifier__ = null

var pipelines_table_row_Component = Object(component_normalizer["a" /* default */])(
  pipelines_table_row,
  pipelines_table_row_render,
  pipelines_table_row_staticRenderFns,
  pipelines_table_row___vue_template_functional__,
  pipelines_table_row___vue_styles__,
  pipelines_table_row___vue_scopeId__,
  pipelines_table_row___vue_module_identifier__
)

/* harmony default export */ var components_pipelines_table_row = (pipelines_table_row_Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./pipelines/components/pipelines_table.vue






/**
 * Pipelines Table Component.
 *
 * Given an array of objects, renders a table.
 */
/* harmony default export */ var pipelines_table = ({
  components: {
    pipelinesTableRowComponent: components_pipelines_table_row,
    modal: modal["a" /* default */]
  },
  props: {
    pipelines: {
      type: Array,
      required: true
    },
    updateGraphDropdown: {
      type: Boolean,
      required: false,
      default: false
    },
    autoDevopsHelpPath: {
      type: String,
      required: true
    },
    viewType: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      pipelineId: '',
      endpoint: '',
      type: ''
    };
  },

  computed: {
    modalTitle: function modalTitle() {
      return this.type === 'stop' ? Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Pipeline|Stop pipeline #%{pipelineId}?'), {
        pipelineId: '\'' + this.pipelineId + '\''
      }, false) : Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Pipeline|Retry pipeline #%{pipelineId}?'), {
        pipelineId: '\'' + this.pipelineId + '\''
      }, false);
    },
    modalText: function modalText() {
      return this.type === 'stop' ? Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Pipeline|You’re about to stop pipeline %{pipelineId}.'), {
        pipelineId: '<strong>#' + this.pipelineId + '</strong>'
      }, false) : Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('Pipeline|You’re about to retry pipeline %{pipelineId}.'), {
        pipelineId: '<strong>#' + this.pipelineId + '</strong>'
      }, false);
    },
    primaryButtonLabel: function primaryButtonLabel() {
      return this.type === 'stop' ? Object(locale["e" /* s__ */])('Pipeline|Stop pipeline') : Object(locale["e" /* s__ */])('Pipeline|Retry pipeline');
    }
  },
  created: function created() {
    event_hub["a" /* default */].$on('openConfirmationModal', this.setModalData);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('openConfirmationModal', this.setModalData);
  },

  methods: {
    setModalData: function setModalData(data) {
      this.pipelineId = data.pipelineId;
      this.endpoint = data.endpoint;
      this.type = data.type;
    },
    onSubmit: function onSubmit() {
      event_hub["a" /* default */].$emit('postAction', this.endpoint);
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-494085a2","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_table.vue
var pipelines_table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ci-table"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.pipelines),function(model){return _c('pipelines-table-row-component',{key:model.id,attrs:{"pipeline":model,"update-graph-dropdown":_vm.updateGraphDropdown,"auto-devops-help-path":_vm.autoDevopsHelpPath,"view-type":_vm.viewType}})}),_vm._v(" "),_c('modal',{attrs:{"id":"confirmation-modal","title":_vm.modalTitle,"text":_vm.modalText,"kind":"danger","primary-button-label":_vm.primaryButtonLabel},on:{"submit":_vm.onSubmit},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_c('p',{domProps:{"innerHTML":_vm._s(props.text)}})]}}])})],2)}
var pipelines_table_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-responsive-table-row table-row-header",attrs:{"role":"row"}},[_c('div',{staticClass:"table-section section-10 js-pipeline-status pipeline-status",attrs:{"role":"rowheader"}},[_vm._v("\n      Status\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-section section-15 js-pipeline-info pipeline-info",attrs:{"role":"rowheader"}},[_vm._v("\n      Pipeline\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-section section-20 js-pipeline-commit pipeline-commit",attrs:{"role":"rowheader"}},[_vm._v("\n      Commit\n    ")]),_vm._v(" "),_c('div',{staticClass:"table-section section-20 js-pipeline-stages pipeline-stages",attrs:{"role":"rowheader"}},[_vm._v("\n      Stages\n    ")])])}]

// CONCATENATED MODULE: ./pipelines/components/pipelines_table.vue
/* script */


/* template */

/* template functional */
var pipelines_table___vue_template_functional__ = false
/* styles */
var pipelines_table___vue_styles__ = null
/* scopeId */
var pipelines_table___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var pipelines_table___vue_module_identifier__ = null

var pipelines_table_Component = Object(component_normalizer["a" /* default */])(
  pipelines_table,
  pipelines_table_render,
  pipelines_table_staticRenderFns,
  pipelines_table___vue_template_functional__,
  pipelines_table___vue_styles__,
  pipelines_table___vue_scopeId__,
  pipelines_table___vue_module_identifier__
)

/* harmony default export */ var components_pipelines_table = (pipelines_table_Component.exports);

// CONCATENATED MODULE: ./pipelines/mixins/pipelines.js










/* harmony default export */ var pipelines = __webpack_exports__["a"] = ({
  components: {
    PipelinesTableComponent: components_pipelines_table,
    SvgBlankState: components_blank_state,
    EmptyState: components_empty_state,
    LoadingIcon: loading_icon["a" /* default */]
  },
  data: function data() {
    return {
      isLoading: false,
      hasError: false,
      isMakingRequest: false,
      updateGraphDropdown: false,
      hasMadeRequest: false
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.poll = new poll["a" /* default */]({
      resource: this.service,
      method: 'getPipelines',
      data: this.requestData ? this.requestData : undefined,
      successCallback: this.successCallback,
      errorCallback: this.errorCallback,
      notificationCallback: this.setIsMakingRequest
    });

    if (!visibilityjs_default.a.hidden()) {
      this.isLoading = true;
      this.poll.makeRequest();
    } else {
      // If tab is not visible we need to make the first request so we don't show the empty
      // state without knowing if there are any pipelines
      this.fetchPipelines();
    }

    visibilityjs_default.a.change(function () {
      if (!visibilityjs_default.a.hidden()) {
        _this.poll.restart();
      } else {
        _this.poll.stop();
      }
    });

    event_hub["a" /* default */].$on('refreshPipelines', this.fetchPipelines);
    event_hub["a" /* default */].$on('postAction', this.postAction);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('refreshPipelines');
    event_hub["a" /* default */].$on('postAction', this.postAction);
  },
  destroyed: function destroyed() {
    this.poll.stop();
  },

  methods: {
    fetchPipelines: function fetchPipelines() {
      var _this2 = this;

      if (!this.isMakingRequest) {
        this.isLoading = true;

        this.service.getPipelines(this.requestData).then(function (response) {
          return _this2.successCallback(response);
        }).catch(function () {
          return _this2.errorCallback();
        });
      }
    },
    setCommonData: function setCommonData(pipelines) {
      this.store.storePipelines(pipelines);
      this.isLoading = false;
      this.updateGraphDropdown = true;
      this.hasMadeRequest = true;
    },
    errorCallback: function errorCallback() {
      this.hasError = true;
      this.isLoading = false;
      this.updateGraphDropdown = false;
      this.hasMadeRequest = true;
    },
    setIsMakingRequest: function setIsMakingRequest(isMakingRequest) {
      this.isMakingRequest = isMakingRequest;

      if (isMakingRequest) {
        this.updateGraphDropdown = false;
      }
    },
    postAction: function postAction(endpoint) {
      this.service.postAction(endpoint).then(function () {
        return event_hub["a" /* default */].$emit('refreshPipelines');
      }).catch(function () {
        return Object(flash["a" /* default */])(Object(locale["a" /* __ */])('An error occurred while making the request.'));
      });
    }
  }
});

/***/ }),

/***/ "./pipelines/services/pipelines_service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_vue_resource_interceptor__ = __webpack_require__("./vue_shared/vue_resource_interceptor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

var PipelinesService = function () {

  /**
  * Commits and merge request endpoints need to be requested with `.json`.
  *
  * The url provided to request the pipelines in the new merge request
  * page already has `.json`.
  *
  * @param  {String} root
  */
  function PipelinesService(root) {
    _classCallCheck(this, PipelinesService);

    var endpoint = void 0;

    if (root.indexOf('.json') === -1) {
      endpoint = root + '.json';
    } else {
      endpoint = root;
    }

    this.pipelines = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(endpoint);
  }

  _createClass(PipelinesService, [{
    key: 'getPipelines',
    value: function getPipelines() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var scope = data.scope,
          page = data.page;

      return this.pipelines.get({ scope: scope, page: page });
    }

    /**
     * Post request for all pipelines actions.
     *
     * @param  {String} endpoint
     * @return {Promise}
     */

  }, {
    key: 'postAction',
    value: function postAction(endpoint) {
      return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.post(endpoint + '.json');
    }
  }]);

  return PipelinesService;
}();

/* harmony default export */ __webpack_exports__["a"] = (PipelinesService);

/***/ }),

/***/ "./pipelines/stores/pipelines_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PipelinesStore = function () {
  function PipelinesStore() {
    _classCallCheck(this, PipelinesStore);

    this.state = {};

    this.state.pipelines = [];
    this.state.count = {};
    this.state.pageInfo = {};
  }

  _createClass(PipelinesStore, [{
    key: 'storePipelines',
    value: function storePipelines() {
      var pipelines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.state.pipelines = pipelines;
    }
  }, {
    key: 'storeCount',
    value: function storeCount() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.state.count = count;
    }
  }, {
    key: 'storePagination',
    value: function storePagination() {
      var pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var paginationInfo = void 0;

      if (Object.keys(pagination).length) {
        var normalizedHeaders = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["x" /* normalizeHeaders */])(pagination);
        paginationInfo = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_common_utils__["z" /* parseIntPagination */])(normalizedHeaders);
      } else {
        paginationInfo = pagination;
      }

      this.state.pageInfo = paginationInfo;
    }
  }]);

  return PipelinesStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (PipelinesStore);

/***/ }),

/***/ "./project_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = projectSelect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__project_select_combo_button__ = __webpack_require__("./project_select_combo_button.js");
/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-var, comma-dangle, object-shorthand, one-var, one-var-declaration-per-line, no-else-return, quotes, max-len */



function projectSelect() {
  $('.ajax-project-select').each(function (i, select) {
    var placeholder;
    var simpleFilter = $(select).data('simpleFilter') || false;
    this.groupId = $(select).data('groupId');
    this.includeGroups = $(select).data('includeGroups');
    this.allProjects = $(select).data('allProjects') || false;
    this.orderBy = $(select).data('orderBy') || 'id';
    this.withIssuesEnabled = $(select).data('withIssuesEnabled');
    this.withMergeRequestsEnabled = $(select).data('withMergeRequestsEnabled');

    placeholder = "Search for project";
    if (this.includeGroups) {
      placeholder += " or group";
    }

    $(select).select2({
      placeholder: placeholder,
      minimumInputLength: 0,
      query: function (_this) {
        return function (query) {
          var finalCallback, projectsCallback;
          finalCallback = function finalCallback(projects) {
            var data;
            data = {
              results: projects
            };
            return query.callback(data);
          };
          if (_this.includeGroups) {
            projectsCallback = function projectsCallback(projects) {
              var groupsCallback;
              groupsCallback = function groupsCallback(groups) {
                var data;
                data = groups.concat(projects);
                return finalCallback(data);
              };
              return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groups(query.term, {}, groupsCallback);
            };
          } else {
            projectsCallback = finalCallback;
          }
          if (_this.groupId) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].groupProjects(_this.groupId, query.term, projectsCallback);
          } else {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].projects(query.term, {
              order_by: _this.orderBy,
              with_issues_enabled: _this.withIssuesEnabled,
              with_merge_requests_enabled: _this.withMergeRequestsEnabled,
              membership: !_this.allProjects
            }, projectsCallback);
          }
        };
      }(this),
      id: function id(project) {
        if (simpleFilter) return project.id;
        return JSON.stringify({
          name: project.name,
          url: project.web_url
        });
      },
      text: function text(project) {
        return project.name_with_namespace || project.name;
      },
      dropdownCssClass: "ajax-project-dropdown"
    });
    if (simpleFilter) return select;
    return new __WEBPACK_IMPORTED_MODULE_1__project_select_combo_button__["a" /* default */](select);
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./project_select_combo_button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var ProjectSelectComboButton = function () {
  function ProjectSelectComboButton(select) {
    _classCallCheck(this, ProjectSelectComboButton);

    this.projectSelectInput = $(select);
    this.newItemBtn = $('.new-project-item-link');
    this.resourceType = this.newItemBtn.data('type');
    this.resourceLabel = this.newItemBtn.data('label');
    this.formattedText = this.deriveTextVariants();
    this.groupId = this.projectSelectInput.data('groupId');
    this.bindEvents();
    this.initLocalStorage();
  }

  _createClass(ProjectSelectComboButton, [{
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;

      this.projectSelectInput.siblings('.new-project-item-select-button').on('click', function (e) {
        return _this.openDropdown(e);
      });

      this.newItemBtn.on('click', function (e) {
        if (!_this.getProjectFromLocalStorage()) {
          e.preventDefault();
          _this.openDropdown(e);
        }
      });

      this.projectSelectInput.on('change', function () {
        return _this.selectProject();
      });
    }
  }, {
    key: 'initLocalStorage',
    value: function initLocalStorage() {
      var localStorageIsSafe = __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe();

      if (localStorageIsSafe) {
        this.localStorageKey = ['group', this.groupId, this.formattedText.localStorageItemType, 'recent-project'].join('-');
        this.setBtnTextFromLocalStorage();
      }
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'openDropdown',
    value: function openDropdown(event) {
      $(event.currentTarget).siblings('.project-item-select').select2('open');
    }
  }, {
    key: 'selectProject',
    value: function selectProject() {
      var selectedProjectData = JSON.parse(this.projectSelectInput.val());
      var projectUrl = selectedProjectData.url + '/' + this.projectSelectInput.data('relativePath');
      var projectName = selectedProjectData.name;

      var projectMeta = {
        url: projectUrl,
        name: projectName
      };

      this.setNewItemBtnAttributes(projectMeta);
      this.setProjectInLocalStorage(projectMeta);
    }
  }, {
    key: 'setBtnTextFromLocalStorage',
    value: function setBtnTextFromLocalStorage() {
      var cachedProjectData = this.getProjectFromLocalStorage();

      this.setNewItemBtnAttributes(cachedProjectData);
    }
  }, {
    key: 'setNewItemBtnAttributes',
    value: function setNewItemBtnAttributes(project) {
      if (project) {
        this.newItemBtn.attr('href', project.url);
        this.newItemBtn.text(this.formattedText.defaultTextPrefix + ' in ' + project.name);
      } else {
        this.newItemBtn.text('Select project to create ' + this.formattedText.presetTextSuffix);
      }
    }
  }, {
    key: 'getProjectFromLocalStorage',
    value: function getProjectFromLocalStorage() {
      var projectString = localStorage.getItem(this.localStorageKey);

      return JSON.parse(projectString);
    }
  }, {
    key: 'setProjectInLocalStorage',
    value: function setProjectInLocalStorage(projectMeta) {
      var projectString = JSON.stringify(projectMeta);

      localStorage.setItem(this.localStorageKey, projectString);
    }
  }, {
    key: 'deriveTextVariants',
    value: function deriveTextVariants() {
      var defaultTextPrefix = this.resourceLabel;

      // the trailing slice call depluralizes each of these strings (e.g. new-issues -> new-issue)
      var localStorageItemType = 'new-' + this.resourceType.split('_').join('-').slice(0, -1);
      var presetTextSuffix = this.resourceType.split('_').join(' ').slice(0, -1);

      return {
        localStorageItemType: localStorageItemType, // new-issue / new-merge-request
        defaultTextPrefix: defaultTextPrefix, // New issue / New merge request
        presetTextSuffix: presetTextSuffix // issue / merge request
      };
    }
  }]);

  return ProjectSelectComboButton;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProjectSelectComboButton);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./right_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-unused-vars, consistent-return, one-var, one-var-declaration-per-line, quotes, prefer-template, object-shorthand, comma-dangle, no-else-return, no-param-reassign, max-len */






function Sidebar(currentUser) {
  this.toggleTodo = this.toggleTodo.bind(this);
  this.sidebar = $('aside');

  this.removeListeners();
  this.addEventListeners();
}

Sidebar.initialize = function (currentUser) {
  if (!this.instance) {
    this.instance = new Sidebar(currentUser);
  }
};

Sidebar.prototype.removeListeners = function () {
  this.sidebar.off('click', '.sidebar-collapsed-icon');
  this.sidebar.off('hidden.gl.dropdown');
  $('.dropdown').off('loading.gl.dropdown');
  $('.dropdown').off('loaded.gl.dropdown');
  $(document).off('click', '.js-sidebar-toggle');
};

Sidebar.prototype.addEventListeners = function () {
  var $document = $(document);

  this.sidebar.on('click', '.sidebar-collapsed-icon', this, this.sidebarCollapseClicked);
  this.sidebar.on('hidden.gl.dropdown', this, this.onSidebarDropdownHidden);
  $('.dropdown').on('loading.gl.dropdown', this.sidebarDropdownLoading);
  $('.dropdown').on('loaded.gl.dropdown', this.sidebarDropdownLoaded);

  $document.on('click', '.js-sidebar-toggle', this.sidebarToggleClicked);
  return $(document).off('click', '.js-issuable-todo').on('click', '.js-issuable-todo', this.toggleTodo);
};

Sidebar.prototype.sidebarToggleClicked = function (e, triggered) {
  var $allGutterToggleIcons, $this, $thisIcon;
  e.preventDefault();
  $this = $(this);
  $thisIcon = $this.find('i');
  $allGutterToggleIcons = $('.js-sidebar-toggle i');
  if ($thisIcon.hasClass('fa-angle-double-right')) {
    $allGutterToggleIcons.removeClass('fa-angle-double-right').addClass('fa-angle-double-left');
    $('aside.right-sidebar').removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
    $('.layout-page').removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
  } else {
    $allGutterToggleIcons.removeClass('fa-angle-double-left').addClass('fa-angle-double-right');
    $('aside.right-sidebar').removeClass('right-sidebar-collapsed').addClass('right-sidebar-expanded');
    $('.layout-page').removeClass('right-sidebar-collapsed').addClass('right-sidebar-expanded');

    if (gl.lazyLoader) gl.lazyLoader.loadCheck();
  }
  if (!triggered) {
    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set("collapsed_gutter", $('.right-sidebar').hasClass('right-sidebar-collapsed'));
  }
};

Sidebar.prototype.toggleTodo = function (e) {
  var _this = this;

  var $btnText, $this, $todoLoading, ajaxType, url;
  $this = $(e.currentTarget);
  ajaxType = $this.attr('data-delete-path') ? 'delete' : 'post';
  if ($this.attr('data-delete-path')) {
    url = "" + $this.attr('data-delete-path');
  } else {
    url = "" + $this.data('url');
  }

  $this.tooltip('hide');

  $('.js-issuable-todo').disable().addClass('is-loading');

  __WEBPACK_IMPORTED_MODULE_3__lib_utils_axios_utils__["a" /* default */][ajaxType](url, {
    issuable_id: $this.data('issuableId'),
    issuable_type: $this.data('issuableType')
  }).then(function (_ref) {
    var data = _ref.data;

    _this.todoUpdateDone(data);
  }).catch(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])('There was an error ' + (ajaxType === 'post' ? 'adding a' : 'deleting the') + ' todo.');
  });
};

Sidebar.prototype.todoUpdateDone = function (data) {
  var deletePath = data.delete_path ? data.delete_path : null;
  var attrPrefix = deletePath ? 'mark' : 'todo';
  var $todoBtns = $('.js-issuable-todo');

  $(document).trigger('todo:toggle', data.count);

  $todoBtns.each(function (i, el) {
    var $el = $(el);
    var $elText = $el.find('.js-issuable-todo-inner');

    $el.removeClass('is-loading').enable().attr('aria-label', $el.data(attrPrefix + 'Text')).attr('data-delete-path', deletePath).attr('title', $el.data(attrPrefix + 'Text'));

    if ($el.hasClass('has-tooltip')) {
      $el.tooltip('fixTitle');
    }

    if ($el.data(attrPrefix + 'Icon')) {
      $elText.html($el.data(attrPrefix + 'Icon'));
    } else {
      $elText.text($el.data(attrPrefix + 'Text'));
    }
  });
};

Sidebar.prototype.sidebarDropdownLoading = function (e) {
  var $loading, $sidebarCollapsedIcon, i, img;
  $sidebarCollapsedIcon = $(this).closest('.block').find('.sidebar-collapsed-icon');
  img = $sidebarCollapsedIcon.find('img');
  i = $sidebarCollapsedIcon.find('i');
  $loading = $('<i class="fa fa-spinner fa-spin"></i>');
  if (img.length) {
    img.before($loading);
    return img.hide();
  } else if (i.length) {
    i.before($loading);
    return i.hide();
  }
};

Sidebar.prototype.sidebarDropdownLoaded = function (e) {
  var $sidebarCollapsedIcon, i, img;
  $sidebarCollapsedIcon = $(this).closest('.block').find('.sidebar-collapsed-icon');
  img = $sidebarCollapsedIcon.find('img');
  $sidebarCollapsedIcon.find('i.fa-spin').remove();
  i = $sidebarCollapsedIcon.find('i');
  if (img.length) {
    return img.show();
  } else {
    return i.show();
  }
};

Sidebar.prototype.sidebarCollapseClicked = function (e) {
  var $block, sidebar;
  if ($(e.currentTarget).hasClass('dont-change-state')) {
    return;
  }
  sidebar = e.data;
  e.preventDefault();
  $block = $(this).closest('.block');
  return sidebar.openDropdown($block);
};

Sidebar.prototype.openDropdown = function (blockOrName) {
  var $block;
  $block = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.isString(blockOrName) ? this.getBlock(blockOrName) : blockOrName;
  if (!this.isOpen()) {
    this.setCollapseAfterUpdate($block);
    this.toggleSidebar('open');
  }

  // Wait for the sidebar to trigger('click') open
  // so it doesn't cause our dropdown to close preemptively
  setTimeout(function () {
    $block.find('.js-sidebar-dropdown-toggle').trigger('click');
  });
};

Sidebar.prototype.setCollapseAfterUpdate = function ($block) {
  $block.addClass('collapse-after-update');
  return $('.layout-page').addClass('with-overlay');
};

Sidebar.prototype.onSidebarDropdownHidden = function (e) {
  var $block, sidebar;
  sidebar = e.data;
  e.preventDefault();
  $block = $(e.target).closest('.block');
  return sidebar.sidebarDropdownHidden($block);
};

Sidebar.prototype.sidebarDropdownHidden = function ($block) {
  if ($block.hasClass('collapse-after-update')) {
    $block.removeClass('collapse-after-update');
    $('.layout-page').removeClass('with-overlay');
    return this.toggleSidebar('hide');
  }
};

Sidebar.prototype.triggerOpenSidebar = function () {
  return this.sidebar.find('.js-sidebar-toggle').trigger('click');
};

Sidebar.prototype.toggleSidebar = function (action) {
  if (action == null) {
    action = 'toggle';
  }
  if (action === 'toggle') {
    this.triggerOpenSidebar();
  }
  if (action === 'open') {
    if (!this.isOpen()) {
      this.triggerOpenSidebar();
    }
  }
  if (action === 'hide') {
    if (this.isOpen()) {
      return this.triggerOpenSidebar();
    }
  }
};

Sidebar.prototype.isOpen = function () {
  return this.sidebar.is('.right-sidebar-expanded');
};

Sidebar.prototype.getBlock = function (name) {
  return this.sidebar.find(".block." + name);
};

/* harmony default export */ __webpack_exports__["a"] = (Sidebar);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./shortcuts_issuable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__right_sidebar__ = __webpack_require__("./right_sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shortcuts__ = __webpack_require__("./shortcuts.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__behaviors_copy_as_gfm__ = __webpack_require__("./behaviors/copy_as_gfm.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ShortcutsIssuable = function (_Shortcuts) {
  _inherits(ShortcutsIssuable, _Shortcuts);

  function ShortcutsIssuable(isMergeRequest) {
    _classCallCheck(this, ShortcutsIssuable);

    var _this = _possibleConstructorReturn(this, (ShortcutsIssuable.__proto__ || Object.getPrototypeOf(ShortcutsIssuable)).call(this));

    _this.$replyField = isMergeRequest ? $('.js-main-target-form #note_note') : $('.js-main-target-form .js-vue-comment-form');

    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('a', function () {
      return ShortcutsIssuable.openSidebarDropdown('assignee');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('m', function () {
      return ShortcutsIssuable.openSidebarDropdown('milestone');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('l', function () {
      return ShortcutsIssuable.openSidebarDropdown('labels');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('r', _this.replyWithSelectedText.bind(_this));
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('e', ShortcutsIssuable.editIssue);

    if (isMergeRequest) {
      _this.enabledHelp.push('.hidden-shortcut.merge_requests');
    } else {
      _this.enabledHelp.push('.hidden-shortcut.issues');
    }
    return _this;
  }

  _createClass(ShortcutsIssuable, [{
    key: 'replyWithSelectedText',
    value: function replyWithSelectedText() {
      var documentFragment = window.gl.utils.getSelectedFragment();

      if (!documentFragment) {
        this.$replyField.focus();
        return false;
      }

      var el = __WEBPACK_IMPORTED_MODULE_4__behaviors_copy_as_gfm__["a" /* CopyAsGFM */].transformGFMSelection(documentFragment.cloneNode(true));
      var selected = __WEBPACK_IMPORTED_MODULE_4__behaviors_copy_as_gfm__["a" /* CopyAsGFM */].nodeToGFM(el);

      if (selected.trim() === '') {
        return false;
      }

      var quote = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.map(selected.split('\n'), function (val) {
        return ('> ' + val).trim() + '\n';
      });

      // If replyField already has some content, add a newline before our quote
      var separator = this.$replyField.val().trim() !== '' && '\n\n' || '';
      this.$replyField.val(function (a, current) {
        return '' + current + separator + quote.join('') + '\n';
      }).trigger('input').trigger('change');

      // Trigger autosize
      var event = document.createEvent('Event');
      event.initEvent('autosize:update', true, false);
      this.$replyField.get(0).dispatchEvent(event);

      // Focus the input field
      this.$replyField.focus();

      return false;
    }
  }], [{
    key: 'editIssue',
    value: function editIssue() {
      // Need to click the element as on issues, editing is inline
      // on merge request, editing is on a different page
      document.querySelector('.js-issuable-edit').click();

      return false;
    }
  }, {
    key: 'openSidebarDropdown',
    value: function openSidebarDropdown(name) {
      __WEBPACK_IMPORTED_MODULE_2__right_sidebar__["a" /* default */].instance.openDropdown(name);
      return false;
    }
  }]);

  return ShortcutsIssuable;
}(__WEBPACK_IMPORTED_MODULE_3__shortcuts__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ShortcutsIssuable);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./sidebar/components/assignees/assignee_title.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AssigneeTitle',
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    numberOfAssignees: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    },
    showToggle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    assigneeTitle: function assigneeTitle() {
      var assignees = this.numberOfAssignees;
      return assignees > 1 ? assignees + ' Assignees' : 'Assignee';
    }
  },
  template: '\n    <div class="title hide-collapsed">\n      {{assigneeTitle}}\n      <i\n        v-if="loading"\n        aria-hidden="true"\n        class="fa fa-spinner fa-spin block-loading"\n      />\n      <a\n        v-if="editable"\n        class="js-sidebar-dropdown-toggle edit-link pull-right"\n        href="#"\n      >\n        {{ __(\'Edit\') }}\n      </a>\n      <a\n        v-if="showToggle"\n        aria-label="Toggle sidebar"\n        class="gutter-toggle pull-right js-sidebar-toggle"\n        href="#"\n        role="button"\n      >\n        <i\n          aria-hidden="true"\n          data-hidden="true"\n          class="fa fa-angle-double-right"\n        />\n      </a>\n    </div>\n  '
});

/***/ }),

/***/ "./sidebar/components/assignees/assignees.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/assignees/assignees.vue

/* harmony default export */ var assignees = ({
  name: 'Assignees',
  props: {
    rootPath: {
      type: String,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      defaultRenderCount: 5,
      defaultMaxCounter: 99,
      showLess: true
    };
  },

  computed: {
    firstUser: function firstUser() {
      return this.users[0];
    },
    hasMoreThanTwoAssignees: function hasMoreThanTwoAssignees() {
      return this.users.length > 2;
    },
    hasMoreThanOneAssignee: function hasMoreThanOneAssignee() {
      return this.users.length > 1;
    },
    hasAssignees: function hasAssignees() {
      return this.users.length > 0;
    },
    hasNoUsers: function hasNoUsers() {
      return !this.users.length;
    },
    hasOneUser: function hasOneUser() {
      return this.users.length === 1;
    },
    renderShowMoreSection: function renderShowMoreSection() {
      return this.users.length > this.defaultRenderCount;
    },
    numberOfHiddenAssignees: function numberOfHiddenAssignees() {
      return this.users.length - this.defaultRenderCount;
    },
    isHiddenAssignees: function isHiddenAssignees() {
      return this.numberOfHiddenAssignees > 0;
    },
    hiddenAssigneesLabel: function hiddenAssigneesLabel() {
      return '+ ' + this.numberOfHiddenAssignees + ' more';
    },
    collapsedTooltipTitle: function collapsedTooltipTitle() {
      var maxRender = Math.min(this.defaultRenderCount, this.users.length);
      var renderUsers = this.users.slice(0, maxRender);
      var names = renderUsers.map(function (u) {
        return u.name;
      });

      if (this.users.length > maxRender) {
        names.push('+ ' + (this.users.length - maxRender) + ' more');
      }

      return names.join(', ');
    },
    sidebarAvatarCounter: function sidebarAvatarCounter() {
      var counter = '+' + (this.users.length - 1);

      if (this.users.length > this.defaultMaxCounter) {
        counter = this.defaultMaxCounter + '+';
      }

      return counter;
    }
  },
  methods: {
    assignSelf: function assignSelf() {
      this.$emit('assign-self');
    },
    toggleShowLess: function toggleShowLess() {
      this.showLess = !this.showLess;
    },
    renderAssignee: function renderAssignee(index) {
      return !this.showLess || index < this.defaultRenderCount && this.showLess;
    },
    avatarUrl: function avatarUrl(user) {
      return user.avatar || user.avatar_url || gon.default_avatar_url;
    },
    assigneeUrl: function assigneeUrl(user) {
      return '' + this.rootPath + user.username;
    },
    assigneeAlt: function assigneeAlt(user) {
      return user.name + '\'s avatar';
    },
    assigneeUsername: function assigneeUsername(user) {
      return '@' + user.username;
    },
    shouldRenderCollapsedAssignee: function shouldRenderCollapsedAssignee(index) {
      var firstTwo = this.users.length <= 2 && index <= 2;

      return index === 0 || firstTwo;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02fef924","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/assignees/assignees.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar-collapsed-icon sidebar-collapsed-user",class:{ 'multiple-users': _vm.hasMoreThanOneAssignee, 'has-tooltip': _vm.hasAssignees },attrs:{"data-container":"body","data-placement":"left","title":_vm.collapsedTooltipTitle}},[(_vm.hasNoUsers)?_c('i',{staticClass:"fa fa-user",attrs:{"aria-label":"No Assignee"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.users),function(user,index){return (_vm.shouldRenderCollapsedAssignee(index))?_c('button',{key:user.id,staticClass:"btn-link",attrs:{"type":"button"}},[_c('img',{staticClass:"avatar avatar-inline s24",attrs:{"width":"24","alt":_vm.assigneeAlt(user),"src":_vm.avatarUrl(user)}}),_vm._v(" "),_c('span',{staticClass:"author"},[_vm._v("\n        "+_vm._s(user.name)+"\n      ")])]):_vm._e()}),_vm._v(" "),(_vm.hasMoreThanTwoAssignees)?_c('button',{staticClass:"btn-link",attrs:{"type":"button"}},[_c('span',{staticClass:"avatar-counter sidebar-avatar-counter"},[_vm._v("\n        "+_vm._s(_vm.sidebarAvatarCounter)+"\n      ")])]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"value hide-collapsed"},[(_vm.hasNoUsers)?[_c('span',{staticClass:"assign-yourself no-value"},[_vm._v("\n        No assignee\n        "),(_vm.editable)?[_vm._v("\n          -\n          "),_c('button',{staticClass:"btn-link",attrs:{"type":"button"},on:{"click":_vm.assignSelf}},[_vm._v("\n            assign yourself\n          ")])]:_vm._e()],2)]:(_vm.hasOneUser)?[_c('a',{staticClass:"author_link bold",attrs:{"href":_vm.assigneeUrl(_vm.firstUser)}},[_c('img',{staticClass:"avatar avatar-inline s32",attrs:{"width":"32","alt":_vm.assigneeAlt(_vm.firstUser),"src":_vm.avatarUrl(_vm.firstUser)}}),_vm._v(" "),_c('span',{staticClass:"author"},[_vm._v("\n          "+_vm._s(_vm.firstUser.name)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"username"},[_vm._v("\n          "+_vm._s(_vm.assigneeUsername(_vm.firstUser))+"\n        ")])])]:[_c('div',{staticClass:"user-list"},_vm._l((_vm.users),function(user,index){return (_vm.renderAssignee(index))?_c('div',{key:user.id,staticClass:"user-item"},[_c('a',{staticClass:"user-link has-tooltip",attrs:{"data-container":"body","data-placement":"bottom","href":_vm.assigneeUrl(user),"data-title":user.name}},[_c('img',{staticClass:"avatar avatar-inline s32",attrs:{"width":"32","alt":_vm.assigneeAlt(user),"src":_vm.avatarUrl(user)}})])]):_vm._e()})),_vm._v(" "),(_vm.renderShowMoreSection)?_c('div',{staticClass:"user-list-more"},[_c('button',{staticClass:"btn-link",attrs:{"type":"button"},on:{"click":_vm.toggleShowLess}},[(_vm.showLess)?[_vm._v("\n            "+_vm._s(_vm.hiddenAssigneesLabel)+"\n          ")]:[_vm._v("\n            - show less\n          ")]],2)]):_vm._e()]],2)])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/assignees/assignees.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  assignees,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var assignees_assignees = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./sidebar/components/assignees/sidebar_assignees.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./sidebar/components/assignees/assignee_title.js
var assignee_title = __webpack_require__("./sidebar/components/assignees/assignee_title.js");

// EXTERNAL MODULE: ./sidebar/components/assignees/assignees.vue + 2 modules
var assignees = __webpack_require__("./sidebar/components/assignees/assignees.vue");

// EXTERNAL MODULE: ./sidebar/stores/sidebar_store.js
var sidebar_store = __webpack_require__("./sidebar/stores/sidebar_store.js");

// EXTERNAL MODULE: ./sidebar/event_hub.js
var event_hub = __webpack_require__("./sidebar/event_hub.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/assignees/sidebar_assignees.vue







/* harmony default export */ var sidebar_assignees = ({
  name: 'SidebarAssignees',
  components: {
    AssigneeTitle: assignee_title["a" /* default */],
    Assignees: assignees["a" /* default */]
  },
  props: {
    mediator: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    signedIn: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      store: new sidebar_store["a" /* default */](),
      loading: false
    };
  },
  created: function created() {
    this.removeAssignee = this.store.removeAssignee.bind(this.store);
    this.addAssignee = this.store.addAssignee.bind(this.store);
    this.removeAllAssignees = this.store.removeAllAssignees.bind(this.store);

    // Get events from glDropdown
    event_hub["a" /* default */].$on('sidebar.removeAssignee', this.removeAssignee);
    event_hub["a" /* default */].$on('sidebar.addAssignee', this.addAssignee);
    event_hub["a" /* default */].$on('sidebar.removeAllAssignees', this.removeAllAssignees);
    event_hub["a" /* default */].$on('sidebar.saveAssignees', this.saveAssignees);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('sidebar.removeAssignee', this.removeAssignee);
    event_hub["a" /* default */].$off('sidebar.addAssignee', this.addAssignee);
    event_hub["a" /* default */].$off('sidebar.removeAllAssignees', this.removeAllAssignees);
    event_hub["a" /* default */].$off('sidebar.saveAssignees', this.saveAssignees);
  },

  methods: {
    assignSelf: function assignSelf() {
      // Notify gl dropdown that we are now assigning to current user
      this.$el.parentElement.dispatchEvent(new Event('assignYourself'));

      this.mediator.assignYourself();
      this.saveAssignees();
    },
    saveAssignees: function saveAssignees() {
      this.loading = true;

      function setLoadingFalse() {
        this.loading = false;
      }

      this.mediator.saveAssignees(this.field).then(setLoadingFalse.bind(this)).catch(function () {
        setLoadingFalse();
        return new flash["a" /* default */]('Error occurred when saving assignees');
      });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1589a2dd","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/assignees/sidebar_assignees.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('assignee-title',{attrs:{"number-of-assignees":_vm.store.assignees.length,"loading":_vm.loading || _vm.store.isFetching.assignees,"editable":_vm.store.editable,"show-toggle":!_vm.signedIn}}),_vm._v(" "),(!_vm.store.isFetching.assignees)?_c('assignees',{staticClass:"value",attrs:{"root-path":_vm.store.rootPath,"users":_vm.store.assignees,"editable":_vm.store.editable},on:{"assign-self":_vm.assignSelf}}):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/assignees/sidebar_assignees.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sidebar_assignees,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var assignees_sidebar_assignees = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./sidebar/components/confidential/confidential_issue_sidebar.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/confidential/edit_form_buttons.vue

/* harmony default export */ var edit_form_buttons = ({
  props: {
    isConfidential: {
      required: true,
      type: Boolean
    },
    toggleForm: {
      required: true,
      type: Function
    },
    updateConfidentialAttribute: {
      required: true,
      type: Function
    }
  },
  computed: {
    toggleButtonText: function toggleButtonText() {
      return this.isConfidential ? 'Turn Off' : 'Turn On';
    },
    updateConfidentialBool: function updateConfidentialBool() {
      return !this.isConfidential;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e44864f","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/confidential/edit_form_buttons.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-item-warning-message-actions"},[_c('button',{staticClass:"btn btn-default append-right-10",attrs:{"type":"button"},on:{"click":_vm.toggleForm}},[_vm._v("\n    "+_vm._s(_vm.__('Cancel'))+"\n  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-close",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.updateConfidentialAttribute(_vm.updateConfidentialBool)}}},[_vm._v("\n    "+_vm._s(_vm.toggleButtonText)+"\n  ")])])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/confidential/edit_form_buttons.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  edit_form_buttons,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var confidential_edit_form_buttons = (Component.exports);

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/confidential/edit_form.vue




/* harmony default export */ var edit_form = ({
  components: {
    editFormButtons: confidential_edit_form_buttons
  },
  props: {
    isConfidential: {
      required: true,
      type: Boolean
    },
    toggleForm: {
      required: true,
      type: Function
    },
    updateConfidentialAttribute: {
      required: true,
      type: Function
    }
  },
  computed: {
    confidentialityOnWarning: function confidentialityOnWarning() {
      return Object(locale["e" /* s__ */])('confidentiality|You are going to turn on the confidentiality. This means that only team members with <strong>at least Reporter access</strong> are able to see and leave comments on the issue.');
    },
    confidentialityOffWarning: function confidentialityOffWarning() {
      return Object(locale["e" /* s__ */])('confidentiality|You are going to turn off the confidentiality. This means <strong>everyone</strong> will be able to see and leave a comment on this issue.');
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-562b52c5","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/confidential/edit_form.vue
var edit_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown open"},[_c('div',{staticClass:"dropdown-menu sidebar-item-warning-message"},[_c('div',[(!_vm.isConfidential)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.confidentialityOnWarning)}}):_c('p',{domProps:{"innerHTML":_vm._s(_vm.confidentialityOffWarning)}}),_vm._v(" "),_c('edit-form-buttons',{attrs:{"is-confidential":_vm.isConfidential,"toggle-form":_vm.toggleForm,"update-confidential-attribute":_vm.updateConfidentialAttribute}})],1)])])}
var edit_form_staticRenderFns = []

// CONCATENATED MODULE: ./sidebar/components/confidential/edit_form.vue
/* script */


/* template */

/* template functional */
var edit_form___vue_template_functional__ = false
/* styles */
var edit_form___vue_styles__ = null
/* scopeId */
var edit_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var edit_form___vue_module_identifier__ = null

var edit_form_Component = Object(component_normalizer["a" /* default */])(
  edit_form,
  edit_form_render,
  edit_form_staticRenderFns,
  edit_form___vue_template_functional__,
  edit_form___vue_styles__,
  edit_form___vue_scopeId__,
  edit_form___vue_module_identifier__
)

/* harmony default export */ var confidential_edit_form = (edit_form_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/confidential/confidential_issue_sidebar.vue






/* harmony default export */ var confidential_issue_sidebar = ({
  components: {
    editForm: confidential_edit_form,
    Icon: icon["a" /* default */]
  },
  props: {
    isConfidential: {
      required: true,
      type: Boolean
    },
    isEditable: {
      required: true,
      type: Boolean
    },
    service: {
      required: true,
      type: Object
    }
  },
  data: function data() {
    return {
      edit: false
    };
  },

  computed: {
    confidentialityIcon: function confidentialityIcon() {
      return this.isConfidential ? 'eye-slash' : 'eye';
    }
  },
  methods: {
    toggleForm: function toggleForm() {
      this.edit = !this.edit;
    },
    updateConfidentialAttribute: function updateConfidentialAttribute(confidential) {
      this.service.update('issue', { confidential: confidential }).then(function () {
        return location.reload();
      }).catch(function () {
        Object(flash["a" /* default */])(Object(locale["a" /* __ */])('Something went wrong trying to change the confidentiality of this issue'));
      });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5945913e","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/confidential/confidential_issue_sidebar.vue
var confidential_issue_sidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block issuable-sidebar-item confidentiality"},[_c('div',{staticClass:"sidebar-collapsed-icon"},[_c('icon',{attrs:{"name":_vm.confidentialityIcon,"size":16,"aria-hidden":"true"}})],1),_vm._v(" "),_c('div',{staticClass:"title hide-collapsed"},[_vm._v("\n    "+_vm._s(_vm.__('Confidentiality'))+"\n    "),(_vm.isEditable)?_c('a',{staticClass:"pull-right confidential-edit",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.toggleForm($event)}}},[_vm._v("\n      "+_vm._s(_vm.__('Edit'))+"\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"value sidebar-item-value hide-collapsed"},[(_vm.edit)?_c('editForm',{attrs:{"toggle-form":_vm.toggleForm,"is-confidential":_vm.isConfidential,"update-confidential-attribute":_vm.updateConfidentialAttribute}}):_vm._e(),_vm._v(" "),(!_vm.isConfidential)?_c('div',{staticClass:"no-value sidebar-item-value"},[_c('icon',{staticClass:"sidebar-item-icon inline",attrs:{"name":"eye","size":16,"aria-hidden":"true"}}),_vm._v("\n      "+_vm._s(_vm.__('Not confidential'))+"\n    ")],1):_c('div',{staticClass:"value sidebar-item-value hide-collapsed"},[_c('icon',{staticClass:"sidebar-item-icon inline is-active",attrs:{"name":"eye-slash","size":16,"aria-hidden":"true"}}),_vm._v("\n      "+_vm._s(_vm.__('This issue is confidential'))+"\n    ")],1)],1)])}
var confidential_issue_sidebar_staticRenderFns = []

// CONCATENATED MODULE: ./sidebar/components/confidential/confidential_issue_sidebar.vue
/* script */


/* template */

/* template functional */
var confidential_issue_sidebar___vue_template_functional__ = false
/* styles */
var confidential_issue_sidebar___vue_styles__ = null
/* scopeId */
var confidential_issue_sidebar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confidential_issue_sidebar___vue_module_identifier__ = null

var confidential_issue_sidebar_Component = Object(component_normalizer["a" /* default */])(
  confidential_issue_sidebar,
  confidential_issue_sidebar_render,
  confidential_issue_sidebar_staticRenderFns,
  confidential_issue_sidebar___vue_template_functional__,
  confidential_issue_sidebar___vue_styles__,
  confidential_issue_sidebar___vue_scopeId__,
  confidential_issue_sidebar___vue_module_identifier__
)

/* harmony default export */ var confidential_confidential_issue_sidebar = __webpack_exports__["a"] = (confidential_issue_sidebar_Component.exports);


/***/ }),

/***/ "./sidebar/components/lock/lock_issue_sidebar.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/lock/edit_form_buttons.vue

/* harmony default export */ var edit_form_buttons = ({
  props: {
    isLocked: {
      required: true,
      type: Boolean
    },

    toggleForm: {
      required: true,
      type: Function
    },

    updateLockedAttribute: {
      required: true,
      type: Function
    }
  },

  computed: {
    buttonText: function buttonText() {
      return this.isLocked ? this.__('Unlock') : this.__('Lock');
    },
    toggleLock: function toggleLock() {
      return !this.isLocked;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-393c72f5","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/lock/edit_form_buttons.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-item-warning-message-actions"},[_c('button',{staticClass:"btn btn-default append-right-10",attrs:{"type":"button"},on:{"click":_vm.toggleForm}},[_vm._v("\n    "+_vm._s(_vm.__('Cancel'))+"\n  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-close",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.updateLockedAttribute(_vm.toggleLock)}}},[_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")])])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/lock/edit_form_buttons.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  edit_form_buttons,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var lock_edit_form_buttons = (Component.exports);

// EXTERNAL MODULE: ./vue_shared/mixins/issuable.js
var issuable = __webpack_require__("./vue_shared/mixins/issuable.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/lock/edit_form.vue





/* harmony default export */ var edit_form = ({
  components: {
    editFormButtons: lock_edit_form_buttons
  },
  mixins: [issuable["a" /* default */]],
  props: {
    isLocked: {
      required: true,
      type: Boolean
    },

    toggleForm: {
      required: true,
      type: Function
    },

    updateLockedAttribute: {
      required: true,
      type: Function
    }
  },
  computed: {
    lockWarning: function lockWarning() {
      return Object(locale["f" /* sprintf */])(Object(locale["a" /* __ */])('Lock this %{issuableDisplayName}? Only <strong>project members</strong> will be able to comment.'), { issuableDisplayName: this.issuableDisplayName });
    },
    unlockWarning: function unlockWarning() {
      return Object(locale["f" /* sprintf */])(Object(locale["a" /* __ */])('Unlock this %{issuableDisplayName}? <strong>Everyone</strong> will be able to comment.'), { issuableDisplayName: this.issuableDisplayName });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3432d361","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/lock/edit_form.vue
var edit_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown open"},[_c('div',{staticClass:"dropdown-menu sidebar-item-warning-message"},[(_vm.isLocked)?_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.unlockWarning)}}):_c('p',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.lockWarning)}}),_vm._v(" "),_c('edit-form-buttons',{attrs:{"is-locked":_vm.isLocked,"toggle-form":_vm.toggleForm,"update-locked-attribute":_vm.updateLockedAttribute}})],1)])}
var edit_form_staticRenderFns = []

// CONCATENATED MODULE: ./sidebar/components/lock/edit_form.vue
/* script */


/* template */

/* template functional */
var edit_form___vue_template_functional__ = false
/* styles */
var edit_form___vue_styles__ = null
/* scopeId */
var edit_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var edit_form___vue_module_identifier__ = null

var edit_form_Component = Object(component_normalizer["a" /* default */])(
  edit_form,
  edit_form_render,
  edit_form_staticRenderFns,
  edit_form___vue_template_functional__,
  edit_form___vue_styles__,
  edit_form___vue_scopeId__,
  edit_form___vue_module_identifier__
)

/* harmony default export */ var lock_edit_form = (edit_form_Component.exports);

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/lock/lock_issue_sidebar.vue






/* harmony default export */ var lock_issue_sidebar = ({
  components: {
    editForm: lock_edit_form,
    Icon: icon["a" /* default */]
  },
  mixins: [issuable["a" /* default */]],

  props: {
    isLocked: {
      required: true,
      type: Boolean
    },

    isEditable: {
      required: true,
      type: Boolean
    },

    mediator: {
      required: true,
      type: Object,
      validator: function validator(mediatorObject) {
        return mediatorObject.service && mediatorObject.service.update && mediatorObject.store;
      }
    }
  },

  computed: {
    lockIcon: function lockIcon() {
      return this.isLocked ? 'lock' : 'lock-open';
    },
    isLockDialogOpen: function isLockDialogOpen() {
      return this.mediator.store.isLockDialogOpen;
    }
  },

  methods: {
    toggleForm: function toggleForm() {
      this.mediator.store.isLockDialogOpen = !this.mediator.store.isLockDialogOpen;
    },
    updateLockedAttribute: function updateLockedAttribute(locked) {
      var _this = this;

      this.mediator.service.update(this.issuableType, {
        discussion_locked: locked
      }).then(function () {
        return location.reload();
      }).catch(function () {
        return Object(flash["a" /* default */])(_this.__('Something went wrong trying to change the locked state of this ' + _this.issuableDisplayName));
      });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46351bb8","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/lock/lock_issue_sidebar.vue
var lock_issue_sidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block issuable-sidebar-item lock"},[_c('div',{staticClass:"sidebar-collapsed-icon"},[_c('icon',{staticClass:"sidebar-item-icon is-active",attrs:{"name":_vm.lockIcon,"size":16,"aria-hidden":"true"}})],1),_vm._v(" "),_c('div',{staticClass:"title hide-collapsed"},[_vm._v("\n    "+_vm._s(_vm.sprintf(_vm.__('Lock %{issuableDisplayName}'), { issuableDisplayName: _vm.issuableDisplayName }))+"\n    "),(_vm.isEditable)?_c('button',{staticClass:"pull-right lock-edit",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.toggleForm($event)}}},[_vm._v("\n      "+_vm._s(_vm.__('Edit'))+"\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"value sidebar-item-value hide-collapsed"},[(_vm.isLockDialogOpen)?_c('edit-form',{attrs:{"toggle-form":_vm.toggleForm,"is-locked":_vm.isLocked,"update-locked-attribute":_vm.updateLockedAttribute,"issuable-type":_vm.issuableType}}):_vm._e(),_vm._v(" "),(_vm.isLocked)?_c('div',{staticClass:"value sidebar-item-value"},[_c('icon',{staticClass:"sidebar-item-icon inline is-active",attrs:{"name":"lock","size":16,"aria-hidden":"true"}}),_vm._v("\n      "+_vm._s(_vm.__('Locked'))+"\n    ")],1):_c('div',{staticClass:"no-value sidebar-item-value hide-collapsed"},[_c('icon',{staticClass:"sidebar-item-icon inline",attrs:{"name":"lock-open","size":16,"aria-hidden":"true"}}),_vm._v("\n      "+_vm._s(_vm.__('Unlocked'))+"\n    ")],1)],1)])}
var lock_issue_sidebar_staticRenderFns = []

// CONCATENATED MODULE: ./sidebar/components/lock/lock_issue_sidebar.vue
/* script */


/* template */

/* template functional */
var lock_issue_sidebar___vue_template_functional__ = false
/* styles */
var lock_issue_sidebar___vue_styles__ = null
/* scopeId */
var lock_issue_sidebar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var lock_issue_sidebar___vue_module_identifier__ = null

var lock_issue_sidebar_Component = Object(component_normalizer["a" /* default */])(
  lock_issue_sidebar,
  lock_issue_sidebar_render,
  lock_issue_sidebar_staticRenderFns,
  lock_issue_sidebar___vue_template_functional__,
  lock_issue_sidebar___vue_styles__,
  lock_issue_sidebar___vue_scopeId__,
  lock_issue_sidebar___vue_module_identifier__
)

/* harmony default export */ var lock_lock_issue_sidebar = __webpack_exports__["a"] = (lock_issue_sidebar_Component.exports);


/***/ }),

/***/ "./sidebar/components/participants/sidebar_participants.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./sidebar/stores/sidebar_store.js
var sidebar_store = __webpack_require__("./sidebar/stores/sidebar_store.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue + 2 modules
var user_avatar_image = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/participants/participants.vue





/* harmony default export */ var participants = ({
  components: {
    loadingIcon: loading_icon["a" /* default */],
    userAvatarImage: user_avatar_image["a" /* default */]
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    participants: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    numberOfLessParticipants: {
      type: Number,
      required: false,
      default: 7
    }
  },
  data: function data() {
    return {
      isShowingMoreParticipants: false
    };
  },

  computed: {
    lessParticipants: function lessParticipants() {
      return this.participants.slice(0, this.numberOfLessParticipants);
    },
    visibleParticipants: function visibleParticipants() {
      return this.isShowingMoreParticipants ? this.participants : this.lessParticipants;
    },
    hasMoreParticipants: function hasMoreParticipants() {
      return this.participants.length > this.numberOfLessParticipants;
    },
    toggleLabel: function toggleLabel() {
      var label = '';
      if (this.isShowingMoreParticipants) {
        label = Object(locale["a" /* __ */])('- show less');
      } else {
        label = Object(locale["f" /* sprintf */])(Object(locale["a" /* __ */])('+ %{moreCount} more'), {
          moreCount: this.participants.length - this.numberOfLessParticipants
        });
      }

      return label;
    },
    participantLabel: function participantLabel() {
      return Object(locale["f" /* sprintf */])(Object(locale["d" /* n__ */])('%{count} participant', '%{count} participants', this.participants.length), { count: this.loading ? '' : this.participantCount });
    },
    participantCount: function participantCount() {
      return this.participants.length;
    }
  },
  methods: {
    toggleMoreParticipants: function toggleMoreParticipants() {
      this.isShowingMoreParticipants = !this.isShowingMoreParticipants;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e3b61e6","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/participants/participants.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar-collapsed-icon"},[_c('i',{staticClass:"fa fa-users",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.loading)?_c('loading-icon',{staticClass:"js-participants-collapsed-loading-icon"}):_c('span',{staticClass:"js-participants-collapsed-count"},[_vm._v("\n      "+_vm._s(_vm.participantCount)+"\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"title hide-collapsed"},[(_vm.loading)?_c('loading-icon',{staticClass:"js-participants-expanded-loading-icon",attrs:{"inline":true}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.participantLabel)+"\n  ")],1),_vm._v(" "),_c('div',{staticClass:"participants-list hide-collapsed"},_vm._l((_vm.visibleParticipants),function(participant){return _c('div',{key:participant.id,staticClass:"participants-author js-participants-author"},[_c('a',{staticClass:"author_link",attrs:{"href":participant.web_url}},[_c('user-avatar-image',{attrs:{"lazy":true,"img-src":participant.avatar_url,"css-classes":"avatar-inline","size":24,"tooltip-text":participant.name,"tooltip-placement":"bottom"}})],1)])})),_vm._v(" "),(_vm.hasMoreParticipants)?_c('div',{staticClass:"participants-more hide-collapsed"},[_c('button',{staticClass:"btn-transparent btn-blank js-toggle-participants-button",attrs:{"type":"button"},on:{"click":_vm.toggleMoreParticipants}},[_vm._v("\n      "+_vm._s(_vm.toggleLabel)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/participants/participants.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  participants,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var participants_participants = (Component.exports);

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/participants/sidebar_participants.vue




/* harmony default export */ var sidebar_participants = ({
  components: {
    participants: participants_participants
  },
  props: {
    mediator: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      store: new sidebar_store["a" /* default */]()
    };
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ce48697","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/participants/sidebar_participants.vue
var sidebar_participants_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block participants"},[_c('participants',{attrs:{"loading":_vm.store.isFetching.participants,"participants":_vm.store.participants,"number-of-less-participants":7}})],1)}
var sidebar_participants_staticRenderFns = []

// CONCATENATED MODULE: ./sidebar/components/participants/sidebar_participants.vue
/* script */


/* template */

/* template functional */
var sidebar_participants___vue_template_functional__ = false
/* styles */
var sidebar_participants___vue_styles__ = null
/* scopeId */
var sidebar_participants___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sidebar_participants___vue_module_identifier__ = null

var sidebar_participants_Component = Object(component_normalizer["a" /* default */])(
  sidebar_participants,
  sidebar_participants_render,
  sidebar_participants_staticRenderFns,
  sidebar_participants___vue_template_functional__,
  sidebar_participants___vue_styles__,
  sidebar_participants___vue_scopeId__,
  sidebar_participants___vue_module_identifier__
)

/* harmony default export */ var participants_sidebar_participants = __webpack_exports__["a"] = (sidebar_participants_Component.exports);


/***/ }),

/***/ "./sidebar/components/subscriptions/sidebar_subscriptions.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./sidebar/stores/sidebar_store.js
var sidebar_store = __webpack_require__("./sidebar/stores/sidebar_store.js");

// EXTERNAL MODULE: ./sidebar/event_hub.js
var event_hub = __webpack_require__("./sidebar/event_hub.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./sidebar/components/subscriptions/subscriptions.vue + 2 modules
var subscriptions = __webpack_require__("./sidebar/components/subscriptions/subscriptions.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/subscriptions/sidebar_subscriptions.vue







/* harmony default export */ var sidebar_subscriptions = ({
  components: {
    subscriptions: subscriptions["a" /* default */]
  },
  props: {
    mediator: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      store: new sidebar_store["a" /* default */]()
    };
  },
  created: function created() {
    event_hub["a" /* default */].$on('toggleSubscription', this.onToggleSubscription);
  },
  beforeDestroy: function beforeDestroy() {
    event_hub["a" /* default */].$off('toggleSubscription', this.onToggleSubscription);
  },

  methods: {
    onToggleSubscription: function onToggleSubscription() {
      this.mediator.toggleSubscription().catch(function () {
        Object(flash["a" /* default */])(Object(locale["a" /* __ */])('Error occurred when toggling the notification subscription'));
      });
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a64caa4","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/subscriptions/sidebar_subscriptions.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block subscriptions"},[_c('subscriptions',{attrs:{"loading":_vm.store.isFetching.subscriptions,"subscribed":_vm.store.subscribed}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/subscriptions/sidebar_subscriptions.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  sidebar_subscriptions,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var subscriptions_sidebar_subscriptions = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./sidebar/components/subscriptions/subscriptions.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/toggle_button.vue + 2 modules
var toggle_button = __webpack_require__("./vue_shared/components/toggle_button.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./sidebar/event_hub.js
var event_hub = __webpack_require__("./sidebar/event_hub.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/subscriptions/subscriptions.vue







var ICON_ON = 'notifications';
var ICON_OFF = 'notifications-off';
var LABEL_ON = Object(locale["a" /* __ */])('Notifications on');
var LABEL_OFF = Object(locale["a" /* __ */])('Notifications off');

/* harmony default export */ var subscriptions = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    icon: icon["a" /* default */],
    toggleButton: toggle_button["a" /* default */]
  },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    subscribed: {
      type: Boolean,
      required: false,
      default: null
    },
    id: {
      type: Number,
      required: false,
      default: null
    }
  },
  computed: {
    showLoadingState: function showLoadingState() {
      return this.subscribed === null;
    },
    notificationIcon: function notificationIcon() {
      return this.subscribed ? ICON_ON : ICON_OFF;
    },
    notificationTooltip: function notificationTooltip() {
      return this.subscribed ? LABEL_ON : LABEL_OFF;
    }
  },
  methods: {
    toggleSubscription: function toggleSubscription() {
      event_hub["a" /* default */].$emit('toggleSubscription', this.id);
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-999c2692","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/subscriptions/subscriptions.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar-collapsed-icon"},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],attrs:{"title":_vm.notificationTooltip,"data-container":"body","data-placement":"left"}},[_c('icon',{staticClass:"sidebar-item-icon is-active",attrs:{"name":_vm.notificationIcon,"size":16,"aria-hidden":"true"}})],1)]),_vm._v(" "),_c('span',{staticClass:"issuable-header-text hide-collapsed pull-left"},[_vm._v("\n    "+_vm._s(_vm.__('Notifications'))+"\n  ")]),_vm._v(" "),_c('toggle-button',{ref:"toggleButton",staticClass:"pull-right hide-collapsed js-issuable-subscribe-button",attrs:{"is-loading":_vm.showLoadingState,"value":_vm.subscribed},on:{"change":_vm.toggleSubscription}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/subscriptions/subscriptions.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  subscriptions,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var subscriptions_subscriptions = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./sidebar/components/time_tracking/sidebar_time_tracking.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__smart_interval__ = __webpack_require__("./smart_interval.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__time_tracker_vue__ = __webpack_require__("./sidebar/components/time_tracking/time_tracker.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_sidebar_store__ = __webpack_require__("./sidebar/stores/sidebar_store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sidebar_mediator__ = __webpack_require__("./sidebar/sidebar_mediator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__event_hub__ = __webpack_require__("./sidebar/event_hub.js");










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      mediator: new __WEBPACK_IMPORTED_MODULE_4__sidebar_mediator__["a" /* default */](),
      store: new __WEBPACK_IMPORTED_MODULE_3__stores_sidebar_store__["a" /* default */]()
    };
  },

  components: {
    IssuableTimeTracker: __WEBPACK_IMPORTED_MODULE_2__time_tracker_vue__["a" /* default */]
  },
  methods: {
    listenForQuickActions: function listenForQuickActions() {
      var _this = this;

      $(document).on('ajax:success', '.gfm-form', this.quickActionListened);
      __WEBPACK_IMPORTED_MODULE_5__event_hub__["a" /* default */].$on('timeTrackingUpdated', function (data) {
        _this.quickActionListened(null, data);
      });
    },
    quickActionListened: function quickActionListened(e, data) {
      var subscribedCommands = ['spend_time', 'time_estimate'];
      var changedCommands = void 0;
      if (data !== undefined) {
        changedCommands = data.commands_changes ? Object.keys(data.commands_changes) : [];
      } else {
        changedCommands = [];
      }
      if (changedCommands && __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.intersection(subscribedCommands, changedCommands).length) {
        this.mediator.fetch();
      }
    }
  },
  mounted: function mounted() {
    this.listenForQuickActions();
  },

  template: '\n    <div class="block">\n      <issuable-time-tracker\n        :time_estimate="store.timeEstimate"\n        :time_spent="store.totalTimeSpent"\n        :human_time_estimate="store.humanTimeEstimate"\n        :human_time_spent="store.humanTotalTimeSpent"\n        :rootPath="store.rootPath"\n      />\n    </div>\n  '
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./sidebar/components/time_tracking/time_tracker.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// CONCATENATED MODULE: ./sidebar/components/time_tracking/help_state.js


/* harmony default export */ var help_state = ({
  name: 'time-tracking-help-state',
  props: {
    rootPath: {
      type: String,
      required: true
    }
  },
  computed: {
    href: function href() {
      return this.rootPath + 'help/workflow/time_tracking.md';
    },
    estimateText: function estimateText() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('estimateCommand|%{slash_command} will update the estimated time with the latest command.'), {
        slash_command: '<code>/estimate</code>'
      }, false);
    },
    spendText: function spendText() {
      return Object(locale["f" /* sprintf */])(Object(locale["e" /* s__ */])('spendCommand|%{slash_command} will update the sum of the time spent.'), {
        slash_command: '<code>/spend</code>'
      }, false);
    }
  },
  template: '\n    <div class="time-tracking-help-state">\n      <div class="time-tracking-info">\n        <h4>\n          {{ __(\'Track time with quick actions\') }}\n        </h4>\n        <p>\n          {{ __(\'Quick actions can be used in the issues description and comment boxes.\') }}\n        </p>\n        <p v-html="estimateText">\n        </p>\n        <p v-html="spendText">\n        </p>\n        <a\n          class="btn btn-default learn-more-button"\n          :href="href"\n        >\n          {{ __(\'Learn more\') }}\n        </a>\n      </div>\n    </div>\n  '
});
// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/app/views/shared/icons/_icon_stopwatch.svg
var _icon_stopwatch = __webpack_require__("../../views/shared/icons/_icon_stopwatch.svg");
var _icon_stopwatch_default = /*#__PURE__*/__webpack_require__.n(_icon_stopwatch);

// EXTERNAL MODULE: ./lib/utils/pretty_time.js
var pretty_time = __webpack_require__("./lib/utils/pretty_time.js");

// CONCATENATED MODULE: ./sidebar/components/time_tracking/collapsed_state.js



/* harmony default export */ var collapsed_state = ({
  name: 'time-tracking-collapsed-state',
  props: {
    showComparisonState: {
      type: Boolean,
      required: true
    },
    showSpentOnlyState: {
      type: Boolean,
      required: true
    },
    showEstimateOnlyState: {
      type: Boolean,
      required: true
    },
    showNoTimeTrackingState: {
      type: Boolean,
      required: true
    },
    timeSpentHumanReadable: {
      type: String,
      required: false,
      default: ''
    },
    timeEstimateHumanReadable: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    timeSpent: function timeSpent() {
      return this.abbreviateTime(this.timeSpentHumanReadable);
    },
    timeEstimate: function timeEstimate() {
      return this.abbreviateTime(this.timeEstimateHumanReadable);
    },
    divClass: function divClass() {
      if (this.showComparisonState) {
        return 'compare';
      } else if (this.showEstimateOnlyState) {
        return 'estimate-only';
      } else if (this.showSpentOnlyState) {
        return 'spend-only';
      } else if (this.showNoTimeTrackingState) {
        return 'no-tracking';
      }

      return '';
    },
    spanClass: function spanClass() {
      if (this.showComparisonState) {
        return '';
      } else if (this.showEstimateOnlyState || this.showSpentOnlyState) {
        return 'bold';
      } else if (this.showNoTimeTrackingState) {
        return 'no-value';
      }

      return '';
    },
    text: function text() {
      if (this.showComparisonState) {
        return this.timeSpent + ' / ' + this.timeEstimate;
      } else if (this.showEstimateOnlyState) {
        return '-- / ' + this.timeEstimate;
      } else if (this.showSpentOnlyState) {
        return this.timeSpent + ' / --';
      } else if (this.showNoTimeTrackingState) {
        return 'None';
      }

      return '';
    }
  },
  methods: {
    abbreviateTime: function abbreviateTime(timeStr) {
      return Object(pretty_time["a" /* abbreviateTime */])(timeStr);
    }
  },
  template: '\n    <div class="sidebar-collapsed-icon">\n      ' + _icon_stopwatch_default.a + '\n      <div class="time-tracking-collapsed-summary">\n        <div :class="divClass">\n          <span :class="spanClass">\n            {{ text }}\n          </span>\n        </div>\n      </div>\n    </div>\n    '
});
// CONCATENATED MODULE: ./sidebar/components/time_tracking/spent_only_pane.js
/* harmony default export */ var spent_only_pane = ({
  name: 'time-tracking-spent-only-pane',
  props: {
    timeSpentHumanReadable: {
      type: String,
      required: true
    }
  },
  template: '\n    <div class="time-tracking-spend-only-pane">\n      <span class="bold">Spent:</span>\n      {{ timeSpentHumanReadable }}\n    </div>\n  '
});
// CONCATENATED MODULE: ./sidebar/components/time_tracking/no_tracking_pane.js
/* harmony default export */ var no_tracking_pane = ({
  name: 'time-tracking-no-tracking-pane',
  template: '\n    <div class="time-tracking-no-tracking-pane">\n      <span class="no-value">\n        {{ __(\'No estimate or time spent\') }}\n      </span>\n    </div>\n  '
});
// CONCATENATED MODULE: ./sidebar/components/time_tracking/estimate_only_pane.js
/* harmony default export */ var estimate_only_pane = ({
  name: 'time-tracking-estimate-only-pane',
  props: {
    timeEstimateHumanReadable: {
      type: String,
      required: true
    }
  },
  template: '\n    <div class="time-tracking-estimate-only-pane">\n      <span class="bold">\n        {{ s__(\'TimeTracking|Estimated:\') }}\n      </span>\n      {{ timeEstimateHumanReadable }}\n    </div>\n  '
});
// CONCATENATED MODULE: ./sidebar/components/time_tracking/comparison_pane.js


/* harmony default export */ var comparison_pane = ({
  name: 'time-tracking-comparison-pane',
  props: {
    timeSpent: {
      type: Number,
      required: true
    },
    timeEstimate: {
      type: Number,
      required: true
    },
    timeSpentHumanReadable: {
      type: String,
      required: true
    },
    timeEstimateHumanReadable: {
      type: String,
      required: true
    }
  },
  computed: {
    parsedTimeRemaining: function parsedTimeRemaining() {
      var diffSeconds = this.timeEstimate - this.timeSpent;
      return Object(pretty_time["b" /* parseSeconds */])(diffSeconds);
    },
    timeRemainingHumanReadable: function timeRemainingHumanReadable() {
      return Object(pretty_time["c" /* stringifyTime */])(this.parsedTimeRemaining);
    },
    timeRemainingTooltip: function timeRemainingTooltip() {
      var prefix = this.timeRemainingMinutes < 0 ? 'Over by' : 'Time remaining:';
      return prefix + ' ' + this.timeRemainingHumanReadable;
    },

    /* Diff values for comparison meter */
    timeRemainingMinutes: function timeRemainingMinutes() {
      return this.timeEstimate - this.timeSpent;
    },
    timeRemainingPercent: function timeRemainingPercent() {
      return Math.floor(this.timeSpent / this.timeEstimate * 100) + '%';
    },
    timeRemainingStatusClass: function timeRemainingStatusClass() {
      return this.timeEstimate >= this.timeSpent ? 'within_estimate' : 'over_estimate';
    }
  },
  template: '\n    <div class="time-tracking-comparison-pane">\n      <div\n        class="compare-meter"\n        data-toggle="tooltip"\n        data-placement="top"\n        role="timeRemainingDisplay"\n        :aria-valuenow="timeRemainingTooltip"\n        :title="timeRemainingTooltip"\n        :data-original-title="timeRemainingTooltip"\n        :class="timeRemainingStatusClass"\n      >\n        <div\n          class="meter-container"\n          role="timeSpentPercent"\n          :aria-valuenow="timeRemainingPercent"\n        >\n          <div\n            :style="{ width: timeRemainingPercent }"\n            class="meter-fill"\n          />\n        </div>\n        <div class="compare-display-container">\n          <div class="compare-display pull-left">\n            <span class="compare-label">\n            {{ s__(\'TimeTracking|Spent\') }}\n            </span>\n            <span class="compare-value spent">\n              {{ timeSpentHumanReadable }}\n            </span>\n          </div>\n          <div class="compare-display estimated pull-right">\n            <span class="compare-label">\n              {{ s__(\'TimeTrackingEstimated|Est\') }}\n            </span>\n            <span class="compare-value">\n              {{ timeEstimateHumanReadable }}\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n  '
});
// EXTERNAL MODULE: ./sidebar/event_hub.js
var event_hub = __webpack_require__("./sidebar/event_hub.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./sidebar/components/time_tracking/time_tracker.vue










/* harmony default export */ var time_tracker = ({
  name: 'IssuableTimeTracker',
  components: {
    'time-tracking-collapsed-state': collapsed_state,
    'time-tracking-estimate-only-pane': estimate_only_pane,
    'time-tracking-spent-only-pane': spent_only_pane,
    'time-tracking-no-tracking-pane': no_tracking_pane,
    'time-tracking-comparison-pane': comparison_pane,
    'time-tracking-help-state': help_state
  },
  props: {
    time_estimate: {
      type: Number,
      required: true
    },
    time_spent: {
      type: Number,
      required: true
    },
    human_time_estimate: {
      type: String,
      required: false,
      default: ''
    },
    human_time_spent: {
      type: String,
      required: false,
      default: ''
    },
    rootPath: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      showHelp: false
    };
  },

  computed: {
    timeSpent: function timeSpent() {
      return this.time_spent;
    },
    timeEstimate: function timeEstimate() {
      return this.time_estimate;
    },
    timeEstimateHumanReadable: function timeEstimateHumanReadable() {
      return this.human_time_estimate;
    },
    timeSpentHumanReadable: function timeSpentHumanReadable() {
      return this.human_time_spent;
    },
    hasTimeSpent: function hasTimeSpent() {
      return !!this.timeSpent;
    },
    hasTimeEstimate: function hasTimeEstimate() {
      return !!this.timeEstimate;
    },
    showComparisonState: function showComparisonState() {
      return this.hasTimeEstimate && this.hasTimeSpent;
    },
    showEstimateOnlyState: function showEstimateOnlyState() {
      return this.hasTimeEstimate && !this.hasTimeSpent;
    },
    showSpentOnlyState: function showSpentOnlyState() {
      return this.hasTimeSpent && !this.hasTimeEstimate;
    },
    showNoTimeTrackingState: function showNoTimeTrackingState() {
      return !this.hasTimeEstimate && !this.hasTimeSpent;
    },
    showHelpState: function showHelpState() {
      return !!this.showHelp;
    }
  },
  created: function created() {
    event_hub["a" /* default */].$on('timeTracker:updateData', this.update);
  },

  methods: {
    toggleHelpState: function toggleHelpState(show) {
      this.showHelp = show;
    },
    update: function update(data) {
      this.time_estimate = data.time_estimate;
      this.time_spent = data.time_spent;
      this.human_time_estimate = data.human_time_estimate;
      this.human_time_spent = data.human_time_spent;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc25cbb2","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./sidebar/components/time_tracking/time_tracker.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time_tracker time-tracking-component-wrap"},[_c('time-tracking-collapsed-state',{attrs:{"show-comparison-state":_vm.showComparisonState,"show-no-time-tracking-state":_vm.showNoTimeTrackingState,"show-help-state":_vm.showHelpState,"show-spent-only-state":_vm.showSpentOnlyState,"show-estimate-only-state":_vm.showEstimateOnlyState,"time-spent-human-readable":_vm.timeSpentHumanReadable,"time-estimate-human-readable":_vm.timeEstimateHumanReadable}}),_vm._v(" "),_c('div',{staticClass:"title hide-collapsed"},[_vm._v("\n    "+_vm._s(_vm.__('Time tracking'))+"\n    "),(!_vm.showHelpState)?_c('div',{staticClass:"help-button pull-right",on:{"click":function($event){_vm.toggleHelpState(true)}}},[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.showHelpState)?_c('div',{staticClass:"close-help-button pull-right",on:{"click":function($event){_vm.toggleHelpState(false)}}},[_c('i',{staticClass:"fa fa-close",attrs:{"aria-hidden":"true"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"time-tracking-content hide-collapsed"},[(_vm.showEstimateOnlyState)?_c('time-tracking-estimate-only-pane',{attrs:{"time-estimate-human-readable":_vm.timeEstimateHumanReadable}}):_vm._e(),_vm._v(" "),(_vm.showSpentOnlyState)?_c('time-tracking-spent-only-pane',{attrs:{"time-spent-human-readable":_vm.timeSpentHumanReadable}}):_vm._e(),_vm._v(" "),(_vm.showNoTimeTrackingState)?_c('time-tracking-no-tracking-pane'):_vm._e(),_vm._v(" "),(_vm.showComparisonState)?_c('time-tracking-comparison-pane',{attrs:{"time-estimate":_vm.timeEstimate,"time-spent":_vm.timeSpent,"time-spent-human-readable":_vm.timeSpentHumanReadable,"time-estimate-human-readable":_vm.timeEstimateHumanReadable}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"help-state-toggle"}},[(_vm.showHelpState)?_c('time-tracking-help-state',{attrs:{"root-path":_vm.rootPath}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./sidebar/components/time_tracking/time_tracker.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  time_tracker,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var time_tracking_time_tracker = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./sidebar/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


var eventHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

// TODO: remove eventHub hack after code splitting refactor
window.emitSidebarEvent = function () {
  return eventHub.$emit.apply(eventHub, arguments);
};

/* harmony default export */ __webpack_exports__["a"] = (eventHub);

/***/ }),

/***/ "./sidebar/lib/sidebar_move_issue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function isValidProjectId(id) {
  return id > 0;
}

var SidebarMoveIssue = function () {
  function SidebarMoveIssue(mediator, dropdownToggle, confirmButton) {
    _classCallCheck(this, SidebarMoveIssue);

    this.mediator = mediator;

    this.$dropdownToggle = $(dropdownToggle);
    this.$confirmButton = $(confirmButton);

    this.onConfirmClickedWrapper = this.onConfirmClicked.bind(this);
  }

  _createClass(SidebarMoveIssue, [{
    key: 'init',
    value: function init() {
      this.initDropdown();
      this.addEventListeners();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.removeEventListeners();
    }
  }, {
    key: 'initDropdown',
    value: function initDropdown() {
      var _this = this;

      this.$dropdownToggle.glDropdown({
        search: {
          fields: ['name_with_namespace']
        },
        showMenuAbove: true,
        selectable: true,
        filterable: true,
        filterRemote: true,
        multiSelect: false,
        // Keep the dropdown open after selecting an option
        shouldPropagate: false,
        data: function data(searchTerm, callback) {
          _this.mediator.fetchAutocompleteProjects(searchTerm).then(callback).catch(function () {
            return new window.Flash('An error occurred while fetching projects autocomplete.');
          });
        },
        renderRow: function renderRow(project) {
          return '\n        <li>\n          <a href="#" class="js-move-issue-dropdown-item">\n            ' + project.name_with_namespace + '\n          </a>\n        </li>\n      ';
        },
        clicked: function clicked(options) {
          var project = options.selectedObj;
          var selectedProjectId = options.isMarking ? project.id : 0;
          _this.mediator.setMoveToProjectId(selectedProjectId);

          _this.$confirmButton.prop('disabled', !isValidProjectId(selectedProjectId));
        }
      });
    }
  }, {
    key: 'addEventListeners',
    value: function addEventListeners() {
      this.$confirmButton.on('click', this.onConfirmClickedWrapper);
    }
  }, {
    key: 'removeEventListeners',
    value: function removeEventListeners() {
      this.$confirmButton.off('click', this.onConfirmClickedWrapper);
    }
  }, {
    key: 'onConfirmClicked',
    value: function onConfirmClicked() {
      var _this2 = this;

      if (isValidProjectId(this.mediator.store.moveToProjectId)) {
        this.$confirmButton.disable().addClass('is-loading');

        this.mediator.moveIssue().catch(function () {
          window.Flash('An error occurred while moving the issue.');
          _this2.$confirmButton.enable().removeClass('is-loading');
        });
      }
    }
  }]);

  return SidebarMoveIssue;
}();

/* harmony default export */ __webpack_exports__["a"] = (SidebarMoveIssue);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./sidebar/mount_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["b"] = mountSidebar;
/* harmony export (immutable) */ __webpack_exports__["a"] = getSidebarOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_time_tracking_sidebar_time_tracking__ = __webpack_require__("./sidebar/components/time_tracking/sidebar_time_tracking.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_assignees_sidebar_assignees_vue__ = __webpack_require__("./sidebar/components/assignees/sidebar_assignees.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_confidential_confidential_issue_sidebar_vue__ = __webpack_require__("./sidebar/components/confidential/confidential_issue_sidebar.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_sidebar_move_issue__ = __webpack_require__("./sidebar/lib/sidebar_move_issue.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_lock_lock_issue_sidebar_vue__ = __webpack_require__("./sidebar/components/lock/lock_issue_sidebar.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_participants_sidebar_participants_vue__ = __webpack_require__("./sidebar/components/participants/sidebar_participants.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_subscriptions_sidebar_subscriptions_vue__ = __webpack_require__("./sidebar/components/subscriptions/sidebar_subscriptions.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vue_shared_translate__ = __webpack_require__("./vue_shared/translate.js");










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__vue_shared_translate__["a" /* default */]);

function mountAssigneesComponent(mediator) {
  var el = document.getElementById('js-vue-sidebar-assignees');

  if (!el) return;

  // eslint-disable-next-line no-new
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: el,
    components: {
      SidebarAssignees: __WEBPACK_IMPORTED_MODULE_2__components_assignees_sidebar_assignees_vue__["a" /* default */]
    },
    render: function render(createElement) {
      return createElement('sidebar-assignees', {
        props: {
          mediator: mediator,
          field: el.dataset.field,
          signedIn: el.hasAttribute('data-signed-in')
        }
      });
    }
  });
}

function mountConfidentialComponent(mediator) {
  var el = document.getElementById('js-confidential-entry-point');

  if (!el) return;

  var dataNode = document.getElementById('js-confidential-issue-data');
  var initialData = JSON.parse(dataNode.innerHTML);

  var ConfidentialComp = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_3__components_confidential_confidential_issue_sidebar_vue__["a" /* default */]);

  new ConfidentialComp({
    propsData: {
      isConfidential: initialData.is_confidential,
      isEditable: initialData.is_editable,
      service: mediator.service
    }
  }).$mount(el);
}

function mountLockComponent(mediator) {
  var el = document.getElementById('js-lock-entry-point');

  if (!el) return;

  var dataNode = document.getElementById('js-lock-issue-data');
  var initialData = JSON.parse(dataNode.innerHTML);

  var LockComp = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend(__WEBPACK_IMPORTED_MODULE_5__components_lock_lock_issue_sidebar_vue__["a" /* default */]);

  new LockComp({
    propsData: {
      isLocked: initialData.is_locked,
      isEditable: initialData.is_editable,
      mediator: mediator,
      issuableType: gl.utils.isInIssuePage() ? 'issue' : 'merge_request'
    }
  }).$mount(el);
}

function mountParticipantsComponent(mediator) {
  var el = document.querySelector('.js-sidebar-participants-entry-point');

  // eslint-disable-next-line no-new
  if (!el) return;

  // eslint-disable-next-line no-new
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: el,
    components: {
      sidebarParticipants: __WEBPACK_IMPORTED_MODULE_6__components_participants_sidebar_participants_vue__["a" /* default */]
    },
    render: function render(createElement) {
      return createElement('sidebar-participants', {
        props: {
          mediator: mediator
        }
      });
    }
  });
}

function mountSubscriptionsComponent(mediator) {
  var el = document.querySelector('.js-sidebar-subscriptions-entry-point');

  if (!el) return;

  // eslint-disable-next-line no-new
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: el,
    components: {
      sidebarSubscriptions: __WEBPACK_IMPORTED_MODULE_7__components_subscriptions_sidebar_subscriptions_vue__["a" /* default */]
    },
    render: function render(createElement) {
      return createElement('sidebar-subscriptions', {
        props: {
          mediator: mediator
        }
      });
    }
  });
}

function mountTimeTrackingComponent() {
  var el = document.getElementById('issuable-time-tracker');

  if (!el) return;

  // eslint-disable-next-line no-new
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: el,
    components: {
      SidebarTimeTracking: __WEBPACK_IMPORTED_MODULE_1__components_time_tracking_sidebar_time_tracking__["a" /* default */]
    },
    render: function render(createElement) {
      return createElement('sidebar-time-tracking', {});
    }
  });
}

function mountSidebar(mediator) {
  mountAssigneesComponent(mediator);
  mountConfidentialComponent(mediator);
  mountLockComponent(mediator);
  mountParticipantsComponent(mediator);
  mountSubscriptionsComponent(mediator);

  new __WEBPACK_IMPORTED_MODULE_4__lib_sidebar_move_issue__["a" /* default */](mediator, $('.js-move-issue'), $('.js-move-issue-confirmation-button')).init();

  mountTimeTrackingComponent();
}

function getSidebarOptions() {
  return JSON.parse(document.querySelector('.js-sidebar-options').innerHTML);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./sidebar/sidebar_mediator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/ee/app/assets/javascripts/sidebar/stores/sidebar_store.js
var sidebar_store = __webpack_require__("../../../ee/app/assets/javascripts/sidebar/stores/sidebar_store.js");

// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-resource/dist/vue-resource.esm.js
var vue_resource_esm = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.esm.js");

// CONCATENATED MODULE: ./sidebar/services/sidebar_service.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




vue_esm["a" /* default */].use(vue_resource_esm["a" /* default */]);

var sidebar_service_SidebarService = function () {
  function SidebarService(endpointMap) {
    _classCallCheck(this, SidebarService);

    if (!SidebarService.singleton) {
      this.endpoint = endpointMap.endpoint;
      this.toggleSubscriptionEndpoint = endpointMap.toggleSubscriptionEndpoint;
      this.moveIssueEndpoint = endpointMap.moveIssueEndpoint;
      this.projectsAutocompleteEndpoint = endpointMap.projectsAutocompleteEndpoint;

      SidebarService.singleton = this;
    }

    return SidebarService.singleton;
  }

  _createClass(SidebarService, [{
    key: 'get',
    value: function get() {
      return vue_esm["a" /* default */].http.get(this.endpoint);
    }
  }, {
    key: 'update',
    value: function update(key, data) {
      return vue_esm["a" /* default */].http.put(this.endpoint, _defineProperty({}, key, data), {
        emulateJSON: true
      });
    }
  }, {
    key: 'getProjectsAutocomplete',
    value: function getProjectsAutocomplete(searchTerm) {
      return vue_esm["a" /* default */].http.get(this.projectsAutocompleteEndpoint, {
        params: {
          search: searchTerm
        }
      });
    }
  }, {
    key: 'toggleSubscription',
    value: function toggleSubscription() {
      return vue_esm["a" /* default */].http.post(this.toggleSubscriptionEndpoint);
    }
  }, {
    key: 'moveIssue',
    value: function moveIssue(moveToProjectId) {
      return vue_esm["a" /* default */].http.post(this.moveIssueEndpoint, {
        move_to_project_id: moveToProjectId
      });
    }
  }]);

  return SidebarService;
}();

/* harmony default export */ var sidebar_service = (sidebar_service_SidebarService);
// CONCATENATED MODULE: ./sidebar/sidebar_mediator.js
var sidebar_mediator__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function sidebar_mediator__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var sidebar_mediator_SidebarMediator = function () {
  function SidebarMediator(options) {
    sidebar_mediator__classCallCheck(this, SidebarMediator);

    if (!SidebarMediator.singleton) {
      this.initSingleton(options);
    }
    return SidebarMediator.singleton;
  }

  sidebar_mediator__createClass(SidebarMediator, [{
    key: 'initSingleton',
    value: function initSingleton(options) {
      this.store = new sidebar_store["a" /* default */](options);
      this.service = new sidebar_service({
        endpoint: options.endpoint,
        toggleSubscriptionEndpoint: options.toggleSubscriptionEndpoint,
        moveIssueEndpoint: options.moveIssueEndpoint,
        projectsAutocompleteEndpoint: options.projectsAutocompleteEndpoint
      });
      SidebarMediator.singleton = this;
    }
  }, {
    key: 'assignYourself',
    value: function assignYourself() {
      this.store.addAssignee(this.store.currentUser);
    }
  }, {
    key: 'saveAssignees',
    value: function saveAssignees(field) {
      var selected = this.store.assignees.map(function (u) {
        return u.id;
      });

      // If there are no ids, that means we have to unassign (which is id = 0)
      // And it only accepts an array, hence [0]
      return this.service.update(field, selected.length === 0 ? [0] : selected);
    }
  }, {
    key: 'setMoveToProjectId',
    value: function setMoveToProjectId(projectId) {
      this.store.setMoveToProjectId(projectId);
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      var _this = this;

      return this.service.get().then(function (response) {
        return response.json();
      }).then(function (data) {
        _this.processFetchedData(data);
      }).catch(function () {
        return new flash["a" /* default */]('Error occurred when fetching sidebar data');
      });
    }
  }, {
    key: 'processFetchedData',
    value: function processFetchedData(data) {
      this.store.setAssigneeData(data);
      this.store.setTimeTrackingData(data);
      this.store.setParticipantsData(data);
      this.store.setSubscriptionsData(data);
    }
  }, {
    key: 'toggleSubscription',
    value: function toggleSubscription() {
      var _this2 = this;

      this.store.setFetchingState('subscriptions', true);
      return this.service.toggleSubscription().then(function () {
        _this2.store.setSubscribedState(!_this2.store.subscribed);
        _this2.store.setFetchingState('subscriptions', false);
      }).catch(function (err) {
        _this2.store.setFetchingState('subscriptions', false);
        throw err;
      });
    }
  }, {
    key: 'fetchAutocompleteProjects',
    value: function fetchAutocompleteProjects(searchTerm) {
      var _this3 = this;

      return this.service.getProjectsAutocomplete(searchTerm).then(function (response) {
        return response.json();
      }).then(function (data) {
        _this3.store.setAutocompleteProjects(data);
        return _this3.store.autocompleteProjects;
      });
    }
  }, {
    key: 'moveIssue',
    value: function moveIssue() {
      return this.service.moveIssue(this.store.moveToProjectId).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (location.pathname !== data.web_url) {
          Object(url_utility["g" /* visitUrl */])(data.web_url);
        }
      });
    }
  }]);

  return SidebarMediator;
}();

/* harmony default export */ var sidebar_mediator = __webpack_exports__["a"] = (sidebar_mediator_SidebarMediator);

/***/ }),

/***/ "./sidebar/stores/sidebar_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SidebarStore = function () {
  function SidebarStore(options) {
    _classCallCheck(this, SidebarStore);

    if (!SidebarStore.singleton) {
      this.initSingleton(options);
    }

    return SidebarStore.singleton;
  }

  _createClass(SidebarStore, [{
    key: 'initSingleton',
    value: function initSingleton(options) {
      var currentUser = options.currentUser,
          rootPath = options.rootPath,
          editable = options.editable;

      this.currentUser = currentUser;
      this.rootPath = rootPath;
      this.editable = editable;
      this.timeEstimate = 0;
      this.totalTimeSpent = 0;
      this.humanTimeEstimate = '';
      this.humanTimeSpent = '';
      this.assignees = [];
      this.isFetching = {
        assignees: true,
        participants: true,
        subscriptions: true
      };
      this.isLoading = {};
      this.autocompleteProjects = [];
      this.moveToProjectId = 0;
      this.isLockDialogOpen = false;
      this.participants = [];
      this.subscribed = null;

      SidebarStore.singleton = this;
    }
  }, {
    key: 'setAssigneeData',
    value: function setAssigneeData(data) {
      this.isFetching.assignees = false;
      if (data.assignees) {
        this.assignees = data.assignees;
      }
    }
  }, {
    key: 'setTimeTrackingData',
    value: function setTimeTrackingData(data) {
      this.timeEstimate = data.time_estimate;
      this.totalTimeSpent = data.total_time_spent;
      this.humanTimeEstimate = data.human_time_estimate;
      this.humanTotalTimeSpent = data.human_total_time_spent;
    }
  }, {
    key: 'setParticipantsData',
    value: function setParticipantsData(data) {
      this.isFetching.participants = false;
      this.participants = data.participants || [];
    }
  }, {
    key: 'setSubscriptionsData',
    value: function setSubscriptionsData(data) {
      this.isFetching.subscriptions = false;
      this.subscribed = data.subscribed || false;
    }
  }, {
    key: 'setFetchingState',
    value: function setFetchingState(key, value) {
      this.isFetching[key] = value;
    }
  }, {
    key: 'setLoadingState',
    value: function setLoadingState(key, value) {
      this.isLoading[key] = value;
    }
  }, {
    key: 'addAssignee',
    value: function addAssignee(assignee) {
      if (!this.findAssignee(assignee)) {
        this.assignees.push(assignee);
      }
    }
  }, {
    key: 'findAssignee',
    value: function findAssignee(_findAssignee) {
      return this.assignees.filter(function (assignee) {
        return assignee.id === _findAssignee.id;
      })[0];
    }
  }, {
    key: 'removeAssignee',
    value: function removeAssignee(_removeAssignee) {
      if (_removeAssignee) {
        this.assignees = this.assignees.filter(function (assignee) {
          return assignee.id !== _removeAssignee.id;
        });
      }
    }
  }, {
    key: 'removeAllAssignees',
    value: function removeAllAssignees() {
      this.assignees = [];
    }
  }, {
    key: 'setAutocompleteProjects',
    value: function setAutocompleteProjects(projects) {
      this.autocompleteProjects = projects;
    }
  }, {
    key: 'setSubscribedState',
    value: function setSubscribedState(subscribed) {
      this.subscribed = subscribed;
    }
  }, {
    key: 'setMoveToProjectId',
    value: function setMoveToProjectId(moveToProjectId) {
      this.moveToProjectId = moveToProjectId;
    }
  }]);

  return SidebarStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (SidebarStore);

/***/ }),

/***/ "./single_file_diff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__files_comment_button__ = __webpack_require__("./files_comment_button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__image_diff_helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__syntax_highlight__ = __webpack_require__("./syntax_highlight.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, prefer-arrow-callback, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, one-var-declaration-per-line, consistent-return, no-param-reassign, max-len */








var WRAPPER = '<div class="diff-content"></div>';
var LOADING_HTML = '<i class="fa fa-spinner fa-spin"></i>';
var ERROR_HTML = '<div class="nothing-here-block"><i class="fa fa-warning"></i> Could not load diff</div>';
var COLLAPSED_HTML = '<div class="nothing-here-block diff-collapsed">This diff is collapsed. <a class="click-to-expand">Click to expand it.</a></div>';

var SingleFileDiff = function () {
  function SingleFileDiff(file) {
    _classCallCheck(this, SingleFileDiff);

    this.file = file;
    this.toggleDiff = this.toggleDiff.bind(this);
    this.content = $('.diff-content', this.file);
    this.$toggleIcon = $('.diff-toggle-caret', this.file);
    this.diffForPath = this.content.find('[data-diff-for-path]').data('diffForPath');
    this.isOpen = !this.diffForPath;
    if (this.diffForPath) {
      this.collapsedContent = this.content;
      this.loadingContent = $(WRAPPER).addClass('loading').html(LOADING_HTML).hide();
      this.content = null;
      this.collapsedContent.after(this.loadingContent);
      this.$toggleIcon.addClass('fa-caret-right');
    } else {
      this.collapsedContent = $(WRAPPER).html(COLLAPSED_HTML).hide();
      this.content.after(this.collapsedContent);
      this.$toggleIcon.addClass('fa-caret-down');
    }

    $('.js-file-title, .click-to-expand', this.file).on('click', function (e) {
      this.toggleDiff($(e.target));
    }.bind(this));
  }

  _createClass(SingleFileDiff, [{
    key: 'toggleDiff',
    value: function toggleDiff($target, cb) {
      if (!$target.hasClass('js-file-title') && !$target.hasClass('click-to-expand') && !$target.hasClass('diff-toggle-caret')) return;
      this.isOpen = !this.isOpen;
      if (!this.isOpen && !this.hasError) {
        this.content.hide();
        this.$toggleIcon.addClass('fa-caret-right').removeClass('fa-caret-down');
        this.collapsedContent.show();
        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }
      } else if (this.content) {
        this.collapsedContent.hide();
        this.content.show();
        this.$toggleIcon.addClass('fa-caret-down').removeClass('fa-caret-right');
        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }
      } else {
        this.$toggleIcon.addClass('fa-caret-down').removeClass('fa-caret-right');
        return this.getContentHTML(cb);
      }
    }
  }, {
    key: 'getContentHTML',
    value: function getContentHTML(cb) {
      var _this = this;

      this.collapsedContent.hide();
      this.loadingContent.show();

      __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(this.diffForPath).then(function (_ref) {
        var data = _ref.data;

        _this.loadingContent.hide();
        if (data.html) {
          _this.content = $(data.html);
          Object(__WEBPACK_IMPORTED_MODULE_5__syntax_highlight__["a" /* default */])(_this.content);
        } else {
          _this.hasError = true;
          _this.content = $(ERROR_HTML);
        }
        _this.collapsedContent.after(_this.content);

        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }

        var $file = $(_this.file);
        __WEBPACK_IMPORTED_MODULE_3__files_comment_button__["a" /* default */].init($file);

        var canCreateNote = $file.closest('.files').is('[data-can-create-note]');
        __WEBPACK_IMPORTED_MODULE_4__image_diff_helpers_index__["a" /* default */].initImageDiff($file[0], canCreateNote);

        if (cb) cb();
      }).catch(function () {
        Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */])('An error occurred while retrieving diff'));
      });
    }
  }]);

  return SingleFileDiff;
}();

/* harmony default export */ __webpack_exports__["a"] = (SingleFileDiff);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./smart_interval.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Instances of SmartInterval extend the functionality of `setInterval`, make it configurable
 * and controllable by a public API.
 */

var SmartInterval = function () {
  /**
   * @param { function } opts.callback Function that returns a promise, called on each iteration
   *                     unless still in progress (required)
   * @param { milliseconds } opts.startingInterval `currentInterval` is set to this initially
   * @param { milliseconds } opts.maxInterval `currentInterval` will be incremented to this
   * @param { milliseconds } opts.hiddenInterval `currentInterval` is set to this
   *                         when the page is hidden
   * @param { integer } opts.incrementByFactorOf `currentInterval` is incremented by this factor
   * @param { boolean } opts.lazyStart Configure if timer is initialized on
   *                    instantiation or lazily
   * @param { boolean } opts.immediateExecution Configure if callback should
   *                    be executed before the first interval.
   */
  function SmartInterval() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SmartInterval);

    this.cfg = {
      callback: opts.callback,
      startingInterval: opts.startingInterval,
      maxInterval: opts.maxInterval,
      hiddenInterval: opts.hiddenInterval,
      incrementByFactorOf: opts.incrementByFactorOf,
      lazyStart: opts.lazyStart,
      immediateExecution: opts.immediateExecution
    };

    this.state = {
      intervalId: null,
      currentInterval: this.cfg.startingInterval,
      pageVisibility: 'visible'
    };

    this.initInterval();
  }

  /* public */

  _createClass(SmartInterval, [{
    key: 'start',
    value: function start() {
      var _this = this;

      var cfg = this.cfg;
      var state = this.state;

      if (cfg.immediateExecution && !this.isLoading) {
        cfg.immediateExecution = false;
        this.triggerCallback();
      }

      state.intervalId = window.setInterval(function () {
        if (_this.isLoading) {
          return;
        }
        _this.triggerCallback();

        if (_this.getCurrentInterval() === cfg.maxInterval) {
          return;
        }

        _this.incrementInterval();
        _this.resume();
      }, this.getCurrentInterval());
    }

    // cancel the existing timer, setting the currentInterval back to startingInterval

  }, {
    key: 'cancel',
    value: function cancel() {
      this.setCurrentInterval(this.cfg.startingInterval);
      this.stopTimer();
    }
  }, {
    key: 'onVisibilityHidden',
    value: function onVisibilityHidden() {
      if (this.cfg.hiddenInterval) {
        this.setCurrentInterval(this.cfg.hiddenInterval);
        this.resume();
      } else {
        this.cancel();
      }
    }

    // start a timer, using the existing interval

  }, {
    key: 'resume',
    value: function resume() {
      this.stopTimer(); // stop existing timer, in case timer was not previously stopped
      this.start();
    }
  }, {
    key: 'onVisibilityVisible',
    value: function onVisibilityVisible() {
      this.cancel();
      this.start();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.cancel();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      $(document).off('visibilitychange').off('beforeunload');
    }

    /* private */

  }, {
    key: 'initInterval',
    value: function initInterval() {
      var cfg = this.cfg;

      if (!cfg.lazyStart) {
        this.start();
      }

      this.initVisibilityChangeHandling();
      this.initPageUnloadHandling();
    }
  }, {
    key: 'triggerCallback',
    value: function triggerCallback() {
      var _this2 = this;

      this.isLoading = true;
      this.cfg.callback().then(function () {
        _this2.isLoading = false;
      }).catch(function (err) {
        _this2.isLoading = false;
        throw err;
      });
    }
  }, {
    key: 'initVisibilityChangeHandling',
    value: function initVisibilityChangeHandling() {
      // cancel interval when tab no longer shown (prevents cached pages from polling)
      document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
    }
  }, {
    key: 'initPageUnloadHandling',
    value: function initPageUnloadHandling() {
      var _this3 = this;

      // TODO: Consider refactoring in light of turbolinks removal.
      // prevent interval continuing after page change, when kept in cache by Turbolinks
      $(document).on('beforeunload', function () {
        return _this3.cancel();
      });
    }
  }, {
    key: 'handleVisibilityChange',
    value: function handleVisibilityChange(e) {
      this.state.pageVisibility = e.target.visibilityState;
      var intervalAction = this.isPageVisible() ? this.onVisibilityVisible : this.onVisibilityHidden;

      intervalAction.apply(this);
    }
  }, {
    key: 'getCurrentInterval',
    value: function getCurrentInterval() {
      return this.state.currentInterval;
    }
  }, {
    key: 'setCurrentInterval',
    value: function setCurrentInterval(newInterval) {
      this.state.currentInterval = newInterval;
    }
  }, {
    key: 'incrementInterval',
    value: function incrementInterval() {
      var cfg = this.cfg;
      var currentInterval = this.getCurrentInterval();
      if (cfg.hiddenInterval && !this.isPageVisible()) return;
      var nextInterval = currentInterval * cfg.incrementByFactorOf;

      if (nextInterval > cfg.maxInterval) {
        nextInterval = cfg.maxInterval;
      }

      this.setCurrentInterval(nextInterval);
    }
  }, {
    key: 'isPageVisible',
    value: function isPageVisible() {
      return this.state.pageVisibility === 'visible';
    }
  }, {
    key: 'stopTimer',
    value: function stopTimer() {
      var state = this.state;

      state.intervalId = window.clearInterval(state.intervalId);
    }
  }]);

  return SmartInterval;
}();

/* harmony default export */ __webpack_exports__["a"] = (SmartInterval);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./task_list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deckar01_task_list__ = __webpack_require__("../../../node_modules/deckar01-task_list/dist/task_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deckar01_task_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_deckar01_task_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var TaskList = function () {
  function TaskList() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, TaskList);

    this.selector = options.selector;
    this.dataType = options.dataType;
    this.fieldName = options.fieldName;
    this.onSuccess = options.onSuccess || function () {};
    this.onError = function showFlash(e) {
      var errorMessages = '';

      if (e.response.data && _typeof(e.response.data) === 'object') {
        errorMessages = e.response.data.errors.join(' ');
      }

      return new __WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */](errorMessages || 'Update failed', 'alert');
    };

    this.init();
  }

  _createClass(TaskList, [{
    key: 'init',
    value: function init() {
      // Prevent duplicate event bindings
      this.disable();
      $(this.selector + ' .js-task-list-container').taskList('enable');
      $(document).on('tasklist:changed', this.selector + ' .js-task-list-container', this.update.bind(this));
    }
  }, {
    key: 'disable',
    value: function disable() {
      $(this.selector + ' .js-task-list-container').taskList('disable');
      $(document).off('tasklist:changed', this.selector + ' .js-task-list-container');
    }
  }, {
    key: 'update',
    value: function update(e) {
      var _this = this;

      var $target = $(e.target);
      var patchData = {};
      patchData[this.dataType] = _defineProperty({}, this.fieldName, $target.val());

      return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].patch($target.data('updateUrl') || $('form.js-issuable-update').attr('action'), patchData).then(function (_ref) {
        var data = _ref.data;
        return _this.onSuccess(data);
      }).catch(function (err) {
        return _this.onError(err);
      });
    }
  }]);

  return TaskList;
}();

/* harmony default export */ __webpack_exports__["a"] = (TaskList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./users_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable func-names, space-before-function-paren, one-var, no-var, prefer-rest-params, wrap-iife, quotes, max-len, one-var-declaration-per-line, vars-on-top, prefer-arrow-callback, consistent-return, comma-dangle, object-shorthand, no-shadow, no-unused-vars, no-else-return, no-self-compare, prefer-template, no-unused-expressions, no-lonely-if, yoda, prefer-spread, no-void, camelcase, no-param-reassign */
/* global Issuable */
/* global emitSidebarEvent */



// TODO: remove eventHub hack after code splitting refactor
window.emitSidebarEvent = window.emitSidebarEvent || $.noop;

function UsersSelect(currentUser, els) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var $els;
  this.users = this.users.bind(this);
  this.user = this.user.bind(this);
  this.usersPath = "/autocomplete/users.json";
  this.userPath = "/autocomplete/users/:id.json";
  if (currentUser != null) {
    if ((typeof currentUser === 'undefined' ? 'undefined' : _typeof(currentUser)) === 'object') {
      this.currentUser = currentUser;
    } else {
      this.currentUser = JSON.parse(currentUser);
    }
  }

  var handleClick = options.handleClick;


  $els = $(els);

  if (!els) {
    $els = $('.js-user-search');
  }

  $els.each(function (_this) {
    return function (i, dropdown) {
      var options = {};
      var $block, $collapsedSidebar, $dropdown, $loading, $selectbox, $value, abilityName, assignTo, assigneeTemplate, collapsedAssigneeTemplate, defaultLabel, defaultNullUser, firstUser, issueURL, selectedId, selectedIdDefault, showAnyUser, showNullUser, showMenuAbove;
      $dropdown = $(dropdown);
      options.projectId = $dropdown.data('projectId');
      options.groupId = $dropdown.data('groupId');
      options.showCurrentUser = $dropdown.data('currentUser');
      options.todoFilter = $dropdown.data('todoFilter');
      options.todoStateFilter = $dropdown.data('todoStateFilter');
      showNullUser = $dropdown.data('nullUser');
      defaultNullUser = $dropdown.data('nullUserDefault');
      showMenuAbove = $dropdown.data('showMenuAbove');
      showAnyUser = $dropdown.data('anyUser');
      firstUser = $dropdown.data('firstUser');
      options.authorId = $dropdown.data('authorId');
      defaultLabel = $dropdown.data('defaultLabel');
      issueURL = $dropdown.data('issueUpdate');
      $selectbox = $dropdown.closest('.selectbox');
      $block = $selectbox.closest('.block');
      abilityName = $dropdown.data('abilityName');
      $value = $block.find('.value');
      $collapsedSidebar = $block.find('.sidebar-collapsed-user');
      $loading = $block.find('.block-loading').fadeOut();
      selectedIdDefault = defaultNullUser && showNullUser ? 0 : null;
      selectedId = $dropdown.data('selected');

      if (selectedId === undefined) {
        selectedId = selectedIdDefault;
      }

      var assignYourself = function assignYourself() {
        var unassignedSelected = $dropdown.closest('.selectbox').find('input[name=\'' + $dropdown.data('fieldName') + '\'][value=0]');

        if (unassignedSelected) {
          unassignedSelected.remove();
        }

        // Save current selected user to the DOM
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = $dropdown.data('fieldName');

        var currentUserInfo = $dropdown.data('currentUserInfo');

        if (currentUserInfo) {
          input.value = currentUserInfo.id;
          input.dataset.meta = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(currentUserInfo.name);
        } else if (_this.currentUser) {
          input.value = _this.currentUser.id;
        }

        if ($selectbox) {
          $dropdown.parent().before(input);
        } else {
          $dropdown.after(input);
        }
      };

      if ($block[0]) {
        $block[0].addEventListener('assignYourself', assignYourself);
      }

      var getSelectedUserInputs = function getSelectedUserInputs() {
        return $selectbox.find('input[name="' + $dropdown.data('fieldName') + '"]');
      };

      var getSelected = function getSelected() {
        return getSelectedUserInputs().map(function (index, input) {
          return parseInt(input.value, 10);
        }).get();
      };

      var checkMaxSelect = function checkMaxSelect() {
        var maxSelect = $dropdown.data('maxSelect');
        if (maxSelect) {
          var selected = getSelected();

          if (selected.length > maxSelect) {
            var firstSelectedId = selected[0];
            var firstSelected = $dropdown.closest('.selectbox').find('input[name=\'' + $dropdown.data('fieldName') + '\'][value=' + firstSelectedId + ']');

            firstSelected.remove();
            emitSidebarEvent('sidebar.removeAssignee', {
              id: firstSelectedId
            });
          }
        }
      };

      var getMultiSelectDropdownTitle = function getMultiSelectDropdownTitle(selectedUser, isSelected) {
        var selectedUsers = getSelected().filter(function (u) {
          return u !== 0;
        });

        var firstUser = getSelectedUserInputs().map(function (index, input) {
          return {
            name: input.dataset.meta,
            value: parseInt(input.value, 10)
          };
        }).filter(function (u) {
          return u.id !== 0;
        }).get(0);

        if (selectedUsers.length === 0) {
          return 'Unassigned';
        } else if (selectedUsers.length === 1) {
          return firstUser.name;
        } else if (isSelected) {
          var otherSelected = selectedUsers.filter(function (s) {
            return s !== selectedUser.id;
          });
          return selectedUser.name + ' + ' + otherSelected.length + ' more';
        } else {
          return firstUser.name + ' + ' + (selectedUsers.length - 1) + ' more';
        }
      };

      $('.assign-to-me-link').on('click', function (e) {
        e.preventDefault();
        $(e.currentTarget).hide();

        if ($dropdown.data('multiSelect')) {
          assignYourself();
          checkMaxSelect();

          var currentUserInfo = $dropdown.data('currentUserInfo');
          $dropdown.find('.dropdown-toggle-text').text(getMultiSelectDropdownTitle(currentUserInfo)).removeClass('is-default');
        } else {
          var $input = $('input[name="' + $dropdown.data('fieldName') + '"]');
          $input.val(gon.current_user_id);
          selectedId = $input.val();
          $dropdown.find('.dropdown-toggle-text').text(gon.current_user_fullname).removeClass('is-default');
        }
      });

      $block.on('click', '.js-assign-yourself', function (e) {
        e.preventDefault();
        return assignTo(_this.currentUser.id);
      });

      assignTo = function assignTo(selected) {
        var data;
        data = {};
        data[abilityName] = {};
        data[abilityName].assignee_id = selected != null ? selected : null;
        $loading.removeClass('hidden').fadeIn();
        $dropdown.trigger('loading.gl.dropdown');

        return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].put(issueURL, data).then(function (_ref) {
          var data = _ref.data;

          var user;
          $dropdown.trigger('loaded.gl.dropdown');
          $loading.fadeOut();
          if (data.assignee) {
            user = {
              name: data.assignee.name,
              username: data.assignee.username,
              avatar: data.assignee.avatar_url
            };
          } else {
            user = {
              name: 'Unassigned',
              username: '',
              avatar: ''
            };
          }
          $value.html(assigneeTemplate(user));
          $collapsedSidebar.attr('title', __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name)).tooltip('fixTitle');
          return $collapsedSidebar.html(collapsedAssigneeTemplate(user));
        });
      };
      collapsedAssigneeTemplate = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<% if( avatar ) { %> <a class="author_link" href="/<%- username %>"> <img width="24" class="avatar avatar-inline s24" alt="" src="<%- avatar %>"> </a> <% } else { %> <i class="fa fa-user"></i> <% } %>');
      assigneeTemplate = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.template('<% if (username) { %> <a class="author_link bold" href="/<%- username %>"> <% if( avatar ) { %> <img width="32" class="avatar avatar-inline s32" alt="" src="<%- avatar %>"> <% } %> <span class="author"><%- name %></span> <span class="username"> @<%- username %> </span> </a> <% } else { %> <span class="no-value assign-yourself"> No assignee - <a href="#" class="js-assign-yourself"> assign yourself </a> </span> <% } %>');
      return $dropdown.glDropdown({
        showMenuAbove: showMenuAbove,
        data: function data(term, callback) {
          return _this.users(term, options, function (users) {
            // GitLabDropdownFilter returns this.instance
            // GitLabDropdownRemote returns this.options.instance
            var glDropdown = this.instance || this.options.instance;
            glDropdown.options.processData(term, users, callback);
          }.bind(this));
        },
        processData: function processData(term, data, callback) {
          var users = data;

          // Only show assigned user list when there is no search term
          if ($dropdown.hasClass('js-multiselect') && term.length === 0) {
            var selectedInputs = getSelectedUserInputs();

            // Potential duplicate entries when dealing with issue board
            // because issue board is also managed by vue
            var selectedUsers = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.uniq(selectedInputs, false, function (a) {
              return a.value;
            }).filter(function (input) {
              var userId = parseInt(input.value, 10);
              var inUsersArray = users.find(function (u) {
                return u.id === userId;
              });

              return !inUsersArray && userId !== 0;
            }).map(function (input) {
              var userId = parseInt(input.value, 10);
              var _input$dataset = input.dataset,
                  avatarUrl = _input$dataset.avatarUrl,
                  avatar_url = _input$dataset.avatar_url,
                  name = _input$dataset.name,
                  username = _input$dataset.username;

              return {
                avatar_url: avatarUrl || avatar_url,
                id: userId,
                name: name,
                username: username
              };
            });

            users = data.concat(selectedUsers);
          }

          var anyUser = void 0;
          var index = void 0;
          var j = void 0;
          var len = void 0;
          var name = void 0;
          var obj = void 0;
          var showDivider = void 0;
          if (term.length === 0) {
            showDivider = 0;
            if (firstUser) {
              // Move current user to the front of the list
              for (index = j = 0, len = users.length; j < len; index = j += 1) {
                obj = users[index];
                if (obj.username === firstUser) {
                  users.splice(index, 1);
                  users.unshift(obj);
                  break;
                }
              }
            }
            if (showNullUser) {
              showDivider += 1;
              users.unshift({
                beforeDivider: true,
                name: 'Unassigned',
                id: 0
              });
            }
            if (showAnyUser) {
              showDivider += 1;
              name = showAnyUser;
              if (name === true) {
                name = 'Any User';
              }
              anyUser = {
                beforeDivider: true,
                name: name,
                id: null
              };
              users.unshift(anyUser);
            }

            if (showDivider) {
              users.splice(showDivider, 0, 'divider');
            }

            if ($dropdown.hasClass('js-multiselect')) {
              var selected = getSelected().filter(function (i) {
                return i !== 0;
              });

              if (selected.length > 0) {
                if ($dropdown.data('dropdownHeader')) {
                  showDivider += 1;
                  users.splice(showDivider, 0, {
                    header: $dropdown.data('dropdownHeader')
                  });
                }

                var _selectedUsers = users.filter(function (u) {
                  return selected.indexOf(u.id) !== -1;
                }).sort(function (a, b) {
                  return a.name > b.name;
                });

                users = users.filter(function (u) {
                  return selected.indexOf(u.id) === -1;
                });

                _selectedUsers.forEach(function (selectedUser) {
                  showDivider += 1;
                  users.splice(showDivider, 0, selectedUser);
                });

                users.splice(showDivider + 1, 0, 'divider');
              }
            }
          }

          callback(users);
          if (showMenuAbove) {
            $dropdown.data('glDropdown').positionMenuAbove();
          }
        },
        filterable: true,
        filterRemote: true,
        search: {
          fields: ['name', 'username']
        },
        selectable: true,
        fieldName: $dropdown.data('fieldName'),
        toggleLabel: function toggleLabel(selected, el, glDropdown) {
          var inputValue = glDropdown.filterInput.val();

          if (this.multiSelect && inputValue === '') {
            // Remove non-users from the fullData array
            var users = glDropdown.filteredFullData();
            var callback = glDropdown.parseData.bind(glDropdown);

            // Update the data model
            this.processData(inputValue, users, callback);
          }

          if (this.multiSelect) {
            return getMultiSelectDropdownTitle(selected, $(el).hasClass('is-active'));
          }

          if (selected && 'id' in selected && $(el).hasClass('is-active')) {
            $dropdown.find('.dropdown-toggle-text').removeClass('is-default');
            if (selected.text) {
              return selected.text;
            } else {
              return selected.name;
            }
          } else {
            $dropdown.find('.dropdown-toggle-text').addClass('is-default');
            return defaultLabel;
          }
        },
        defaultLabel: defaultLabel,
        hidden: function hidden(e) {
          if ($dropdown.hasClass('js-multiselect')) {
            emitSidebarEvent('sidebar.saveAssignees');
          }

          if (!$dropdown.data('alwaysShowSelectbox')) {
            $selectbox.hide();

            // Recalculate where .value is because vue might have changed it
            $block = $selectbox.closest('.block');
            $value = $block.find('.value');
            // display:block overrides the hide-collapse rule
            $value.css('display', '');
          }
        },
        multiSelect: $dropdown.hasClass('js-multiselect'),
        inputMeta: $dropdown.data('inputMeta'),
        clicked: function clicked(options) {
          var $el = options.$el,
              e = options.e,
              isMarking = options.isMarking;

          var user = options.selectedObj;

          if ($dropdown.hasClass('js-multiselect')) {
            var isActive = $el.hasClass('is-active');
            var previouslySelected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('fieldName') + "'][value!=0]");

            // Enables support for limiting the number of users selected
            // Automatically removes the first on the list if more users are selected
            checkMaxSelect();

            if (user.beforeDivider && user.name.toLowerCase() === 'unassigned') {
              // Unassigned selected
              previouslySelected.each(function (index, element) {
                var id = parseInt(element.value, 10);
                element.remove();
              });
              emitSidebarEvent('sidebar.removeAllAssignees');
            } else if (isActive) {
              // user selected
              emitSidebarEvent('sidebar.addAssignee', user);

              // Remove unassigned selection (if it was previously selected)
              var unassignedSelected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('fieldName') + "'][value=0]");

              if (unassignedSelected) {
                unassignedSelected.remove();
              }
            } else {
              if (previouslySelected.length === 0) {
                // Select unassigned because there is no more selected users
                this.addInput($dropdown.data('fieldName'), 0, {});
              }

              // User unselected
              emitSidebarEvent('sidebar.removeAssignee', user);
            }

            if (getSelected().find(function (u) {
              return u === gon.current_user_id;
            })) {
              $('.assign-to-me-link').hide();
            } else {
              $('.assign-to-me-link').show();
            }
          }

          var isIssueIndex, isMRIndex, page, selected;
          page = $('body').attr('data-page');
          isIssueIndex = page === 'projects:issues:index';
          isMRIndex = page === page && page === 'projects:merge_requests:index';
          if ($dropdown.hasClass('js-filter-bulk-update') || $dropdown.hasClass('js-issuable-form-dropdown')) {
            e.preventDefault();

            var isSelecting = user.id !== selectedId;
            selectedId = isSelecting ? user.id : selectedIdDefault;

            if (selectedId === gon.current_user_id) {
              $('.assign-to-me-link').hide();
            } else {
              $('.assign-to-me-link').show();
            }
            return;
          }
          if ($el.closest('.add-issues-modal').length) {
            gl.issueBoards.ModalStore.store.filter[$dropdown.data('fieldName')] = user.id;
          } else if (handleClick) {
            e.preventDefault();
            handleClick(user, isMarking);
          } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
            return Issuable.filterResults($dropdown.closest('form'));
          } else if ($dropdown.hasClass('js-filter-submit')) {
            return $dropdown.closest('form').submit();
          } else if (!$dropdown.hasClass('js-multiselect')) {
            selected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('fieldName') + "']").val();
            return assignTo(selected);
          }

          // Automatically close dropdown after assignee is selected
          // since CE has no multiple assignees
          // EE does not have a max-select
          if ($dropdown.data('maxSelect') && getSelected().length === $dropdown.data('maxSelect')) {
            // Close the dropdown
            $dropdown.dropdown('toggle');
          }
        },
        id: function id(user) {
          return user.id;
        },
        opened: function opened(e) {
          var $el = $(e.currentTarget);
          var selected = getSelected();
          if ($dropdown.hasClass('js-issue-board-sidebar') && selected.length === 0) {
            this.addInput($dropdown.data('fieldName'), 0, {});
          }
          $el.find('.is-active').removeClass('is-active');

          function highlightSelected(id) {
            $el.find('li[data-user-id="' + id + '"] .dropdown-menu-user-link').addClass('is-active');
          }

          if (selected.length > 0) {
            getSelected().forEach(function (selectedId) {
              return highlightSelected(selectedId);
            });
          } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
            highlightSelected(0);
          } else {
            highlightSelected(selectedId);
          }
        },
        updateLabel: $dropdown.data('dropdownTitle'),
        renderRow: function renderRow(user) {
          var avatar, img, listClosingTags, listWithName, listWithUserName, username;
          username = user.username ? "@" + user.username : "";
          avatar = user.avatar_url ? user.avatar_url : gon.default_avatar_url;

          var selected = false;

          if (this.multiSelect) {
            selected = getSelected().find(function (u) {
              return user.id === u;
            });

            var fieldName = this.fieldName;
            var field = $dropdown.closest('.selectbox').find("input[name='" + fieldName + "'][value='" + user.id + "']");

            if (field.length) {
              selected = true;
            }
          } else {
            selected = user.id === selectedId;
          }

          img = "";
          if (user.beforeDivider != null) {
            '<li><a href=\'#\' class=\'' + (selected === true ? 'is-active' : '') + '\'>' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + '</a></li>';
          } else {
            img = "<img src='" + avatar + "' class='avatar avatar-inline' width='32' />";
          }

          return '\n            <li data-user-id=' + user.id + '>\n              <a href=\'#\' class=\'dropdown-menu-user-link ' + (selected === true ? 'is-active' : '') + '\'>\n                ' + img + '\n                <strong class=\'dropdown-menu-user-full-name\'>\n                  ' + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + '\n                </strong>\n                ' + (username ? '<span class=\'dropdown-menu-user-username\'>' + username + '</span>' : '') + '\n              </a>\n            </li>\n          ';
        }
      });
    };
  }(this));
  $('.ajax-users-select').each(function (_this) {
    return function (i, select) {
      var firstUser, showAnyUser, showEmailUser, showNullUser;
      var options = {};
      options.skipLdap = $(select).hasClass('skip_ldap');
      options.projectId = $(select).data('projectId');
      options.groupId = $(select).data('groupId');
      options.showCurrentUser = $(select).data('currentUser');
      options.authorId = $(select).data('authorId');
      options.skipUsers = $(select).data('skipUsers');
      showNullUser = $(select).data('nullUser');
      showAnyUser = $(select).data('anyUser');
      showEmailUser = $(select).data('emailUser');
      firstUser = $(select).data('firstUser');
      return $(select).select2({
        placeholder: "Search for a user",
        multiple: $(select).hasClass('multiselect'),
        minimumInputLength: 0,
        query: function query(_query) {
          return _this.users(_query.term, options, function (users) {
            var anyUser, data, emailUser, index, j, len, name, nullUser, obj, ref;
            data = {
              results: users
            };
            if (_query.term.length === 0) {
              if (firstUser) {
                // Move current user to the front of the list
                ref = data.results;
                for (index = j = 0, len = ref.length; j < len; index = j += 1) {
                  obj = ref[index];
                  if (obj.username === firstUser) {
                    data.results.splice(index, 1);
                    data.results.unshift(obj);
                    break;
                  }
                }
              }
              if (showNullUser) {
                nullUser = {
                  name: 'Unassigned',
                  id: 0
                };
                data.results.unshift(nullUser);
              }
              if (showAnyUser) {
                name = showAnyUser;
                if (name === true) {
                  name = 'Any User';
                }
                anyUser = {
                  name: name,
                  id: null
                };
                data.results.unshift(anyUser);
              }
            }
            if (showEmailUser && data.results.length === 0 && _query.term.match(/^[^@]+@[^@]+$/)) {
              var trimmed = _query.term.trim();
              emailUser = {
                name: "Invite \"" + _query.term + "\" by email",
                username: trimmed,
                id: trimmed,
                invite: true
              };
              data.results.unshift(emailUser);
            }
            return _query.callback(data);
          });
        },
        initSelection: function initSelection() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.initSelection.apply(_this, args);
        },
        formatResult: function formatResult() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.formatResult.apply(_this, args);
        },
        formatSelection: function formatSelection() {
          var args;
          args = 1 <= arguments.length ? [].slice.call(arguments, 0) : [];
          return _this.formatSelection.apply(_this, args);
        },
        dropdownCssClass: "ajax-users-dropdown",
        // we do not want to escape markup since we are displaying html in results
        escapeMarkup: function escapeMarkup(m) {
          return m;
        }
      });
    };
  }(this));
}

UsersSelect.prototype.initSelection = function (element, callback) {
  var id, nullUser;
  id = $(element).val();
  if (id === "0") {
    nullUser = {
      name: 'Unassigned'
    };
    return callback(nullUser);
  } else if (id !== "") {
    return this.user(id, callback);
  }
};

UsersSelect.prototype.formatResult = function (user) {
  var avatar;
  if (user.avatar_url) {
    avatar = user.avatar_url;
  } else {
    avatar = gon.default_avatar_url;
  }
  return "<div class='user-result " + (!user.username ? 'no-username' : void 0) + "'> <div class='user-image'><img class='avatar avatar-inline s32' src='" + avatar + "'></div> <div class='user-name dropdown-menu-user-full-name'>" + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name) + "</div> <div class='user-username dropdown-menu-user-username'>" + (!user.invite ? "@" + __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.username) : "") + "</div> </div>";
};

UsersSelect.prototype.formatSelection = function (user) {
  return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.escape(user.name);
};

UsersSelect.prototype.user = function (user_id, callback) {
  if (!/^\d+$/.test(user_id)) {
    return false;
  }

  var url;
  url = this.buildUrl(this.userPath);
  url = url.replace(':id', user_id);
  return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(url).then(function (_ref2) {
    var data = _ref2.data;

    callback(data);
  });
};

// Return users list. Filtered by query
// Only active users retrieved
UsersSelect.prototype.users = function (query, options, callback) {
  var url = this.buildUrl(this.usersPath);
  var params = {
    search: query,
    active: true,
    project_id: options.projectId || null,
    group_id: options.groupId || null,
    skip_ldap: options.skipLdap || null,
    todo_filter: options.todoFilter || null,
    todo_state_filter: options.todoStateFilter || null,
    current_user: options.showCurrentUser || null,
    author_id: options.authorId || null,
    skip_users: options.skipUsers || null
  };
  return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(url, { params: params }).then(function (_ref3) {
    var data = _ref3.data;

    callback(data);
  });
};

UsersSelect.prototype.buildUrl = function (url) {
  if (gon.relative_url_root != null) {
    url = gon.relative_url_root.replace(/\/$/, '') + url;
  }
  return url;
};

/* harmony default export */ __webpack_exports__["a"] = (UsersSelect);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_merge_request_widget/components/mr_widget_status_icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/ci_icon.vue + 2 modules
var ci_icon = __webpack_require__("./vue_shared/components/ci_icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_merge_request_widget/components/mr_widget_status_icon.vue




/* harmony default export */ var mr_widget_status_icon = ({
  components: {
    ciIcon: ci_icon["a" /* default */],
    loadingIcon: loading_icon["a" /* default */]
  },
  props: {
    status: {
      type: String,
      required: true
    },
    showDisabledButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isLoading: function isLoading() {
      return this.status === 'loading';
    },
    statusObj: function statusObj() {
      return {
        group: this.status,
        icon: 'status_' + this.status
      };
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b6b0385","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/mr_widget_status_icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-children flex-container-block append-right-10"},[(_vm.isLoading)?_c('div',{staticClass:"mr-widget-icon"},[_c('loading-icon')],1):_c('ci-icon',{attrs:{"status":_vm.statusObj}}),_vm._v(" "),(_vm.showDisabledButton)?_c('button',{staticClass:"js-disabled-merge-button btn btn-success btn-sm",attrs:{"type":"button","disabled":"true"}},[_vm._v("\n    "+_vm._s(_vm.s__("mrWidget|Merge"))+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_merge_request_widget/components/mr_widget_status_icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  mr_widget_status_icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_mr_widget_status_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_merge_request_widget/components/states/mr_widget_wip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mr_widget_status_icon_vue__ = __webpack_require__("./vue_merge_request_widget/components/mr_widget_status_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_directives_tooltip__ = __webpack_require__("./vue_shared/directives/tooltip.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub__ = __webpack_require__("./vue_merge_request_widget/event_hub.js");




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MRWidgetWIP',
  props: {
    mr: { type: Object, required: true },
    service: { type: Object, required: true }
  },
  directives: {
    tooltip: __WEBPACK_IMPORTED_MODULE_1__vue_shared_directives_tooltip__["a" /* default */]
  },
  data: function data() {
    return {
      isMakingRequest: false
    };
  },

  components: {
    statusIcon: __WEBPACK_IMPORTED_MODULE_0__mr_widget_status_icon_vue__["a" /* default */]
  },
  methods: {
    removeWIP: function removeWIP() {
      var _this = this;

      this.isMakingRequest = true;
      this.service.removeWIP().then(function (res) {
        return res.data;
      }).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_2__event_hub__["a" /* default */].$emit('UpdateWidgetData', data);
        new window.Flash('The merge request can now be merged.', 'notice'); // eslint-disable-line
        $('.merge-request .detail-page-description .title').text(_this.mr.title);
      }).catch(function () {
        _this.isMakingRequest = false;
        new window.Flash('Something went wrong. Please try again.'); // eslint-disable-line
      });
    }
  },
  template: '\n    <div class="mr-widget-body media">\n      <status-icon status="warning" :show-disabled-button="Boolean(mr.removeWIPPath)" />\n      <div class="media-body space-children">\n        <span class="bold">\n          This is a Work in Progress\n          <i\n            v-tooltip\n            class="fa fa-question-circle"\n            title="When this merge request is ready, remove the WIP: prefix from the title to allow it to be merged"\n            aria-label="When this merge request is ready, remove the WIP: prefix from the title to allow it to be merged">\n           </i>\n        </span>\n        <button\n          v-if="mr.removeWIPPath"\n          @click="removeWIP"\n          :disabled="isMakingRequest"\n          type="button"\n          class="btn btn-default btn-xs js-remove-wip">\n          <i\n            v-if="isMakingRequest"\n            class="fa fa-spinner fa-spin"\n            aria-hidden="true" />\n            Resolve WIP status\n        </button>\n      </div>\n    </div>\n  '
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_merge_request_widget/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),

/***/ "./vue_shared/components/ci_badge_link.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/ci_icon.vue + 2 modules
var ci_icon = __webpack_require__("./vue_shared/components/ci_icon.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_badge_link.vue



/**
 * Renders CI Badge link with CI icon and status text based on
 * API response shared between all places where it is used.
 *
 * Receives status object containing:
 * status: {
 *   details_path: "/gitlab-org/gitlab-ce/pipelines/8150156" // url
 *   group:"running" // used for CSS class
 *   icon: "icon_status_running" // used to render the icon
 *   label:"running" // used for potential tooltip
 *   text:"running" // text rendered
 * }
 *
 * Used in:
 * - Pipelines table - first column
 * - Jobs table - first column
 * - Pipeline show view - header
 * - Job show view - header
 * - MR widget
 */

/* harmony default export */ var ci_badge_link = ({
  components: {
    ciIcon: ci_icon["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    status: {
      type: Object,
      required: true
    },
    showText: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    cssClass: function cssClass() {
      var className = this.status.group;
      return className ? 'ci-status ci-' + className : 'ci-status';
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a93a9e9","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_badge_link.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],class:_vm.cssClass,attrs:{"href":_vm.status.details_path,"title":!_vm.showText ? _vm.status.text : ''}},[_c('ci-icon',{attrs:{"status":_vm.status}}),_vm._v(" "),(_vm.showText)?[_vm._v("\n    "+_vm._s(_vm.status.text)+"\n  ")]:_vm._e()],2)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/ci_badge_link.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ci_badge_link,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_ci_badge_link = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/ci_icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/ci_icon.vue



/**
 * Renders CI icon based on API response shared between all places where it is used.
 *
 * Receives status object containing:
 * status: {
 *   details_path: "/gitlab-org/gitlab-ce/pipelines/8150156" // url
 *   group:"running" // used for CSS class
 *   icon: "icon_status_running" // used to render the icon
 *   label:"running" // used for potential tooltip
 *   text:"running" // text rendered
 * }
 *
 * Used in:
 * - Pipelines table Badge
 * - Pipelines table mini graph
 * - Pipeline graph
 * - Pipeline show view badge
 * - Jobs table
 * - Jobs show view header
 * - Jobs show view sidebar
 * - Linked pipelines
 */
/* harmony default export */ var ci_icon = ({
  components: {
    icon: icon["a" /* default */]
  },

  props: {
    status: {
      type: Object,
      required: true
    }
  },

  computed: {
    cssClass: function cssClass() {
      var status = this.status.group;
      return 'ci-status-icon ci-status-icon-' + status + ' js-ci-status-icon-' + status;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40fee415","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/ci_icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.cssClass},[_c('icon',{attrs:{"name":_vm.status.icon}})],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/ci_icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ci_icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_ci_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/clipboard_button.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/clipboard_button.vue

/**
 * Falls back to the code used in `copy_to_clipboard.js`
 */


/* harmony default export */ var clipboard_button = ({
  name: 'ClipboardButton',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    text: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    },
    tooltipContainer: {
      type: [String, Boolean],
      required: false,
      default: false
    },
    cssClass: {
      type: String,
      required: false,
      default: 'btn-default'
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ceaea0ee","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/clipboard_button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn",class:_vm.cssClass,attrs:{"type":"button","title":_vm.title,"data-clipboard-text":_vm.text,"data-container":_vm.tooltipContainer,"data-placement":_vm.tooltipPlacement}},[_c('i',{staticClass:"fa fa-clipboard",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/clipboard_button.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  clipboard_button,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_clipboard_button = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/commit.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/app/views/shared/icons/_icon_commit.svg
var _icon_commit = __webpack_require__("../../views/shared/icons/_icon_commit.svg");
var _icon_commit_default = /*#__PURE__*/__webpack_require__.n(_icon_commit);

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue + 2 modules
var user_avatar_link = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/commit.vue






/* harmony default export */ var commit = ({
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  components: {
    userAvatarLink: user_avatar_link["a" /* default */],
    icon: icon["a" /* default */]
  },
  props: {
    /**
     * Indicates the existance of a tag.
     * Used to render the correct icon, if true will render `fa-tag` icon,
     * if false will render a svg sprite fork icon
     */
    tag: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * If provided is used to render the branch name and url.
     * Should contain the following properties:
     * name
     * ref_url
     */
    commitRef: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    /**
     * Used to link to the commit sha.
     */
    commitUrl: {
      type: String,
      required: false,
      default: ''
    },

    /**
     * Used to show the commit short sha that links to the commit url.
     */
    shortSha: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * If provided shows the commit tile.
     */
    title: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * If provided renders information about the author of the commit.
     * When provided should include:
     * `avatar_url` to render the avatar icon
     * `web_url` to link to user profile
     * `username` to render alt and title tags
     */
    author: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    showBranch: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    /**
     * Used to verify if all the properties needed to render the commit
     * ref section were provided.
     *
     * @returns {Boolean}
     */
    hasCommitRef: function hasCommitRef() {
      return this.commitRef && this.commitRef.name && this.commitRef.ref_url;
    },

    /**
     * Used to verify if all the properties needed to render the commit
     * author section were provided.
     *
     * @returns {Boolean}
     */
    hasAuthor: function hasAuthor() {
      return this.author && this.author.avatar_url && this.author.path && this.author.username;
    },

    /**
     * If information about the author is provided will return a string
     * to be rendered as the alt attribute of the img tag.
     *
     * @returns {String}
     */
    userImageAltDescription: function userImageAltDescription() {
      return this.author && this.author.username ? this.author.username + '\'s avatar' : null;
    }
  },
  created: function created() {
    this.commitIconSvg = _icon_commit_default.a;
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03412931","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/commit.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"branch-commit"},[(_vm.hasCommitRef && _vm.showBranch)?[_c('div',{staticClass:"icon-container"},[(_vm.tag)?_c('i',{staticClass:"fa fa-tag",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),(!_vm.tag)?_c('icon',{attrs:{"name":"fork"}}):_vm._e()],1),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"ref-name",attrs:{"href":_vm.commitRef.ref_url,"data-container":"body","title":_vm.commitRef.name}},[_vm._v("\n      "+_vm._s(_vm.commitRef.name)+"\n    ")])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"commit-icon js-commit-icon",domProps:{"innerHTML":_vm._s(_vm.commitIconSvg)}}),_vm._v(" "),_c('a',{staticClass:"commit-sha",attrs:{"href":_vm.commitUrl}},[_vm._v("\n    "+_vm._s(_vm.shortSha)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"commit-title flex-truncate-parent"},[(_vm.title)?_c('span',{staticClass:"flex-truncate-child"},[(_vm.hasAuthor)?_c('user-avatar-link',{staticClass:"avatar-image-container",attrs:{"link-href":_vm.author.path,"img-src":_vm.author.avatar_url,"img-alt":_vm.userImageAltDescription,"tooltip-text":_vm.author.username}}):_vm._e(),_vm._v(" "),_c('a',{staticClass:"commit-row-message",attrs:{"href":_vm.commitUrl}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])],1):_c('span',[_vm._v("\n      Cant find HEAD commit for this branch\n    ")])])],2)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/commit.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  commit,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_commit = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/expand_button.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/expand_button.vue


/**
 * Port of detail_behavior expand button.
 *
 * @example
 * <expand-button>
 *   <template slot="expanded">
 *      Text goes here.
 *    </template>
 * </expand-button>
 */
/* harmony default export */ var expand_button = ({
  name: 'ExpandButton',
  data: function data() {
    return {
      isCollapsed: true
    };
  },

  computed: {
    ariaLabel: function ariaLabel() {
      return Object(locale["a" /* __ */])('Click to expand text');
    }
  },
  methods: {
    onClick: function onClick() {
      this.isCollapsed = !this.isCollapsed;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3767b76","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/expand_button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCollapsed),expression:"isCollapsed"}],staticClass:"text-expander btn-blank",attrs:{"type":"button","aria-label":_vm.ariaLabel},on:{"click":_vm.onClick}},[_vm._v("\n    ...\n  ")]),_vm._v(" "),(!_vm.isCollapsed)?_c('span',[_vm._t("expanded")],2):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/expand_button.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  expand_button,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_expand_button = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/gl_modal.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/gl_modal.vue

var buttonVariants = ['danger', 'primary', 'success', 'warning'];

/* harmony default export */ var gl_modal = ({
  name: 'GlModal',

  props: {
    id: {
      type: String,
      required: false,
      default: null
    },
    headerTitleText: {
      type: String,
      required: false,
      default: ''
    },
    footerPrimaryButtonVariant: {
      type: String,
      required: false,
      default: 'primary',
      validator: function validator(value) {
        return buttonVariants.indexOf(value) !== -1;
      }
    },
    footerPrimaryButtonText: {
      type: String,
      required: false,
      default: ''
    }
  },

  methods: {
    emitCancel: function emitCancel(event) {
      this.$emit('cancel', event);
    },
    emitSubmit: function emitSubmit(event) {
      this.$emit('submit', event);
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-240a30a4","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/gl_modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":_vm.id,"tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":_vm.s__('Modal|Close')},on:{"click":function($event){_vm.emitCancel($event)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._t("title",[_vm._v("\n              "+_vm._s(_vm.headerTitleText)+"\n            ")])],2)])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_c('button',{staticClass:"btn",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.emitCancel($event)}}},[_vm._v("\n            "+_vm._s(_vm.s__('Modal|Cancel'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn",class:("btn-" + _vm.footerPrimaryButtonVariant),attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.emitSubmit($event)}}},[_vm._v("\n            "+_vm._s(_vm.footerPrimaryButtonText)+"\n          ")])])],2)])])])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/gl_modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  gl_modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_gl_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/icon.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/icon.vue


/* This is a re-usable vue component for rendering a svg sprite
  icon

  Sample configuration:

  <icon
    name="retry"
    :size="32"
    css-classes="top"
  />

*/
// only allow classes in images.scss e.g. s12
var validSizes = [8, 12, 16, 18, 24, 32, 48, 72];

/* harmony default export */ var icon = ({
  props: {
    name: {
      type: String,
      required: true
    },

    size: {
      type: Number,
      required: false,
      default: 16,
      validator: function validator(value) {
        return validSizes.includes(value);
      }
    },

    cssClasses: {
      type: String,
      required: false,
      default: ''
    },

    width: {
      type: Number,
      required: false,
      default: null
    },

    height: {
      type: Number,
      required: false,
      default: null
    },

    y: {
      type: Number,
      required: false,
      default: null
    },

    x: {
      type: Number,
      required: false,
      default: null
    }
  },

  computed: {
    spriteHref: function spriteHref() {
      return gon.sprite_icons + '#' + this.name;
    },
    iconSizeClass: function iconSizeClass() {
      return this.size ? 's' + this.size : '';
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43441268","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:[_vm.iconSizeClass, _vm.cssClasses],attrs:{"width":_vm.width,"height":_vm.height,"x":_vm.x,"y":_vm.y}},[_c('use',_vm._b({},'use',{ 'xlink:href':_vm.spriteHref },false))])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/icon.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  icon,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/modal.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/modal.vue
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable vue/require-default-prop */
/* harmony default export */ var modal = ({
  name: 'Modal',

  props: {
    id: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: false
    },
    hideFooter: {
      type: Boolean,
      required: false,
      default: false
    },
    kind: {
      type: String,
      required: false,
      default: 'primary'
    },
    modalDialogClass: {
      type: String,
      required: false,
      default: ''
    },
    closeKind: {
      type: String,
      required: false,
      default: 'default'
    },
    closeButtonLabel: {
      type: String,
      required: false,
      default: 'Cancel'
    },
    primaryButtonLabel: {
      type: String,
      required: false,
      default: ''
    },
    secondaryButtonLabel: {
      type: String,
      required: false,
      default: ''
    },
    submitDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    btnKindClass: function btnKindClass() {
      return _defineProperty({}, 'btn-' + this.kind, true);
    },
    btnCancelKindClass: function btnCancelKindClass() {
      return _defineProperty({}, 'btn-' + this.closeKind, true);
    }
  },

  methods: {
    emitCancel: function emitCancel(event) {
      this.$emit('cancel', event);
    },
    emitSubmit: function emitSubmit(event) {
      this.$emit('submit', event);
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e18618c","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-open"},[_c('div',{staticClass:"modal",class:_vm.id ? '' : 'show',attrs:{"id":_vm.id,"role":"dialog","tabindex":"-1"}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalDialogClass,attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('h4',{staticClass:"modal-title pull-left"},[_vm._v("\n              "+_vm._s(_vm.title)+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"close pull-right",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){_vm.emitCancel($event)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",[_c('p',[_vm._v(_vm._s(_vm.text))])],{text:_vm.text})],2),_vm._v(" "),(!_vm.hideFooter)?_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",class:_vm.btnCancelKindClass,attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.emitCancel($event)}}},[_vm._v("\n            "+_vm._s(_vm.closeButtonLabel)+"\n          ")]),_vm._v(" "),(_vm.secondaryButtonLabel)?_vm._t("secondary-button",[(_vm.secondaryButtonLabel)?_c('button',{staticClass:"btn",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n              "+_vm._s(_vm.secondaryButtonLabel)+"\n            ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.primaryButtonLabel)?_c('button',{staticClass:"btn js-primary-button",class:_vm.btnKindClass,attrs:{"type":"button","disabled":_vm.submitDisabled,"data-dismiss":"modal"},on:{"click":function($event){_vm.emitSubmit($event)}}},[_vm._v("\n            "+_vm._s(_vm.primaryButtonLabel)+"\n          ")]):_vm._e()],2):_vm._e()])])]),_vm._v(" "),(!_vm.id)?_c('div',{staticClass:"modal-backdrop fade in"}):_vm._e()])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/modal.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  modal,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/toggle_button.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./locale/index.js + 1 modules
var locale = __webpack_require__("./locale/index.js");

// EXTERNAL MODULE: ./vue_shared/components/icon.vue + 2 modules
var icon = __webpack_require__("./vue_shared/components/icon.vue");

// EXTERNAL MODULE: ./vue_shared/components/loading_icon.vue + 2 modules
var loading_icon = __webpack_require__("./vue_shared/components/loading_icon.vue");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/toggle_button.vue





var ICON_ON = 'status_success_borderless';
var ICON_OFF = 'status_failed_borderless';
var LABEL_ON = Object(locale["e" /* s__ */])('ToggleButton|Toggle Status: ON');
var LABEL_OFF = Object(locale["e" /* s__ */])('ToggleButton|Toggle Status: OFF');

/* harmony default export */ var toggle_button = ({
  components: {
    icon: icon["a" /* default */],
    loadingIcon: loading_icon["a" /* default */]
  },

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    name: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: Boolean,
      required: false,
      default: null
    },
    disabledInput: {
      type: Boolean,
      required: false,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    toggleIcon: function toggleIcon() {
      return this.value ? ICON_ON : ICON_OFF;
    },
    ariaLabel: function ariaLabel() {
      return this.value ? LABEL_ON : LABEL_OFF;
    }
  },

  methods: {
    toggleFeature: function toggleFeature() {
      if (!this.disabledInput) this.$emit('change', !this.value);
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c91d7c","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/toggle_button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"toggle-wrapper"},[(_vm.name)?_c('input',{attrs:{"type":"hidden","name":_vm.name},domProps:{"value":_vm.value}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"project-feature-toggle",class:{
      'is-checked': _vm.value,
      'is-disabled': _vm.disabledInput,
      'is-loading': _vm.isLoading
    },attrs:{"type":"button","aria-label":_vm.ariaLabel},on:{"click":_vm.toggleFeature}},[_c('loadingIcon',{staticClass:"loading-icon"}),_vm._v(" "),_c('span',{staticClass:"toggle-icon"},[_c('icon',{attrs:{"css-classes":"toggle-icon-svg","name":_vm.toggleIcon}})],1)],1)])}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/toggle_button.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  toggle_button,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_toggle_button = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_image.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../images/no_avatar.png
var no_avatar = __webpack_require__("../images/no_avatar.png");
var no_avatar_default = /*#__PURE__*/__webpack_require__.n(no_avatar);

// EXTERNAL MODULE: ./lazy_loader.js
var lazy_loader = __webpack_require__("./lazy_loader.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue


/* This is a re-usable vue component for rendering a user avatar that
  does not need to link to the user's profile. The image and an optional
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-image
    :lazy="true"
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :tooltip-text="tooltipText"
    tooltip-placement="top"
  />

*/





/* harmony default export */ var user_avatar_image = ({
  name: 'UserAvatarImage',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    lazy: {
      type: Boolean,
      required: false,
      default: false
    },
    imgSrc: {
      type: String,
      required: false,
      default: no_avatar_default.a
    },
    cssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: 'user avatar'
    },
    size: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    }
  },
  computed: {
    // API response sends null when gravatar is disabled and
    // we provide an empty string when we use it inside user avatar link.
    // In both cases we should render the defaultAvatarUrl
    sanitizedSource: function sanitizedSource() {
      return this.imgSrc === '' || this.imgSrc === null ? no_avatar_default.a : this.imgSrc;
    },
    resultantSrcAttribute: function resultantSrcAttribute() {
      return this.lazy ? lazy_loader["b" /* placeholderImage */] : this.sanitizedSource;
    },
    tooltipContainer: function tooltipContainer() {
      return this.tooltipText ? 'body' : null;
    },
    avatarSizeClass: function avatarSizeClass() {
      return 's' + this.size;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75ce3616","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"avatar",class:( _obj = {
    lazy: _vm.lazy
  }, _obj[_vm.avatarSizeClass] = true, _obj[_vm.cssClasses] = true, _obj ),attrs:{"src":_vm.resultantSrcAttribute,"width":_vm.size,"height":_vm.size,"alt":_vm.imgAlt,"data-src":_vm.sanitizedSource,"data-container":_vm.tooltipContainer,"data-placement":_vm.tooltipPlacement,"title":_vm.tooltipText}})
var _obj;}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_avatar_image,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var user_avatar_user_avatar_image = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_link.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue + 2 modules
var user_avatar_image = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/babel-loader/lib!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue


/* This is a re-usable vue component for rendering a user avatar wrapped in
  a clickable link (likely to the user's profile). The link, image, and
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-link
    :link-href="userProfileUrl"
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :img-size="20"
    :tooltip-text="tooltipText"
    :tooltip-placement="top"
    :username="username"
  />

*/




/* harmony default export */ var user_avatar_link = ({
  name: 'UserAvatarLink',
  components: {
    userAvatarImage: user_avatar_image["a" /* default */]
  },
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    linkHref: {
      type: String,
      required: false,
      default: ''
    },
    imgSrc: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: ''
    },
    imgCssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgSize: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    },
    username: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    shouldShowUsername: function shouldShowUsername() {
      return this.username.length > 0;
    },
    avatarTooltipText: function avatarTooltipText() {
      return this.shouldShowUsername ? '' : this.tooltipText;
    }
  }
});
// CONCATENATED MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dd80867","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_link.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"user-avatar-link",attrs:{"href":_vm.linkHref}},[_c('user-avatar-image',{attrs:{"img-src":_vm.imgSrc,"img-alt":_vm.imgAlt,"css-classes":_vm.imgCssClasses,"size":_vm.imgSize,"tooltip-text":_vm.avatarTooltipText,"tooltip-placement":_vm.tooltipPlacement}}),(_vm.shouldShowUsername)?_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip"}],attrs:{"title":_vm.tooltipText,"tooltip-placement":_vm.tooltipPlacement}},[_vm._v(_vm._s(_vm.username))]):_vm._e()],1)}
var staticRenderFns = []

// EXTERNAL MODULE: /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/user_avatar/user_avatar_link.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_avatar_link,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var user_avatar_user_avatar_link = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/directives/popover.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * Helper to user bootstrap popover in vue.js.
 * Follow docs for html attributes: https://getbootstrap.com/docs/3.3/javascript/#static-popover
 *
 * @example
 * import popover from 'vue_shared/directives/popover.js';
 * {
 *   directives: [popover]
 * }
 * <a v-popover="{options}">popover</a>
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding) {
    $(el).popover(binding.value);
  },
  unbind: function unbind(el) {
    $(el).popover('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/directives/tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    $(el).tooltip();
  },
  componentUpdated: function componentUpdated(el) {
    $(el).tooltip('fixTitle');
  },
  unbind: function unbind(el) {
    $(el).tooltip('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/mixins/issuable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    issuableType: {
      required: true,
      type: String
    }
  },

  computed: {
    issuableDisplayName: function issuableDisplayName() {
      return this.issuableType.replace(/_/g, ' ');
    }
  }
});

/***/ }),

/***/ "./vue_shared/mixins/timeago.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");


/**
 * Mixin with time ago methods used in some vue components
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    timeFormated: function timeFormated(time) {
      var timeago = Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__["f" /* getTimeago */])();

      return timeago.format(time);
    },
    tooltipTitle: function tooltipTitle(time) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_datetime_utility__["b" /* formatDate */])(time);
    }
  }
});

/***/ }),

/***/ "./zen_mode.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_scrollTo__ = __webpack_require__("../../../vendor/assets/javascripts/jquery.scrollTo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_scrollTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendor_jquery_scrollTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dropzone__ = __webpack_require__("../../../node_modules/dropzone/dist/dropzone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mousetrap_plugins_pause_mousetrap_pause__ = __webpack_require__("../../../node_modules/mousetrap/plugins/pause/mousetrap-pause.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mousetrap_plugins_pause_mousetrap_pause___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mousetrap_plugins_pause_mousetrap_pause__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-unused-vars, consistent-return, camelcase, comma-dangle, max-len, class-methods-use-this */

// Zen Mode (full screen) textarea
//
/*= provides zen_mode:enter */
/*= provides zen_mode:leave */






__WEBPACK_IMPORTED_MODULE_1_dropzone___default.a.autoDiscover = false;

//
// ### Events
//
// `zen_mode:enter`
//
// Fired when the "Edit in fullscreen" link is clicked.
//
// **Synchronicity** Sync
// **Bubbles** Yes
// **Cancelable** No
// **Target** a.js-zen-enter
//
// `zen_mode:leave`
//
// Fired when the "Leave Fullscreen" link is clicked.
//
// **Synchronicity** Sync
// **Bubbles** Yes
// **Cancelable** No
// **Target** a.js-zen-leave
//

var ZenMode = function () {
  function ZenMode() {
    _classCallCheck(this, ZenMode);

    this.active_backdrop = null;
    this.active_textarea = null;
    $(document).on('click', '.js-zen-enter', function (e) {
      e.preventDefault();
      return $(e.currentTarget).trigger('zen_mode:enter');
    });
    $(document).on('click', '.js-zen-leave', function (e) {
      e.preventDefault();
      return $(e.currentTarget).trigger('zen_mode:leave');
    });
    $(document).on('zen_mode:enter', function (_this) {
      return function (e) {
        return _this.enter($(e.target).closest('.md-area').find('.zen-backdrop'));
      };
    }(this));
    $(document).on('zen_mode:leave', function (_this) {
      return function (e) {
        return _this.exit();
      };
    }(this));
    $(document).on('keydown', function (e) {
      // Esc
      if (e.keyCode === 27) {
        e.preventDefault();
        return $(document).trigger('zen_mode:leave');
      }
    });
  }

  _createClass(ZenMode, [{
    key: 'enter',
    value: function enter(backdrop) {
      __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.pause();
      this.active_backdrop = $(backdrop);
      this.active_backdrop.addClass('fullscreen');
      this.active_textarea = this.active_backdrop.find('textarea');
      // Prevent a user-resized textarea from persisting to fullscreen
      this.active_textarea.removeAttr('style');
      this.active_textarea.focus();
    }
  }, {
    key: 'exit',
    value: function exit() {
      if (this.active_textarea) {
        __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.unpause();
        this.active_textarea.closest('.zen-backdrop').removeClass('fullscreen');
        this.scrollTo(this.active_textarea);
        this.active_textarea = null;
        this.active_backdrop = null;

        var $dropzone = $('.div-dropzone');
        if ($dropzone && !$dropzone.hasClass('js-invalid-dropzone')) {
          __WEBPACK_IMPORTED_MODULE_1_dropzone___default.a.forElement('.div-dropzone').enable();
        }
      }
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo(zen_area) {
      return $.scrollTo(zen_area, 0, {
        offset: -150
      });
    }
  }]);

  return ZenMode;
}();

/* harmony default export */ __webpack_exports__["a"] = (ZenMode);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ })

},["../../../ee/app/assets/javascripts/pages/projects/merge_requests/show/index.js"]);


// WEBPACK FOOTER //
// pages.projects.merge_requests.show.b170d5a9842fb9be9d84.bundle.js